(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-redux"), require("lodash"), require("@spinnaker/core"), require("classnames"), require("angular"), require("redux-actions"), require("@uirouter/react"), require("redux"), require("d3-scale"), require("react-bootstrap"), require("semiotic"), require("moment-timezone"), require("react2angular"), require("reselect"), require("class-autobind-decorator"), require("d3-array"), require("d3-shape"), require("@uirouter/angularjs"), require("brace/ext/searchbox"), require("brace/mode/json"), require("d3-format"), require("formik"), require("labella"), require("moment"), require("ngimport"), require("react-bootstrap-typeahead"), require("react-container-dimensions"), require("react-dom"), require("react-select"), require("react-tooltip"), require("redux-logger"), require("redux-observable"), require("rxjs/Observable"), require("rxjs/add/observable/concat"));
	else if(typeof define === 'function' && define.amd)
		define("@spinnaker/kayenta", ["react", "react-redux", "lodash", "@spinnaker/core", "classnames", "angular", "redux-actions", "@uirouter/react", "redux", "d3-scale", "react-bootstrap", "semiotic", "moment-timezone", "react2angular", "reselect", "class-autobind-decorator", "d3-array", "d3-shape", "@uirouter/angularjs", "brace/ext/searchbox", "brace/mode/json", "d3-format", "formik", "labella", "moment", "ngimport", "react-bootstrap-typeahead", "react-container-dimensions", "react-dom", "react-select", "react-tooltip", "redux-logger", "redux-observable", "rxjs/Observable", "rxjs/add/observable/concat"], factory);
	else if(typeof exports === 'object')
		exports["@spinnaker/kayenta"] = factory(require("react"), require("react-redux"), require("lodash"), require("@spinnaker/core"), require("classnames"), require("angular"), require("redux-actions"), require("@uirouter/react"), require("redux"), require("d3-scale"), require("react-bootstrap"), require("semiotic"), require("moment-timezone"), require("react2angular"), require("reselect"), require("class-autobind-decorator"), require("d3-array"), require("d3-shape"), require("@uirouter/angularjs"), require("brace/ext/searchbox"), require("brace/mode/json"), require("d3-format"), require("formik"), require("labella"), require("moment"), require("ngimport"), require("react-bootstrap-typeahead"), require("react-container-dimensions"), require("react-dom"), require("react-select"), require("react-tooltip"), require("redux-logger"), require("redux-observable"), require("rxjs/Observable"), require("rxjs/add/observable/concat"));
	else
		root["@spinnaker/kayenta"] = factory(root["react"], root["react-redux"], root["lodash"], root["@spinnaker/core"], root["classnames"], root["angular"], root["redux-actions"], root["@uirouter/react"], root["redux"], root["d3-scale"], root["react-bootstrap"], root["semiotic"], root["moment-timezone"], root["react2angular"], root["reselect"], root["class-autobind-decorator"], root["d3-array"], root["d3-shape"], root["@uirouter/angularjs"], root["brace/ext/searchbox"], root["brace/mode/json"], root["d3-format"], root["formik"], root["labella"], root["moment"], root["ngimport"], root["react-bootstrap-typeahead"], root["react-container-dimensions"], root["react-dom"], root["react-select"], root["react-tooltip"], root["redux-logger"], root["redux-observable"], root["rxjs/Observable"], root["rxjs/add/observable/concat"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_16__, __WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_21__, __WEBPACK_EXTERNAL_MODULE_28__, __WEBPACK_EXTERNAL_MODULE_29__, __WEBPACK_EXTERNAL_MODULE_30__, __WEBPACK_EXTERNAL_MODULE_36__, __WEBPACK_EXTERNAL_MODULE_37__, __WEBPACK_EXTERNAL_MODULE_38__, __WEBPACK_EXTERNAL_MODULE_49__, __WEBPACK_EXTERNAL_MODULE_50__, __WEBPACK_EXTERNAL_MODULE_74__, __WEBPACK_EXTERNAL_MODULE_290__, __WEBPACK_EXTERNAL_MODULE_291__, __WEBPACK_EXTERNAL_MODULE_292__, __WEBPACK_EXTERNAL_MODULE_293__, __WEBPACK_EXTERNAL_MODULE_294__, __WEBPACK_EXTERNAL_MODULE_295__, __WEBPACK_EXTERNAL_MODULE_296__, __WEBPACK_EXTERNAL_MODULE_297__, __WEBPACK_EXTERNAL_MODULE_298__, __WEBPACK_EXTERNAL_MODULE_299__, __WEBPACK_EXTERNAL_MODULE_300__, __WEBPACK_EXTERNAL_MODULE_301__, __WEBPACK_EXTERNAL_MODULE_302__, __WEBPACK_EXTERNAL_MODULE_303__, __WEBPACK_EXTERNAL_MODULE_304__, __WEBPACK_EXTERNAL_MODULE_305__, __WEBPACK_EXTERNAL_MODULE_306__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 307);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("react-redux");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const redux_actions_1 = __webpack_require__(16);
const Actions = __webpack_require__(10);
exports.openDeleteConfigModal = redux_actions_1.createAction(Actions.DELETE_CONFIG_MODAL_OPEN);
exports.closeDeleteConfigModal = redux_actions_1.createAction(Actions.DELETE_CONFIG_MODAL_CLOSE);
exports.deleteConfig = redux_actions_1.createAction(Actions.DELETE_CONFIG_REQUEST);
exports.closeConfigJsonModal = redux_actions_1.createAction(Actions.CONFIG_JSON_MODAL_CLOSE);
exports.openConfigJsonModal = redux_actions_1.createAction(Actions.CONFIG_JSON_MODAL_OPEN);
exports.editMetricCancel = redux_actions_1.createAction(Actions.EDIT_METRIC_CANCEL);
exports.editMetricConfirm = redux_actions_1.createAction(Actions.EDIT_METRIC_CONFIRM);
exports.updateMetricDirection = redux_actions_1.createAction(Actions.UPDATE_METRIC_DIRECTION);
exports.updateMetricNanStrategy = redux_actions_1.createAction(Actions.UPDATE_METRIC_NAN_STRATEGY);
exports.updateMetricCriticality = redux_actions_1.createAction(Actions.UPDATE_METRIC_CRITICALITY);
exports.updateMetricGroup = redux_actions_1.createAction(Actions.UPDATE_METRIC_GROUP);
exports.addGroup = redux_actions_1.createAction(Actions.ADD_GROUP);
exports.saveConfig = redux_actions_1.createAction(Actions.SAVE_CONFIG_REQUEST);
exports.dismissSaveConfigError = redux_actions_1.createAction(Actions.DISMISS_SAVE_CONFIG_ERROR);
exports.setConfigJsonModalTabState = redux_actions_1.createAction(Actions.SET_CONFIG_JSON_MODAL_TAB_STATE);
exports.setConfigJson = redux_actions_1.createAction(Actions.SET_CONFIG_JSON);
exports.deleteConfigSuccess = redux_actions_1.createAction(Actions.DELETE_CONFIG_SUCCESS);
exports.loadConfigRequest = redux_actions_1.createAction(Actions.LOAD_CONFIG_REQUEST);
exports.saveConfigSuccess = redux_actions_1.createAction(Actions.SAVE_CONFIG_SUCCESS);
exports.selectConfig = redux_actions_1.createAction(Actions.SELECT_CONFIG);
exports.clearSelectedConfig = redux_actions_1.createAction(Actions.CLEAR_SELECTED_CONFIG);
exports.renameMetric = redux_actions_1.createAction(Actions.RENAME_METRIC);
exports.selectGroup = redux_actions_1.createAction(Actions.SELECT_GROUP);
exports.updateGroupWeight = redux_actions_1.createAction(Actions.UPDATE_GROUP_WEIGHT);
exports.selectJudgeName = redux_actions_1.createAction(Actions.SELECT_JUDGE_NAME);
exports.editMetricBegin = redux_actions_1.createAction(Actions.EDIT_METRIC_BEGIN);
exports.removeMetric = redux_actions_1.createAction(Actions.REMOVE_METRIC);
exports.addMetric = redux_actions_1.createAction(Actions.ADD_METRIC);
exports.updateConfigName = redux_actions_1.createAction(Actions.UPDATE_CONFIG_NAME);
exports.updateConfigDescription = redux_actions_1.createAction(Actions.UPDATE_CONFIG_DESCRIPTION);
exports.saveConfigFailure = redux_actions_1.createAction(Actions.SAVE_CONFIG_FAILURE);
exports.deleteConfigFailure = redux_actions_1.createAction(Actions.DELETE_CONFIG_FAILURE);
exports.updateConfigSummaries = redux_actions_1.createAction(Actions.UPDATE_CONFIG_SUMMARIES);
exports.updateJudges = redux_actions_1.createAction(Actions.UPDATE_JUDGES);
exports.loadConfigSuccess = redux_actions_1.createAction(Actions.LOAD_CONFIG_SUCCESS);
exports.loadConfigFailure = redux_actions_1.createAction(Actions.LOAD_CONFIG_FAILURE);
exports.copySelectedConfig = redux_actions_1.createAction(Actions.COPY_SELECTED_CONFIG);
exports.createNewConfig = redux_actions_1.createAction(Actions.CREATE_NEW_CONFIG);
exports.editGroupBegin = redux_actions_1.createAction(Actions.EDIT_GROUP_BEGIN);
exports.editGroupUpdate = redux_actions_1.createAction(Actions.EDIT_GROUP_UPDATE);
exports.editGroupConfirm = redux_actions_1.createAction(Actions.EDIT_GROUP_CONFIRM);
exports.changeMetricGroupSelect = redux_actions_1.createAction(Actions.CHANGE_METRIC_GROUP_SELECT);
exports.changeMetricGroupConfirm = redux_actions_1.createAction(Actions.CHANGE_METRIC_GROUP_CONFIRM);
exports.loadRunRequest = redux_actions_1.createAction(Actions.LOAD_RUN_REQUEST);
exports.loadRunSuccess = redux_actions_1.createAction(Actions.LOAD_RUN_SUCCESS);
exports.loadRunFailure = redux_actions_1.createAction(Actions.LOAD_RUN_FAILURE);
exports.selectReportMetricGroup = redux_actions_1.createAction(Actions.SELECT_REPORT_METRIC_GROUP);
exports.selectReportMetric = redux_actions_1.createAction(Actions.SELECT_REPORT_METRIC);
exports.loadMetricSetPairRequest = redux_actions_1.createAction(Actions.LOAD_METRIC_SET_PAIR_REQUEST);
exports.loadMetricSetPairSuccess = redux_actions_1.createAction(Actions.LOAD_METRIC_SET_PAIR_SUCCESS);
exports.loadMetricSetPairFailure = redux_actions_1.createAction(Actions.LOAD_METRIC_SET_PAIR_FAILURE);
exports.addTemplate = redux_actions_1.createAction(Actions.ADD_TEMPLATE);
exports.editTemplateBegin = redux_actions_1.createAction(Actions.EDIT_TEMPLATE_BEGIN);
exports.editTemplateConfirm = redux_actions_1.createAction(Actions.EDIT_TEMPLATE_CONFIRM);
exports.editTemplateCancel = redux_actions_1.createAction(Actions.EDIT_TEMPLATE_CANCEL);
exports.editTemplateName = redux_actions_1.createAction(Actions.EDIT_TEMPLATE_NAME);
exports.editTemplateValue = redux_actions_1.createAction(Actions.EDIT_TEMPLATE_VALUE);
exports.editInlineTemplate = redux_actions_1.createAction(Actions.EDIT_INLINE_TEMPLATE);
exports.updatePrometheusLabelBindings = redux_actions_1.createAction(Actions.UPDATE_PROMETHEUS_LABEL_BINDINGS);
exports.updatePrometheusGroupBy = redux_actions_1.createAction(Actions.UPDATE_PROMETHEUS_GROUP_BY_FIELDS);
exports.updatePrometheusMetricQueryField = redux_actions_1.createAction(Actions.UPDATE_PROMETHEUS_METRIC_QUERY_FIELD);
exports.updateStackdriverGroupBy = redux_actions_1.createAction(Actions.UPDATE_STACKDRIVER_GROUP_BY_FIELDS);
exports.deleteTemplate = redux_actions_1.createAction(Actions.DELETE_TEMPLATE);
exports.selectTemplate = redux_actions_1.createAction(Actions.SELECT_TEMPLATE);
exports.changeMetricGroup = redux_actions_1.createAction(Actions.CHANGE_METRIC_GROUP);
exports.loadMetricsServiceMetadataRequest = redux_actions_1.createAction(Actions.LOAD_METRICS_SERVICE_METADATA_REQUEST);
exports.loadMetricsServiceMetadataSuccess = redux_actions_1.createAction(Actions.LOAD_METRICS_SERVICE_METADATA_SUCCESS);
exports.loadMetricsServiceMetadataFailure = redux_actions_1.createAction(Actions.LOAD_METRICS_SERVICE_METADATA_FAILURE);
exports.updatePrometheusMetricDescriptorFilter = redux_actions_1.createAction(Actions.UPDATE_PROMETHEUS_METRIC_DESCRIPTOR_FILTER);
exports.updateGraphiteMetricDescriptorFilter = redux_actions_1.createAction(Actions.UPDATE_GRAPHITE_METRIC_DESCRIPTOR_FILTER);
exports.updateStackdriverMetricDescriptorFilter = redux_actions_1.createAction(Actions.UPDATE_STACKDRIVER_METRIC_DESCRIPTOR_FILTER);
exports.updateDatadogMetricDescriptorFilter = redux_actions_1.createAction(Actions.UPDATE_DATADOG_METRIC_DESCRIPTOR_FILTER);
exports.updateStackdriverMetricResourceField = redux_actions_1.createAction(Actions.UPDATE_STACKDRIVER_METRIC_QUERY_FIELD);
exports.updateDatadogMetricName = redux_actions_1.createAction(Actions.UPDATE_DATADOG_METRIC_NAME);
exports.updateNewRelicSelect = redux_actions_1.createAction(Actions.UPDATE_NEWRELIC_SELECT);
exports.loadExecutionsRequest = redux_actions_1.createAction(Actions.LOAD_EXECUTIONS_REQUEST);
exports.loadExecutionsFailure = redux_actions_1.createAction(Actions.LOAD_EXECUTIONS_FAILURE);
exports.loadExecutionsSuccess = redux_actions_1.createAction(Actions.LOAD_EXECUTIONS_SUCCESS);
exports.selectGraphType = redux_actions_1.createAction(Actions.SELECT_GRAPH_TYPE);
exports.loadKayentaAccountsRequest = redux_actions_1.createAction(Actions.LOAD_KAYENTA_ACCOUNTS_REQUEST);
exports.loadKayentaAccountsSuccess = redux_actions_1.createAction(Actions.LOAD_KAYENTA_ACCOUNTS_SUCCESS);
exports.loadKayentaAccountsFailure = redux_actions_1.createAction(Actions.LOAD_KAYENTA_ACCOUNTS_FAILURE);
exports.selectMetricStore = redux_actions_1.createAction(Actions.SELECT_METRIC_STORE);
exports.updateSignalFxMetricName = redux_actions_1.createAction(Actions.UPDATE_SIGNAL_FX_METRIC_NAME);
exports.updateSignalFxAggregationMethod = redux_actions_1.createAction(Actions.UPDATE_SIGNAL_FX_AGGREGATION_METHOD);
exports.updateSignalFxQueryPairs = redux_actions_1.createAction(Actions.UPDATE_SIGNAL_FX_QUERY_PAIRS);
exports.updateGraphiteMetricName = redux_actions_1.createAction(Actions.UPDATE_GRAPHITE_METRIC_NAME);


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader 
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	}),
	getElement = (function(fn) {
		var memo = {};
		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				memo[selector] = fn.call(this, selector);
			}
			return memo[selector]
		};
	})(function (styleTarget) {
		return document.querySelector(styleTarget)
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [],
	fixUrls = __webpack_require__(288);

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (typeof options.insertInto === "undefined") options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list, options);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list, options) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var styleTarget = getElement(options.insertInto)
	if (!styleTarget) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			styleTarget.insertBefore(styleElement, styleTarget.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			styleTarget.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		styleTarget.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	options.attrs.type = "text/css";

	attachTagAttrs(styleElement, options.attrs);
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	attachTagAttrs(linkElement, options.attrs);
	insertStyleElement(options, linkElement);
	return linkElement;
}

function attachTagAttrs(element, attrs) {
	Object.keys(attrs).forEach(function (key) {
		element.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var styleElement, update, remove, transformResult;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    transformResult = options.transform(obj.css);
	    
	    if (transformResult) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = transformResult;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css. 
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement, options);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
	and there is no publicPath defined then lets turn convertToAbsoluteUrls
	on by default.  Otherwise default to the convertToAbsoluteUrls option
	directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls){
		css = fixUrls(css);
	}

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("@spinnaker/core");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const lodash_1 = __webpack_require__(2);
const classNames = __webpack_require__(7);
const react_select_1 = __webpack_require__(301);
const react_bootstrap_typeahead_1 = __webpack_require__(298);
exports.DISABLE_EDIT_CONFIG = 'app.disableConfigEdit';
const mapStateToProps = (state, ownProps) => ({
    disabledBecauseOfState: (ownProps.disabledStateKeys || []).some(key => lodash_1.get(state, key, false)),
});
function disableable(Component) {
    return react_redux_1.connect(mapStateToProps)((props) => {
        const { disabled, disabledBecauseOfState } = props;
        const otherProps = lodash_1.omit(props, ['disabled', 'disabledBecauseOfState', 'disabledStateKeys', 'dispatch']);
        return React.createElement(Component, Object.assign({}, otherProps, { disabled: disabled || disabledBecauseOfState }));
    });
}
exports.DisableableButton = disableable(props => {
    const { children } = props, otherProps = __rest(props, ["children"]);
    return React.createElement("button", Object.assign({}, otherProps), children);
});
exports.DisableableInput = disableable(props => {
    const { className } = props, inputProps = __rest(props, ["className"]);
    return (React.createElement("input", Object.assign({}, inputProps, { className: classNames(className, {
            'form-control': !['radio', 'checkbox'].includes(inputProps.type),
            'input-sm': !['radio', 'checkbox'].includes(inputProps.type),
        }) })));
});
exports.DisableableReactSelect = disableable(props => {
    const { children } = props, selectProps = __rest(props, ["children"]);
    return React.createElement(react_select_1.default, Object.assign({}, selectProps), children);
});
exports.DisableableReactTypeahead = disableable(props => {
    const { children } = props, selectProps = __rest(props, ["children"]);
    return React.createElement(react_bootstrap_typeahead_1.Typeahead, Object.assign({}, selectProps), children);
});
exports.DisableableSelect = disableable(props => {
    const { children } = props, selectProps = __rest(props, ["children"]);
    return React.createElement("select", Object.assign({}, selectProps), children);
});
exports.DisableableTextarea = disableable(props => {
    const { className } = props, textareaProps = __rest(props, ["className"]);
    return React.createElement("textarea", Object.assign({ className: classNames('form-control', 'input-sm', className) }, textareaProps));
});


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const reselect_1 = __webpack_require__(38);
const lodash_1 = __webpack_require__(2);
const editMetricValidation_1 = __webpack_require__(177);
exports.runSelector = (state) => state.selectedRun.run;
exports.judgeResultSelector = reselect_1.createSelector(exports.runSelector, run => run.result.judgeResult);
exports.configIdSelector = reselect_1.createSelector(exports.runSelector, run => run.config.id);
exports.metricResultsSelector = reselect_1.createSelector(exports.runSelector, run => run.result.judgeResult.results);
exports.canaryExecutionRequestSelector = reselect_1.createSelector(exports.runSelector, run => run.canaryExecutionRequest);
exports.serializedCanaryConfigSelector = reselect_1.createSelector(exports.runSelector, run => run.config);
exports.serializedGroupWeightsSelector = reselect_1.createSelector(exports.serializedCanaryConfigSelector, (config) => config.classifier.groupWeights);
exports.selectedMetricResultIdSelector = (state) => state.selectedRun.selectedMetric;
exports.selectedMetricResultSelector = reselect_1.createSelector(exports.selectedMetricResultIdSelector, exports.metricResultsSelector, (id, results) => results.find(result => result.id === id));
exports.selectedMetricConfigSelector = reselect_1.createSelector(exports.selectedMetricResultSelector, exports.serializedCanaryConfigSelector, (metric, config) => config.metrics.find(m => m.name === metric.name));
exports.selectedConfigSelector = (state) => state.selectedConfig.config;
exports.configTemplatesSelector = reselect_1.createSelector(exports.selectedConfigSelector, config => (config ? config.templates : null));
exports.editingTemplateSelector = (state) => state.selectedConfig.editingTemplate;
exports.resolveConfigIdFromExecutionId = (state, executionId) => {
    const executions = lodash_1.get(state, ['data', 'executions', 'data'], []);
    const execution = executions.find(ex => ex.pipelineId === executionId);
    return execution.canaryConfigId;
};
exports.editingMetricSelector = (state) => state.selectedConfig.editingMetric;
exports.metricListSelector = (state) => state.selectedConfig.metricList;
exports.editingMetricValidationErrorsSelector = reselect_1.createSelector(exports.editingMetricSelector, exports.metricListSelector, editMetricValidation_1.validateMetric);


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.LOAD_CONFIG_REQUEST = 'load_config_request';
exports.LOAD_CONFIG_SUCCESS = 'load_config_success';
exports.LOAD_CONFIG_FAILURE = 'load_config_failure';
exports.DELETE_CONFIG_REQUEST = 'delete_config_request';
exports.DELETE_CONFIG_SUCCESS = 'delete_config_success';
exports.DELETE_CONFIG_FAILURE = 'delete_config_failure';
exports.SAVE_CONFIG_REQUEST = 'save_config_request';
exports.SAVE_CONFIG_SUCCESS = 'save_config_success';
exports.SAVE_CONFIG_FAILURE = 'save_config_failure';
exports.DELETE_CONFIG_MODAL_OPEN = 'delete_config_modal_open';
exports.DELETE_CONFIG_MODAL_CLOSE = 'delete_config_modal_close';
exports.DISMISS_SAVE_CONFIG_ERROR = 'dismiss_save_config_error';
exports.INITIALIZE = 'initialize';
exports.ADD_METRIC = 'add_metric';
exports.RENAME_METRIC = 'rename_metric';
exports.EDIT_METRIC_BEGIN = 'edit_metric_begin';
exports.EDIT_METRIC_CONFIRM = 'edit_metric_modal_confirm';
exports.EDIT_METRIC_CANCEL = 'edit_metric_modal_cancel';
exports.UPDATE_METRIC_DIRECTION = 'update_metric_direction';
exports.UPDATE_METRIC_NAN_STRATEGY = 'update_metric_nan_strategy';
exports.UPDATE_METRIC_CRITICALITY = 'update_metric_criticality';
exports.UPDATE_METRIC_GROUP = 'update_metric_group';
exports.UPDATE_METRIC_SCOPE_NAME = 'update_metric_scope_name';
exports.REMOVE_METRIC = 'remove_metric';
exports.SELECT_CONFIG = 'select_config';
exports.CLEAR_SELECTED_CONFIG = 'clear_selected_config';
exports.UPDATE_CONFIG_SUMMARIES = 'update_config_summaries';
exports.ADD_GROUP = 'add_group';
exports.SELECT_GROUP = 'select_group';
exports.UPDATE_CONFIG_NAME = 'update_config_name';
exports.UPDATE_CONFIG_DESCRIPTION = 'update_config_description';
exports.CONFIG_JSON_MODAL_OPEN = 'config_json_modal_open';
exports.CONFIG_JSON_MODAL_CLOSE = 'config_json_modal_close';
exports.SET_CONFIG_JSON = 'set_config_json';
exports.UPDATE_PROMETHEUS_METRIC_TYPE = 'update_prometheus_metric_type';
exports.UPDATE_PROMETHEUS_METRIC_QUERY_FIELD = 'update_prometheus_metric_query_field';
exports.UPDATE_PROMETHEUS_LABEL_BINDINGS = 'update_prometheus_label_bindings';
exports.UPDATE_PROMETHEUS_GROUP_BY_FIELDS = 'update_prometheus_group_by_fields';
exports.UPDATE_STACKDRIVER_METRIC_TYPE = 'update_stackdriver_metric_type';
exports.UPDATE_STACKDRIVER_METRIC_QUERY_FIELD = 'update_stackdriver_metric_query_field';
exports.UPDATE_STACKDRIVER_GROUP_BY_FIELDS = 'update_stackdriver_group_by_fields';
exports.UPDATE_JUDGES = 'update_judges';
exports.SELECT_JUDGE_NAME = 'select_judge_name';
exports.UPDATE_GROUP_WEIGHT = 'update_group_weight';
exports.SET_CONFIG_JSON_MODAL_TAB_STATE = 'set_config_json_modal_tab_state';
exports.UPDATE_ATLAS_QUERY = 'update_atlas_query';
exports.UPDATE_DATADOG_METRIC_TYPE = 'update_datadog_metric_type';
exports.UPDATE_DATADOG_METRIC_NAME = 'update_datadog_metric_name';
exports.UPDATE_NEWRELIC_SELECT = 'update_newrelic_select';
exports.COPY_SELECTED_CONFIG = 'copy_selected_config';
exports.CREATE_NEW_CONFIG = 'create_new_config';
exports.EDIT_GROUP_BEGIN = 'edit_group_name_begin';
exports.EDIT_GROUP_CONFIRM = 'edit_group_name_confirm';
exports.EDIT_GROUP_UPDATE = 'edit_group_name_update';
exports.CHANGE_METRIC_GROUP = 'change_metric_group';
exports.CHANGE_METRIC_GROUP_SELECT = 'change_metric_group_select';
exports.CHANGE_METRIC_GROUP_CONFIRM = 'change_metric_group_confirm';
exports.LOAD_RUN_REQUEST = 'load_run_request';
exports.LOAD_RUN_SUCCESS = 'load_run_success';
exports.LOAD_RUN_FAILURE = 'load_run_failure';
exports.SELECT_REPORT_METRIC_GROUP = 'select_result_metric_group';
exports.SELECT_REPORT_METRIC = 'select_result_metric';
exports.LOAD_METRIC_SET_PAIR_REQUEST = 'load_metric_set_pair_request';
exports.LOAD_METRIC_SET_PAIR_SUCCESS = 'load_metric_set_pair_success';
exports.LOAD_METRIC_SET_PAIR_FAILURE = 'load_metric_set_pair_failure';
exports.ADD_TEMPLATE = 'add_template';
exports.EDIT_TEMPLATE_BEGIN = 'edit_template_begin';
exports.EDIT_TEMPLATE_CANCEL = 'edit_template_cancel';
exports.EDIT_TEMPLATE_CONFIRM = 'edit_template_confirm';
exports.EDIT_TEMPLATE_NAME = 'edit_template_name';
exports.EDIT_TEMPLATE_VALUE = 'edit_template_value';
exports.DELETE_TEMPLATE = 'delete_template';
exports.SELECT_TEMPLATE = 'select_template';
exports.EDIT_INLINE_TEMPLATE = 'edit_inline_template';
exports.LOAD_METRICS_SERVICE_METADATA_REQUEST = 'load_metrics_service_metadata_request';
exports.LOAD_METRICS_SERVICE_METADATA_SUCCESS = 'load_metrics_service_metadata_success';
exports.LOAD_METRICS_SERVICE_METADATA_FAILURE = 'load_metrics_service_metadata_failure';
exports.UPDATE_PROMETHEUS_METRIC_DESCRIPTOR_FILTER = 'update_prometheus_metric_descriptor_filter';
exports.UPDATE_GRAPHITE_METRIC_DESCRIPTOR_FILTER = 'update_graphite_metric_descriptor_filter';
exports.UPDATE_STACKDRIVER_METRIC_DESCRIPTOR_FILTER = 'update_stackdriver_metric_descriptor_filter';
exports.UPDATE_DATADOG_METRIC_DESCRIPTOR_FILTER = 'update_datadog_metric_descriptor_filter';
exports.LOAD_EXECUTIONS_REQUEST = 'load_executions_request';
exports.LOAD_EXECUTIONS_SUCCESS = 'load_executions_success';
exports.LOAD_EXECUTIONS_FAILURE = 'load_executions_failure';
exports.SELECT_GRAPH_TYPE = 'select_graph_type';
exports.LOAD_KAYENTA_ACCOUNTS_REQUEST = 'load_kayenta_accounts_request';
exports.LOAD_KAYENTA_ACCOUNTS_SUCCESS = 'load_kayenta_accounts_success';
exports.LOAD_KAYENTA_ACCOUNTS_FAILURE = 'load_kayenta_accounts_failure';
exports.SELECT_METRIC_STORE = 'select_metric_store';
exports.UPDATE_SIGNAL_FX_METRIC_NAME = 'update_signalfx_metric_name';
exports.UPDATE_SIGNAL_FX_AGGREGATION_METHOD = 'update_signalfx_aggregation_method';
exports.UPDATE_SIGNAL_FX_QUERY_PAIRS = 'update_signalfx_query_pairs';
exports.UPDATE_GRAPHITE_METRIC_NAME = 'update_graphite_metric_name';


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = __webpack_require__(6);
exports.CanarySettings = core_1.SETTINGS.canary || { featureDisabled: true };


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("angular");

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(151));
__export(__webpack_require__(157));
__export(__webpack_require__(152));
__export(__webpack_require__(155));
__export(__webpack_require__(156));
__export(__webpack_require__(158));
__export(__webpack_require__(159));
__export(__webpack_require__(161));
__export(__webpack_require__(163));
__export(__webpack_require__(154));
__export(__webpack_require__(162));
__export(__webpack_require__(153));
__export(__webpack_require__(160));
__export(__webpack_require__(164));
__export(__webpack_require__(56));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
const core_1 = __webpack_require__(6);
function FormRow({ label, helpId, children, checkbox, error, warning }) {
    return (React.createElement("div", { className: "form-group row" },
        React.createElement("label", { className: "col-sm-2 control-label sm-label-right" },
            label,
            " ",
            helpId && React.createElement(core_1.HelpField, { id: helpId })),
        React.createElement("div", { className: classNames('col-sm-10', { checkbox }), style: checkbox ? { marginTop: '0', marginBottom: '0' } : null },
            children,
            error && React.createElement(core_1.ValidationMessage, { type: "error", message: error }),
            warning && React.createElement(core_1.ValidationMessage, { type: "warning", message: warning }))));
}
exports.default = FormRow;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AsyncRequestState;
(function (AsyncRequestState) {
    AsyncRequestState["Requesting"] = "requesting";
    AsyncRequestState["Fulfilled"] = "fulfilled";
    AsyncRequestState["Failed"] = "failed";
})(AsyncRequestState = exports.AsyncRequestState || (exports.AsyncRequestState = {}));


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = require("redux-actions");

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const delegateFactory_1 = __webpack_require__(72);
exports.default = delegateFactory_1.buildDelegateService();


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __webpack_require__(2);
const core_1 = __webpack_require__(6);
const canary_settings_1 = __webpack_require__(11);
function getCanaryConfigById(id) {
    return core_1.API.one('v2/canaryConfig')
        .one(id)
        .get()
        .then((config) => (Object.assign({}, config, { id })));
}
exports.getCanaryConfigById = getCanaryConfigById;
function getCanaryConfigSummaries(...application) {
    return core_1.API.one('v2/canaryConfig')
        .withParams({ application })
        .get();
}
exports.getCanaryConfigSummaries = getCanaryConfigSummaries;
function updateCanaryConfig(config) {
    return core_1.API.one('v2/canaryConfig')
        .one(config.id)
        .put(config);
}
exports.updateCanaryConfig = updateCanaryConfig;
function createCanaryConfig(config) {
    return core_1.API.one('v2/canaryConfig').post(config);
}
exports.createCanaryConfig = createCanaryConfig;
function deleteCanaryConfig(id) {
    return core_1.API.one('v2/canaryConfig')
        .one(id)
        .remove();
}
exports.deleteCanaryConfig = deleteCanaryConfig;
function listJudges() {
    return core_1.API.one('v2/canaries/judges')
        .get()
        .then((judges) => judges.filter(judge => judge.visible));
}
exports.listJudges = listJudges;
function listKayentaAccounts() {
    return core_1.API.one('v2/canaries/credentials')
        .useCache()
        .get();
}
exports.listKayentaAccounts = listKayentaAccounts;
function mapStateToConfig(state) {
    const { selectedConfig } = state;
    if (selectedConfig.config) {
        return Object.assign({}, selectedConfig.config, { judge: selectedConfig.judge.judgeConfig, metrics: selectedConfig.metricList.map(metric => lodash_1.omit(metric, 'id')), classifier: Object.assign({}, selectedConfig.config.classifier, { groupWeights: selectedConfig.group.groupWeights }) });
    }
    else {
        return null;
    }
}
exports.mapStateToConfig = mapStateToConfig;
function buildNewConfig(state) {
    let configName = 'new-config';
    let i = 1;
    while ((state.data.configSummaries || []).some(summary => summary.name === configName)) {
        configName = `new-config-${i}`;
        i++;
    }
    return {
        name: configName,
        applications: [state.data.application.name],
        description: '',
        isNew: true,
        metrics: [],
        configVersion: '1',
        templates: {},
        classifier: {
            groupWeights: {},
        },
        judge: {
            name: canary_settings_1.CanarySettings.defaultJudge,
            judgeConfigurations: {},
        },
    };
}
exports.buildNewConfig = buildNewConfig;
function buildConfigCopy(state) {
    const config = Object.assign({}, mapStateToConfig(state), { applications: [state.data.application.name] });
    if (!config) {
        return null;
    }
    let configName = `${config.name}-copy`;
    let i = 1;
    while ((state.data.configSummaries || []).some(summary => summary.name === configName)) {
        configName = `${config.name}-copy-${i}`;
        i++;
    }
    return lodash_1.omit(Object.assign({}, config, { name: configName, isNew: true }), 'id');
}
exports.buildConfigCopy = buildConfigCopy;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.vizConfig = {
    colors: {
        baseline: '#52b3d9',
        canary: '#e26a6a',
        background: '#f8f8f8',
    },
    height: 400,
    timeSeries: {
        minimapDataPointsThreshold: 240,
        minimapHeight: 40,
        axisTickLineHeight: 4,
        axisTickLabelHeight: 32,
        axisLabelHeight: 16,
    },
    dataGroupMap: {
        baseline: 'control',
        canary: 'experiment',
    },
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = require("@uirouter/react");

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = require("redux");

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
__webpack_require__(111);
exports.STYLEGUIDE_CLASS = 'styleguide';
exports.KAYENTA_CLASS = 'kayenta';
function Styleguide({ children, className }) {
    return React.createElement("div", { className: classNames(exports.STYLEGUIDE_CLASS, exports.KAYENTA_CLASS, className) }, children);
}
exports.default = Styleguide;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(199));
__export(__webpack_require__(200));
__export(__webpack_require__(65));
__export(__webpack_require__(198));
__export(__webpack_require__(64));


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const d3_format_1 = __webpack_require__(293);
const moment = __webpack_require__(36);
const d3_scale_1 = __webpack_require__(28);
const d3_array_1 = __webpack_require__(50);
exports.formatMetricValue = (value) => {
    if (typeof value !== 'number' || isNaN(value)) {
        return 'N/A';
    }
    else if (Math.abs(value) >= Math.pow(10, 25)) {
        return d3_format_1.format('-.3~e')(value);
    }
    else {
        return d3_format_1.format('-.3~s')(value);
    }
};
exports.dateTimeTickFormatter = (d) => {
    const m = moment(d);
    if (m
        .clone()
        .startOf('day')
        .unix() === m.unix()) {
        return [m.format('HH:mm'), m.format('MMM DD')];
    }
    else {
        return [m.format('HH:mm')];
    }
};
exports.calculateDateTimeTicks = (millisSet) => {
    const minMillis = millisSet[0];
    const maxMillis = millisSet[millisSet.length - 1];
    const offsetMillis = moment(minMillis).utcOffset() * 60000;
    const minMillisShifted = minMillis + offsetMillis;
    const maxMillisShifted = maxMillis + offsetMillis;
    const scale = d3_scale_1.scaleUtc().domain([new Date(minMillisShifted), new Date(maxMillisShifted)]);
    const ticks = scale.ticks(6).map((d) => new Date(d.valueOf() - offsetMillis));
    return ticks;
};
exports.calculateSummaryStatistics = (values) => {
    const output = {
        min: {
            value: d3_array_1.quantile(values, 0.0),
            label: 'Minimum',
        },
        q1area: {
            value: d3_array_1.quantile(values, 0.25),
            label: '25th %-ile',
        },
        median: {
            value: d3_array_1.quantile(values, 0.5),
            label: 'Median',
        },
        q3area: {
            value: d3_array_1.quantile(values, 0.75),
            label: '75th %-ile',
        },
        max: {
            value: d3_array_1.quantile(values, 1.0),
            label: 'Maximum',
        },
    };
    return output;
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
function CenteredDetail({ children }) {
    return (React.createElement("div", { className: "row" },
        React.createElement("div", { className: "col-sm-offset-4" }, children)));
}
exports.default = CenteredDetail;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const moment = __webpack_require__(36);
const core_1 = __webpack_require__(6);
const DEFAULT_FORMAT = 'YYYY-MM-DD HH:mm:ss z';
function FormattedDate({ dateIso, format }) {
    if (dateIso) {
        return React.createElement("span", null, moment.tz(dateIso, core_1.SETTINGS.defaultTimeZone).format(format || DEFAULT_FORMAT));
    }
    else {
        return React.createElement("span", null, "N/A");
    }
}
exports.default = FormattedDate;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const delegateFactory_1 = __webpack_require__(72);
var GraphType;
(function (GraphType) {
    GraphType["TimeSeries"] = "Time Series";
    GraphType["Histogram"] = "Histogram";
    GraphType["BoxPlot"] = "Beeswarm Box Plot";
})(GraphType = exports.GraphType || (exports.GraphType = {}));
exports.metricSetPairGraphService = delegateFactory_1.buildDelegateService();


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = require("d3-scale");

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = require("react-bootstrap");

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = require("semiotic");

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
const canaryRun_service_1 = __webpack_require__(35);
__webpack_require__(112);
class CanaryScore extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getLabelState(props);
    }
    getLabelState(props) {
        const score = props.score === 0 || (props.score && props.score > 0) ? props.score : 'N/A';
        return {
            score,
            healthLabel: canaryRun_service_1.getHealthLabel(props.health, props.result),
        };
    }
    componentWillReceiveProps(props) {
        this.setState(this.getLabelState(props));
    }
    render() {
        const className = [
            this.props.inverse ? 'inverse' : '',
            'score',
            'score-label',
            'label-default',
            `label-${this.state.healthLabel}`,
        ].join(' ');
        return (React.createElement("span", { className: classNames(className, this.props.className) },
            this.state.score,
            this.props.classification && (React.createElement("span", { className: "score-classification" }, this.props.classification.toString()))));
    }
}
CanaryScore.defaultProps = {
    health: '',
};
exports.CanaryScore = CanaryScore;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const core_1 = __webpack_require__(6);
const asyncRequest_1 = __webpack_require__(15);
class LoadStatesBuilder {
    onRequesting(requesting) {
        this.requesting = requesting;
        return this;
    }
    onFulfilled(fulfilled) {
        this.fulfilled = fulfilled;
        return this;
    }
    onFailed(failed) {
        this.failed = failed;
        return this;
    }
    build() {
        return ({ state }) => {
            switch (state) {
                case asyncRequest_1.AsyncRequestState.Requesting:
                    return (this.requesting || (React.createElement("div", { className: "horizontal center middle spinner-container" },
                        React.createElement(core_1.Spinner, null))));
                case asyncRequest_1.AsyncRequestState.Fulfilled:
                    return this.fulfilled;
                case asyncRequest_1.AsyncRequestState.Failed:
                    return this.failed;
            }
        };
    }
}
exports.default = LoadStatesBuilder;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const disableable_1 = __webpack_require__(8);
const addNewButton_1 = __webpack_require__(59);
const deleteButton_1 = __webpack_require__(60);
__webpack_require__(121);
var ListAction;
(function (ListAction) {
    ListAction[ListAction["Add"] = 0] = "Add";
    ListAction[ListAction["Edit"] = 1] = "Edit";
    ListAction[ListAction["Delete"] = 2] = "Delete";
})(ListAction = exports.ListAction || (exports.ListAction = {}));
exports.updateListReducer = (defaultValue = '') => (state, action) => {
    const { index, value } = action.payload;
    switch (action.payload.type) {
        case ListAction.Add:
            return state.concat(defaultValue);
        case ListAction.Delete:
            return [...state.slice(0, index), ...state.slice(index + 1)];
        case ListAction.Edit:
            return [...state.slice(0, index), value, ...state.slice(index + 1)];
    }
};
exports.List = ({ list, valueKey, actionCreator }) => {
    const onChange = (i) => (event) => actionCreator({
        type: ListAction.Edit,
        index: i,
        value: event.target.value,
    });
    const deleteValue = (i) => () => actionCreator({
        type: ListAction.Delete,
        index: i,
    });
    const addValue = () => actionCreator({
        type: ListAction.Add,
    });
    return (React.createElement("section", null,
        list.map((value, i) => (React.createElement("div", { key: valueKey ? valueKey(value) : i, className: "horizontal form-group kayenta-list" },
            React.createElement(disableable_1.DisableableInput, { value: value, onChange: onChange(i), disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }),
            React.createElement(deleteButton_1.default, { onClick: deleteValue(i) })))),
        React.createElement(addNewButton_1.default, { onClick: addValue })));
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const reselect_1 = __webpack_require__(38);
const lodash_1 = __webpack_require__(2);
const selectors_1 = __webpack_require__(9);
const queryTypeSelectors_1 = __webpack_require__(218);
const filterTemplatesValidation_1 = __webpack_require__(179);
const IPrometheusCanaryMetricSetQueryConfig_1 = __webpack_require__(41);
exports.queryTypeToTransformFunctions = Object.assign({}, queryTypeSelectors_1.prometheusQueryTypeToTransformFunction);
exports.queryTypeSelector = reselect_1.createSelector((state) => state.selectedConfig.editingMetric, editingMetric => {
    return editingMetric && editingMetric.query.serviceType === 'prometheus'
        ? queryTypeSelectors_1.getPrometheusQueryType(editingMetric)
        : null;
});
exports.transformInlineTemplateForDisplay = reselect_1.createSelector(exports.queryTypeSelector, queryType => lodash_1.get(exports.queryTypeToTransformFunctions, [queryType, 'fromValue'], lodash_1.identity));
exports.transformInlineTemplateForSave = reselect_1.createSelector(exports.queryTypeSelector, queryType => lodash_1.get(exports.queryTypeToTransformFunctions, [queryType, 'toValue'], lodash_1.identity));
exports.selectedTemplateNameSelector = (state) => lodash_1.get(state, 'selectedConfig.editingMetric.query.customFilterTemplate');
exports.inlineTemplateValueSelector = reselect_1.createSelector((state) => lodash_1.get(state, 'selectedConfig.editingMetric.query.customInlineTemplate'), exports.transformInlineTemplateForDisplay, (template, transformer) => transformer(template));
exports.editingTemplateValidationSelector = reselect_1.createSelector(selectors_1.editingTemplateSelector, selectors_1.configTemplatesSelector, selectors_1.metricListSelector, selectors_1.editingMetricSelector, (editingTemplate, configTemplates, metricList, editingMetric) => filterTemplatesValidation_1.validateTemplate({
    editingTemplate,
    configTemplates,
    metricList,
    editingMetric,
}));
exports.isFilterTemplateValidSelector = reselect_1.createSelector(exports.editingTemplateValidationSelector, validation => lodash_1.isEmpty(Object.keys(validation.errors)));
exports.isInlineTemplateValidSelector = reselect_1.createSelector(exports.inlineTemplateValueSelector, value => !lodash_1.isEmpty(value));
const inlineTemplateQueryTypes = [IPrometheusCanaryMetricSetQueryConfig_1.PrometheusQueryType.PROMQL];
exports.useInlineTemplateEditorSelector = reselect_1.createSelector(exports.queryTypeSelector, queryType => inlineTemplateQueryTypes.includes(queryType));
exports.isTemplateValidSelector = reselect_1.createSelector(exports.useInlineTemplateEditorSelector, exports.isFilterTemplateValidSelector, exports.isInlineTemplateValidSelector, (isInlineTemplate, isFilterTemplateValid, isInlineTemplateValid) => isInlineTemplate ? isInlineTemplateValid : isFilterTemplateValid);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __webpack_require__(2);
const core_1 = __webpack_require__(6);
const canary_settings_1 = __webpack_require__(11);
exports.getCanaryRun = (configId, canaryExecutionId) => core_1.API.one('v2/canaries/canary')
    .one(configId)
    .one(canaryExecutionId)
    .withParams({ storageAccountName: canary_settings_1.CanarySettings.storageAccountName })
    .useCache()
    .get()
    .then((run) => {
    const { config } = run;
    config.id = configId;
    run.id = canaryExecutionId;
    run.result.judgeResult.results = lodash_1.sortBy(run.result.judgeResult.results, 'name');
    return run;
});
exports.startCanaryRun = (configId, executionRequest, params = {}) => {
    return core_1.API.one('v2/canaries/canary')
        .one(configId)
        .withParams(params)
        .post(executionRequest);
};
exports.getMetricSetPair = (metricSetPairListId, metricSetPairId) => core_1.API.one('v2/canaries/metricSetPairList')
    .one(metricSetPairListId)
    .withParams({ storageAccountName: canary_settings_1.CanarySettings.storageAccountName })
    .useCache()
    .get()
    .then((list) => list.find(pair => pair.id === metricSetPairId));
exports.listCanaryExecutions = (application, limit, statuses, storageAccountName) => core_1.API.one('v2/canaries')
    .one(application)
    .one('executions')
    .withParams({ limit, statuses, storageAccountName })
    .get();
exports.getHealthLabel = (health, result) => {
    const healthLC = (health || '').toLowerCase();
    const resultLC = (result || '').toLowerCase();
    return healthLC === 'unhealthy'
        ? 'unhealthy'
        : resultLC === 'success'
            ? 'healthy'
            : resultLC === 'failure'
                ? 'failing'
                : 'unknown';
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = require("moment-timezone");

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = require("react2angular");

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = require("reselect");

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const Creators = __webpack_require__(3);
const formRow_1 = __webpack_require__(14);
const disableable_1 = __webpack_require__(8);
var JudgeSelectRenderState;
(function (JudgeSelectRenderState) {
    JudgeSelectRenderState[JudgeSelectRenderState["Multiple"] = 0] = "Multiple";
    JudgeSelectRenderState[JudgeSelectRenderState["Single"] = 1] = "Single";
    JudgeSelectRenderState[JudgeSelectRenderState["None"] = 2] = "None";
})(JudgeSelectRenderState = exports.JudgeSelectRenderState || (exports.JudgeSelectRenderState = {}));
function JudgeSelect({ judgeOptions, selectedJudge, handleJudgeSelect, renderState, }) {
    switch (renderState) {
        case JudgeSelectRenderState.Multiple:
            return (React.createElement(formRow_1.default, null,
                React.createElement(disableable_1.DisableableReactSelect, { value: selectedJudge, options: judgeOptions, clearable: false, onChange: handleJudgeSelect, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] })));
        case JudgeSelectRenderState.Single:
            return (React.createElement(formRow_1.default, null,
                React.createElement(disableable_1.DisableableInput, { type: "text", value: selectedJudge, disabled: true, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] })));
        case JudgeSelectRenderState.None:
            return null;
    }
}
function mapStateToProps(state) {
    return {
        judgeOptions: (state.data.judges || []).map(judge => ({ value: judge.name, label: judge.name })),
        selectedJudge: state.selectedConfig.judge.judgeConfig.name,
        renderState: state.selectedConfig.judge.renderState,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        handleJudgeSelect: (option) => {
            dispatch(Creators.selectJudgeName({ judge: { name: option.value } }));
        },
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(JudgeSelect);


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const disableable_1 = __webpack_require__(8);
function RadioChoice({ value, label, name, current, action }) {
    return (React.createElement("label", { style: { fontWeight: 'normal', marginRight: '1em' } },
        React.createElement(disableable_1.DisableableInput, { type: "radio", name: name, value: value, onChange: action, checked: value === current, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }),
        ' ',
        label));
}
exports.default = RadioChoice;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PrometheusQueryType;
(function (PrometheusQueryType) {
    PrometheusQueryType["PROMQL"] = "PROMQL";
    PrometheusQueryType["DEFAULT"] = "DEFAULT";
})(PrometheusQueryType = exports.PrometheusQueryType || (exports.PrometheusQueryType = {}));


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = __webpack_require__(13);
const GREEN = 'var(--color-success)';
const RED = 'var(--color-danger)';
const GREY = 'var(--color-text-caption)';
const YELLOW = 'var(--color-warning)';
exports.mapMetricClassificationToColor = (classification) => ({
    [domain_1.MetricClassificationLabel.High]: RED,
    [domain_1.MetricClassificationLabel.Low]: RED,
    [domain_1.MetricClassificationLabel.Error]: YELLOW,
    [domain_1.MetricClassificationLabel.Nodata]: GREY,
    [domain_1.MetricClassificationLabel.Pass]: GREEN,
}[classification]);
exports.mapScoreClassificationToColor = (classification) => ({
    [domain_1.ScoreClassificationLabel.Fail]: RED,
    [domain_1.ScoreClassificationLabel.Error]: YELLOW,
    [domain_1.ScoreClassificationLabel.Marginal]: GREY,
    [domain_1.ScoreClassificationLabel.Nodata]: GREY,
    [domain_1.ScoreClassificationLabel.Pass]: GREEN,
}[classification]);
exports.mapGroupToColor = (group, scoreThresholds) => {
    if (typeof group.score !== 'number') {
        return YELLOW;
    }
    else if (group.score > scoreThresholds.pass) {
        return GREEN;
    }
    else if (group.score > scoreThresholds.marginal) {
        return GREY;
    }
    else {
        return RED;
    }
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
exports.default = ({ metric }) => {
    return (React.createElement("div", { className: "chart-header" },
        React.createElement("h6", { className: "heading-6 color-text-primary" },
            React.createElement("span", { className: "uppercase prefix" }, "metric name:"),
            React.createElement("span", null,
                "\u00A0",
                metric))));
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
const config_1 = __webpack_require__(19);
__webpack_require__(129);
exports.default = (props) => {
    const { onClickHandler, showGroup = { baseline: true, canary: true }, isClickable = false } = props;
    const baselineIconStyle = {
        backgroundColor: config_1.vizConfig.colors.baseline,
    };
    const canaryIconStyle = {
        backgroundColor: config_1.vizConfig.colors.canary,
    };
    const handleClick = (group) => (onClickHandler ? () => onClickHandler(group) : undefined);
    const legendItemClass = classNames('legend-item', { clickable: isClickable });
    const legendItemClassCanary = classNames(legendItemClass, { deselected: !showGroup.canary });
    const legendItemClassBaseline = classNames(legendItemClass, { deselected: !showGroup.baseline });
    return (React.createElement("div", { className: "chart-legend" },
        React.createElement("div", { className: legendItemClassBaseline, onClick: handleClick('baseline') },
            React.createElement("div", { className: "legend-icon", style: baselineIconStyle }),
            React.createElement("div", null, "Baseline")),
        React.createElement("div", { className: legendItemClassCanary, onClick: handleClick('canary') },
            React.createElement("div", { className: "legend-icon", style: canaryIconStyle }),
            React.createElement("div", null, "Canary"))));
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const config_1 = __webpack_require__(19);
exports.default = ({ group }) => {
    const iconStyle = {
        color: config_1.vizConfig.colors[group],
        paddingRight: 4,
    };
    return React.createElement("i", { className: "fas fa-circle", style: iconStyle });
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const utils = __webpack_require__(24);
exports.default = ({ millis }) => {
    const text = utils.dateTimeTickFormatter(millis).map((s, i) => (React.createElement("text", { textAnchor: 'middle', className: 'axis-label', key: i }, s)));
    return React.createElement("g", { className: 'axis-label' }, text);
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const ReactTooltip = __webpack_require__(302);
class Tooltip extends React.Component {
    componentDidUpdate(prevProps) {
        const target = this.tooltipTarget;
        if (prevProps.content && !this.props.content) {
            ReactTooltip.hide(target);
        }
        else if (this.props.content) {
            ReactTooltip.show(target);
        }
    }
    render() {
        const { x, y, content, id = 'tooltip' } = this.props;
        const tooltipTargetStyle = {
            left: x ? x : 0,
            top: y ? y : 0,
            height: 1,
            width: 1,
            opacity: 0,
            pointerEvents: 'none',
            position: 'absolute',
            zIndex: 10,
        };
        const containerStyle = {
            pointerEvents: 'none',
        };
        return (React.createElement("div", { style: containerStyle },
            React.createElement("div", { "data-tip": true, "data-for": id, style: tooltipTargetStyle, ref: el => (this.tooltipTarget = el) }),
            React.createElement(ReactTooltip, { id: id, type: "light", border: true }, content ? content : null)));
    }
}
exports.default = Tooltip;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const core_1 = __webpack_require__(6);
exports.Link = ({ targetState, stateParams, children }) => {
    const handleClick = () => core_1.ReactInjector.$state.go(targetState, stateParams);
    return (React.createElement("a", { className: "clickable", onClick: handleClick }, children));
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = require("class-autobind-decorator");

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = require("d3-array");

/***/ }),
/* 51 */
/***/ (function(module, exports) {

var path = 'kayenta/kayenta/stages/kayentaStage/kayentaStage.html';
var html = "<loading-spinner\n  size=\"'medium'\"\n  ng-if=\"kayentaCanaryStageCtrl.state.backingDataLoading\">\n</loading-spinner>\n\n<div ng-if=\"!kayentaCanaryStageCtrl.state.backingDataLoading\" class=\"form-horizontal canary-config-view\">\n  <div class=\"alert alert-warning\" ng-if=\"kayentaCanaryStageCtrl.state.lifetimeHoursUpdatedToDuration\">\n    <p>\n      <strong>Kayenta now supports analysis lifetimes shorter than 1 hour.</strong>\n    </p>\n    <p>\n      This canary stage has been updated to reflect the new lifetime support.\n      Click \"Save Changes\" to save the updated lifetime on the server.\n    </p>\n  </div>\n\n  <kayenta-stage-config-section title=\"Analysis Config\">\n\n    <stage-config-field label=\"Analysis Type\"\n                        help-key=\"pipeline.config.canary.analysisType\">\n      <kayenta-analysis-type\n        analysis-types=\"kayentaCanaryStageCtrl.state.analysisTypes\"\n        selected-type=\"kayentaCanaryStageCtrl.stage.analysisType\"\n        on-change=\"kayentaCanaryStageCtrl.handleAnalysisTypeChange\"\n      ></kayenta-analysis-type>\n    </stage-config-field>\n\n    <stage-config-field label=\"Config Name\">\n      <ui-select required\n                 ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.canaryConfigId\"\n                 on-select=\"kayentaCanaryStageCtrl.onCanaryConfigSelect()\"\n                 class=\"visible-sm-inline-block visible-md-inline-block visible-lg-inline-block\"\n                 style=\"width:300px\">\n        <ui-select-match>{{$select.selected.name}}</ui-select-match>\n        <ui-select-choices repeat=\"summary.id as summary in kayentaCanaryStageCtrl.canaryConfigSummaries | filter: $select.search\">\n          {{summary.name}}\n        </ui-select-choices>\n      </ui-select>\n    </stage-config-field>\n\n    <for-analysis-type stage=\"kayentaCanaryStageCtrl.stage\" types=\"realTime, realTimeAutomatic\">\n      <stage-config-field label=\"Lifetime\"\n                          field-columns=\"8\"\n                          help-key=\"pipeline.config.canary.lifetime\"\n                          ng-class=\"kayentaCanaryStageCtrl.getLifetimeClassnames()\"\n                          style=\"padding-left: 0; padding-right: 0;\">\n        <input type=\"number\"\n               min=\"0\"\n               ng-class=\"kayentaCanaryStageCtrl.getLifetimeInputClassnames()\"\n               ng-model=\"kayentaCanaryStageCtrl.state.lifetime.hours\"\n               class=\"form-control input-sm\"\n               style=\"display: inline-block; width: 11%\"\n               ng-change=\"kayentaCanaryStageCtrl.onLifetimeChange()\" />\n        <span class=\"form-control-static\">\n        hours\n        </span>\n          <input type=\"number\"\n                 min=\"0\"\n                 max=\"59\"\n                 ng-class=\"kayentaCanaryStageCtrl.getLifetimeInputClassnames()\"\n                 ng-model=\"kayentaCanaryStageCtrl.state.lifetime.minutes\"\n                 class=\"form-control input-sm\"\n                 style=\"display: inline-block; width: 11%; margin-left: 12px;\"\n                 ng-change=\"kayentaCanaryStageCtrl.onLifetimeChange()\" />\n          <span class=\"form-control-static\">\n          minutes\n        </span>\n      </stage-config-field>\n    </for-analysis-type>\n\n    <for-analysis-type stage=\"kayentaCanaryStageCtrl.stage\" types=\"retrospective\">\n      <stage-config-field label=\"Start Time\"\n                          help-key=\"pipeline.config.canary.startTimeIso\">\n        <input\n          required\n          class=\"form-control input-sm\"\n          ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.scopes[0].startTimeIso\"\n          type=\"text\"/>\n      </stage-config-field>\n\n      <stage-config-field label=\"End Time\"\n                          help-key=\"pipeline.config.canary.endTimeIso\">\n        <input\n          required\n          class=\"form-control input-sm\"\n          ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.scopes[0].endTimeIso\"\n          type=\"text\"/>\n      </stage-config-field>\n    </for-analysis-type>\n\n    <for-analysis-type stage=\"kayentaCanaryStageCtrl.stage\" types=\"realTime, realTimeAutomatic\">\n      <stage-config-field label=\"Delay\"\n                          help-key=\"pipeline.config.canary.delayBeforeAnalysis\"\n                          field-columns=\"5\">\n        <input type=\"text\"\n               ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.beginCanaryAnalysisAfterMins\"\n               class=\"form-control input-sm\"\n               style=\"display: inline-block; width: 19%\"/>\n        <span class=\"form-control-static\">\n          minutes before starting analysis\n        </span>\n      </stage-config-field>\n    </for-analysis-type>\n\n    <stage-config-field label=\"Interval\"\n                        help-key=\"pipeline.config.canary.canaryInterval\"\n                        field-columns=\"3\">\n      <input type=\"text\"\n             ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.canaryAnalysisIntervalMins\"\n             class=\"form-control input-sm\"\n             style=\"width: 33%; display: inline-block\"/>\n      <span class=\"form-control-static\"> minutes</span>\n    </stage-config-field>\n\n    <!--TODO(dpeach): add help text here-->\n    <stage-config-field label=\"Step\"\n                        field-columns=\"3\">\n      <input\n        class=\"form-control input-sm\"\n        ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.scopes[0].step\"\n        type=\"number\"\n        min=\"0\"\n        style=\"width: 33%; display: inline-block\"/>\n      <span class=\"form-control-static\"> seconds</span>\n    </stage-config-field>\n\n    <stage-config-field label=\"Baseline Offset\"\n                        help-key=\"pipeline.config.canary.baselineAnalysisOffset\"\n                        field-columns=\"3\">\n      <input\n        class=\"form-control input-sm\"\n        ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.baselineAnalysisOffsetInMins\"\n        type=\"text\"\n        min=\"0\"\n        style=\"width: 33%; display: inline-block\"/>\n      <span class=\"form-control-static\"> minutes</span>\n    </stage-config-field>\n\n    <stage-config-field label=\"Lookback Type\"\n                        help-key=\"pipeline.config.canary.lookback\"\n                        field-columns=\"3\">\n      <select class=\"form-control input-sm\"\n              ng-model=\"kayentaCanaryStageCtrl.state.useLookback\"\n              ng-options=\"(useLookback ? 'Sliding' : 'Growing') for useLookback in [false, true]\"\n              ng-change=\"kayentaCanaryStageCtrl.onUseLookbackChange()\">\n      </select>\n    </stage-config-field>\n\n    <stage-config-field ng-if=\"kayentaCanaryStageCtrl.state.useLookback\">\n      <div class=\"form-group\">\n        <div class=\"col-md-9\">\n          <p class=\"form-control-static\" ng-if=\"kayentaCanaryStageCtrl.isExpression(kayentaCanaryStageCtrl.stage.canaryConfig.lookbackMins)\">\n            Using a sliding lookback duration defined by an expression viewable in the pipeline JSON editor.\n          </p>\n          <span ng-if=\"!kayentaCanaryStageCtrl.isExpression(kayentaCanaryStageCtrl.stage.canaryConfig.lookbackMins)\">\n            with a look-back duration of\n            <input type=\"number\"\n                   min=\"1\"\n                   max=\"{{kayentaCanaryStageCtrl.state.lifetime.hours * 60}}\"\n                   required\n                   ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.lookbackMins\"\n                   class=\"form-control input-sm\" style=\"display: inline-block; margin: 0 5px; width: 15%\"/>\n            minutes\n          </span>\n        </div>\n      </div>\n      <div class=\"error-message col-md-12\"\n           ng-if=\"kayentaCanaryStageCtrl.stage.canaryConfig.lookbackMins > 0 && kayentaCanaryStageCtrl.stage.canaryConfig.lookbackMins < 30\">\n        <b>NOTE:</b> To provide enough data points for the canary analysis it is recommended to set the look-back\n        time to at least 30 minutes.\n      </div>\n    </stage-config-field>\n  </kayenta-stage-config-section>\n\n  <for-analysis-type stage=\"kayentaCanaryStageCtrl.stage\" types=\"realTimeAutomatic\">\n    <stage-config-field label=\"Delay Before Cleanup\"\n                        field-columns=\"8\"\n                        help-key=\"pipeline.config.canary.delayBeforeCleanup\"\n                        style=\"padding-left: 0; padding-right: 0;\">\n      <input type=\"number\"\n             min=\"0\"\n             ng-model=\"kayentaCanaryStageCtrl.state.delayBeforeCleanup.hours\"\n             class=\"form-control input-sm\"\n             style=\"display: inline-block; width: 11%;\"\n             ng-change=\"kayentaCanaryStageCtrl.onDelayBeforeCleanupChange()\" />\n      <span class=\"form-control-static\">\n          hours\n      </span>\n      <input type=\"number\"\n             min=\"0\"\n             max=\"59\"\n             ng-model=\"kayentaCanaryStageCtrl.state.delayBeforeCleanup.minutes\"\n             class=\"form-control input-sm\"\n             style=\"display: inline-block; width: 11%; margin-left: 12px\"\n             ng-change=\"kayentaCanaryStageCtrl.onDelayBeforeCleanupChange()\" />\n      <span class=\"form-control-static\">\n          minutes\n      </span>\n    </stage-config-field>\n  </for-analysis-type>\n\n  <for-analysis-type stage=\"kayentaCanaryStageCtrl.stage\" types=\"realTimeAutomatic\">\n    <kayenta-stage-config-section title=\"Baseline Version\">\n      <stage-config-field label=\"Provider\" ng-if=\"kayentaCanaryStageCtrl.providers.length > 1\n                                                && kayentaCanaryStageCtrl.stage.isNew\">\n        <provider-selector providers=\"kayentaCanaryStageCtrl.providers\"\n                           component=\"kayentaCanaryStageCtrl.stage.deployments.baseline\"\n                           on-change=\"kayentaCanaryStageCtrl.handleProviderChange()\"\n                           field=\"cloudProvider\"\n                           read-only=\"!kayentaCanaryStageCtrl.stage.isNew\"></provider-selector>\n      </stage-config-field>\n\n      <stage-config-field label=\"Account\">\n        <account-select-field\n          component=\"kayentaCanaryStageCtrl.stage.deployments.baseline\"\n          field=\"account\"\n          accounts=\"kayentaCanaryStageCtrl.accounts\"\n          on-change=\"kayentaCanaryStageCtrl.setClusterList()\"\n          provider=\"kayentaCanaryStageCtrl.stage.deployments.baseline.cloudProvider\"\n          required>\n        </account-select-field>\n      </stage-config-field>\n\n      <stage-config-field label=\"Cluster\">\n        <cluster-selector\n          ng-if=\"application.serverGroups.loaded\"\n          clusters=\"kayentaCanaryStageCtrl.clusterList\"\n          required=\"true\"\n          model=\"kayentaCanaryStageCtrl.stage.deployments.baseline.cluster\">\n        </cluster-selector>\n      </stage-config-field>\n    </kayenta-stage-config-section>\n  </for-analysis-type>\n\n  <kayenta-stage-config-section title=\"Baseline + Canary Pair\">\n    <section-header ng-if=\"kayentaCanaryStageCtrl.stage.analysisType === 'realTime'\">\n      <span\n        uib-tooltip=\"Click to populate with expressions for resolving control\n                     and experiment scopes from an upstream clone stage.\"\n        ng-click=\"kayentaCanaryStageCtrl.populateScopeWithExpressions()\"\n        class=\"fa fa-magic clickable\"></span>\n    </section-header>\n\n    <for-analysis-type stage=\"kayentaCanaryStageCtrl.stage\" types=\"realTime, retrospective\">\n      <stage-config-field label=\"Baseline\"\n                          help-key=\"pipeline.config.canary.baselineGroup\">\n        <input\n          ng-if=\"kayentaCanaryStageCtrl.state.atlasScopeType !== 'query'\"\n          class=\"form-control input-sm\"\n          ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.scopes[0].controlScope\"\n          required\n          type=\"text\"/>\n\n        <textarea\n          ng-if=\"kayentaCanaryStageCtrl.state.atlasScopeType === 'query'\"\n          class=\"form-control input-sm\"\n          ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.scopes[0].controlScope\"\n          required>\n        </textarea>\n      </stage-config-field>\n\n      <stage-config-field label=\"Baseline Location\"\n                          help-key=\"pipeline.config.canary.baselineLocation\">\n        <select\n          required\n          class=\"form-control input-sm\"\n          ng-if=\"kayentaCanaryStageCtrl.getLocationChoices().hasChoices\"\n          ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.scopes[0].controlLocation\"\n          ng-options=\"location for location in kayentaCanaryStageCtrl.getLocationChoices().combinedLocations.control\">\n        </select>\n        <input\n          class=\"form-control input-sm\"\n          ng-if=\"!kayentaCanaryStageCtrl.getLocationChoices().hasChoices\"\n          ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.scopes[0].controlLocation\"\n          required\n          type=\"text\"/>\n        <div class=\"pull-right\" ng-if=\"kayentaCanaryStageCtrl.getLocationChoices().hasChoices\">\n          <button\n            ng-click=\"kayentaCanaryStageCtrl.toggleAllLocations('control')\"\n            ng-if=\"!kayentaCanaryStageCtrl.state.showAllLocations.control && kayentaCanaryStageCtrl.getLocationChoices().locations.length > 0\"\n            class=\"link\">\n            Show all locations\n          </button>\n          <button\n            ng-click=\"kayentaCanaryStageCtrl.toggleAllLocations('control')\"\n            ng-if=\"kayentaCanaryStageCtrl.state.showAllLocations.control && kayentaCanaryStageCtrl.getLocationChoices().recommendedLocations.length > 0\"\n            class=\"link\">\n            Only show recommended locations\n          </button>\n        </div>\n      </stage-config-field>\n\n      <stage-config-field label=\"Canary\"\n                          help-key=\"pipeline.config.canary.canaryGroup\">\n        <input\n          ng-if=\"kayentaCanaryStageCtrl.state.atlasScopeType !== 'query'\"\n          class=\"form-control input-sm\"\n          ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.scopes[0].experimentScope\"\n          required\n          type=\"text\"/>\n\n        <textarea\n          ng-if=\"kayentaCanaryStageCtrl.state.atlasScopeType === 'query'\"\n          class=\"form-control input-sm\"\n          ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.scopes[0].experimentScope\"\n          required>\n        </textarea>\n      </stage-config-field>\n\n      <stage-config-field label=\"Canary Location\"\n                          help-key=\"pipeline.config.canary.canaryLocation\">\n        <select\n          required\n          class=\"form-control input-sm\"\n          ng-if=\"kayentaCanaryStageCtrl.getLocationChoices().hasChoices\"\n          ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.scopes[0].experimentLocation\"\n          ng-options=\"location for location in kayentaCanaryStageCtrl.getLocationChoices().combinedLocations.experiment\">\n        </select>\n        <input\n          class=\"form-control input-sm\"\n          ng-if=\"!kayentaCanaryStageCtrl.getLocationChoices().hasChoices\"\n          ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.scopes[0].experimentLocation\"\n          required\n          type=\"text\"/>\n        <div class=\"pull-right\" ng-if=\"kayentaCanaryStageCtrl.getLocationChoices().hasChoices\">\n          <button\n            ng-click=\"kayentaCanaryStageCtrl.toggleAllLocations('experiment')\"\n            ng-if=\"!kayentaCanaryStageCtrl.state.showAllLocations.experiment && kayentaCanaryStageCtrl.getLocationChoices().locations.length > 0\"\n            class=\"link\">\n            Show all locations\n          </button>\n          <button\n            ng-click=\"kayentaCanaryStageCtrl.toggleAllLocations('experiment')\"\n            ng-if=\"kayentaCanaryStageCtrl.state.showAllLocations.experiment && kayentaCanaryStageCtrl.getLocationChoices().recommendedLocations.length > 0\"\n            class=\"link\">\n            Only show recommended locations\n          </button>\n        </div>\n      </stage-config-field>\n    </for-analysis-type>\n\n    <for-analysis-type stage=\"kayentaCanaryStageCtrl.stage\" types=\"realTimeAutomatic\">\n      <div class=\"row\">\n        <div style=\"margin: 10px 10px 0 50px;\">\n          <div class=\"well well-sm\">\n            <table class=\"table\">\n              <thead>\n              <tr>\n                <th>Location</th>\n                <th>Baseline</th>\n                <th>Canary</th>\n                <th>Actions</th>\n              </tr>\n              </thead>\n              <tbody>\n              <tr ng-repeat=\"clusterPair in kayentaCanaryStageCtrl.stage.deployments.serverGroupPairs\">\n                <td>\n                  <account-tag account=\"clusterPair.control.account\"></account-tag>\n                  {{kayentaCanaryStageCtrl.getRegion(clusterPair.control)}}\n                </td>\n                <td>\n                  {{kayentaCanaryStageCtrl.getServerGroupName(clusterPair.control)}}\n                  <br/>\n                  <a href ng-click=\"kayentaCanaryStageCtrl.editServerGroup(clusterPair.control, $index, 'control')\">Edit</a>\n                </td>\n                <td>\n                  {{kayentaCanaryStageCtrl.getServerGroupName(clusterPair.experiment)}}\n                  <br/>\n                  <a href ng-click=\"kayentaCanaryStageCtrl.editServerGroup(clusterPair.experiment, $index, 'experiment')\">Edit</a>\n                </td>\n                <td>\n                  <a href ng-click=\"kayentaCanaryStageCtrl.deletePair($index);\">\n                    <span class=\"glyphicon glyphicon-trash\" uib-tooltip=\"Delete Pair\"></span>\n                  </a>\n                </td>\n              </tr>\n              </tbody>\n              <tfoot>\n              <tr ng-if=\"!kayentaCanaryStageCtrl.stage.deployments.serverGroupPairs.length\">\n                <td colspan=\"4\">\n                  <button class=\"btn btn-block btn-sm add-new\" ng-click=\"kayentaCanaryStageCtrl.addPair()\">\n                    <span class=\"glyphicon glyphicon-plus-sign\"></span> Add Baseline + Canary Pair\n                  </button>\n                </td>\n              </tr>\n              </tfoot>\n            </table>\n          </div>\n        </div>\n      </div>\n    </for-analysis-type>\n  </kayenta-stage-config-section>\n\n  <kayenta-stage-config-section title=\"Metric Scope\">\n\n    <for-analysis-type stage=\"kayentaCanaryStageCtrl.stage\" types=\"realTimeAutomatic\">\n      <stage-config-field label=\"Dataset\" ng-if=\"kayentaCanaryStageCtrl.metricStore === 'atlas'\">\n        <input\n          type=\"checkbox\"\n          ng-model=\"kayentaCanaryStageCtrl.state.useAtlasGlobalDataset\"\n          ng-click=\"kayentaCanaryStageCtrl.handleAtlasDatasetChange($event)\" />\n        Use Global Atlas Dataset\n      </stage-config-field>\n    </for-analysis-type>\n\n    <for-analysis-type stage=\"kayentaCanaryStageCtrl.stage\" types=\"realTime, retrospective\">\n      <stage-config-field label=\"Scope Type\" ng-if=\"kayentaCanaryStageCtrl.metricStore === 'atlas'\">\n        <select\n          required\n          class=\"form-control input-sm\" ng-model=\"kayentaCanaryStageCtrl.state.atlasScopeType\"\n          ng-options=\"(type === 'cluster' ? 'Cluster' : 'Query') for type in ['cluster', 'query']\"\n          ng-change=\"kayentaCanaryStageCtrl.onAtlasScopeTypeChange()\">\n        </select>\n      </stage-config-field>\n    </for-analysis-type>\n\n    <stage-config-field label=\"Extended Params\"\n                        help-key=\"pipeline.config.canary.extendedScopeParams\">\n      <map-editor\n        hidden-keys=\"['resourceType', 'dataset', 'type', 'environment']\"\n        on-change=\"kayentaCanaryStageCtrl.handleExtendedScopeParamsChange()\"\n        model=\"kayentaCanaryStageCtrl.stage.canaryConfig.scopes[0].extendedScopeParams\">\n      </map-editor>\n    </stage-config-field>\n  </kayenta-stage-config-section>\n\n  <kayenta-stage-config-section title=\"Scoring Thresholds\">\n    <kayenta-canary-scores on-change=\"kayentaCanaryStageCtrl.handleScoreThresholdChange\"\n                           successful-help-field-id=\"'pipeline.config.canary.passingScore'\"\n                           successful-label=\"'Pass'\"\n                           successful-score=\"kayentaCanaryStageCtrl.stage.canaryConfig.scoreThresholds.pass\"\n                           unhealthy-help-field-id=\"'pipeline.config.canary.marginalScore'\"\n                           unhealthy-label=\"'Marginal'\"\n                           unhealthy-score=\"kayentaCanaryStageCtrl.stage.canaryConfig.scoreThresholds.marginal\"></kayenta-canary-scores>\n  </kayenta-stage-config-section>\n\n  <kayenta-stage-config-section title=\"Advanced Settings\" ng-if=\"kayentaCanaryStageCtrl.state.showAdvancedSettings\">\n\n    <stage-config-field label=\"Notification Emails\" help-key=\"pipeline.config.canary.legacySiteLocalRecipients\" ng-if=\"kayentaCanaryStageCtrl.state.showLegacySiteLocalRecipients\">\n      <textarea\n        class=\"form-control input-sm\"\n        ng-model=\"kayentaCanaryStageCtrl.state.legacySiteLocalRecipients\"\n        ng-change=\"kayentaCanaryStageCtrl.handleLegacySiteLocalRecipientsChange()\"\n        placeholder=\"Email addresses separated by commas\"\n      >\n      </textarea>\n    </stage-config-field>\n\n    <stage-config-field label=\"Metrics Account\"\n                        help-key=\"pipeline.config.metricsAccount\"\n                        ng-if=\"kayentaCanaryStageCtrl.kayentaAccounts.get('METRICS_STORE').length > 1\">\n      <select\n        class=\"form-control input-sm\"\n        ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.metricsAccountName\"\n        ng-options=\"account.name as account.name for account in kayentaCanaryStageCtrl.kayentaAccounts.get('METRICS_STORE')\"\n      >\n      </select>\n    </stage-config-field>\n    <stage-config-field label=\"Storage Account\"\n                        help-key=\"pipeline.config.storageAccount\"\n                        ng-if=\"kayentaCanaryStageCtrl.kayentaAccounts.get('OBJECT_STORE').length > 1\">\n      <select\n        class=\"form-control input-sm\"\n        ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.storageAccountName\"\n        ng-options=\"account.name as account.name for account in kayentaCanaryStageCtrl.kayentaAccounts.get('OBJECT_STORE')\"\n      >\n      </select>\n    </stage-config-field>\n\n    <stage-config-field label=\"Scope Name\" ng-if=\"kayentaCanaryStageCtrl.scopeNames.length > 1\">\n      <ui-select required\n                 ng-model=\"kayentaCanaryStageCtrl.stage.canaryConfig.scopes[0].scopeName\"\n                 class=\"visible-sm-inline-block visible-md-inline-block visible-lg-inline-block\"\n                 style=\"width:300px\">\n        <ui-select-match>{{$select.selected}}</ui-select-match>\n        <ui-select-choices repeat=\"scopeName in kayentaCanaryStageCtrl.scopeNames | filter: $select.search\">\n          {{scopeName}}\n        </ui-select-choices>\n      </ui-select>\n    </stage-config-field>\n\n    <div class=\"alert alert-warning\" ng-if=\"kayentaCanaryStageCtrl.stage.canaryConfig.scopes.length > 1\">\n      <strong>Warning!</strong> This stage specifies more than one scope. Please edit the stage JSON to configure scopes beyond the first one.\n    </div>\n  </kayenta-stage-config-section>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 52 */
/***/ (function(module, exports) {

var path = 'kayenta/kayenta/stages/kayentaStage/kayentaStageExecutionDetails.html';
var html = "<div class=\"canary-details\" ng-controller=\"kayentaStageExecutionDetailsCtrl as kayentaStageDetailsCtrl\">\n  <execution-details-section-nav sections=\"configSections\"></execution-details-section-nav>\n  <div class=\"step-section-details\" ng-if=\"detailsSection === 'canarySummary'\">\n    <div class=\"row\">\n      <div class=\"col-md-2 canary-summary\">\n        <div class=\"score score-large\">\n          <kayenta-canary-score score=\"stage.context.overallScore\"\n                                health=\"stage.context.overallHealth\"\n                                result=\"stage.context.overallResult\"></kayenta-canary-score>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-md-12 horizontal\">\n        <canary-run-summaries class=\"horizontal flex-1\"\n                              canary-runs=\"kayentaStageDetailsCtrl.canaryRuns\"\n                              first-scope-name=\"kayentaStageDetailsCtrl.firstScopeName\"></canary-run-summaries>\n      </div>\n    </div>\n\n    <stage-failure-message stage=\"stage\"\n                           is-failed=\"stage.exceptions.length > 0\"\n                           messages=\"stage.exceptions\"></stage-failure-message>\n  </div>\n\n  <div class=\"step-section-details\" ng-if=\"detailsSection === 'canaryConfig'\">\n    <div class=\"row\">\n      <div class=\"col-md-12 canary-config-section\">\n        <h5>Scope</h5>\n        <div class=\"horizontal-rule\"></div>\n        <div class=\"row\">\n          <div class=\"col-md-4 sm-label-right compact\">Baseline</div>\n          <div class=\"col-md-8\" style=\"word-wrap: break-word\">{{ kayentaStageDetailsCtrl.resolvedControl }}</div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-md-4 sm-label-right compact\">Canary</div>\n          <div class=\"col-md-8\" style=\"word-wrap: break-word\">{{ kayentaStageDetailsCtrl.resolvedExperiment }}</div>\n        </div>\n        <div class=\"row\" ng-if=\"stage.context.canaryConfig.scopes[0].step\">\n          <div class=\"col-md-4 sm-label-right compact\">Step</div>\n          <div class=\"col-md-8\" style=\"word-wrap: break-word\">{{stage.context.canaryConfig.scopes[0].step}}</div>\n        </div>\n        <div class=\"row\" ng-if=\"stage.context.canaryConfig.scopes[0].startTimeIso\">\n          <div class=\"col-md-4 sm-label-right compact\">Start Time</div>\n          <div class=\"col-md-8\" style=\"word-wrap: break-word\">{{ stage.context.canaryConfig.scopes[0].startTimeIso | dateToMillis | timestamp}}</div>\n        </div>\n        <div class=\"row\" ng-if=\"stage.context.canaryConfig.scopes[0].endTimeIso\">\n          <div class=\"col-md-4 sm-label-right compact\">End Time</div>\n          <div class=\"col-md-8\" style=\"word-wrap: break-word\">{{stage.context.canaryConfig.scopes[0].endTimeIso | dateToMillis | timestamp}}</div>\n        </div>\n      </div>\n      <div class=\"col-md-12 canary-config-section\">\n        <h5>Analysis Config</h5>\n        <div class=\"horizontal-rule\"></div>\n        <div class=\"row\">\n          <div class=\"col-md-4 sm-label-right compact\">Config Name</div>\n          <div class=\"col-md-8\" style=\"word-wrap: break-word\">\n            <a href ui-sref=\"home.applications.application.canary.canaryConfig.configDetail({id: stage.context.canaryConfig.canaryConfigId})\">\n              {{kayentaStageDetailsCtrl.canaryConfigName}}\n            </a>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-md-4 sm-label-right compact\">Analysis Type</div>\n          <div class=\"col-md-8\" style=\"word-wrap: break-word\">{{stage.context.analysisType | robotToHuman}}</div>\n        </div>\n        <div class=\"row\" ng-if=\"stage.context.canaryConfig.lifetimeHours\">\n          <div class=\"col-md-4 sm-label-right compact\">Duration</div>\n          <div class=\"col-md-6\">{{stage.context.canaryConfig.lifetimeHours}} hours</div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-md-4 sm-label-right compact\">Pass</div>\n          <div class=\"col-md-6\">{{stage.context.canaryConfig.scoreThresholds.pass}}</div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-md-4 sm-label-right compact\">Marginal</div>\n          <div class=\"col-md-6\">{{stage.context.canaryConfig.scoreThresholds.marginal}}</div>\n        </div>\n        <div class=\"row\" ng-if=\"stage.context.canaryConfig.beginCanaryAnalysisAfterMins\">\n          <div class=\"col-md-4 sm-label-right compact\">Warmup Period</div>\n          <div class=\"col-md-6\">{{stage.context.canaryConfig.beginCanaryAnalysisAfterMins}} minutes</div>\n        </div>\n        <div class=\"row\" ng-if=\"stage.context.canaryConfig.canaryAnalysisIntervalMins\">\n          <div class=\"col-md-4 sm-label-right compact\">Interval</div>\n          <div class=\"col-md-6\">{{stage.context.canaryConfig.canaryAnalysisIntervalMins}} minutes</div>\n        </div>\n        <div class=\"row\" ng-if=\"stage.context.canaryConfig.baselineAnalysisOffsetInMins\">\n          <div class=\"col-md-4 sm-label-right compact\">Baseline Offset</div>\n          <div class=\"col-md-6\">{{stage.context.canaryConfig.baselineAnalysisOffsetInMins}} minutes</div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"step-section-details\" ng-if=\"detailsSection === 'taskStatus'\">\n    <div class=\"row\">\n      <execution-step-details item=\"stage\"></execution-step-details>\n    </div>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const redux_1 = __webpack_require__(21);
const redux_logger_1 = __webpack_require__(303);
const react_1 = __webpack_require__(20);
const react_redux_1 = __webpack_require__(1);
const reducers_1 = __webpack_require__(233);
const middleware_1 = __webpack_require__(227);
const actions_1 = __webpack_require__(10);
const styleguide_1 = __webpack_require__(22);
const canary_settings_1 = __webpack_require__(11);
const middleware = [middleware_1.epicMiddleware, middleware_1.actionInterceptingMiddleware, middleware_1.asyncDispatchMiddleware];
exports.canaryStore = redux_1.createStore(reducers_1.rootReducer, redux_1.applyMiddleware(...(canary_settings_1.CanarySettings.reduxLogger ? [...middleware, redux_logger_1.logger] : middleware)));
class Canary extends React.Component {
    constructor(props) {
        super(props);
        this.store = exports.canaryStore;
        this.initializeAppState(props.app);
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.app.name !== nextProps.app.name) {
            this.initializeAppState(nextProps.app);
        }
    }
    initializeAppState(app) {
        this.store.dispatch({
            type: actions_1.INITIALIZE,
            state: {
                data: {
                    application: app,
                    configSummaries: app.getDataSource('canaryConfigs').data,
                    judges: app.getDataSource('canaryJudges').data,
                },
            },
        });
    }
    render() {
        const noWrap = { wrap: false };
        return (React.createElement(styleguide_1.default, { className: "kayenta-root vertical" },
            React.createElement(react_redux_1.Provider, { store: this.store },
                React.createElement("div", { className: "vertical flex-1" },
                    React.createElement(react_1.UIView, Object.assign({}, noWrap, { name: "canary" }))))));
    }
}
exports.default = Canary;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __webpack_require__(12);
const react2angular_1 = __webpack_require__(37);
const canaryScores_1 = __webpack_require__(55);
exports.CANARY_SCORES_CONFIG_COMPONENT = 'spinnaker.kayenta.canaryScores.component';
angular_1.module(exports.CANARY_SCORES_CONFIG_COMPONENT, []).component('kayentaCanaryScores', react2angular_1.react2angular(canaryScores_1.CanaryScores, [
    'onChange',
    'successfulHelpFieldId',
    'successfulLabel',
    'successfulScore',
    'unhealthyHelpFieldId',
    'unhealthyLabel',
    'unhealthyScore',
]));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const lodash_1 = __webpack_require__(2);
const class_autobind_decorator_1 = __webpack_require__(49);
const classNames = __webpack_require__(7);
const core_1 = __webpack_require__(6);
__webpack_require__(113);
let CanaryScores = class CanaryScores extends React.Component {
    render() {
        const hasExpressions = this.isExpression(this.props.unhealthyScore) || this.isExpression(this.props.successfulScore);
        let successful;
        let unhealthy;
        if (!hasExpressions) {
            successful = parseInt(this.props.successfulScore, 10);
            unhealthy = parseInt(this.props.unhealthyScore, 10);
        }
        const invalid = !(successful && unhealthy);
        return (React.createElement("div", null,
            hasExpressions && (React.createElement("div", { className: "form-group" },
                React.createElement("div", { className: "col-md-2 col-md-offset-1 sm-label-right" },
                    React.createElement("label", null, "Canary Scores")),
                React.createElement("div", { className: "col-md-9 form-control-static" }, "Expressions are currently being used for canary scores."))),
            !hasExpressions && (React.createElement("div", { className: "canary-score" },
                React.createElement("div", { className: "form-group" },
                    React.createElement("div", { className: "col-md-2 col-md-offset-1 sm-label-right" },
                        React.createElement("label", null, this.props.unhealthyLabel || 'Unhealthy Score'),
                        React.createElement(core_1.HelpField, { id: this.props.unhealthyHelpFieldId || 'pipeline.config.canary.unhealthyScore' })),
                    React.createElement("div", { className: "col-md-2" },
                        React.createElement("input", { type: "number", required: true, disabled: this.props.disabled, value: Number.isNaN(unhealthy) ? '' : unhealthy, onChange: this.handleUnhealthyChange, className: classNames('form-control', 'input-sm', {
                                'ng-invalid': !this.isUnhealthyScoreValid(successful, unhealthy),
                                'ng-invalid-validate-min': !this.isUnhealthyScoreValid(successful, unhealthy),
                            }) })),
                    React.createElement("div", { className: "col-md-2 col-md-offset-1 sm-label-right" },
                        React.createElement("label", null, this.props.successfulLabel || 'Successful Score'),
                        React.createElement(core_1.HelpField, { id: this.props.successfulHelpFieldId || 'pipeline.config.canary.successfulScore' })),
                    React.createElement("div", { className: "col-md-2" },
                        React.createElement("input", { type: "number", required: true, disabled: this.props.disabled, value: Number.isNaN(successful) ? '' : successful, onChange: this.handleSuccessfulChange, className: classNames('form-control', 'input-sm', {
                                'ng-invalid': !this.isSuccessfulScoreValid(successful, unhealthy),
                                'ng-invalid-validate-max': !this.isSuccessfulScoreValid(successful, unhealthy),
                            }) }))),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-offset-1 col-md-10" },
                        React.createElement("div", { className: "progress" },
                            React.createElement("div", { className: "progress-bar progress-bar-danger", style: { width: `${invalid ? 0 : unhealthy}%` } }),
                            React.createElement("div", { className: "progress-bar progress-bar-warning", style: { width: `${invalid ? 0 : 100 - (unhealthy + (100 - successful))}%` } }),
                            React.createElement("div", { className: "progress-bar progress-bar-success", style: { width: `${invalid ? 0 : 100 - successful}%` } }),
                            React.createElement("div", { className: "progress-bar progress-bar-warning", style: { width: `${invalid ? 100 : 0}%` } }))))))));
    }
    handleSuccessfulChange(event) {
        this.props.onChange({
            successfulScore: event.target.value,
            unhealthyScore: this.props.unhealthyScore,
        });
    }
    handleUnhealthyChange(event) {
        this.props.onChange({
            successfulScore: this.props.successfulScore,
            unhealthyScore: event.target.value,
        });
    }
    isSuccessfulScoreValid(successfulScore, unhealthyScore) {
        return successfulScore && (!unhealthyScore || successfulScore > unhealthyScore) && successfulScore <= 100;
    }
    isUnhealthyScoreValid(successfulScore, unhealthyScore) {
        return unhealthyScore && (!successfulScore || unhealthyScore < successfulScore) && unhealthyScore >= 0;
    }
    isExpression(scoreValue) {
        return lodash_1.isString(scoreValue) && scoreValue.includes('${');
    }
};
CanaryScores = __decorate([
    class_autobind_decorator_1.default
], CanaryScores);
exports.CanaryScores = CanaryScores;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ScoreClassificationLabel;
(function (ScoreClassificationLabel) {
    ScoreClassificationLabel["Pass"] = "Pass";
    ScoreClassificationLabel["Marginal"] = "Marginal";
    ScoreClassificationLabel["Fail"] = "Fail";
    ScoreClassificationLabel["Nodata"] = "Nodata";
    ScoreClassificationLabel["Error"] = "Error";
})(ScoreClassificationLabel = exports.ScoreClassificationLabel || (exports.ScoreClassificationLabel = {}));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const react_bootstrap_1 = __webpack_require__(29);
const lodash_1 = __webpack_require__(2);
const core_1 = __webpack_require__(6);
const Creators = __webpack_require__(3);
const canaryConfig_service_1 = __webpack_require__(18);
const styleguide_1 = __webpack_require__(22);
const tabs_1 = __webpack_require__(66);
const disableable_1 = __webpack_require__(8);
__webpack_require__(114);
__webpack_require__(292);
__webpack_require__(291);
var ConfigJsonModalTabState;
(function (ConfigJsonModalTabState) {
    ConfigJsonModalTabState[ConfigJsonModalTabState["Edit"] = 0] = "Edit";
    ConfigJsonModalTabState[ConfigJsonModalTabState["Diff"] = 1] = "Diff";
})(ConfigJsonModalTabState = exports.ConfigJsonModalTabState || (exports.ConfigJsonModalTabState = {}));
function ConfigJsonModal({ show, disabled, configJson, id, deserializationError, closeModal, setConfigJson, updateConfig, setTabState, tabState, diff, }) {
    return (React.createElement(react_bootstrap_1.Modal, { show: show, onHide: () => null, bsSize: "large" },
        React.createElement(styleguide_1.default, null,
            React.createElement(react_bootstrap_1.Modal.Header, null,
                React.createElement(react_bootstrap_1.Modal.Title, null, "JSON")),
            React.createElement(react_bootstrap_1.Modal.Body, null,
                React.createElement("section", null,
                    React.createElement(tabs_1.Tabs, null,
                        React.createElement(tabs_1.Tab, { selected: tabState === ConfigJsonModalTabState.Edit },
                            React.createElement("a", { onClick: setTabState(ConfigJsonModalTabState.Edit) }, "Edit")),
                        React.createElement(tabs_1.Tab, { selected: tabState === ConfigJsonModalTabState.Diff },
                            React.createElement("a", { onClick: setTabState(ConfigJsonModalTabState.Diff) }, "Diff")))),
                React.createElement("section", { className: "kayenta-config-json" },
                    tabState === ConfigJsonModalTabState.Edit && (React.createElement(core_1.JsonEditor, { value: configJson, debounceChangePeriod: 500, onChange: setConfigJson, readOnly: disabled })),
                    tabState === ConfigJsonModalTabState.Diff &&
                        !deserializationError && (React.createElement("div", { className: "modal-show-history" },
                        React.createElement("div", { className: "show-history" },
                            React.createElement(core_1.DiffView, { diff: diff })))),
                    !!deserializationError && (React.createElement("div", { className: "horizontal row center" },
                        React.createElement("span", { className: "error-message" },
                            "Error: ",
                            deserializationError))))),
            React.createElement(react_bootstrap_1.Modal.Footer, null,
                React.createElement("ul", { className: "list-inline pull-right" },
                    React.createElement("li", null,
                        React.createElement("button", { className: "passive", onClick: closeModal }, "Close")),
                    React.createElement("li", null,
                        React.createElement("button", { className: "primary", "data-id": id, "data-serialized": configJson, onClick: updateConfig, disabled: !!deserializationError || disabled }, "Update")))))));
}
function mapDispatchToProps(dispatch) {
    return {
        closeModal: () => dispatch(Creators.closeConfigJsonModal()),
        setTabState: (state) => () => dispatch(Creators.setConfigJsonModalTabState({ state })),
        setConfigJson: (json) => dispatch(Creators.setConfigJson({ json })),
        updateConfig: (event) => {
            dispatch(Creators.selectConfig({
                config: Object.assign({ id: event.target.dataset.id }, JSON.parse(event.target.dataset.serialized)),
            }));
        },
    };
}
function mapStateToProps(state) {
    const id = lodash_1.get(state, 'selectedConfig.config.id');
    const persistedConfig = core_1.JsonUtils.makeSortedStringFromObject(lodash_1.omit(state.data.configs.find(c => c.id === id) || {}, 'id'));
    const configJson = state.selectedConfig.json.configJson ||
        core_1.JsonUtils.makeSortedStringFromObject(lodash_1.omit(canaryConfig_service_1.mapStateToConfig(state) || {}, 'id'));
    const disabled = lodash_1.get(state, disableable_1.DISABLE_EDIT_CONFIG, false);
    return {
        configJson,
        id,
        disabled,
        show: state.app.configJsonModalOpen,
        deserializationError: state.selectedConfig.json.error,
        tabState: state.app.configJsonModalTabState,
        diff: state.selectedConfig.json.error ? null : core_1.JsonUtils.diff(persistedConfig, configJson, true),
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ConfigJsonModal);


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const classNames = __webpack_require__(7);
const core_1 = __webpack_require__(6);
const Creators = __webpack_require__(3);
const tabs_1 = __webpack_require__(66);
const disableable_1 = __webpack_require__(8);
const groupName_1 = __webpack_require__(181);
exports.ALL = 'all';
function GroupTabs({ groupList, selectedGroup, selectGroup, addGroup, editing, editGroupBegin, disableConfigEdit, }) {
    const GroupTab = ({ group, editable = false }) => {
        const selected = selectedGroup === group;
        return (React.createElement(tabs_1.Tab, { selected: selected },
            React.createElement(groupName_1.default, { group: group, editing: selected && editing, onClick: selectGroup, defaultGroup: exports.ALL }),
            selected &&
                editable &&
                !editing && (React.createElement("i", { "data-group": group, onClick: disableConfigEdit ? core_1.noop : editGroupBegin, className: classNames('fas', 'fa-pencil-alt', { disabled: disableConfigEdit }) }))));
    };
    return (React.createElement("section", { className: "group-tabs" },
        React.createElement(tabs_1.Tabs, { style: { marginBottom: '0' } },
            React.createElement(GroupTab, { group: "" }),
            groupList.map(group => (React.createElement(GroupTab, { key: group, group: group, editable: true }))),
            React.createElement(disableable_1.DisableableButton, { className: "passive float-right", onClick: addGroup, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }, "Add Group"))));
}
function mapStateToProps(state) {
    return {
        groupList: state.selectedConfig.group.list,
        selectedGroup: state.selectedConfig.group.selected,
        editing: !!state.selectedConfig.group.edit || state.selectedConfig.group.edit === '',
        disableConfigEdit: state.app.disableConfigEdit,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        selectGroup: (event) => {
            dispatch(Creators.selectGroup({ name: event.target.dataset.group }));
            event.preventDefault();
            event.stopPropagation();
        },
        addGroup: (event) => {
            dispatch(Creators.addGroup());
            event.preventDefault();
            event.stopPropagation();
        },
        editGroupBegin: (event) => {
            dispatch(Creators.editGroupBegin({ group: event.target.dataset.group }));
        },
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(GroupTabs);


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
const disableable_1 = __webpack_require__(8);
exports.default = ({ onClick, className, label }) => (React.createElement(disableable_1.DisableableButton, { onClick: onClick, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG], className: classNames('add-new', 'btn', 'btn-block', 'btn-sm', className) },
    React.createElement("span", { className: "glyphicon glyphicon-plus-sign" }),
    " ",
    label || 'Add new'));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
exports.default = ({ onClick }) => (React.createElement("a", { className: "clickable", onClick: onClick },
    React.createElement("span", { className: "glyphicon glyphicon-trash" })));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
function FormList({ children }) {
    return (React.createElement("ul", { className: "list-group" }, React.Children.map(children, c => c && (React.createElement("li", { className: "list-unstyled" },
        React.createElement("form", { role: "form", className: "form-horizontal container-fluid" },
            React.createElement("div", { className: "col-md-12" }, c)))))));
}
exports.default = FormList;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const classNames = __webpack_require__(7);
const React = __webpack_require__(0);
const addNewButton_1 = __webpack_require__(59);
const deleteButton_1 = __webpack_require__(60);
__webpack_require__(120);
const disableable_1 = __webpack_require__(8);
var KeyValueListAction;
(function (KeyValueListAction) {
    KeyValueListAction[KeyValueListAction["ADD"] = 0] = "ADD";
    KeyValueListAction[KeyValueListAction["DELETE"] = 1] = "DELETE";
    KeyValueListAction[KeyValueListAction["KEY_EDIT"] = 2] = "KEY_EDIT";
    KeyValueListAction[KeyValueListAction["VALUE_EDIT"] = 3] = "VALUE_EDIT";
})(KeyValueListAction = exports.KeyValueListAction || (exports.KeyValueListAction = {}));
exports.updateListReducer = (defaultValue = { key: '', value: '' }) => (state, action) => {
    const { index, value, type } = action.payload;
    switch (type) {
        case KeyValueListAction.ADD:
            return state.concat(defaultValue);
        case KeyValueListAction.DELETE:
            return [...state.slice(0, index), ...state.slice(index + 1)];
        case KeyValueListAction.KEY_EDIT:
            return [...state.slice(0, index), Object.assign({}, state[index], { key: value }), ...state.slice(index + 1)];
        case KeyValueListAction.VALUE_EDIT:
            return [...state.slice(0, index), Object.assign({}, state[index], { value }), ...state.slice(index + 1)];
    }
};
function KeyValueList({ list, className, actionCreator }) {
    const onKeyChange = (i) => (event) => actionCreator({
        type: KeyValueListAction.KEY_EDIT,
        index: i,
        value: event.target.value,
    });
    const onValueChange = (i) => (event) => actionCreator({
        type: KeyValueListAction.VALUE_EDIT,
        index: i,
        value: event.target.value,
    });
    const deleteValue = (i) => () => actionCreator({
        type: KeyValueListAction.DELETE,
        index: i,
    });
    const addValue = () => actionCreator({
        type: KeyValueListAction.ADD,
    });
    return (React.createElement("section", { className: classNames('kv-pair-list', className) },
        list.map((kvPair, index) => {
            const { key, value } = kvPair;
            return (React.createElement("div", { key: index, className: "kv-pair-item" },
                React.createElement("div", { className: "kv-pair-item-section" },
                    React.createElement("div", { className: "kv-pair-item-section-label-wrapper" },
                        React.createElement("div", { className: "kv-pair-item-section-label" }, "Key")),
                    React.createElement("div", { className: "kv-pair-item-section-input" },
                        React.createElement(disableable_1.DisableableInput, { value: key, onChange: onKeyChange(index), disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }))),
                React.createElement("div", { className: "kv-pair-item-section" },
                    React.createElement("div", { className: "kv-pair-item-section-label-wrapper" },
                        React.createElement("div", { className: "kv-pair-item-section-label" }, "Value")),
                    React.createElement("div", { className: "kv-pair-item-section-input" },
                        React.createElement(disableable_1.DisableableInput, { value: value, onChange: onValueChange(index), disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }))),
                React.createElement("div", { className: "kv-pair-item-section" },
                    React.createElement(deleteButton_1.default, { onClick: deleteValue(index) }))));
        }),
        React.createElement(addNewButton_1.default, { onClick: addValue })));
}
exports.default = KeyValueList;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
function ListDetail({ className, list, listWidth = 2, detail, detailWidth = 10, listClass, detailClass, }) {
    return (React.createElement("div", { className: classNames('list-detail', 'horizontal', className) },
        React.createElement("div", { className: classNames(`col-md-${listWidth}`, listClass) }, list),
        React.createElement("div", { className: classNames(`col-md-${detailWidth}`, detailClass) }, detail)));
}
exports.default = ListDetail;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
exports.NativeTableHeader = ({ rows = [], columns, className }) => {
    return (React.createElement("thead", { className: className },
        React.createElement("tr", null, columns.map(({ label, labelClassName, hide }, i) => (React.createElement("th", { key: label || i, className: "native-table-header" }, (!hide || !rows.every(hide)) && (React.createElement("h6", { className: classNames('heading-6', 'uppercase', 'color-text-primary', labelClassName) }, label))))))));
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
exports.TableHeader = ({ columns, className }) => {
    return (React.createElement("div", { className: classNames('horizontal', className) }, columns.map((c, i) => (React.createElement("div", { key: c.label || i, className: `flex-${c.width}` }, !c.hide && (React.createElement("h6", { className: classNames('heading-6', 'uppercase', 'color-text-primary', c.labelClassName) }, c.label)))))));
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
function Tabs({ children, className, style }) {
    return (React.createElement("ul", { className: classNames('tabs-basic', 'list-unstyled', className), style: style }, children));
}
exports.Tabs = Tabs;
function Tab({ selected = false, children, className }) {
    return React.createElement("li", { className: classNames(selected ? 'selected' : '', className) }, children);
}
exports.Tab = Tab;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const d3_scale_1 = __webpack_require__(28);
const semiotic_1 = __webpack_require__(30);
const utils = __webpack_require__(24);
const customAxisTickLabel_1 = __webpack_require__(46);
__webpack_require__(133);
const config_1 = __webpack_require__(19);
class SecondaryTSXAxis extends React.Component {
    render() {
        const { margin, width, millisSet, axisLabel, bottomOffset } = this.props;
        const { axisTickLineHeight, axisTickLabelHeight, axisLabelHeight } = config_1.vizConfig.timeSeries;
        const extent = [millisSet[0], millisSet[millisSet.length - 1]].map((ms) => new Date(ms));
        const totalAxisHeight = axisTickLabelHeight + axisTickLineHeight + (axisLabel ? axisLabelHeight : 0);
        const netWidth = width - margin.left - margin.right;
        const range = [0, netWidth];
        const containerStyle = {
            bottom: bottomOffset,
        };
        const svgWrapperStyle = {
            transform: `translateX(${margin.left}px)`,
        };
        return (React.createElement("svg", { className: "axis secondary-ts-x-axis", width: width, height: totalAxisHeight, style: containerStyle },
            React.createElement("g", { className: "wrapper", style: svgWrapperStyle },
                React.createElement(semiotic_1.Axis, { className: "x axis bottom canary-dual-axis", size: [netWidth, axisTickLineHeight], scale: d3_scale_1.scaleUtc()
                        .domain(extent)
                        .range(range), orient: "bottom", label: "Canary", tickValues: utils.calculateDateTimeTicks(millisSet), tickFormat: (d) => React.createElement(customAxisTickLabel_1.default, { millis: d }) }))));
    }
}
exports.default = SecondaryTSXAxis;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
const ARROW_CLASS = 'arrow-down';
exports.default = ({ arrowColor, className }) => (React.createElement("div", { className: classNames(ARROW_CLASS, className), style: { borderTopColor: arrowColor } }));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
const colors_1 = __webpack_require__(42);
const buildStyle = (classification) => ({
    backgroundColor: colors_1.mapMetricClassificationToColor(classification),
});
const TEXT_COLOR = 'var(--color-text-on-dark)';
exports.default = ({ classification, className }) => (React.createElement("div", { className: classNames('pill', 'metric-result-classification', className), style: buildStyle(classification) },
    React.createElement("span", { style: { color: TEXT_COLOR } }, classification)));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const formatDeviationAsPercentage = (ratio) => {
    if (typeof ratio !== 'number') {
        return 'N/A';
    }
    else if (ratio === 1) {
        return '0%';
    }
    else if (ratio < 1) {
        return ((ratio - 1) * 100).toFixed(1) + '%';
    }
    else {
        return '+' + ((ratio - 1) * 100).toFixed(1) + '%';
    }
};
exports.default = ({ ratio, className }) => ratio && (React.createElement("span", { className: className, style: { color: 'var(--color-text-caption' } }, formatDeviationAsPercentage(ratio)));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const lodash_1 = __webpack_require__(2);
const ScoreClassificationLabel_1 = __webpack_require__(56);
const canaryScore_1 = __webpack_require__(31);
const mapKayentaToACA = (score) => {
    if (score.classification === ScoreClassificationLabel_1.ScoreClassificationLabel.Pass) {
        return { health: null, result: 'success' };
    }
    else if (score.classification === ScoreClassificationLabel_1.ScoreClassificationLabel.Fail) {
        return { health: 'unhealthy', result: null };
    }
    else {
        return { health: null, result: null };
    }
};
exports.default = ({ score, showClassification, inverse }) => (React.createElement(canaryScore_1.CanaryScore, { className: "score-report", score: lodash_1.round(score.score, 2), result: mapKayentaToACA(score).result, health: mapKayentaToACA(score).health, classification: showClassification ? score.classification : null, inverse: inverse }));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDelegateService = () => {
    class DelegateService {
        constructor() {
            this.delegates = [];
        }
        register(delegate) {
            this.delegates.push(delegate);
        }
        getDelegate(name) {
            return this.delegates.find(d => d.name === name);
        }
    }
    return new DelegateService();
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.KAYENTA_CANARY = 'kayentaCanary';
exports.RUN_CANARY = 'runCanary';
exports.WAIT = 'wait';
exports.CREATE_SERVER_GROUP = 'createServerGroup';
exports.DEPLOY_CANARY_SERVER_GROUPS = 'deployCanaryServerGroups';


/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = require("d3-shape");

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var canary_module_1 = __webpack_require__(148);
exports.KAYENTA_MODULE = canary_module_1.KAYENTA_MODULE;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".kayenta {\n  width: 100%;\n}\n.kayenta button[disabled] {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n.kayenta.kayenta-root {\n  overflow: hidden;\n}\n.kayenta .spinner {\n  position: inherit;\n}\n.kayenta .list-detail > .col-md-2,\n.kayenta .list-detail .col-md-10 {\n  padding-left: 0;\n  padding-right: 0;\n}\n.kayenta .config-list ul {\n  max-height: calc(70vh - 44px);\n  overflow: auto;\n}\n@media screen and (max-height: 1000px) {\n  .kayenta .config-list ul {\n    max-height: 55vh;\n  }\n}\n@media screen and (max-height: 700px) {\n  .kayenta .config-list ul {\n    max-height: 45vh;\n  }\n}\n.kayenta .config-detail {\n  padding: 0 1rem 1rem;\n  margin-bottom: 40px;\n  overflow-y: auto;\n}\n.kayenta .config-detail .config-detail-header {\n  padding: 5px 15px 7px 0;\n}\n.kayenta .config-detail .config-detail-header .heading-1 {\n  margin: 3px 0 0 0;\n}\n.kayenta .config-detail .config-detail-edit-warning {\n  padding: 12px;\n  margin-bottom: 12px;\n}\n.kayenta .config-detail .config-detail-edit-warning i.fa {\n  color: var(--color-notice);\n  font-size: 32px;\n}\n.kayenta .config-detail .contents .native-table-header {\n  padding-top: 10px;\n}\n.kayenta .group-tabs .fas.fa-pencil-alt {\n  padding-left: 1rem;\n  font-size: smaller;\n}\n.kayenta .group-tabs .fas.fa-pencil-alt.disabled {\n  color: var(--color-accessory);\n}\n.kayenta .group-tabs .tabs-basic input {\n  text-transform: none;\n  font-weight: normal;\n}\n.kayenta .table-header.sticky-header {\n  background-color: var(--color-alabaster);\n}\n.kayenta .table-header h6 {\n  font-weight: 600;\n}\n.kayenta .table-row > div,\n.kayenta .table-row > td {\n  padding: 0.8rem 0;\n}\n.kayenta .table-row i.fa,\n.kayenta .table-row i.far {\n  padding: 0 0.5rem;\n  cursor: pointer;\n}\n.kayenta .table-row i.fa.fa-edit,\n.kayenta .table-row i.far.fa-edit,\n.kayenta .table-row i.fa.fa-folder,\n.kayenta .table-row i.far.fa-folder {\n  font-weight: 100;\n}\n.kayenta .table-row i.fa.fa-folder,\n.kayenta .table-row i.far.fa-folder {\n  margin-top: 0.2rem;\n}\n.kayenta .table-row i.fa.fa-trash,\n.kayenta .table-row i.far.fa-trash {\n  font-size: small;\n  margin-top: 0.1rem;\n}\n.kayenta .table-row g {\n  margin-top: -0.25rem;\n  margin-right: 0.1rem;\n}\n.kayenta .table-header,\n.kayenta .table-row {\n  border-bottom: 1px solid var(--color-divider);\n}\n.kayenta .table-header h6,\n.kayenta .table-row h6 {\n  margin-bottom: 5px;\n}\n.kayenta .table-header.background-white,\n.kayenta .table-row.background-white {\n  background-color: var(--color-white);\n}\n.kayenta .table-header.selected,\n.kayenta .table-row.selected {\n  background-color: var(--color-accent-g2);\n}\n.kayenta .native-table-header {\n  position: sticky;\n  top: 0;\n  background-color: var(--color-alabaster);\n  box-shadow: 0 1px 0 var(--color-divider);\n}\n.kayenta .metric-list {\n  top: -10px;\n}\n.kayenta .header-transparent .native-table-header {\n  background-color: transparent;\n}\n.kayenta .header-white .native-table-header {\n  background-color: white;\n}\n.kayenta .flex-1 {\n  min-height: 0;\n}\n", ""]);

// exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".score.score-label {\n  font-size: 110%;\n  padding: 3px 6px;\n  display: inline-block;\n  height: 20px;\n  line-height: 14px;\n  color: white;\n}\n.score.score-label.inverse {\n  padding: 0;\n}\n.score.score-label.label-failing {\n  background-color: var(--color-alert-light);\n}\n.score.score-label.label-failing.inverse {\n  color: var(--color-alert-light);\n}\n.score.score-label.label-healthy {\n  background-color: var(--color-success);\n}\n.score.score-label.label-healthy.inverse {\n  color: var(--color-success);\n}\n.score.score-label.label-unhealthy {\n  background-color: var(--color-danger);\n}\n.score.score-label.label-unhealthy.inverse {\n  color: var(--color-danger);\n}\n.score.score-label.label-unknown {\n  background-color: var(--color-text-caption);\n}\n.score.score-label.label-unknown.inverse {\n  color: var(--color-text-caption);\n}\n.score.score-label.inverse {\n  background-color: transparent;\n  font-size: 100%;\n  padding: 0;\n}\n.score.score-label .score-classification {\n  font-size: 45%;\n  display: block;\n  margin-top: 15px;\n  font-weight: 400;\n  text-transform: uppercase;\n}\n.score-large.score {\n  height: 48px;\n}\n.score-large .score.score-label {\n  height: auto;\n  line-height: 48px;\n  padding: 0 10px;\n  font-size: 28px;\n  font-weight: bold;\n  margin: 0;\n  border-radius: 0;\n  display: inline-block;\n}\n.score.score-report {\n  align-items: center;\n  padding: 12px 12px 6px;\n  font-size: 28px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  height: 100%;\n}\n.table-row .score.score-report {\n  display: inline-block;\n}\n", ""]);

// exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "div.canary-score div.progress {\n  border-radius: 0;\n  box-shadow: none;\n  -webkit-box-shadow: none;\n  height: 10px;\n  margin: 20px 0 10px;\n}\ndiv.canary-score div.progress-bar {\n  box-shadow: none;\n  -webkit-box-shadow: none;\n}\ndiv.canary-score div.progress-bar-danger {\n  background-color: var(--color-danger);\n}\ndiv.canary-score div.progress-bar.progress-bar-warning {\n  background-color: var(--color-alto);\n}\ndiv.canary-score div.progress-bar.progress-bar-success {\n  background-color: var(--color-success-light);\n}\n", ""]);

// exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".ace-editor div,\n.ace-editor span {\n  font-family: Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n.ace-editor > div.ace_gutter {\n  z-index: 0;\n}\n.kayenta-config-json textarea {\n  height: 65vh;\n  overflow: scroll;\n  padding: 2px 6px;\n  line-height: 1.4rem;\n  font-family: monospace;\n  font-size: 1rem;\n}\n.kayenta-config-json pre.diff {\n  height: 65vh;\n  box-shadow: none;\n  width: 100%;\n  padding: 0;\n}\n.kayenta-config-json pre.diff .match,\n.kayenta-config-json pre.diff .add,\n.kayenta-config-json pre.diff .remove {\n  font-family: monospace;\n  font-size: 1rem;\n}\n.kayenta-config-json .modal-show-history .show-history .summary-nav {\n  right: 7px;\n}\n", ""]);

// exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".config-list > .tabs-vertical > li {\n  padding: 0;\n}\n.config-list > .tabs-vertical > li > a {\n  padding: 18px 12px;\n}\n", ""]);

// exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".kayenta-edit-metric-modal .modal-content {\n  overflow: visible;\n}\n", ""]);

// exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".template-editor-textarea {\n  min-width: 100%;\n  max-width: 100%;\n}\n.template-editor-value-formatted {\n  margin: 0;\n}\n.filter-template-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n", ""]);

// exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".canary-footer {\n  position: fixed;\n  z-index: 4;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #ffffff;\n  margin: 0;\n  border-top: 1px solid #d9d9d9;\n}\n.canary-footer .col-sm-12 {\n  padding: 5px;\n}\n.canary-footer .alert {\n  display: inline-block;\n  margin-bottom: 0;\n  margin-right: 5px;\n  padding: 6px 12px;\n  vertical-align: middle;\n}\n.canary-footer .fa.fa-exclamation-triangle {\n  font-size: 125%;\n  color: var(--color-danger);\n  opacity: 1;\n  margin-left: 5px;\n  padding: 0 2px;\n}\n", ""]);

// exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".metrics-action-buttons .link {\n  padding: 0 12px;\n}\n", ""]);

// exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".kv-pair-item {\n  display: flex;\n  align-items: center;\n}\n.kv-pair-item .kv-pair-item-section {\n  display: flex;\n  margin-right: 5px;\n  margin-bottom: 7px;\n}\n.kv-pair-item .kv-pair-item-section .kv-pair-item-section-label-wrapper {\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n}\n.kv-pair-item .kv-pair-item-section .kv-pair-item-section-input {\n  margin-left: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".kayenta-list a.clickable {\n  margin: 5px 0 0 10px;\n}\n.kayenta-list input.input-sm {\n  width: 93%;\n}\n", ""]);

// exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".kayenta .titled-section {\n  margin-bottom: 1em;\n}\n.kayenta .titled-section .contents {\n  margin: 10px 10px 0 10px;\n  background-color: var(--color-white);\n  border: 1px solid var(--color-cirrus);\n  padding: 15px;\n}\n.kayenta .titled-section .contents .list-group {\n  margin-bottom: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".kayenta .titled-subsection h5 {\n  font-weight: 600;\n}\n.kayenta .titled-subsection hr {\n  margin-top: 0;\n}\n", ""]);

// exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, "li[id^='rbt-menu-item'] {\n  pointer-events: none;\n}\n", ""]);

// exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".prometheus-metric-type-selector-account-hint {\n  display: flex;\n  align-items: center;\n  height: 30px;\n}\n", ""]);

// exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".signalfx-query-pairs {\n  padding: 10px 10px 0;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n.signalfx-query-pairs .add-new {\n  margin-bottom: 10px;\n  margin-top: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".kayenta-overview-toggle {\n  align-self: flex-end;\n  line-height: 48px;\n  position: fixed;\n  margin-top: -70px;\n  cursor: pointer;\n  padding-right: 10px;\n}\n.kayenta-overview-toggle p {\n  display: inline-block;\n  text-transform: uppercase;\n  margin-right: 10px;\n}\n", ""]);

// exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".boxplot .tooltip-container .columns {\n  display: flex;\n  flex-direction: row;\n}\n.boxplot .tooltip-container .columns .column {\n  padding: 10px;\n}\n.boxplot .tooltip-container .columns .column .header {\n  font-weight: 600;\n  padding-left: 0px;\n}\n.boxplot .boxplot-annotation text {\n  fill: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 600;\n}\n.boxplot .boxplot-annotation .annotation-connector {\n  display: none;\n}\n.boxplot .boxplot-annotation .note-line {\n  display: none;\n}\n.boxplot .boxplot-chart .boxplot-summary g {\n  opacity: 0.8;\n}\n.boxplot .boxplot-chart .boxplot-summary g:nth-child(1),\n.boxplot .boxplot-chart .boxplot-summary g:nth-child(2),\n.boxplot .boxplot-chart .boxplot-summary g:nth-child(3) {\n  opacity: 0.3;\n}\n", ""]);

// exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".chart-legend {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  margin-top: 4px;\n}\n.chart-legend .legend-item {\n  display: flex;\n  align-items: center;\n  margin: 0px 40px;\n  font-size: 12px;\n}\n.chart-legend .clickable {\n  cursor: pointer;\n}\n.chart-legend .deselected {\n  opacity: 0.5;\n}\n.chart-legend .legend-icon {\n  height: 12px;\n  width: 40px;\n  border-radius: 6px;\n  margin-right: 8px;\n}\n", ""]);

// exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".difference-area {\n  margin-top: 20px;\n}\n.difference-area .visualization-layer g.axis.x.bottom line.axis-baseline {\n  stroke: none;\n}\n.difference-area .secondary-ts-x-axis g.axis.x.bottom line.axis-baseline {\n  stroke: none;\n}\n", ""]);

// exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".histogram .graph-container {\n  position: relative;\n}\n.histogram .graph-container .bar-annotation text {\n  font-size: 12px;\n  font-weight: 600;\n}\n.histogram .graph-container .bar-annotation .annotation-connector {\n  display: none;\n}\n.histogram .graph-container .bar-annotation .note-line {\n  display: none;\n}\n.histogram .graph-container g.ordinal-labels {\n  stroke: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 200;\n}\n", ""]);

// exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".no-data-sign {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n", ""]);

// exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".secondary-ts-x-axis {\n  position: absolute;\n}\n.secondary-ts-x-axis g.axis-title.x.axis.bottom text {\n  transform: translateY(-8px);\n}\n", ""]);

// exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".semiotic-graph {\n  margin-bottom: 8px;\n}\n.semiotic-graph .visualization-layer .background-graphics .axis-tick-lines {\n  stroke: var(--color-dovegray);\n  opacity: 0.1;\n}\n.semiotic-graph .visualization-layer .background-graphics .axis-title text {\n  letter-spacing: 1.5px;\n}\n.semiotic-graph .axis {\n  font-size: 12px;\n  font-weight: 400;\n  fill: var(--color-text-primary);\n}\n.semiotic-graph .axis .axis-title.left.y text {\n  letter-spacing: 1.5px;\n}\n.semiotic-graph .axis .x.axis.bottom text.axis-label {\n  transform: translateY(-10px);\n}\n.semiotic-graph .axis .x.axis.bottom text.axis-label:nth-child(2) {\n  transform: translateY(5px);\n}\n.semiotic-graph .chart-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.semiotic-graph .chart-header .prefix {\n  font-weight: 600;\n}\n.semiotic-graph .chart-title {\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  font-size: 12px;\n}\n.semiotic-graph .graph-container {\n  position: relative;\n}\n", ""]);

// exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".time-series .xyframe-matte {\n  fill: var(--color-alabaster);\n}\n.time-series .zoom-icon {\n  bottom: 10px;\n  left: 30px;\n  position: absolute;\n  color: var(--color-dove-gray);\n}\n.time-series .tooltip-dual-axis-row {\n  margin-bottom: 10px;\n}\n.time-series .tooltip-ts {\n  font-weight: 600;\n}\n.time-series .axis-title.x.axis.bottom text {\n  transform: translateY(-8px);\n}\n.time-series .canary-dual-axis .axis-label,\n.time-series .canary-dual-axis .axis-title text {\n  fill: #e26a6a;\n}\n.time-series .baseline-dual-axis .axis-label,\n.time-series .baseline-dual-axis .axis-title text {\n  fill: #52b3d9;\n}\n", ""]);

// exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".graph-type-selector {\n  margin-left: 60px;\n  margin-top: 6px;\n}\n", ""]);

// exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".report-header {\n  margin-bottom: 10px;\n  align-items: center;\n}\n.report-header h1 {\n  flex: 1 0 200px;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  word-break: break-all;\n}\n.report-header .report-score-wrapper {\n  padding: 5px 20px 0 0;\n  margin-left: 15px;\n  border-right: 1px solid var(--color-titanium);\n  text-align: center;\n  flex: 0 0 200px;\n}\n.report-header .report-metadata {\n  flex: 0 1 auto;\n  display: flex;\n  overflow: hidden;\n  padding-left: 20px;\n  padding-top: 10px;\n  width: 100%;\n}\n.report-header .report-metadata .group {\n  flex: 1 1 200px;\n  margin-right: 20px;\n  overflow: hidden;\n}\n.report-header .report-metadata .group.group-time {\n  flex: 0 0 150px;\n}\n.report-header .report-metadata .group.group-threshold {\n  flex: 0 0 80px;\n}\n.report-header .report-metadata .group.group-source {\n  flex: 0 0 64px;\n  margin-right: 0;\n}\n.report-header .report-metadata ul {\n  margin-bottom: 0;\n}\n.report-header .report-metadata .label {\n  padding-left: 0;\n}\n.report-header .report-metadata .label.label-lg {\n  font-size: 85%;\n}\n.report-header .kayenta-scope {\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.popover .kayenta-scope {\n  word-break: break-all;\n}\n", ""]);

// exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".metric-result-actions .actions-layout {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin: 12px 4px;\n}\n.metric-result-actions .action {\n  padding-left: 8px;\n}\n.metric-result-actions .copy-button-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n}\n.metric-result-actions .copy-button-container .clipboard-btn {\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  z-index: 2;\n  position: absolute;\n}\n.metric-result-actions .copy-button-container .copy-button .copy-icon {\n  top: -1px;\n}\n", ""]);

// exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".metric-stats .label {\n  padding-left: 0;\n}\n.metric-stats p {\n  margin: 0;\n}\n", ""]);

// exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".metric-results-list .table-header h6 {\n  padding-left: 5px;\n}\n.metric-results-list .tabs-vertical {\n  overflow-y: auto;\n  display: block;\n}\n.metric-results-list .tabs-vertical li {\n  padding: 8px 0 8px 5px;\n}\n.metric-results-list .metric-result-classification {\n  margin-right: 3px;\n}\n.metric-results-list .table-row {\n  cursor: pointer;\n}\n.metric-results-list .list-group {\n  margin-bottom: 0;\n}\n.metric-results-list li.multiple-results {\n  padding-bottom: 0;\n  border: none;\n}\n.metric-results-list li.multiple-results:hover {\n  border: none;\n}\n.metric-results-list .multiple-results-table {\n  padding-left: 8px;\n}\n.metric-results-list .multiple-results-table h6 {\n  margin-top: 7px;\n}\n", ""]);

// exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".report-scores {\n  height: 40px;\n  margin-bottom: 20px;\n}\n.report-scores .group-score,\n.report-scores .all-metric-results-header {\n  height: 30px;\n  color: white;\n  border-right: 1px solid white;\n  padding-top: 4px;\n}\n.report-scores .group-score h3,\n.report-scores .all-metric-results-header h3 {\n  font-weight: 600;\n}\n.report-scores .group-score:last-of-type {\n  border-right: none;\n}\n.report-scores .report-score.active .arrow-down {\n  width: 0;\n  height: 0;\n  margin: 5px auto 0 auto;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid transparent;\n}\n.report-scores .all-metric-results-header {\n  border: 1px solid var(--color-titanium);\n  width: 70%;\n  margin: 0 auto;\n}\n.report-scores .all-metric-results-header .arrow-down.inner {\n  margin-top: -9px;\n}\n.report-scores .all-metric-results-header .arrow-down.outer {\n  margin-top: 4px;\n}\n", ""]);

// exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".execution-list-container {\n  overflow-y: auto;\n}\n.execution-list-table {\n  margin-bottom: 0;\n}\n", ""]);

// exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".canary-run-summaries .native-table-header {\n  background-color: transparent;\n}\n", ""]);

// exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".canary-config-view .alert {\n  margin-bottom: 0;\n}\n", ""]);

// exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)(undefined);
// imports


// module
exports.push([module.i, ".canary-config-section .col-md-6,\n.canary-config-section .col-md-8 {\n  margin-top: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(76);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/dist/index.js!./canary.less", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/less-loader/dist/index.js!./canary.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(77);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./canaryScore.component.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./canaryScore.component.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(78);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./canaryScores.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./canaryScores.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(79);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./configJson.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./configJson.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(80);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./configList.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./configList.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(81);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./editMetricModal.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./editMetricModal.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(82);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./filterTemplateSelector.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./filterTemplateSelector.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(83);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./footer.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./footer.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(84);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./metricList.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./metricList.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(85);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./keyValueList.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./keyValueList.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(86);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./list.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./list.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(87);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./titledSection.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./titledSection.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(88);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./titledSubsection.less", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/dist/index.js!./titledSubsection.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(89);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./typeahead.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./typeahead.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(90);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./metricTypeSelector.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./metricTypeSelector.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(91);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./metricConfigurer.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./metricConfigurer.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(92);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./detail.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./detail.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(93);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./boxplot.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./boxplot.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(94);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./chartLegend.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./chartLegend.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(95);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./differenceArea.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./differenceArea.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(96);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./histogram.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./histogram.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(97);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./noValidDataSign.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./noValidDataSign.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(98);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./secondaryTSXAxis.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./secondaryTSXAxis.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(99);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./semioticGraph.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./semioticGraph.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(100);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./timeSeries.less", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/less-loader/dist/index.js!./timeSeries.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(101);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./graphTypeSelector.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./graphTypeSelector.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(102);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./header.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./header.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(103);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./metricResultActions.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./metricResultActions.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(104);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./metricResultStats.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./metricResultStats.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(105);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./metricResultsList.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./metricResultsList.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(106);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./reportScores.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./reportScores.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(107);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./executionList.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./executionList.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(108);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./canaryRunSummaries.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./canaryRunSummaries.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(109);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./kayentaStage.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./kayentaStage.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(110);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(5)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./kayentaStageExecutionDetails.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/dist/index.js!./kayentaStageExecutionDetails.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __webpack_require__(12);
const canary_settings_1 = __webpack_require__(11);
const core_1 = __webpack_require__(6);
const canaryConfig_service_1 = __webpack_require__(18);
const canary_1 = __webpack_require__(53);
const Creators = __webpack_require__(3);
const canaryRun_service_1 = __webpack_require__(35);
exports.CANARY_DATA_SOURCE = 'spinnaker.kayenta.canary.dataSource';
angular_1.module(exports.CANARY_DATA_SOURCE, []).run([
    '$q',
    ($q) => {
        'ngInject';
        const loadCanaryConfigs = (application) => {
            const request = canary_settings_1.CanarySettings.showAllConfigs
                ? canaryConfig_service_1.getCanaryConfigSummaries()
                : canaryConfig_service_1.getCanaryConfigSummaries(application.name);
            return $q.resolve(request);
        };
        const configsLoaded = (_application, summaries) => {
            return $q.resolve(summaries);
        };
        const afterConfigsLoad = (application) => {
            if (application !== canary_1.canaryStore.getState().data.application) {
                return;
            }
            canary_1.canaryStore.dispatch(Creators.updateConfigSummaries({
                configSummaries: application.getDataSource('canaryConfigs').data,
            }));
        };
        core_1.ApplicationDataSourceRegistry.registerDataSource({
            optIn: !canary_settings_1.CanarySettings.optInAll,
            optional: true,
            loader: loadCanaryConfigs,
            onLoad: configsLoaded,
            afterLoad: afterConfigsLoad,
            description: 'Canary analysis configuration and reporting',
            key: 'canaryConfigs',
            label: 'Canary',
            defaultData: [],
        });
        const loadCanaryJudges = () => $q.resolve(canaryConfig_service_1.listJudges());
        const judgesLoaded = (_application, judges) => {
            return $q.resolve(judges);
        };
        const afterJudgesLoad = (application) => {
            if (application !== canary_1.canaryStore.getState().data.application) {
                return;
            }
            canary_1.canaryStore.dispatch(Creators.updateJudges({
                judges: application.getDataSource('canaryJudges').data,
            }));
        };
        core_1.ApplicationDataSourceRegistry.registerDataSource({
            key: 'canaryJudges',
            label: 'Canary Configs',
            sref: '.canary.canaryConfig',
            activeState: '**.canaryConfig.**',
            category: 'delivery',
            requiresDataSource: 'canaryConfigs',
            loader: loadCanaryJudges,
            onLoad: judgesLoaded,
            afterLoad: afterJudgesLoad,
            lazy: true,
            autoActivate: true,
            defaultData: [],
        });
        const loadCanaryExecutions = (application) => {
            const listExecutionsRequest = canaryRun_service_1.listCanaryExecutions(application.name, 20);
            listExecutionsRequest.catch(error => {
                canary_1.canaryStore.dispatch(Creators.loadExecutionsFailure({ error }));
            });
            return $q.resolve(listExecutionsRequest);
        };
        const canaryExecutionsLoaded = (_application, executions) => {
            return $q.resolve(executions);
        };
        const afterCanaryExecutionsLoaded = (application) => {
            if (application !== canary_1.canaryStore.getState().data.application) {
                return;
            }
            canary_1.canaryStore.dispatch(Creators.loadExecutionsSuccess({
                executions: application.getDataSource('canaryExecutions').data,
            }));
        };
        core_1.ApplicationDataSourceRegistry.registerDataSource({
            key: 'canaryExecutions',
            label: 'Canary Reports',
            sref: '.canary.report',
            activeState: '**.report.**',
            category: 'delivery',
            requiresDataSource: 'canaryConfigs',
            loader: loadCanaryExecutions,
            onLoad: canaryExecutionsLoaded,
            afterLoad: afterCanaryExecutionsLoaded,
            lazy: true,
            autoActivate: true,
            defaultData: [],
        });
    },
]);


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = __webpack_require__(6);
const helpContents = {
    'pipeline.config.canary.analysisType': `
    <p>
      <strong>Real Time</strong> analysis will be performed
      over a time interval beginning at the moment of execution.
      <ul>
        <li>
          <strong>Automatic:</strong> Spinnaker will provision and clean up the baseline and canary server groups. Not all cloud providers support this mode.
        </li>
        <li>
          <strong>Manual:</strong> You are responsible for provisioning and cleaning up the baseline and canary server groups.
        </li>
      </ul>
    </p>
    <p>
      <strong>Retrospective</strong> analysis will be performed over an explicitly-specified time
      interval (likely in the past). You are responsible for provisioning and cleaning up
      the baseline and canary server groups.
    </p>
  `,
    'pipeline.config.canary.delayBeforeAnalysis': '<p>The number of minutes until the first canary analysis measurement interval begins.</p>',
    'pipeline.config.canary.baselineAnalysisOffset': '<p>The offset in minutes of baseline data collection from the beginning of canary analysis. Useful for comparing metrics pre-canary for relative comparison. This field accepts SpEL</p>',
    'pipeline.config.canary.canaryInterval': `
        <p>The frequency at which a canary score is generated. The recommended interval is at least 30 minutes.</p>
        <p>If an interval is not specified, or the specified interval is larger than the overall time range, there will be one canary run over the full time range.</p>`,
    'pipeline.config.canary.successfulScore': '<p>The minimum score the canary must achieve to be considered successful.</p>',
    'pipeline.config.canary.unhealthyScore': '<p>The lowest score the canary can attain before it is aborted and disabled as a failure.</p>',
    'pipeline.config.canary.baselineGroup': '<p>The server group to treat as the <em>control</em> in the canary analysis.</p>',
    'pipeline.config.canary.baselineLocation': '<p>The location (could be a region, a namespace, or something else) of the server group to treat as the <em>control</em> in the canary analysis.</p>',
    'pipeline.config.canary.canaryGroup': '<p>The server group to treat as the <em>experiment</em> in the canary analysis.</p>',
    'pipeline.config.canary.canaryLocation': '<p>The location (could be a region, a namespace, or something else) of the server group to treat as the <em>experiment</em> in the canary analysis.</p>',
    'pipeline.config.canary.startTimeIso': '<p>The overall start time of the data points to be retrieved, specified as a UTC instant using <a target="_" href="https://docs.oracle.com/javase/8/docs/api/java/time/format/DateTimeFormatter.html#ISO_INSTANT">ISO-8601 instant format.</a> For example, `2018-07-12T20:28:29Z`.</p>',
    'pipeline.config.canary.endTimeIso': '<p>The overall end time of the data points to be retrieved, specified as a UTC instant using <a target="_" href="https://docs.oracle.com/javase/8/docs/api/java/time/format/DateTimeFormatter.html#ISO_INSTANT">ISO-8601 instant format.</a> For example, `2018-07-12T22:28:29Z`.</p>',
    'pipeline.config.canary.extendedScopeParams': `
        <p>Metric source specific parameters which may be used to further alter the canary scope.</p>
        <p>Also used to provide variable bindings for use in the expansion of custom filter templates within the canary config.</p>`,
    'pipeline.config.canary.lookback': '<p>With an analysis type of <strong>Growing</strong>, the entire duration of the canary will be considered during the analysis.</p><p>When choosing <strong>Sliding</strong>, the canary will use the most recent number of specified minutes for its analysis report (<b>useful for long running canaries that span multiple days</b>).</p>',
    'pipeline.config.canary.delayBeforeCleanup': '<p>The total time after canary analysis ends before canary cluster cleanup begins. Allows for manual inspection of instances.</p>',
    'pipeline.config.canary.marginalScore': `
    <p>A canary stage can include multiple canary runs.</p>
    <p>If a given canary run score is less than or equal to the marginal threshold, the canary stage will fail immediately.</p>
    <p>If the canary run score is greater than the marginal threshold, the canary stage will not fail and will execute the remaining downstream canary runs.</p>`,
    'pipeline.config.canary.passingScore': '<p>When all canary runs in a stage have executed, a canary stage is considered a success if the final (that is, the latest) canary run score is greater than or equal to the pass threshold. Otherwise, it is a failure.</p>',
    'pipeline.config.canary.lifetime': `
    <p>The total time for which data will be collected and analyzed during this stage.</p>
  `,
    'pipeline.config.canary.legacySiteLocalRecipients': '<p>Email addresses to be notified when a canary report completes, separated by commas.</p>',
    'pipeline.config.metricsAccount': "<p>The account to be used to access the metric store defined in this stage's canary config.</p>",
    'pipeline.config.storageAccount': '<p>The account to be used to access a storage service, which will be used to store artifacts generated by this stage.</p>',
    'canary.config.metricGroupWeights': `
    <p>A canary score is the weighted sum of metric group scores.</p>
    <p>Group weights must sum to 100.</p>
  `,
    'canary.config.nanStrategy': `
    <p>When there is no value for a metric at a given point in time, it can either be ignored or assumed to be zero. The right choice depends on what is being measured. For example, when measuring successful attempts (like health checks) replacing missing values with zero may be appropriate.</p>
    <p>The default strategy for a given metric will be used if no strategy is selected.</p>
  `,
    'canary.config.filterTemplate': `
    <p>Templates allow you to compose and parameterize advanced queries against your telemetry provider.</p>
    <p>Parameterized queries are hydrated by values provided in the canary stage. The <strong>project</strong>, <strong>resourceType</strong>, </string><strong>scope</strong>, and <strong>location</strong> variable bindings are implicitly available.</p>
    <p>For example, you can interpolate <strong>project</strong> using the following syntax: <strong>\${project}</strong>.</p>
  `,
    'canary.config.signalFx.queryPairs': `
    <p><strong>Query pairs are optional</strong></p>
    <p>Can be dimensions, properties, or tags (Use tag as key for tags).</p>
    <p>
        Example: Given a metric with name <pre>'request.count'</pre> that gets reported with dimensions uri, and stats_code. </br>
        If I added the following query pairs</br>
        <pre>{
  "uri": "v1/some-endpoint",
  "status_code": "5*"
}</pre>
        I could make a metric that tracks the number of server errors for endpoint <pre>/v1/some-endpoint</pre>
    </p>
    <p>These k,v pairs are used to construct filters for the compiled SignalFlow program. EX:<pre>data('request.count', filters=filter('uri', 'v1/some-endpoint') and filter('status_code', '5*') and filter('version', '1.0.0') and filter('environment', 'production')).sum(by=['version', 'environment']).publish()</pre>
        Note that the version and environment would come from the canary scope and the sum method comes from the aggregation method.
    </p>
  `,
    'canary.config.signalFx.aggregationMethod': `
    <p>This must be a method defined in the <a target="_blank" href="https://developers.signalfx.com/reference#signalflow-stream-methods-1">SignalFlow Stream Methods</a> that supports aggregation</p>
    <p>These are methods such as min, max, sum, mean and are documented with supporting the <strong>'by'</strong> keyword, ex: <pre>sum(by=['version', 'environment'])</pre></p>
    <p>Simply put the name of the method that should be used in this field such as sum, Kayenta will populate the by clauses using the canary scope filter keys</p>
    <p>This method is used to construct the compiled SignalFlow program. EX:<pre>data('request.count', filters=filter('uri', 'v1/some-endpoint') and filter('status_code', '5*') and filter('version', '1.0.0') and filter('environment', 'production')).sum(by=['version', 'environment']).publish()</pre>
        Note that the version and environment k,v pairs are sourced from the canary scope. The other k,v pairs come from the metric specific k,v pair list.
    </p>
  `,
    'canary.config.prometheus.queryType': `
    <p>Select <strong>default</strong> to use options from the UI to configure your query.</p>
    <p>Select <strong>PromQL</strong> to compose a custom PromQL query (see <a target="blank" href="https://prometheus.io/docs/prometheus/latest/querying/basics/">documentation</a>).</p>
  `,
    'stackdriver.resourceType': 'For Stackdriver, a set of time series is identified by a <strong>resource type</strong> and a metric type that has data from that resource type.',
    'stackdriver.metricType': 'For Stackdriver, a set of time series is identified by a resource type and a <strong>metric type</strong> that has data from that resource type.',
    'stackdriver.groupBy': 'Group by resource or metric labels to reduce the number of time series.',
    'stackdriver.crossSeriesReducer': 'Use an algorithm to group multiple time series together.',
    'stackdriver.perSeriesAligner': 'Use an algorithm to align individual time series.',
};
Object.keys(helpContents).forEach(key => core_1.HelpContentsRegistry.register(key, helpContents[key]));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __webpack_require__(12);
const canary_settings_1 = __webpack_require__(11);
const components_module_1 = __webpack_require__(150);
const canary_dataSource_1 = __webpack_require__(146);
const stages_module_1 = __webpack_require__(286);
const canary_states_1 = __webpack_require__(228);
__webpack_require__(147);
__webpack_require__(212);
__webpack_require__(248);
const templates = __webpack_require__(289);
templates.keys().forEach(key => {
    templates(key);
});
const modules = [components_module_1.CANARY_COMPONENTS, canary_dataSource_1.CANARY_DATA_SOURCE, canary_states_1.CANARY_STATES];
exports.KAYENTA_MODULE = 'spinnaker.kayenta';
if (canary_settings_1.CanarySettings.featureDisabled) {
    angular_1.module(exports.KAYENTA_MODULE, []);
}
else {
    angular_1.module(exports.KAYENTA_MODULE, canary_settings_1.CanarySettings.stagesEnabled ? [stages_module_1.CANARY_STAGES, ...modules] : modules);
}


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __webpack_require__(12);
const react2angular_1 = __webpack_require__(37);
const canaryScore_1 = __webpack_require__(31);
exports.CANARY_SCORE_COMPONENT = 'spinnaker.kayenta.score.component';
angular_1.module(exports.CANARY_SCORE_COMPONENT, []).component('kayentaCanaryScore', react2angular_1.react2angular(canaryScore_1.CanaryScore, ['score', 'health', 'result', 'inverse']));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __webpack_require__(12);
const canaryScore_component_1 = __webpack_require__(149);
const canaryScores_component_1 = __webpack_require__(54);
exports.CANARY_COMPONENTS = 'spinnaker.kayenta.components.module';
angular_1.module(exports.CANARY_COMPONENTS, [canaryScore_component_1.CANARY_SCORE_COMPONENT, canaryScores_component_1.CANARY_SCORES_CONFIG_COMPONENT]);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CANARY_EXECUTION_NO_PIPELINE_STATUS = 'no-parent-pipeline-execution';


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var KayentaAccountType;
(function (KayentaAccountType) {
    KayentaAccountType["MetricsStore"] = "METRICS_STORE";
    KayentaAccountType["ObjectStore"] = "OBJECT_STORE";
    KayentaAccountType["ConfigurationStore"] = "CONFIGURATION_STORE";
})(KayentaAccountType = exports.KayentaAccountType || (exports.KayentaAccountType = {}));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var KayentaAnalysisType;
(function (KayentaAnalysisType) {
    KayentaAnalysisType["RealTimeAutomatic"] = "realTimeAutomatic";
    KayentaAnalysisType["RealTime"] = "realTime";
    KayentaAnalysisType["Retrospective"] = "retrospective";
})(KayentaAnalysisType = exports.KayentaAnalysisType || (exports.KayentaAnalysisType = {}));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MetricClassificationLabel;
(function (MetricClassificationLabel) {
    MetricClassificationLabel["Pass"] = "Pass";
    MetricClassificationLabel["High"] = "High";
    MetricClassificationLabel["Low"] = "Low";
    MetricClassificationLabel["Nodata"] = "Nodata";
    MetricClassificationLabel["Error"] = "Error";
})(MetricClassificationLabel = exports.MetricClassificationLabel || (exports.MetricClassificationLabel = {}));


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const react_bootstrap_1 = __webpack_require__(29);
const core_1 = __webpack_require__(6);
const Creators = __webpack_require__(3);
const styleguide_1 = __webpack_require__(22);
const disableable_1 = __webpack_require__(8);
function ChangeMetricGroupModal({ groups, toGroup, confirm, clear, select, }) {
    return (React.createElement(react_bootstrap_1.Modal, { show: true, onHide: core_1.noop },
        React.createElement(styleguide_1.default, null,
            React.createElement(react_bootstrap_1.Modal.Header, null,
                React.createElement(react_bootstrap_1.Modal.Title, null, "Change Metric Group")),
            React.createElement(react_bootstrap_1.Modal.Body, null,
                React.createElement(disableable_1.DisableableSelect, { value: toGroup || '', onChange: select, className: "form-control input-sm", disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] },
                    React.createElement("option", { value: '' }, "-- select group --"),
                    groups.map(g => (React.createElement("option", { key: g, value: g }, g))))),
            React.createElement(react_bootstrap_1.Modal.Footer, null,
                React.createElement("ul", { className: "list-inline pull-right" },
                    React.createElement("li", null,
                        React.createElement("button", { className: "passive", onClick: clear }, "Cancel")),
                    React.createElement("li", null,
                        React.createElement("button", { className: "primary", disabled: !toGroup, onClick: confirm }, "OK")))))));
}
function mapStateToProps(state, { metric }) {
    return {
        groups: state.selectedConfig.group.list.filter(g => metric.groups.length > 1 || !metric.groups.includes(g)),
        toGroup: state.selectedConfig.changeMetricGroup.toGroup,
    };
}
function mapDispatchToProps(dispatch, { metric }) {
    return {
        select: (event) => {
            dispatch(Creators.changeMetricGroupSelect({ group: event.target.value || null }));
        },
        clear: () => {
            dispatch(Creators.changeMetricGroupConfirm({ metricId: null }));
        },
        confirm: () => {
            dispatch(Creators.changeMetricGroupConfirm({ metricId: metric.id }));
        },
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ChangeMetricGroupModal);


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const configDetailHeader_1 = __webpack_require__(168);
const groupTabs_1 = __webpack_require__(58);
const metricList_1 = __webpack_require__(186);
const editMetricModal_1 = __webpack_require__(176);
const nameAndDescription_1 = __webpack_require__(188);
const titledSection_1 = __webpack_require__(201);
const scoring_1 = __webpack_require__(195);
function ConfigDetail() {
    return (React.createElement("section", { className: "config-detail" },
        React.createElement(configDetailHeader_1.default, null),
        React.createElement(titledSection_1.default, { title: "Name and Description" },
            React.createElement(nameAndDescription_1.default, null)),
        React.createElement(titledSection_1.default, { title: "Metrics" },
            React.createElement(groupTabs_1.default, null),
            React.createElement(metricList_1.default, null),
            React.createElement(editMetricModal_1.default, null)),
        React.createElement(titledSection_1.default, { title: "Scoring" },
            React.createElement(scoring_1.default, null))));
}
exports.default = ConfigDetail;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const openDeleteModalButton_1 = __webpack_require__(190);
const openConfigJsonModalButton_1 = __webpack_require__(189);
const copyConfigButton_1 = __webpack_require__(172);
function ConfigDetailActionButtons() {
    return (React.createElement("ul", { className: "list-inline pull-right" },
        React.createElement("li", null,
            React.createElement(openConfigJsonModalButton_1.default, null)),
        React.createElement("li", null,
            React.createElement(copyConfigButton_1.default, null)),
        React.createElement("li", null,
            React.createElement(openDeleteModalButton_1.default, null))));
}
exports.default = ConfigDetailActionButtons;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const react_1 = __webpack_require__(20);
const canaryConfig_service_1 = __webpack_require__(18);
const formattedDate_1 = __webpack_require__(26);
const configDetailActionButtons_1 = __webpack_require__(167);
const getOwnerAppLinks = (owners) => {
    if (owners.length === 1) {
        return (React.createElement(react_1.UISref, { to: ".", params: { application: owners[0] } },
            React.createElement("a", null, owners[0])));
    }
    else {
        const lastIndex = owners.length - 1;
        return owners.map((owner, index) => (React.createElement(React.Fragment, { key: owner },
            index === lastIndex ? 'or ' : '',
            React.createElement(react_1.UISref, { to: ".", params: { application: owner } },
                React.createElement("a", null, owner)),
            index < lastIndex && owners.length === 2 ? ' ' : '',
            index < lastIndex && owners.length > 2 ? ', ' : '')));
    }
};
const EditingDisabledWarning = ({ owners }) => {
    return (React.createElement("div", { className: "horizontal middle well-compact alert alert-warning config-detail-edit-warning" },
        React.createElement("i", { className: "fa fa-exclamation-triangle sp-margin-m-right" }),
        React.createElement("span", null,
            React.createElement("b", null,
                "Editing is disabled because this config is owned by",
                ' ',
                owners.length > 1 ? `${owners.length} other applications` : 'another application',
                "."),
            ' ',
            "To edit, view in ",
            getOwnerAppLinks(owners))));
};
function ConfigDetailHeader({ selectedConfig, editingDisabled }) {
    return (React.createElement("div", { className: "vertical" },
        React.createElement("div", { className: "horizontal config-detail-header" },
            React.createElement("div", { className: "flex-3" },
                React.createElement("h1", { className: "heading-1 color-text-primary" }, selectedConfig ? selectedConfig.name : '')),
            React.createElement("div", { className: "flex-1" },
                React.createElement("h5", { className: "heading-5" },
                    React.createElement("strong", null, "Edited:"),
                    ' ',
                    React.createElement(formattedDate_1.default, { dateIso: selectedConfig ? selectedConfig.updatedTimestampIso : '' }))),
            React.createElement("div", { className: "flex-2" },
                React.createElement(configDetailActionButtons_1.default, null))),
        selectedConfig && editingDisabled && React.createElement(EditingDisabledWarning, { owners: selectedConfig.applications })));
}
function mapStateToProps(state) {
    return {
        selectedConfig: canaryConfig_service_1.mapStateToConfig(state),
        editingDisabled: state.app.disableConfigEdit,
    };
}
exports.default = react_redux_1.connect(mapStateToProps)(ConfigDetailHeader);


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const configDetail_1 = __webpack_require__(166);
const centeredDetail_1 = __webpack_require__(25);
const loadStates_1 = __webpack_require__(32);
function ConfigDetailLoadStates({ configLoadState }) {
    const LoadStates = new loadStates_1.default()
        .onFulfilled(React.createElement(configDetail_1.default, null))
        .onFailed(React.createElement(centeredDetail_1.default, null,
        React.createElement("h3", { className: "heading-3" }, "Could not load canary config.")))
        .build();
    return React.createElement(LoadStates, { state: configLoadState });
}
function mapStateToProps(state) {
    return {
        configLoadState: state.selectedConfig.load.state,
    };
}
exports.default = react_redux_1.connect(mapStateToProps)(ConfigDetailLoadStates);


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const configDetailLoadStates_1 = __webpack_require__(169);
const Creators = __webpack_require__(3);
class ConfigDetailLoader extends React.Component {
    constructor(props) {
        const { configNameStream, loadConfig } = props;
        super(props);
        this.subscription = configNameStream.subscribe(loadConfig);
    }
    componentWillUnmount() {
        this.subscription.unsubscribe();
    }
    render() {
        return React.createElement(configDetailLoadStates_1.default, null);
    }
}
function mapDispatchToProps(dispatch) {
    return {
        loadConfig: (stateParams) => {
            if (stateParams.copy) {
                dispatch(Creators.copySelectedConfig());
            }
            else if (stateParams.new) {
                dispatch(Creators.createNewConfig());
            }
            else if (stateParams.id) {
                dispatch(Creators.loadConfigRequest({ id: stateParams.id }));
            }
        },
    };
}
exports.default = react_redux_1.connect(null, mapDispatchToProps)(ConfigDetailLoader);


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const lodash_1 = __webpack_require__(2);
const react_1 = __webpack_require__(20);
const createConfigButton_1 = __webpack_require__(173);
const formattedDate_1 = __webpack_require__(26);
const ownedBy_1 = __webpack_require__(191);
__webpack_require__(115);
function ConfigList({ configs, selectedConfigId, application }) {
    return (React.createElement("section", { className: "config-list" },
        React.createElement("ul", { className: "tabs-vertical list-unstyled ", style: { wordBreak: 'break-all' } }, configs.map(config => (React.createElement("li", { key: config.id, className: config.id === selectedConfigId ? 'selected' : '' },
            React.createElement(react_1.UISref, { to: ".configDetail", params: { id: config.id, new: false, copy: false } },
                React.createElement("a", null,
                    React.createElement("div", { className: "heading-4 color-text-primary" }, config.name),
                    React.createElement("div", { className: "body-small color-text-caption caption", style: { marginTop: '5px', marginBottom: '0' } },
                        "Edited: ",
                        React.createElement(formattedDate_1.default, { dateIso: config.updatedTimestampIso }),
                        React.createElement("br", null),
                        React.createElement(ownedBy_1.OwnedBy, { owningApplications: config.applications, currentApplication: application })))))))),
        React.createElement(createConfigButton_1.default, null)));
}
function mapStateToProps(state) {
    const selectedConfigId = state.selectedConfig.config ? state.selectedConfig.config.id : null;
    const application = state.data.application.name;
    return {
        selectedConfigId,
        configs: lodash_1.sortBy(state.data.configSummaries, 'name'),
        application,
    };
}
exports.default = react_redux_1.connect(mapStateToProps)(ConfigList);


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_1 = __webpack_require__(20);
const react_redux_1 = __webpack_require__(1);
const lodash_1 = __webpack_require__(2);
function CopyConfigButton({ disabled }) {
    return (React.createElement(react_1.UISref, { to: "^.configDetail", params: { copy: true } },
        React.createElement("button", { className: "passive", disabled: disabled },
            React.createElement("i", { className: "fa fa-copy" }),
            React.createElement("span", null, "Copy"))));
}
function mapStateToProps(state) {
    return {
        disabled: lodash_1.get(state.selectedConfig, 'config.isNew') || state.app.disableConfigEdit,
    };
}
exports.default = react_redux_1.connect(mapStateToProps)(CopyConfigButton);


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_1 = __webpack_require__(20);
const react_redux_1 = __webpack_require__(1);
const core_1 = __webpack_require__(6);
function CreateConfigButton({ disabled }) {
    return (React.createElement(react_1.UISref, { to: ".configDetail", params: { id: core_1.UUIDGenerator.generateUuid(), new: true } },
        React.createElement("button", { className: "zombie text-left form-control", disabled: disabled },
            React.createElement("i", { className: "fa fa-plus-circle" }),
            React.createElement("span", null, "Add configuration"))));
}
function mapStateToProps(state) {
    return {
        disabled: state.selectedConfig.config && state.selectedConfig.config.isNew,
    };
}
exports.default = react_redux_1.connect(mapStateToProps)(CreateConfigButton);


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const react_bootstrap_1 = __webpack_require__(29);
const classNames = __webpack_require__(7);
const Creators = __webpack_require__(3);
const styleguide_1 = __webpack_require__(22);
const asyncRequest_1 = __webpack_require__(15);
function DeleteConfigModal({ show, selectedConfigName, deleteConfigState, deleteConfigErrorMessage, closeDeleteConfigModal, deleteConfig, }) {
    return (React.createElement(react_bootstrap_1.Modal, { show: show, onHide: null },
        React.createElement(styleguide_1.default, null,
            React.createElement(react_bootstrap_1.Modal.Header, null,
                React.createElement(react_bootstrap_1.Modal.Title, null,
                    "Really delete ",
                    selectedConfigName,
                    "?")),
            deleteConfigState === asyncRequest_1.AsyncRequestState.Failed && (React.createElement(react_bootstrap_1.Modal.Body, null,
                React.createElement("span", { className: classNames('alert', 'alert-danger') }, buildErrorMessage(deleteConfigErrorMessage)))),
            React.createElement(react_bootstrap_1.Modal.Footer, null,
                React.createElement("ul", { className: "list-inline pull-right" },
                    React.createElement("li", null,
                        React.createElement("button", { className: "passive", onClick: closeDeleteConfigModal }, "Cancel")),
                    React.createElement("li", null,
                        React.createElement("button", { className: "primary", onClick: deleteConfig }, "Delete")))))));
}
function buildErrorMessage(deleteConfigErrorMessage) {
    const message = 'The was an error deleting your config';
    return deleteConfigErrorMessage ? message + `: ${deleteConfigErrorMessage}.` : message + '.';
}
function mapDispatchToProps(dispatch) {
    return {
        closeDeleteConfigModal: () => dispatch(Creators.closeDeleteConfigModal()),
        deleteConfig: () => dispatch(Creators.deleteConfig()),
    };
}
function mapStateToProps(state) {
    return {
        show: state.app.deleteConfigModalOpen,
        selectedConfigName: state.selectedConfig.config ? state.selectedConfig.config.name : null,
        deleteConfigState: state.selectedConfig.destroy.state,
        deleteConfigErrorMessage: state.selectedConfig.destroy.error,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(DeleteConfigModal);


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_1 = __webpack_require__(20);
const listDetail_1 = __webpack_require__(63);
const configList_1 = __webpack_require__(171);
const footer_1 = __webpack_require__(180);
function CanaryConfigEdit() {
    const List = React.createElement(configList_1.default, null);
    const noWrap = { wrap: false };
    const Detail = React.createElement(react_1.UIView, Object.assign({}, noWrap, { name: "detail" }));
    return (React.createElement("div", { className: "vertical flex-1" },
        React.createElement(listDetail_1.default, { list: List, detail: Detail, className: "flex-1", detailClass: "vertical flex-1" }),
        React.createElement(footer_1.default, null,
            React.createElement(react_1.UIView, Object.assign({}, noWrap, { name: "footer" })))));
}
exports.default = CanaryConfigEdit;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
const react_redux_1 = __webpack_require__(1);
const react_bootstrap_1 = __webpack_require__(29);
const lodash_1 = __webpack_require__(2);
const core_1 = __webpack_require__(6);
const Creators = __webpack_require__(3);
const metricConfigurerDelegator_1 = __webpack_require__(185);
const styleguide_1 = __webpack_require__(22);
const formRow_1 = __webpack_require__(14);
const radioChoice_1 = __webpack_require__(40);
const disableable_1 = __webpack_require__(8);
const selectors_1 = __webpack_require__(9);
const filterTemplatesSelectors_1 = __webpack_require__(34);
const canary_settings_1 = __webpack_require__(11);
const filterTemplateSelector_1 = __webpack_require__(178);
const metricStoreConfig_service_1 = __webpack_require__(17);
const inlineTemplateEditor_1 = __webpack_require__(184);
__webpack_require__(116);
function EffectSizeSummary({ effectSizes }) {
    if (!effectSizes || Object.keys(effectSizes).length === 0) {
        return null;
    }
    const { allowedIncrease, criticalIncrease, allowedDecrease, criticalDecrease } = effectSizes;
    return (React.createElement(formRow_1.default, { label: "Effect Sizes" },
        React.createElement("div", { className: "vertical" },
            allowedIncrease && (React.createElement("span", null,
                "Allowed Increase: ",
                React.createElement("b", null, allowedIncrease))),
            criticalIncrease && (React.createElement("span", null,
                "Critical Increase: ",
                React.createElement("b", null, criticalIncrease))),
            allowedDecrease && (React.createElement("span", null,
                "Allowed Decrease: ",
                React.createElement("b", null, allowedDecrease))),
            criticalDecrease && (React.createElement("span", null,
                "Critical Decrease: ",
                React.createElement("b", null, criticalDecrease))),
            React.createElement("span", { className: "body-small color-text-caption", style: { marginTop: '5px' } }, "Effect sizes are not currently configurable via the UI."))));
}
function EditMetricModal({ metric, rename, changeGroup, groups, confirm, cancel, isTemplateValid, updateDirection, updateNanStrategy, updateCriticality, useInlineTemplateEditor, disableEdit, validationErrors, }) {
    if (!metric) {
        return null;
    }
    const direction = lodash_1.get(metric, ['analysisConfigurations', 'canary', 'direction'], 'either');
    const nanStrategy = lodash_1.get(metric, ['analysisConfigurations', 'canary', 'nanStrategy'], 'default');
    const critical = lodash_1.get(metric, ['analysisConfigurations', 'canary', 'critical'], false);
    const effectSize = lodash_1.get(metric, [
        'analysisConfigurations',
        'canary',
        'effectSize',
    ]);
    const isConfirmDisabled = !isTemplateValid || disableEdit || lodash_1.values(validationErrors).some(e => !lodash_1.isNull(e));
    const metricGroup = metric.groups.length ? metric.groups[0] : groups[0];
    const templatesEnabled = metricStoreConfig_service_1.default.getDelegate(metric.query.type) &&
        metricStoreConfig_service_1.default.getDelegate(metric.query.type).useTemplates &&
        canary_settings_1.CanarySettings.templatesEnabled;
    return (React.createElement(react_bootstrap_1.Modal, { bsSize: "large", show: true, onHide: core_1.noop, className: classNames('kayenta-edit-metric-modal') },
        React.createElement(styleguide_1.default, null,
            React.createElement(react_bootstrap_1.Modal.Header, null,
                React.createElement(react_bootstrap_1.Modal.Title, null, disableEdit ? 'Metric Details' : 'Configure Metric')),
            React.createElement(react_bootstrap_1.Modal.Body, null,
                React.createElement(formRow_1.default, { label: "Group" },
                    metric.groups.length > 1 && (React.createElement(disableable_1.DisableableInput, { type: "text", value: metric.groups, "data-id": metric.id, onChange: changeGroup, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] })),
                    metric.groups.length < 2 && (React.createElement(disableable_1.DisableableSelect, { value: metricGroup, onChange: changeGroup, className: "form-control input-sm", disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }, groups.map(g => (React.createElement("option", { key: g, value: g }, g)))))),
                React.createElement(formRow_1.default, { label: "Name", error: lodash_1.get(validationErrors, 'name.message', null) },
                    React.createElement(disableable_1.DisableableInput, { type: "text", value: metric.name, "data-id": metric.id, onChange: rename, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] })),
                React.createElement(formRow_1.default, { label: "Fail on" },
                    React.createElement(radioChoice_1.default, { value: "increase", label: "Increase", name: "direction", current: direction, action: updateDirection }),
                    React.createElement(radioChoice_1.default, { value: "decrease", label: "Decrease", name: "direction", current: direction, action: updateDirection }),
                    React.createElement(radioChoice_1.default, { value: "either", label: "Either", name: "direction", current: direction, action: updateDirection })),
                React.createElement(formRow_1.default, { label: "Criticality", checkbox: true },
                    React.createElement("label", null,
                        React.createElement(disableable_1.DisableableInput, { type: "checkbox", checked: critical, onChange: updateCriticality, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }),
                        "Fail the canary if this metric fails")),
                React.createElement(formRow_1.default, { label: "NaN Strategy", helpId: "canary.config.nanStrategy" },
                    React.createElement(radioChoice_1.default, { value: "default", label: "Default (remove)", name: "nanStrategy", current: nanStrategy, action: updateNanStrategy }),
                    React.createElement(radioChoice_1.default, { value: "replace", label: "Replace with zero", name: "nanStrategy", current: nanStrategy, action: updateNanStrategy }),
                    React.createElement(radioChoice_1.default, { value: "remove", label: "Remove", name: "nanStrategy", current: nanStrategy, action: updateNanStrategy })),
                React.createElement(EffectSizeSummary, { effectSizes: effectSize }),
                React.createElement(metricConfigurerDelegator_1.default, null),
                templatesEnabled && !useInlineTemplateEditor && React.createElement(filterTemplateSelector_1.default, null),
                templatesEnabled && useInlineTemplateEditor && React.createElement(inlineTemplateEditor_1.default, null)),
            React.createElement(react_bootstrap_1.Modal.Footer, null,
                React.createElement("ul", { className: "list-inline pull-right" },
                    React.createElement("li", null,
                        React.createElement("button", { className: "passive", onClick: cancel }, "Cancel")),
                    React.createElement("li", null,
                        React.createElement("button", { className: "primary", disabled: isConfirmDisabled, onClick: confirm }, "OK")))))));
}
function mapDispatchToProps(dispatch) {
    return {
        rename: (event) => {
            dispatch(Creators.renameMetric({ id: event.target.dataset.id, name: event.target.value }));
        },
        changeGroup: (event) => {
            dispatch(Creators.updateMetricGroup({ id: event.target.dataset.id, group: event.target.value }));
        },
        cancel: () => {
            dispatch(Creators.editMetricCancel());
            dispatch(Creators.editTemplateCancel());
        },
        confirm: () => {
            dispatch(Creators.editMetricConfirm());
            dispatch(Creators.editTemplateCancel());
        },
        updateDirection: ({ target }) => {
            dispatch(Creators.updateMetricDirection({ id: target.dataset.id, direction: target.value }));
        },
        updateNanStrategy: ({ target }) => {
            dispatch(Creators.updateMetricNanStrategy({ id: target.dataset.id, strategy: target.value }));
        },
        updateCriticality: ({ target }) => {
            dispatch(Creators.updateMetricCriticality({ id: target.dataset.id, critical: Boolean(target.checked) }));
        },
    };
}
function mapStateToProps(state) {
    return {
        metric: state.selectedConfig.editingMetric,
        groups: state.selectedConfig.group.list.sort(),
        isTemplateValid: filterTemplatesSelectors_1.isTemplateValidSelector(state),
        useInlineTemplateEditor: filterTemplatesSelectors_1.useInlineTemplateEditorSelector(state),
        disableEdit: state.app.disableConfigEdit,
        validationErrors: selectors_1.editingMetricValidationErrorsSelector(state),
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(EditMetricModal);


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __webpack_require__(2);
function validateMetricName(errors, editingMetric, metricList) {
    const nextErrors = Object.assign({}, errors);
    const editingMetricName = lodash_1.get(editingMetric, 'name', '');
    if (!editingMetricName) {
        nextErrors.name = { message: 'Name is required' };
        return nextErrors;
    }
    const isNameUnique = metricList.every(m => m.name !== editingMetricName || m.id === editingMetric.id);
    if (!isNameUnique) {
        nextErrors.name = { message: `Metric '${editingMetricName}' already exists` };
    }
    return nextErrors;
}
exports.validateMetricName = validateMetricName;
function validateMetric(editingMetric, metricList) {
    const errors = {
        name: null,
    };
    return [validateMetricName].reduce((reducedErrors, validator) => validator(reducedErrors, editingMetric, metricList), errors);
}
exports.validateMetric = validateMetric;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const lodash_1 = __webpack_require__(2);
const formRow_1 = __webpack_require__(14);
const disableable_1 = __webpack_require__(8);
const Creators = __webpack_require__(3);
const selectors_1 = __webpack_require__(9);
const filterTemplatesSelectors_1 = __webpack_require__(34);
__webpack_require__(117);
class FilterTemplateSelector extends React.Component {
    constructor() {
        super(...arguments);
        this.getOptions = () => {
            const templateOptions = Object.keys(this.props.templates).map(t => ({
                value: t,
                label: t,
                requestingNew: false,
            }));
            templateOptions.push({ value: null, label: null, requestingNew: true });
            return templateOptions;
        };
        this.optionRenderer = (option) => {
            if (option.requestingNew) {
                return React.createElement("span", null, "Create new...");
            }
            return (React.createElement("span", { className: "filter-template-option" },
                React.createElement("span", null, option.label),
                React.createElement("span", null,
                    React.createElement("button", { className: "link", onMouseDown: e => this.props.deleteTemplate(e, option.value) }, "Delete"),
                    React.createElement("button", { className: "link", onMouseDown: e => this.props.editTemplateBegin(e, option.value, this.props.templates[option.value]) }, "Edit"))));
        };
    }
    render() {
        const { editedTemplateName, editedTemplateValue, editTemplateCancel, editTemplateConfirm, editTemplateName, editTemplateValue, selectTemplate, selectedTemplateName, templates, validation, } = this.props;
        const isEditing = lodash_1.isString(editedTemplateName) && lodash_1.isString(editedTemplateValue);
        return (React.createElement(React.Fragment, null,
            React.createElement(formRow_1.default, { label: "Filter Template", helpId: "canary.config.filterTemplate" }, !isEditing && (React.createElement(disableable_1.DisableableReactSelect, { value: selectedTemplateName, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG], onChange: selectTemplate, options: this.getOptions(), optionRenderer: this.optionRenderer }))),
            isEditing && (React.createElement(React.Fragment, null,
                React.createElement(formRow_1.default, { label: "Name", error: lodash_1.get(validation, 'errors.templateName.message') },
                    React.createElement(disableable_1.DisableableInput, { disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG], onChange: editTemplateName, value: editedTemplateName })),
                React.createElement(formRow_1.default, { label: "Template", error: lodash_1.get(validation, 'errors.templateValue.message'), warning: lodash_1.get(validation, 'warnings.template.message') },
                    React.createElement(disableable_1.DisableableTextarea, { className: "template-editor-textarea", disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG], onChange: editTemplateValue, value: editedTemplateValue })),
                React.createElement(formRow_1.default, null,
                    React.createElement("div", { className: "horizontal pull-right" },
                        React.createElement("button", { className: "link", onClick: editTemplateCancel }, "Cancel"),
                        React.createElement("button", { className: "link", disabled: [validation.errors.templateName, validation.errors.templateValue].some(e => e != null), onClick: editTemplateConfirm }, "Save"))))),
            !isEditing &&
                selectedTemplateName && (React.createElement(formRow_1.default, null,
                React.createElement("pre", { className: "template-editor-value-formatted" }, templates[selectedTemplateName])))));
    }
}
exports.FilterTemplateSelector = FilterTemplateSelector;
const mapStateToProps = (state) => ({
    editedTemplateName: lodash_1.get(selectors_1.editingTemplateSelector(state), 'editedName'),
    editedTemplateValue: lodash_1.get(selectors_1.editingTemplateSelector(state), 'editedValue'),
    selectedTemplateName: filterTemplatesSelectors_1.selectedTemplateNameSelector(state),
    templates: selectors_1.configTemplatesSelector(state),
    validation: filterTemplatesSelectors_1.editingTemplateValidationSelector(state),
});
const mapDispatchToProps = (dispatch) => ({
    deleteTemplate: (e, name) => {
        e.stopPropagation();
        dispatch(Creators.selectTemplate({ name: null }));
        dispatch(Creators.deleteTemplate({ name }));
    },
    editTemplateBegin: (e, name, value) => {
        e.stopPropagation();
        dispatch(Creators.selectTemplate({ name }));
        dispatch(Creators.editTemplateBegin({
            name,
            value,
        }));
    },
    editTemplateCancel: () => dispatch(Creators.editTemplateCancel()),
    editTemplateConfirm: () => dispatch(Creators.editTemplateConfirm()),
    editTemplateName: (event) => dispatch(Creators.editTemplateName({ name: event.target.value })),
    editTemplateValue: (event) => dispatch(Creators.editTemplateValue({ value: event.target.value })),
    selectTemplate: (option) => {
        if (option && option.requestingNew === true) {
            dispatch(Creators.selectTemplate({ name: null }));
            dispatch(Creators.addTemplate());
        }
        else {
            dispatch(Creators.selectTemplate({ name: option ? option.value : null }));
        }
    },
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(FilterTemplateSelector);


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __webpack_require__(2);
function validateTemplateName(validation, validationInput) {
    const { editingTemplate, configTemplates } = validationInput;
    if (editingTemplate.editedName === '') {
        validation.errors.templateName = {
            message: 'Name is required',
        };
        return validation;
    }
    const isNameEdited = editingTemplate && editingTemplate.editedName !== editingTemplate.name;
    const savedTemplateNames = Object.keys(configTemplates || {});
    const isNameDuplicate = isNameEdited && savedTemplateNames.some(name => editingTemplate.editedName === name);
    if (isNameDuplicate) {
        validation.errors.templateName = {
            message: `Filter template named '${editingTemplate.editedName}' already exists`,
        };
    }
    return validation;
}
exports.validateTemplateName = validateTemplateName;
function validateTemplateValue(validation, validationInput) {
    const { editingTemplate } = validationInput;
    if (editingTemplate.editedValue === '') {
        validation.errors.templateValue = {
            message: 'Value is required',
        };
    }
    return validation;
}
exports.validateTemplateValue = validateTemplateValue;
function validateTemplateInUseWarning(validation, validationInput) {
    const { metricList, editingMetric } = validationInput;
    const filterTemplate = lodash_1.get(editingMetric, 'query.customFilterTemplate');
    const otherMetricsUsingTemplate = editingMetric != null &&
        filterTemplate != null &&
        metricList.filter(m => m.name !== editingMetric.name && filterTemplate === lodash_1.get(m, 'query.customFilterTemplate'));
    if (!lodash_1.isEmpty(otherMetricsUsingTemplate)) {
        validation.warnings.template = {
            message: `Warning: editing or deleting this template will affect the following metrics: ${otherMetricsUsingTemplate
                .map(m => m.name)
                .join(', ')}`,
        };
    }
    return validation;
}
exports.validateTemplateInUseWarning = validateTemplateInUseWarning;
function validateTemplate(templateValidationInput) {
    return [validateTemplateName, validateTemplateValue, validateTemplateInUseWarning].reduce((reducedValidation, validator) => validator(reducedValidation, templateValidationInput), { errors: {}, warnings: {} });
}
exports.validateTemplate = validateTemplate;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
__webpack_require__(118);
function Footer({ children }) {
    return React.createElement("div", { className: classNames('row', 'canary-footer') }, children);
}
exports.default = Footer;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const Creators = __webpack_require__(3);
const disableable_1 = __webpack_require__(8);
function GroupName({ editing, edit, group, onClick, handleUpdate, handleSubmit, defaultGroup, }) {
    if (editing) {
        return (React.createElement("form", { onSubmit: handleSubmit, onBlur: handleSubmit, "data-group": group, "data-edit": edit },
            React.createElement(disableable_1.DisableableInput, { autoFocus: true, value: edit, onChange: handleUpdate, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] })));
    }
    else {
        return (React.createElement("a", { "data-group": group, onClick: onClick }, group || defaultGroup));
    }
}
function mapStateToProps(state, ownProps) {
    return Object.assign({ edit: state.selectedConfig.group.edit }, ownProps);
}
function mapDispatchToProps(dispatch) {
    return {
        handleUpdate: (event) => {
            dispatch(Creators.editGroupUpdate({ edit: event.target.value }));
        },
        handleSubmit: (event) => {
            dispatch(Creators.editGroupConfirm(Object.assign({}, event.currentTarget.dataset)));
            event.stopPropagation();
            event.preventDefault();
        },
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(GroupName);


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const lodash_1 = __webpack_require__(2);
const formRow_1 = __webpack_require__(14);
const disableable_1 = __webpack_require__(8);
const Creators = __webpack_require__(3);
const canaryConfig_service_1 = __webpack_require__(18);
function GroupWeight({ group, config, handleInputChange, }) {
    const groupWeight = getGroupWeights(config)[group];
    return (React.createElement(formRow_1.default, { label: group },
        React.createElement(disableable_1.DisableableInput, { type: "number", value: lodash_1.isNumber(groupWeight) ? groupWeight : '', onChange: handleInputChange, min: 0, max: 100, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] })));
}
function getGroupWeights(config) {
    return lodash_1.get(config, 'classifier.groupWeights', {});
}
function mapStateToProps(state, ownProps) {
    return Object.assign({}, ownProps, { config: canaryConfig_service_1.mapStateToConfig(state) });
}
function mapDispatchToProps(dispatch, { group }) {
    return {
        handleInputChange: (event) => {
            dispatch(Creators.updateGroupWeight({
                group,
                weight: event.target.value ? parseInt(event.target.value, 10) : null,
            }));
        },
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(GroupWeight);


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const lodash_1 = __webpack_require__(2);
const groupWeight_1 = __webpack_require__(182);
const canaryConfig_service_1 = __webpack_require__(18);
function GroupWeights({ groups }) {
    const hasGroups = groups.length > 0;
    return (React.createElement("section", null, hasGroups ? (groups.map(group => React.createElement(groupWeight_1.default, { key: group, group: group }))) : (React.createElement("p", { key: "no-groups" }, "You have not configured any grouped metrics."))));
}
function mapStateToProps(state) {
    const config = canaryConfig_service_1.mapStateToConfig(state);
    const metrics = config ? config.metrics : [];
    const groups = lodash_1.uniq(lodash_1.flatMap(metrics, metric => metric.groups || []));
    return {
        groups,
    };
}
exports.default = react_redux_1.connect(mapStateToProps)(GroupWeights);


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const lodash_1 = __webpack_require__(2);
const formRow_1 = __webpack_require__(14);
const disableable_1 = __webpack_require__(8);
const Creators = __webpack_require__(3);
const filterTemplatesSelectors_1 = __webpack_require__(34);
function InlineTemplateEditor({ editTemplateValue, templateValue, transformValueForSave, }) {
    return (React.createElement(formRow_1.default, { label: "Template", helpId: "canary.config.filterTemplate", error: lodash_1.isEmpty(templateValue) && 'Template is required' },
        React.createElement(disableable_1.DisableableTextarea, { className: "template-editor-textarea", disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG], onChange: (e) => editTemplateValue(transformValueForSave(e.target.value)), value: templateValue })));
}
exports.InlineTemplateEditor = InlineTemplateEditor;
function mapStateToProps(state) {
    return {
        templateValue: filterTemplatesSelectors_1.inlineTemplateValueSelector(state),
        transformValueForSave: filterTemplatesSelectors_1.transformInlineTemplateForSave(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        editTemplateValue: (value) => dispatch(Creators.editInlineTemplate({ value })),
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(InlineTemplateEditor);


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const metricStoreConfig_service_1 = __webpack_require__(17);
function MetricConfigurerDelegator({ editingMetric }) {
    const config = metricStoreConfig_service_1.default.getDelegate(editingMetric.query.type);
    if (config && config.metricConfigurer) {
        const MetricConfigurer = config.metricConfigurer;
        return React.createElement(MetricConfigurer, null);
    }
    else {
        return React.createElement("p", null,
            "Metric configuration has not been implemented for ",
            editingMetric.query.type,
            ".");
    }
}
function mapStateToProps(state) {
    return {
        editingMetric: state.selectedConfig.editingMetric,
    };
}
exports.default = react_redux_1.connect(mapStateToProps)(MetricConfigurerDelegator);


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const lodash_1 = __webpack_require__(2);
const Creators = __webpack_require__(3);
const table_1 = __webpack_require__(23);
const changeMetricGroupModal_1 = __webpack_require__(165);
const disableable_1 = __webpack_require__(8);
__webpack_require__(119);
function MetricList({ metrics, groupList, selectedGroup, showGroups, addMetric, editMetric, copyMetric, removeMetric, changingGroupMetric, openChangeMetricGroupModal, metricStore, disableEdit, }) {
    const columns = [
        {
            label: 'Metric Name',
            getContent: metric => React.createElement("span", null, metric.name || '(new)'),
        },
        {
            label: 'Groups',
            getContent: metric => React.createElement("span", null, metric.groups.join(', ')),
            hide: () => !showGroups,
        },
        {
            getContent: metric => (React.createElement("div", { className: "horizontal pull-right metrics-action-buttons" },
                React.createElement("button", { className: "link", "data-id": metric.id, onClick: editMetric }, disableEdit ? 'View' : 'Edit'),
                React.createElement("button", { className: "link", "data-id": metric.id, disabled: disableEdit, onClick: openChangeMetricGroupModal }, "Move Group"),
                React.createElement("button", { className: "link", "data-id": metric.id, disabled: disableEdit, onClick: () => copyMetric(metric) }, "Copy"),
                React.createElement("button", { className: "link", "data-id": metric.id, disabled: disableEdit, onClick: removeMetric }, "Delete"))),
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(table_1.NativeTable, { columns: columns, rows: metrics, rowKey: metric => metric.id, className: "header-white" }),
        !metrics.length && selectedGroup ? (React.createElement("p", null, "This group is empty! The group will be not be present the next time the config is loaded unless it is saved with at least one metric in it.")) : null,
        changingGroupMetric && React.createElement(changeMetricGroupModal_1.default, { metric: changingGroupMetric }),
        React.createElement(disableable_1.DisableableButton, { className: "passive self-left", "data-group": selectedGroup, "data-default": groupList[0], "data-metric-store": metricStore, onClick: addMetric, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }, "Add Metric")));
}
function mapStateToProps(state) {
    const selectedGroup = state.selectedConfig.group.selected;
    const metricList = state.selectedConfig.metricList;
    const filter = selectedGroup ? (metric) => metric.groups.includes(selectedGroup) : () => true;
    return {
        selectedGroup,
        groupList: state.selectedConfig.group.list,
        metrics: metricList.filter(filter),
        showGroups: !selectedGroup || metricList.filter(filter).some(metric => metric.groups.length > 1),
        changingGroupMetric: state.selectedConfig.metricList.find(m => m.id === state.selectedConfig.changeMetricGroup.metric),
        metricStore: state.selectedConfig.selectedStore,
        disableEdit: state.app.disableConfigEdit,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        addMetric: (event) => {
            const group = event.target.dataset.group || event.target.dataset.default;
            dispatch(Creators.addMetric({
                metric: {
                    id: '[new]',
                    analysisConfigurations: {},
                    name: '',
                    query: {
                        type: event.target.dataset.metricStore,
                        serviceType: event.target.dataset.metricStore,
                    },
                    groups: group ? [group] : [],
                    scopeName: 'default',
                    isNew: true,
                },
            }));
        },
        copyMetric: (metric) => {
            const metricCopy = lodash_1.cloneDeep(metric);
            metricCopy.id = '[new]';
            metricCopy.isNew = true;
            metricCopy.name = '';
            dispatch(Creators.addMetric({ metric: metricCopy }));
        },
        editMetric: (event) => {
            dispatch(Creators.editMetricBegin({ id: event.target.dataset.id }));
        },
        removeMetric: (event) => {
            dispatch(Creators.removeMetric({ id: event.target.dataset.id }));
        },
        openChangeMetricGroupModal: (event) => dispatch(Creators.changeMetricGroup({ id: event.target.dataset.id })),
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(MetricList);


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const lodash_1 = __webpack_require__(2);
const Creators = __webpack_require__(3);
const domain_1 = __webpack_require__(13);
const formRow_1 = __webpack_require__(14);
const disableable_1 = __webpack_require__(8);
const MetricStoreSelector = ({ stores, selectedStore, select, }) => {
    if (stores.length < 2) {
        return null;
    }
    return (React.createElement(formRow_1.default, { label: "Metric Store" },
        React.createElement(disableable_1.DisableableSelect, { value: selectedStore || '', onChange: select, className: "form-control input-sm", disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }, stores.map(s => (React.createElement("option", { key: s, value: s }, s))))));
};
const mapStateToProps = (state) => {
    return {
        stores: lodash_1.chain(state.data.kayentaAccounts.data)
            .filter(account => account.supportedTypes.includes(domain_1.KayentaAccountType.MetricsStore))
            .map(account => account.metricsStoreType || account.type)
            .uniq()
            .sort()
            .valueOf(),
        selectedStore: state.selectedConfig.selectedStore,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        select: (event) => dispatch(Creators.selectMetricStore({ store: event.target.value })),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(MetricStoreSelector);


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const formRow_1 = __webpack_require__(14);
const Creators = __webpack_require__(3);
const formList_1 = __webpack_require__(61);
const disableable_1 = __webpack_require__(8);
const metricStoreSelector_1 = __webpack_require__(187);
function NameAndDescription({ name, description, changeName, changeDescription, }) {
    return (React.createElement(formList_1.default, null,
        React.createElement(formRow_1.default, { label: "Configuration Name" },
            React.createElement(disableable_1.DisableableInput, { type: "text", value: name, onChange: changeName, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] })),
        React.createElement(metricStoreSelector_1.default, null),
        React.createElement(formRow_1.default, { label: "Description" },
            React.createElement(disableable_1.DisableableTextarea, { className: "form-control input-sm", value: description, onChange: changeDescription, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }))));
}
function mapStateToProps(state) {
    if (state.selectedConfig.config) {
        return {
            name: state.selectedConfig.config.name,
            description: state.selectedConfig.config.description,
        };
    }
    else {
        return {
            name: '',
            description: '',
        };
    }
}
function mapDispatchToProps(dispatch) {
    return {
        changeName: (event) => {
            dispatch(Creators.updateConfigName({
                name: event.target.value,
            }));
        },
        changeDescription: (event) => {
            dispatch(Creators.updateConfigDescription({
                description: event.target.value,
            }));
        },
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(NameAndDescription);


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const Creators = __webpack_require__(3);
const configJsonModal_1 = __webpack_require__(57);
function OpenConfigJsonModalButton({ openConfigJsonModal }) {
    return (React.createElement("div", null,
        React.createElement("button", { className: "passive", onClick: openConfigJsonModal },
            React.createElement("i", { className: "far fa-file-code" }),
            React.createElement("span", null, "JSON")),
        React.createElement(configJsonModal_1.default, null)));
}
function mapDispatchToProps(dispatch) {
    return {
        openConfigJsonModal: () => dispatch(Creators.openConfigJsonModal()),
    };
}
exports.default = react_redux_1.connect(null, mapDispatchToProps)(OpenConfigJsonModalButton);


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const Creators = __webpack_require__(3);
const deleteModal_1 = __webpack_require__(174);
const disableable_1 = __webpack_require__(8);
function DeleteConfigButton({ openDeleteConfigModal, disabled }) {
    return (React.createElement("div", null,
        React.createElement(disableable_1.DisableableButton, { className: "passive", disabled: disabled, onClick: openDeleteConfigModal, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] },
            React.createElement("i", { className: "fa fa-trash" }),
            React.createElement("span", null, "Delete")),
        React.createElement(deleteModal_1.default, null)));
}
function mapStateToProps(state) {
    return {
        disabled: state.selectedConfig.config && state.selectedConfig.config.isNew,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        openDeleteConfigModal: () => dispatch(Creators.openDeleteConfigModal()),
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(DeleteConfigButton);


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const core_1 = __webpack_require__(6);
const buildHelpText = (ownedBy) => {
    if (ownedBy.length === 0) {
        return null;
    }
    else if (ownedBy.length === 1) {
        return `This config can only be edited from within the application <strong>${ownedBy[0]}.</strong>`;
    }
    else {
        return `This config can only be edited from within the following applications: <strong>${ownedBy.join(', ')}.</strong>`;
    }
};
exports.OwnedBy = ({ owningApplications, currentApplication }) => {
    if (owningApplications.length < 2 && owningApplications.includes(currentApplication)) {
        return null;
    }
    return (React.createElement("span", null,
        "Owned by: ",
        owningApplications.join(', '),
        "\u00A0",
        React.createElement(core_1.HelpField, { placement: "right", content: buildHelpText(owningApplications) })));
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
const validationErrors_1 = __webpack_require__(197);
const saveConfigButton_1 = __webpack_require__(193);
const saveConfigError_1 = __webpack_require__(194);
function Save() {
    return (React.createElement("div", { className: classNames('col-sm-12', 'text-right') },
        React.createElement(validationErrors_1.default, null),
        React.createElement(saveConfigError_1.default, null),
        React.createElement(saveConfigButton_1.default, null)));
}
exports.default = Save;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const core_1 = __webpack_require__(6);
const Creators = __webpack_require__(3);
const asyncRequest_1 = __webpack_require__(15);
function SaveConfigButton({ saveConfigState, inSyncWithServer, saveConfig, disable, }) {
    if (inSyncWithServer && saveConfigState !== asyncRequest_1.AsyncRequestState.Requesting) {
        return (React.createElement("span", { className: "btn btn-link disabled" },
            React.createElement("i", { className: "far fa-check-circle" }),
            " In sync with server"));
    }
    else {
        return (React.createElement(core_1.SubmitButton, { label: "Save Changes", onClick: saveConfig, isDisabled: disable, submitting: saveConfigState === asyncRequest_1.AsyncRequestState.Requesting }));
    }
}
function mapStateToProps(state) {
    const disable = !!state.selectedConfig.validationErrors.length;
    return {
        saveConfigState: state.selectedConfig.save.state,
        inSyncWithServer: state.selectedConfig.isInSyncWithServer,
        disable,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        saveConfig: () => {
            dispatch(Creators.saveConfig());
        },
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SaveConfigButton);


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const classNames = __webpack_require__(7);
const Creators = __webpack_require__(3);
const asyncRequest_1 = __webpack_require__(15);
function SaveConfigError({ saveConfigState, saveConfigErrorMessage, dismissError, }) {
    return (saveConfigState === asyncRequest_1.AsyncRequestState.Failed && (React.createElement("span", { className: classNames('alert', 'alert-danger') },
        buildErrorMessage(saveConfigErrorMessage),
        React.createElement("a", { className: classNames('alert-dismiss', 'clickable'), onClick: dismissError },
            ' ',
            "[dismiss]"))));
}
function buildErrorMessage(saveConfigErrorMessage) {
    const message = 'The was an error saving your config';
    return saveConfigErrorMessage ? message + `: ${saveConfigErrorMessage}.` : message + '.';
}
function mapStateToProps(state) {
    return {
        saveConfigState: state.selectedConfig.save.state,
        saveConfigErrorMessage: state.selectedConfig.save.error,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dismissError: () => {
            dispatch(Creators.dismissSaveConfigError());
        },
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SaveConfigError);


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const titledSubsection_1 = __webpack_require__(202);
const groupWeights_1 = __webpack_require__(183);
const judgeSelect_1 = __webpack_require__(39);
const formList_1 = __webpack_require__(61);
function Scoring({ renderJudgeSelect }) {
    return (React.createElement(formList_1.default, null,
        renderJudgeSelect && (React.createElement(titledSubsection_1.default, { title: "Judge" },
            React.createElement(judgeSelect_1.default, null))),
        React.createElement(titledSubsection_1.default, { title: "Metric Group Weights", helpKey: "canary.config.metricGroupWeights" },
            React.createElement(groupWeights_1.default, null))));
}
function mapStateToProps(state) {
    return {
        renderJudgeSelect: state.selectedConfig.judge.renderState !== judgeSelect_1.JudgeSelectRenderState.None,
    };
}
exports.default = react_redux_1.connect(mapStateToProps)(Scoring);


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const centeredDetail_1 = __webpack_require__(25);
function SelectConfig() {
    return (React.createElement(centeredDetail_1.default, null,
        React.createElement("h3", { className: "heading-3" }, "Click a configuration to edit.")));
}
exports.default = SelectConfig;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const core_1 = __webpack_require__(6);
const ConfigValidationErrors = ({ errors }) => {
    if (!errors || !errors.length) {
        return null;
    }
    const template = (React.createElement("section", null,
        React.createElement("p", null, "The following errors may prevent this config from working properly:"),
        React.createElement("ul", null, errors.map(e => (React.createElement("li", { key: e }, e))))));
    return (React.createElement(core_1.HoverablePopover, { placement: 'left', template: template },
        React.createElement("button", { className: "btn btn-link" },
            React.createElement("i", { className: "fa fa-exclamation-triangle" }))));
};
const mapStateToProps = (state) => ({
    errors: state.selectedConfig.validationErrors.map(e => e.message),
});
exports.default = react_redux_1.connect(mapStateToProps)(ConfigValidationErrors);


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
const nativeTableHeader_1 = __webpack_require__(64);
function NativeTable({ rows, columns, rowKey, tableBodyClassName, rowClassName, onRowClick, customRow, className, headerClassName, }) {
    const TableRow = ({ row }) => (React.createElement("tr", { onClick: onRowClick ? () => onRowClick(row) : null, className: classNames({ 'table-row': !rowClassName }, rowClassName && rowClassName(row)) }, columns.map(({ label, hide, getContent }, i) => (React.createElement("td", { key: label || i }, (!hide || !hide(row)) && getContent(row))))));
    return (React.createElement("table", { className: className },
        React.createElement(nativeTableHeader_1.NativeTableHeader, { rows: rows, columns: columns, className: classNames('table-header', headerClassName) }),
        React.createElement("tbody", { className: tableBodyClassName }, rows.map(r => customRow && customRow(r) ? React.createElement("td", { key: rowKey(r) }, customRow(r)) : React.createElement(TableRow, { key: rowKey(r), row: r })))));
}
exports.NativeTable = NativeTable;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
const tableHeader_1 = __webpack_require__(65);
function Table({ rows, columns, rowKey, tableBodyClassName, rowClassName, onRowClick, customRow, className, headerClassName, }) {
    const TableRow = ({ row }) => (React.createElement("li", { onClick: onRowClick ? () => onRowClick(row) : null, className: classNames({ horizontal: !rowClassName, 'table-row': !rowClassName }, rowClassName && rowClassName(row)) }, columns.map((c, i) => (React.createElement("div", { key: c.label || i, className: `flex-${c.width}` }, !c.hide && c.getContent(row))))));
    return (React.createElement("div", { className: className },
        React.createElement("ul", { className: classNames(tableBodyClassName, 'list-group') },
            React.createElement(tableHeader_1.TableHeader, { columns: columns, className: classNames('table-header', 'sticky-header', headerClassName) }),
            rows.map(r => customRow && customRow(r) ? (React.createElement("div", { key: rowKey(r) }, customRow(r))) : (React.createElement(TableRow, { key: rowKey(r), row: r }))))));
}
exports.Table = Table;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
__webpack_require__(122);
function TitledSection({ title, children }) {
    return (React.createElement("section", { className: "pod open titled-section" },
        React.createElement("div", { className: "header horizontal middle" },
            React.createElement("div", { className: "flex-1 heading-2 uppercase" }, title)),
        React.createElement("div", { className: "contents vertical" }, children)));
}
exports.default = TitledSection;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const core_1 = __webpack_require__(6);
__webpack_require__(123);
function TitledSubsection({ title, children, helpKey }) {
    return (React.createElement("section", { className: "titled-subsection" },
        React.createElement("h5", { className: "heading-5" },
            title,
            " ",
            helpKey && React.createElement(core_1.HelpField, { id: helpKey })),
        React.createElement("hr", null),
        children));
}
exports.default = TitledSubsection;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const lodash_1 = __webpack_require__(2);
const formik_1 = __webpack_require__(294);
const react_bootstrap_1 = __webpack_require__(29);
const core_1 = __webpack_require__(6);
const domain_1 = __webpack_require__(13);
const canaryScores_1 = __webpack_require__(55);
const canaryRun_service_1 = __webpack_require__(35);
const RESOURCE_TYPES = {
    prometheus: [
        { label: '', value: '' },
        { label: 'gce_instance', value: 'gce_instance' },
        { label: 'aws_ec2_instance', value: 'aws_ec2_instance' },
    ],
    stackdriver: [
        { label: 'gce_instance', value: 'gce_instance' },
        { label: 'aws_ec2_instance', value: 'aws_ec2_instance' },
        { label: 'gae_app', value: 'gae_app' },
        { label: 'k8s_container', value: 'k8s_container' },
        { label: 'k8s_pod', value: 'k8s_pod' },
        { label: 'k8s_node', value: 'k8s_node' },
        { label: 'gke_container', value: 'gke_container' },
        { label: 'https_lb_rule', value: 'https_lb_rule' },
        { label: 'global', value: 'global' },
    ],
};
const transformFormPropsToExecutionRequest = (values, accounts) => {
    const step = parseInt(values.step, 10);
    const pass = parseInt(values.passThreshold, 10);
    const marginal = parseInt(values.marginalThreshold, 10);
    const metricsAccount = accounts.find(({ name }) => values.metricsAccountName === name);
    const accountSpecificParams = {};
    if (values.resourceType) {
        accountSpecificParams.resourceType = values.resourceType;
    }
    if (metricsAccount.type === 'atlas') {
        accountSpecificParams.type = 'cluster';
    }
    const extendedScopeParams = Object.assign({}, values.extendedScopeParams, accountSpecificParams);
    return {
        scopes: {
            default: {
                controlScope: {
                    scope: values.baselineScope,
                    start: values.startTime,
                    end: values.endTime,
                    location: values.baselineLocation,
                    step,
                    extendedScopeParams,
                },
                experimentScope: {
                    scope: values.canaryScope,
                    start: values.startTime,
                    end: values.endTime,
                    location: values.canaryLocation,
                    step,
                    extendedScopeParams,
                },
            },
        },
        thresholds: {
            pass,
            marginal,
        },
    };
};
const initialValues = {
    configId: null,
    startTime: '',
    endTime: '',
    step: '',
    baselineScope: '',
    canaryScope: '',
    baselineLocation: '',
    canaryLocation: '',
    extendedScopeParams: {},
    resourceType: '',
    marginalThreshold: '',
    passThreshold: '',
    metricsAccountName: '',
    storageAccountName: '',
};
class ManualAnalysisModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAllControlLocations: false,
            showAllExperimentLocations: false,
        };
        this.validate = (values) => {
            const errors = {};
            if (!values.configId) {
                errors.configId = 'You must choose a canary config';
            }
            if (!values.startTime) {
                errors.startTime = 'You must provide a start time';
            }
            if (!values.endTime) {
                errors.endTime = 'You must provide an end time';
            }
            if (!values.step) {
                errors.step = 'You must provide a step value';
            }
            else if (parseInt(values.step, 10) < 1) {
                errors.step = 'Invalid step value';
            }
            if (!values.baselineScope) {
                errors.baselineScope = 'You must provide a baseline scope';
            }
            if (!values.canaryScope) {
                errors.canaryScope = 'You must provide a canary scope';
            }
            if (!values.baselineLocation) {
                errors.baselineLocation = 'You must provide a baseline location';
            }
            if (!values.canaryLocation) {
                errors.canaryLocation = 'You must provide a canary location';
            }
            const marginalThreshold = parseInt(values.marginalThreshold, 10);
            const passThreshold = parseInt(values.passThreshold, 10);
            if (!values.marginalThreshold) {
                errors.marginalThreshold = 'You must provide a marginal score threshold';
            }
            else if (marginalThreshold > passThreshold || marginalThreshold < 1) {
                errors.marginalThreshold = 'Invalid marginal score threshold';
            }
            if (!values.passThreshold) {
                errors.passThreshold = 'You must provide a passing score threshold';
            }
            else if (passThreshold < marginalThreshold || passThreshold > 100) {
                errors.passThreshold = 'Invalid passing score threshold';
            }
            if (!values.metricsAccountName) {
                errors.metricsAccountName = 'You must choose a metrics account';
            }
            if (!values.storageAccountName) {
                errors.storageAccountName = 'You must choose a storage account';
            }
            return errors;
        };
        this.submit = (values, actions) => {
            const { configId, metricsAccountName, storageAccountName } = values;
            const { application, accounts } = this.props;
            const executionRequest = transformFormPropsToExecutionRequest(values, accounts);
            canaryRun_service_1.startCanaryRun(configId, executionRequest, {
                application: application.name,
                metricsAccountName,
                storageAccountName,
            })
                .then(() => {
                actions.setSubmitting(false);
                actions.setStatus({ succeeded: true });
            })
                .catch(error => {
                actions.setSubmitting(false);
                actions.setStatus({ succeeded: false, error });
            });
        };
    }
    static show(props) {
        const modalProps = { dialogClassName: 'modal-lg' };
        return core_1.ReactModal.show(ManualAnalysisModal, props, modalProps);
    }
    render() {
        const { dismissModal, title, application, accounts } = this.props;
        const { showAllControlLocations, showAllExperimentLocations } = this.state;
        const canaryConfigs = application.getDataSource('canaryConfigs').data;
        const metricsStores = accounts.filter(({ supportedTypes }) => supportedTypes.includes(domain_1.KayentaAccountType.MetricsStore));
        const objectStores = accounts.filter(({ supportedTypes }) => supportedTypes.includes(domain_1.KayentaAccountType.ObjectStore));
        const showAdvancedSettings = metricsStores.length > 1 || objectStores.length > 1;
        return (React.createElement(formik_1.Formik, { initialValues: Object.assign({}, initialValues, { metricsAccountName: lodash_1.get(metricsStores[0], 'name', ''), storageAccountName: lodash_1.get(objectStores[0], 'name', '') }), onSubmit: this.submit, validate: this.validate, render: ({ values, touched, isValid, isSubmitting, status, setFieldValue, }) => {
                if (lodash_1.get(status, 'succeeded') === true) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(core_1.ModalClose, { dismiss: dismissModal }),
                        React.createElement(react_bootstrap_1.Modal.Header, null, React.createElement("h3", null, "Analysis Started")),
                        React.createElement(react_bootstrap_1.Modal.Body, null,
                            React.createElement("p", null, "Analysis started \u2014 check the list of reports in a few minutes to view results")),
                        React.createElement(react_bootstrap_1.Modal.Footer, null,
                            React.createElement("button", { className: "btn btn-primary", onClick: dismissModal, type: "button" }, "Got it"))));
                }
                const selectedMetricsStore = metricsStores.find(({ name }) => values.metricsAccountName === name);
                const selectedObjectStore = objectStores.find(({ name }) => values.storageAccountName === name);
                const recommendedLocations = lodash_1.get(selectedMetricsStore, 'recommendedLocations', []);
                const locations = lodash_1.get(selectedMetricsStore, 'locations', []);
                const hasLocationChoices = recommendedLocations.length > 0 || locations.length > 0;
                return (React.createElement(formik_1.Form, { className: "form-horizontal" },
                    React.createElement(core_1.ModalClose, { dismiss: dismissModal }),
                    React.createElement(react_bootstrap_1.Modal.Header, null, title && React.createElement("h3", null, title)),
                    React.createElement(react_bootstrap_1.Modal.Body, null,
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-md-12" },
                                React.createElement("div", { className: "container-fluid form-horizontal" },
                                    React.createElement("h5", null, "Analysis Configuration"),
                                    React.createElement("div", { className: "horizontal-rule" }),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("div", { className: "col-md-3 sm-label-right" }, "Config Name"),
                                        React.createElement("div", { className: "col-md-7" },
                                            React.createElement(core_1.TetheredSelect, { value: values.configId, options: canaryConfigs.map(({ id, name }) => ({ label: name, value: id })), onChange: (item) => setFieldValue('configId', (item && item.value) || null) }))),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("div", { className: "col-md-3 sm-label-right" },
                                            "Start Time ",
                                            React.createElement(core_1.HelpField, { id: "pipeline.config.canary.startTimeIso" })),
                                        React.createElement("div", { className: "col-md-7" },
                                            React.createElement(formik_1.Field, { className: "form-control input-sm", name: "startTime", required: touched.startTime }))),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("div", { className: "col-md-3 sm-label-right" },
                                            "End Time ",
                                            React.createElement(core_1.HelpField, { id: "pipeline.config.canary.endTimeIso" })),
                                        React.createElement("div", { className: "col-md-7" },
                                            React.createElement(formik_1.Field, { className: "form-control input-sm", name: "endTime", required: touched.endTime }))),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("div", { className: "col-md-3 sm-label-right" }, "Step"),
                                        React.createElement("div", { className: "col-md-7" },
                                            React.createElement(formik_1.Field, { type: "number", style: { width: '60px', display: 'inline-block' }, className: "form-control input-sm", name: "step", required: touched.step }),
                                            React.createElement("span", { className: "form-control-static" }, " seconds"))),
                                    React.createElement("h5", null, "Baseline + Canary Pair"),
                                    React.createElement("div", { className: "horizontal-rule" }),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("div", { className: "col-md-3 sm-label-right" },
                                            "Baseline ",
                                            React.createElement(core_1.HelpField, { id: "pipeline.config.canary.baselineGroup" })),
                                        React.createElement("div", { className: "col-md-7" },
                                            React.createElement(formik_1.Field, { className: "form-control input-sm", name: "baselineScope", required: touched.baselineScope }))),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("div", { className: "col-md-3 sm-label-right" },
                                            "Baseline Location ",
                                            React.createElement(core_1.HelpField, { id: "pipeline.config.canary.baselineLocation" })),
                                        React.createElement("div", { className: "col-md-7" },
                                            React.createElement(LocationField, { hasLocationChoices: hasLocationChoices, showAll: showAllControlLocations, recommendedLocations: recommendedLocations, locations: locations, value: values.baselineLocation, onChange: location => setFieldValue('baselineLocation', location), onShowAllChange: showAll => this.setState({ showAllControlLocations: showAll }), input: React.createElement(formik_1.Field, { className: "form-control input-sm", name: "baselineLocation", required: touched.baselineLocation }) }))),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("div", { className: "col-md-3 sm-label-right" },
                                            "Canary ",
                                            React.createElement(core_1.HelpField, { id: "pipeline.config.canary.canaryGroup" })),
                                        React.createElement("div", { className: "col-md-7" },
                                            React.createElement(formik_1.Field, { className: "form-control input-sm", name: "canaryScope", required: touched.canaryScope }))),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("div", { className: "col-md-3 sm-label-right" },
                                            "Canary Location ",
                                            React.createElement(core_1.HelpField, { id: "pipeline.config.canary.canaryLocation" })),
                                        React.createElement("div", { className: "col-md-7" },
                                            React.createElement(LocationField, { hasLocationChoices: hasLocationChoices, showAll: showAllExperimentLocations, recommendedLocations: recommendedLocations, locations: locations, value: values.canaryLocation, onChange: location => setFieldValue('canaryLocation', location), onShowAllChange: showAll => this.setState({ showAllExperimentLocations: showAll }), input: React.createElement(formik_1.Field, { className: "form-control input-sm", name: "canaryLocation", required: touched.canaryLocation }) }))),
                                    React.createElement("h5", null, "Metric Scope"),
                                    React.createElement("div", { className: "horizontal-rule" }),
                                    RESOURCE_TYPES.hasOwnProperty(lodash_1.get(selectedMetricsStore, 'type')) && (React.createElement("div", { className: "form-group" },
                                        React.createElement("div", { className: "col-md-3 sm-label-right" }, "Resource Type"),
                                        React.createElement("div", { className: "col-md-7" },
                                            React.createElement(core_1.TetheredSelect, { value: values.resourceType, options: RESOURCE_TYPES[selectedMetricsStore.type], onChange: (item) => setFieldValue('resourceType', (item && item.value) || '') })))),
                                    React.createElement("div", { className: "form-group" },
                                        React.createElement("div", { className: "col-md-3 sm-label-right" },
                                            "Extended Params ",
                                            React.createElement(core_1.HelpField, { id: "pipeline.config.canary.extendedScopeParams" })),
                                        React.createElement("div", { className: "col-md-7" },
                                            React.createElement(core_1.MapEditor, { model: values.extendedScopeParams, onChange: model => setFieldValue('extendedScopeParams', model), hiddenKeys: ['resourceType'] }))),
                                    React.createElement("h5", null, "Scoring Thresholds"),
                                    React.createElement("div", { className: "horizontal-rule" }),
                                    React.createElement(canaryScores_1.CanaryScores, { onChange: ({ unhealthyScore, successfulScore }) => {
                                            setFieldValue('marginalThreshold', unhealthyScore);
                                            setFieldValue('passThreshold', successfulScore);
                                        }, successfulHelpFieldId: "pipeline.config.canary.passingScore", successfulLabel: "Pass", successfulScore: values.passThreshold, unhealthyHelpFieldId: "pipeline.config.canary.marginalScore", unhealthyLabel: "Marginal", unhealthyScore: values.marginalThreshold }),
                                    showAdvancedSettings && (React.createElement(AdvancedSettings, { metricsStores: metricsStores, selectedMetricsStore: selectedMetricsStore, objectStores: objectStores, selectedObjectStore: selectedObjectStore, onChange: setFieldValue }))))),
                        lodash_1.get(status, 'error') && (React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-md-7 col-md-offset-3" },
                                React.createElement("div", { className: "well-compact alert alert-danger" },
                                    React.createElement("b", null, "There was a problem starting your analysis:"),
                                    React.createElement("span", null, JSON.stringify(status.error.data))))))),
                    React.createElement(react_bootstrap_1.Modal.Footer, null,
                        React.createElement("button", { className: "btn btn-default", onClick: dismissModal, type: "button" }, "Cancel"),
                        React.createElement(core_1.SubmitButton, { isDisabled: !isValid, submitting: isSubmitting, isFormSubmit: true, label: "Start analysis" }))));
            } }));
    }
}
ManualAnalysisModal.defaultProps = {
    closeModal: core_1.noop,
    dismissModal: core_1.noop,
};
exports.ManualAnalysisModal = ManualAnalysisModal;
const combineLocations = (includeAll, recommendedLocations, locations) => {
    if (includeAll) {
        return [...new Set(recommendedLocations.concat(locations))];
    }
    return recommendedLocations.length > 0 ? recommendedLocations : locations;
};
const LocationField = ({ hasLocationChoices, showAll, recommendedLocations, locations, value, onChange, onShowAllChange, input, }) => {
    if (!hasLocationChoices) {
        return input;
    }
    const combinedLocations = combineLocations(showAll, recommendedLocations, locations);
    const options = combinedLocations.map(location => ({ label: location, value: location }));
    return (React.createElement(React.Fragment, null,
        React.createElement(core_1.TetheredSelect, { clearable: false, value: value, options: options, onChange: (item) => onChange((item && item.value) || '') }),
        recommendedLocations.length > 0 &&
            locations.length > 0 && (React.createElement("div", { className: "pull-right" },
            React.createElement("button", { type: "button", className: "link", onClick: () => {
                    onShowAllChange(!showAll);
                    if (!combineLocations(!showAll, recommendedLocations, locations).includes(value)) {
                        onChange('');
                    }
                } }, showAll ? 'Only show recommended locations' : 'Show all locations')))));
};
const AdvancedSettings = ({ metricsStores, selectedMetricsStore, objectStores, selectedObjectStore, onChange, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("h5", null, "Advanced Settings"),
        React.createElement("div", { className: "horizontal-rule" }),
        React.createElement("div", { className: "form-group" },
            React.createElement("div", { className: "col-md-3 sm-label-right" },
                "Metrics Account ",
                React.createElement(core_1.HelpField, { id: "pipeline.config.metricsAccount" })),
            React.createElement("div", { className: "col-md-7" },
                React.createElement(core_1.TetheredSelect, { clearable: false, value: lodash_1.get(selectedMetricsStore, 'name'), options: metricsStores.map(({ name }) => ({ label: name, value: name })), onChange: (item) => onChange('metricsAccountName', (item && item.value) || '') }))),
        React.createElement("div", { className: "form-group" },
            React.createElement("div", { className: "col-md-3 sm-label-right" },
                "Storage Account ",
                React.createElement(core_1.HelpField, { id: "pipeline.config.storageAccount" })),
            React.createElement("div", { className: "col-md-7" },
                React.createElement(core_1.TetheredSelect, { clearable: false, value: lodash_1.get(selectedObjectStore, 'name'), options: objectStores.map(({ name }) => ({ label: name, value: name })), onChange: (item) => onChange('storageAccountName', (item && item.value) || '') })))));
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const ReactDOM = __webpack_require__(300);
const react_redux_1 = __webpack_require__(1);
const lodash_1 = __webpack_require__(2);
const index_1 = __webpack_require__(10);
const canary_settings_1 = __webpack_require__(11);
const class_autobind_decorator_1 = __webpack_require__(49);
if (canary_settings_1.CanarySettings.atlasWebComponentsUrl) {
    const global = window;
    global['React'] = React;
    global['ReactDOM'] = ReactDOM;
    if (canary_settings_1.CanarySettings.atlasWebComponentsPolyfillUrl) {
        const polyfillScript = document.createElement('script');
        polyfillScript.src = canary_settings_1.CanarySettings.atlasWebComponentsPolyfillUrl;
        document.head.appendChild(polyfillScript);
    }
    const componentScript = document.createElement('script');
    componentScript.src = canary_settings_1.CanarySettings.atlasWebComponentsUrl;
    document.head.appendChild(componentScript);
}
const queryFinder = (metric) => lodash_1.get(metric, 'query.q', '');
exports.queryFinder = queryFinder;
let AtlasMetricConfigurer = class AtlasMetricConfigurer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { webComponent: null };
    }
    bindComponent(ref) {
        this.setState({ webComponent: ref });
        if (ref) {
            ref.addEventListener('change.queryString', (event) => {
                this.props.updateQuery(event.detail);
            });
            ref.setAttribute('key', 'react');
        }
    }
    render() {
        const editingMetric = this.props.editingMetric;
        const query = queryFinder(editingMetric);
        const atlasBackend = 'https://atlas-global.prod.netflix.net';
        return (React.createElement("atlas-query-selector", { class: "spinnaker-theme", backends: atlasBackend, hide: "add_scope,comparison,timeOffset,lineStyle,des,trend,lineWidth,axis,color,alpha,multi", query: query, ref: this.bindComponent }));
    }
};
AtlasMetricConfigurer = __decorate([
    class_autobind_decorator_1.default,
    __metadata("design:paramtypes", [Object])
], AtlasMetricConfigurer);
function mapStateToProps(state) {
    return {
        editingMetric: state.selectedConfig.editingMetric,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        updateQuery: (query) => {
            dispatch({
                type: index_1.UPDATE_ATLAS_QUERY,
                query,
            });
        },
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(AtlasMetricConfigurer);


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const metricStoreConfig_service_1 = __webpack_require__(17);
const atlasMetricConfigurer_1 = __webpack_require__(204);
metricStoreConfig_service_1.default.register({
    name: 'atlas',
    metricConfigurer: atlasMetricConfigurer_1.default,
    queryFinder: atlasMetricConfigurer_1.queryFinder,
});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const metricStoreConfig_service_1 = __webpack_require__(17);
const metricConfigurer_1 = __webpack_require__(207);
metricStoreConfig_service_1.default.register({
    name: 'datadog',
    metricConfigurer: metricConfigurer_1.default,
    queryFinder: metricConfigurer_1.queryFinder,
});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const lodash_1 = __webpack_require__(2);
const react_redux_1 = __webpack_require__(1);
const formRow_1 = __webpack_require__(14);
const radioChoice_1 = __webpack_require__(40);
const Creators = __webpack_require__(3);
const metricTypeSelector_1 = __webpack_require__(208);
exports.queryFinder = (metric) => lodash_1.get(metric, 'query.metricName', ':');
exports.nameFinder = (metric) => exports.queryFinder(metric).split(':', 2)[1];
exports.aggFinder = (metric) => exports.queryFinder(metric).split(':', 2)[0];
function DatadogMetricConfigurer({ changeMetricName, editingMetric }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(formRow_1.default, { label: "Datadog Metric" },
            React.createElement(metricTypeSelector_1.default, { value: exports.nameFinder(editingMetric), onChange: (option) => changeMetricName(exports.aggFinder(editingMetric), lodash_1.get(option, 'value')) })),
        React.createElement(formRow_1.default, { label: "Metric Aggregation" },
            React.createElement(radioChoice_1.default, { value: "avg", label: "Average", name: "aggregator", current: exports.aggFinder(editingMetric), action: () => changeMetricName('avg', exports.nameFinder(editingMetric)) }),
            React.createElement(radioChoice_1.default, { value: "sum", label: "Sum", name: "aggregator", current: exports.aggFinder(editingMetric), action: () => changeMetricName('sum', exports.nameFinder(editingMetric)) }),
            React.createElement(radioChoice_1.default, { value: "max", label: "Max", name: "aggregator", current: exports.aggFinder(editingMetric), action: () => changeMetricName('max', exports.nameFinder(editingMetric)) }),
            React.createElement(radioChoice_1.default, { value: "min", label: "Min", name: "aggregator", current: exports.aggFinder(editingMetric), action: () => changeMetricName('min', exports.nameFinder(editingMetric)) }))));
}
function mapStateToProps(state) {
    return {
        editingMetric: state.selectedConfig.editingMetric,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        changeMetricName: (agg, name) => {
            const metricName = agg + ':' + name;
            dispatch(Creators.updateDatadogMetricName({ metricName }));
        },
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(DatadogMetricConfigurer);


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const asyncRequest_1 = __webpack_require__(15);
const Creators = __webpack_require__(3);
const disableable_1 = __webpack_require__(8);
exports.DatadogMetricTypeSelector = ({ loading, load, options, value, onChange, }) => {
    if (value && options.every(o => o.value !== value)) {
        options = options.concat({ label: value, value });
    }
    return (React.createElement(disableable_1.DisableableReactSelect, { isLoading: loading, options: options, onChange: onChange, value: value, placeholder: 'Enter at least three characters to search.', onInputChange: (input) => {
            load(input);
            return input;
        }, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }));
};
exports.mapStateToProps = (state, ownProps) => {
    const descriptors = state.data.metricsServiceMetadata.data;
    const options = descriptors.map(d => ({ label: d.name, value: d.name }));
    return Object.assign({ options, loading: state.data.metricsServiceMetadata.load === asyncRequest_1.AsyncRequestState.Requesting }, ownProps);
};
exports.mapDispatchToProps = (dispatch) => {
    return {
        load: (filter) => {
            dispatch(Creators.updateDatadogMetricDescriptorFilter({ filter }));
        },
    };
};
exports.default = react_redux_1.connect(exports.mapStateToProps, exports.mapDispatchToProps)(exports.DatadogMetricTypeSelector);


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const metricStoreConfig_service_1 = __webpack_require__(17);
const metricConfigurer_1 = __webpack_require__(210);
metricStoreConfig_service_1.default.register({
    name: 'graphite',
    metricConfigurer: metricConfigurer_1.default,
    queryFinder: metricConfigurer_1.queryFinder,
});


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const lodash_1 = __webpack_require__(2);
const react_redux_1 = __webpack_require__(1);
const formRow_1 = __webpack_require__(14);
const Creators = __webpack_require__(3);
const metricTypeSelector_1 = __webpack_require__(211);
exports.queryFinder = (metric) => lodash_1.get(metric, 'query.metricName', '');
function GraphiteMetricConfigurer({ changeMetricName, editingMetric }) {
    return (React.createElement(formRow_1.default, { label: "Graphite Metric" },
        React.createElement(metricTypeSelector_1.default, { value: exports.queryFinder(editingMetric), onChange: (option) => {
                changeMetricName(option[0]);
            } })));
}
function mapStateToProps(state) {
    return {
        editingMetric: state.selectedConfig.editingMetric,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        changeMetricName: (metricName) => {
            dispatch(Creators.updateGraphiteMetricName({ metricName }));
        },
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(GraphiteMetricConfigurer);


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const asyncRequest_1 = __webpack_require__(15);
const Creators = __webpack_require__(3);
const disableable_1 = __webpack_require__(8);
__webpack_require__(124);
exports.GraphiteMetricTypeSelector = ({ loading, load, options, value, onChange, }) => {
    options = options.concat(value);
    return (React.createElement(disableable_1.DisableableReactTypeahead, { options: options, isLoading: loading, onChange: (option) => {
            onChange(option);
            load(option[0]);
        }, defaultInputValue: value, renderMenuItemChildren: option => (React.createElement("a", { style: { pointerEvents: 'all', textDecoration: 'none', color: '#000000' } }, option)), placeholder: 'Enter at least three characters to search.', onInputChange: input => {
            onChange([input]);
            load(input);
            return input;
        }, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }));
};
exports.mapStateToProps = (state, ownProps) => {
    const descriptors = state.data.metricsServiceMetadata.data;
    const options = descriptors.map(d => d.name);
    return Object.assign({ options, loading: state.data.metricsServiceMetadata.load === asyncRequest_1.AsyncRequestState.Requesting }, ownProps);
};
exports.mapDispatchToProps = (dispatch) => {
    return {
        load: (filter) => {
            dispatch(Creators.updateGraphiteMetricDescriptorFilter({ filter }));
        },
    };
};
exports.default = react_redux_1.connect(exports.mapStateToProps, exports.mapDispatchToProps)(exports.GraphiteMetricTypeSelector);


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(205);
__webpack_require__(206);
__webpack_require__(215);
__webpack_require__(219);
__webpack_require__(221);
__webpack_require__(209);
__webpack_require__(213);


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const metricStoreConfig_service_1 = __webpack_require__(17);
const metricConfigurer_1 = __webpack_require__(214);
metricStoreConfig_service_1.default.register({
    name: 'newrelic',
    metricConfigurer: metricConfigurer_1.default,
    queryFinder: metricConfigurer_1.queryFinder,
});


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const formRow_1 = __webpack_require__(14);
const disableable_1 = __webpack_require__(8);
const Creators = __webpack_require__(3);
const lodash_1 = __webpack_require__(2);
exports.queryFinder = (metric) => lodash_1.get(metric, 'query.select', '');
function NewRelicMetricConfigurer({ changeSelect, editingMetric }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(formRow_1.default, { label: "NRQL Select" },
            React.createElement(disableable_1.DisableableInput, { type: "text", value: exports.queryFinder(editingMetric), onChange: changeSelect, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }),
            React.createElement("span", { className: "body-small color-text-caption", style: { marginTop: '5px' } }, "Enter the NRQL query only up to, but not including, the WHERE clause"))));
}
function mapStateToProps(state) {
    return {
        editingMetric: state.selectedConfig.editingMetric,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        changeSelect: (event) => {
            dispatch(Creators.updateNewRelicSelect({ select: event.target.value }));
        },
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(NewRelicMetricConfigurer);


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __webpack_require__(2);
const metricStoreConfig_service_1 = __webpack_require__(17);
const metricConfigurer_1 = __webpack_require__(216);
metricStoreConfig_service_1.default.register({
    name: 'prometheus',
    metricConfigurer: metricConfigurer_1.default,
    queryFinder: (metric) => lodash_1.get(metric, 'query.metricName', ''),
    useTemplates: true,
});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const lodash_1 = __webpack_require__(2);
const formRow_1 = __webpack_require__(14);
const list_1 = __webpack_require__(33);
const Creators = __webpack_require__(3);
const metricTypeSelector_1 = __webpack_require__(217);
const disableable_1 = __webpack_require__(8);
const radioChoice_1 = __webpack_require__(40);
const IPrometheusCanaryMetricSetQueryConfig_1 = __webpack_require__(41);
const filterTemplatesSelectors_1 = __webpack_require__(34);
const RESOURCE_TYPES = ['gce_instance', 'aws_ec2_instance'];
const toReactSelectOptions = (values) => values.map(value => ({ value, label: value }));
function PrometheusMetricConfigurer({ editingMetric, queryType, updateLabelBindings, updateGroupBy, updateFilterQueryType, updatePrometheusMetricQueryField, }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(formRow_1.default, { label: "Query Type", helpId: "canary.config.prometheus.queryType" },
            React.createElement(radioChoice_1.default, { value: IPrometheusCanaryMetricSetQueryConfig_1.PrometheusQueryType.DEFAULT, label: "Default", name: "queryType", current: queryType, action: () => updateFilterQueryType(IPrometheusCanaryMetricSetQueryConfig_1.PrometheusQueryType.DEFAULT) }),
            React.createElement(radioChoice_1.default, { value: IPrometheusCanaryMetricSetQueryConfig_1.PrometheusQueryType.PROMQL, label: "PromQL", name: "queryType", current: queryType, action: () => updateFilterQueryType(IPrometheusCanaryMetricSetQueryConfig_1.PrometheusQueryType.PROMQL) })),
        queryType === IPrometheusCanaryMetricSetQueryConfig_1.PrometheusQueryType.DEFAULT && (React.createElement(React.Fragment, null,
            React.createElement(formRow_1.default, { label: "Resource Type" },
                React.createElement(disableable_1.DisableableReactSelect, { value: lodash_1.get(editingMetric, 'query.resourceType'), options: toReactSelectOptions(RESOURCE_TYPES), onChange: (option) => updatePrometheusMetricQueryField('resourceType', option), disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] })),
            React.createElement(formRow_1.default, { label: "Metric Name" },
                React.createElement(metricTypeSelector_1.default, { value: lodash_1.get(editingMetric, 'query.metricName', ''), onChange: (option) => updatePrometheusMetricQueryField('metricName', option) })),
            React.createElement(formRow_1.default, { label: "Label Bindings" },
                React.createElement(list_1.List, { list: editingMetric.query.labelBindings || [], actionCreator: updateLabelBindings })),
            React.createElement(formRow_1.default, { label: "Group By" },
                React.createElement(list_1.List, { list: editingMetric.query.groupByFields || [], actionCreator: updateGroupBy }))))));
}
function mapStateToProps(state) {
    return {
        editingMetric: state.selectedConfig.editingMetric,
        queryType: filterTemplatesSelectors_1.queryTypeSelector(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        updateLabelBindings: payload => dispatch(Creators.updatePrometheusLabelBindings(payload)),
        updateGroupBy: payload => dispatch(Creators.updatePrometheusGroupBy(payload)),
        updatePrometheusMetricQueryField: (field, option) => dispatch(Creators.updatePrometheusMetricQueryField({ field, value: option && option.value })),
        updateFilterQueryType: (value) => {
            dispatch(Creators.updatePrometheusMetricQueryField({ field: 'queryType', value }));
            dispatch(Creators.editTemplateCancel());
            dispatch(Creators.selectTemplate({ name: null }));
            dispatch(Creators.editInlineTemplate({ value: '' }));
        },
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(PrometheusMetricConfigurer);


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const reselect_1 = __webpack_require__(38);
const lodash_1 = __webpack_require__(2);
const domain_1 = __webpack_require__(13);
const asyncRequest_1 = __webpack_require__(15);
const Creators = __webpack_require__(3);
const disableable_1 = __webpack_require__(8);
__webpack_require__(125);
class PrometheusMetricTypeSelector extends React.Component {
    constructor(props) {
        super(props);
        this.showAccountDropdown = () => {
            this.setState({
                showAccountDropdown: true,
            });
        };
        this.selectAccount = (option) => {
            this.setState({
                selectedAccount: option.value,
                showAccountDropdown: false,
            });
        };
        this.state = {
            showAccountDropdown: false,
            selectedAccount: lodash_1.get(props, ['accountOptions', 0, 'value']),
        };
    }
    render() {
        const { accountOptions, load, loading, metricOptions, onChange, value } = this.props;
        const metricOptionsWithSelected = value && metricOptions.every(o => o.value !== value)
            ? metricOptions.concat({ label: value, value })
            : metricOptions;
        return (React.createElement(React.Fragment, null,
            React.createElement(disableable_1.DisableableReactSelect, { isLoading: loading, options: metricOptionsWithSelected, onChange: onChange, value: value, placeholder: 'Enter at least three characters to search.', onInputChange: input => {
                    load(input, this.state.selectedAccount);
                    return input;
                }, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }),
            accountOptions.length > 1 && (React.createElement("div", { className: "prometheus-metric-type-selector-account-hint" },
                React.createElement("span", null,
                    "Metric search is currently populating from ",
                    this.state.selectedAccount,
                    "."),
                React.createElement("span", { className: "btn btn-link", onClick: this.showAccountDropdown }, !this.state.showAccountDropdown && 'Switch Account'))),
            this.state.showAccountDropdown && (React.createElement(disableable_1.DisableableReactSelect, { clearable: false, options: accountOptions, onChange: this.selectAccount, value: this.state.selectedAccount, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }))));
    }
}
exports.PrometheusMetricTypeSelector = PrometheusMetricTypeSelector;
const accountOptionsSelector = reselect_1.createSelector((state) => state.data.kayentaAccounts.data, (accounts) => {
    return lodash_1.chain(accounts)
        .filter(a => a.supportedTypes.includes(domain_1.KayentaAccountType.MetricsStore) && a.type === 'prometheus')
        .sortBy(a => a.name)
        .map(a => ({ label: a.name, value: a.name }))
        .value();
});
const metricOptionsSelector = reselect_1.createSelector((state) => state.data.metricsServiceMetadata.data, (descriptors) => descriptors.map(d => ({ label: d.name, value: d.name })));
const mapStateToProps = (state, ownProps) => {
    return Object.assign({ accountOptions: accountOptionsSelector(state), metricOptions: metricOptionsSelector(state), loading: state.data.metricsServiceMetadata.load === asyncRequest_1.AsyncRequestState.Requesting }, ownProps);
};
const mapDispatchToProps = (dispatch) => {
    return {
        load: (filter, metricsAccountName) => {
            dispatch(Creators.updatePrometheusMetricDescriptorFilter({ filter, metricsAccountName }));
        },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(PrometheusMetricTypeSelector);


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const IPrometheusCanaryMetricSetQueryConfig_1 = __webpack_require__(41);
const PROMQL_PREFIX = 'PromQL:';
function isQueryPromQL(template) {
    return template != null && template.startsWith(PROMQL_PREFIX);
}
exports.isQueryPromQL = isQueryPromQL;
function removePromQLPrefix(template) {
    if (isQueryPromQL(template)) {
        return template.substring(PROMQL_PREFIX.length);
    }
    return template;
}
exports.removePromQLPrefix = removePromQLPrefix;
function appendPromQLPrefix(template) {
    return `${PROMQL_PREFIX}${template}`;
}
exports.appendPromQLPrefix = appendPromQLPrefix;
exports.getPrometheusQueryType = (editingMetric) => {
    if (editingMetric.query.queryType) {
        return editingMetric.query.queryType;
    }
    const inlineTemplate = editingMetric.query.customInlineTemplate;
    if (isQueryPromQL(inlineTemplate)) {
        return IPrometheusCanaryMetricSetQueryConfig_1.PrometheusQueryType.PROMQL;
    }
    return IPrometheusCanaryMetricSetQueryConfig_1.PrometheusQueryType.DEFAULT;
};
exports.prometheusQueryTypeToTransformFunction = {
    [IPrometheusCanaryMetricSetQueryConfig_1.PrometheusQueryType.PROMQL]: {
        fromValue: removePromQLPrefix,
        toValue: appendPromQLPrefix,
    },
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const metricStoreConfig_service_1 = __webpack_require__(17);
const metricConfigurer_1 = __webpack_require__(220);
metricStoreConfig_service_1.default.register({
    name: 'signalfx',
    metricConfigurer: metricConfigurer_1.default,
    queryFinder: metricConfigurer_1.queryFinder,
});


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const lodash_1 = __webpack_require__(2);
const class_autobind_decorator_1 = __webpack_require__(49);
const formRow_1 = __webpack_require__(14);
const Creators = __webpack_require__(3);
const disableable_1 = __webpack_require__(8);
const keyValueList_1 = __webpack_require__(62);
__webpack_require__(126);
const reselect_1 = __webpack_require__(38);
const selectors_1 = __webpack_require__(9);
exports.queryFinder = (metric) => lodash_1.get(metric, 'query.metricName', '');
const getSignalFxMetric = exports.queryFinder;
const getQueryPairs = (metric) => lodash_1.get(metric, 'query.queryPairs', []);
const getAggregationMethod = (metric) => lodash_1.get(metric, 'query.aggregationMethod', '');
let SignalFxMetricConfigurer = class SignalFxMetricConfigurer extends React.Component {
    onMetricNameChange(e) {
        this.props.updateMetricName(e.target.value);
    }
    onAggregationMethodChange(e) {
        this.props.updateAggregationMethod(e.target.value);
    }
    render() {
        const { editingMetric, updateQueryPairs, validationErrors } = this.props;
        return (React.createElement("section", null,
            React.createElement(formRow_1.default, { label: "SignalFx Metric", error: lodash_1.get(validationErrors, 'signalFxMetric.message', null) },
                React.createElement(disableable_1.DisableableInput, { type: "text", value: getSignalFxMetric(editingMetric), onChange: this.onMetricNameChange, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] })),
            React.createElement(formRow_1.default, { label: "Aggregation Method", helpId: "canary.config.signalFx.aggregationMethod", error: lodash_1.get(validationErrors, 'aggregationMethod.message', null) },
                React.createElement(disableable_1.DisableableInput, { type: "text", value: getAggregationMethod(editingMetric), onChange: this.onAggregationMethodChange, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] })),
            React.createElement(formRow_1.default, { label: "Query Pairs", helpId: "canary.config.signalFx.queryPairs", error: lodash_1.get(validationErrors, 'queryPairs.message', null) },
                React.createElement(keyValueList_1.default, { className: "signalfx-query-pairs", list: getQueryPairs(editingMetric), actionCreator: updateQueryPairs }))));
    }
};
SignalFxMetricConfigurer = __decorate([
    class_autobind_decorator_1.default
], SignalFxMetricConfigurer);
function validateMetric(editingMetric) {
    const errors = {};
    const validators = [...getSignalFxValidators(editingMetric)];
    return validators.reduce((reducedErrors, validator) => validator(reducedErrors, editingMetric), errors);
}
exports.validateMetric = validateMetric;
function getSignalFxValidators(editingMetric) {
    if (!editingMetric || !editingMetric.query) {
        return [];
    }
    return [validateSignalFxMetricName, validateAggregationMethod, validateQueryPairs];
}
exports.getSignalFxValidators = getSignalFxValidators;
function validateSignalFxMetricName(errors, editingMetric) {
    const nextErrors = Object.assign({}, errors);
    const signalFxMetric = getSignalFxMetric(editingMetric);
    if (!signalFxMetric) {
        nextErrors.signalFxMetric = { message: 'The SignalFx metric is required.' };
    }
    return nextErrors;
}
function validateAggregationMethod(errors, editingMetric) {
    const nextErrors = Object.assign({}, errors);
    const aggregationMethod = getAggregationMethod(editingMetric);
    if (!aggregationMethod) {
        nextErrors.aggregationMethod = { message: 'The SignalFx SignalFlow stream aggregation method is required.' };
    }
    return nextErrors;
}
function validateQueryPairs(errors, editingMetric) {
    const nextErrors = Object.assign({}, errors);
    const queryPairs = getQueryPairs(editingMetric);
    queryPairs.forEach(qp => {
        if (!qp.key || !qp.value) {
            nextErrors.queryPairs = { message: 'All query pairs must contain a non-blank key and value.' };
        }
    });
    return nextErrors;
}
const sfxEditingMetricValidationErrorsSelector = reselect_1.createSelector(selectors_1.editingMetricSelector, validateMetric);
function mapStateToProps(state) {
    return {
        editingMetric: state.selectedConfig.editingMetric,
        validationErrors: sfxEditingMetricValidationErrorsSelector(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        updateMetricName: (metricName) => {
            dispatch(Creators.updateSignalFxMetricName({ metricName }));
        },
        updateAggregationMethod: (aggregationMethod) => {
            dispatch(Creators.updateSignalFxAggregationMethod({ aggregationMethod }));
        },
        updateQueryPairs: payload => dispatch(Creators.updateSignalFxQueryPairs(payload)),
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SignalFxMetricConfigurer);


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __webpack_require__(2);
const metricStoreConfig_service_1 = __webpack_require__(17);
const metricConfigurer_1 = __webpack_require__(222);
metricStoreConfig_service_1.default.register({
    name: 'stackdriver',
    metricConfigurer: metricConfigurer_1.default,
    queryFinder: (metric) => lodash_1.get(metric, 'query.metricType', ''),
    useTemplates: true,
});


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const lodash_1 = __webpack_require__(2);
const formRow_1 = __webpack_require__(14);
const list_1 = __webpack_require__(33);
const Creators = __webpack_require__(3);
const metricTypeSelector_1 = __webpack_require__(223);
const disableable_1 = __webpack_require__(8);
const RESOURCE_TYPES = [
    'gce_instance',
    'aws_ec2_instance',
    'gae_app',
    'k8s_container',
    'k8s_pod',
    'k8s_node',
    'gke_container',
    'https_lb_rule',
    'global',
];
const CROSS_SERIES_REDUCERS = [
    'REDUCE_NONE',
    'REDUCE_MEAN',
    'REDUCE_MIN',
    'REDUCE_MAX',
    'REDUCE_SUM',
    'REDUCE_COUNT_TRUE',
    'REDUCE_COUNT_FALSE',
    'REDUCE_FRACTION_TRUE',
    'REDUCE_PERCENTILE_99',
    'REDUCE_PERCENTILE_95',
    'REDUCE_PERCENTILE_50',
    'REDUCE_PERCENTILE_05',
];
const PER_SERIES_ALIGNERS = [
    'ALIGN_NONE',
    'ALIGN_DELTA',
    'ALIGN_RATE',
    'ALIGN_INTERPOLATE',
    'ALIGN_NEXT_OLDER',
    'ALIGN_MIN',
    'ALIGN_MAX',
    'ALIGN_MEAN',
    'ALIGN_COUNT',
    'ALIGN_SUM',
    'ALIGN_STDDEV',
    'ALIGN_COUNT_TRUE',
    'ALIGN_COUNT_FALSE',
    'ALIGN_FRACTION_TRUE',
    'ALIGN_PERCENTILE_99',
    'ALIGN_PERCENTILE_95',
    'ALIGN_PERCENTILE_50',
    'ALIGN_PERCENTILE_05',
    'ALIGN_PERCENT_CHANGE',
];
const STACKDRIVER_HELP_ID_PREFIX = 'stackdriver';
const toReactSelectOptions = (values) => values.map(value => ({ value, label: value }));
function StackdriverMetricConfigurer({ editingMetric, updateGroupBy, updateStackdriverQueryField, }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(formRow_1.default, { label: "Resource Type", helpId: `${STACKDRIVER_HELP_ID_PREFIX}.resourceType` },
            React.createElement(disableable_1.DisableableReactSelect, { value: lodash_1.get(editingMetric, 'query.resourceType'), options: toReactSelectOptions(RESOURCE_TYPES), onChange: (option) => updateStackdriverQueryField('resourceType', option), disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] })),
        React.createElement(formRow_1.default, { label: "Metric Type", helpId: `${STACKDRIVER_HELP_ID_PREFIX}.metricType` },
            React.createElement(metricTypeSelector_1.default, { value: lodash_1.get(editingMetric, 'query.metricType', ''), onChange: (option) => updateStackdriverQueryField('metricType', option) })),
        React.createElement(formRow_1.default, { label: "Group By", helpId: `${STACKDRIVER_HELP_ID_PREFIX}.groupBy` },
            React.createElement(list_1.List, { list: editingMetric.query.groupByFields || [], actionCreator: updateGroupBy })),
        React.createElement(formRow_1.default, { label: "Aligner", helpId: `${STACKDRIVER_HELP_ID_PREFIX}.perSeriesAligner` },
            React.createElement(disableable_1.DisableableReactSelect, { value: lodash_1.get(editingMetric, 'query.perSeriesAligner'), options: toReactSelectOptions(PER_SERIES_ALIGNERS), onChange: (option) => updateStackdriverQueryField('perSeriesAligner', option), disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] })),
        React.createElement(formRow_1.default, { label: "Reducer", helpId: `${STACKDRIVER_HELP_ID_PREFIX}.crossSeriesReducer` },
            React.createElement(disableable_1.DisableableReactSelect, { value: lodash_1.get(editingMetric, 'query.crossSeriesReducer'), options: toReactSelectOptions(CROSS_SERIES_REDUCERS), onChange: (option) => updateStackdriverQueryField('crossSeriesReducer', option), disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }))));
}
function mapStateToProps(state) {
    return {
        editingMetric: state.selectedConfig.editingMetric,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        updateStackdriverQueryField: (field, option) => dispatch(Creators.updateStackdriverMetricResourceField({ field, value: option && option.value })),
        updateGroupBy: payload => dispatch(Creators.updateStackdriverGroupBy(payload)),
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(StackdriverMetricConfigurer);


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const asyncRequest_1 = __webpack_require__(15);
const Creators = __webpack_require__(3);
const disableable_1 = __webpack_require__(8);
const MetricField = ({ descriptor, field, label, }) => {
    if (!descriptor || !descriptor[field]) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement("strong", null,
            label,
            ": "),
        descriptor[field]));
};
class StackdriverMetricTypeSelector extends React.Component {
    componentDidMount() {
        this.props.load(this.props.value);
    }
    render() {
        const { loading, load, descriptors, value, onChange } = this.props;
        let options = descriptors.map(d => ({ label: d.type, value: d.type }));
        if (value && options.every(o => o.value !== value)) {
            options = options.concat({ label: value, value });
        }
        return (React.createElement(disableable_1.DisableableReactSelect, { isLoading: loading, options: options, onChange: onChange, value: value, optionRenderer: (option) => {
                const descriptor = descriptors.find(d => d.type === option.value);
                if (!descriptor) {
                    return React.createElement("span", null, option.label);
                }
                return (React.createElement(React.Fragment, null,
                    React.createElement(MetricField, { descriptor: descriptor, field: "type", label: "Metric" }),
                    React.createElement(MetricField, { descriptor: descriptor, field: "description", label: "Description" }),
                    React.createElement(MetricField, { descriptor: descriptor, field: "unit", label: "Unit" }),
                    React.createElement(MetricField, { descriptor: descriptor, field: "metricKind", label: "Kind" }),
                    React.createElement(MetricField, { descriptor: descriptor, field: "valueType", label: "Value type" })));
            }, placeholder: 'Enter at least three characters to search.', onInputChange: input => {
                load(input);
                return input;
            }, disabledStateKeys: [disableable_1.DISABLE_EDIT_CONFIG] }));
    }
}
exports.StackdriverMetricTypeSelector = StackdriverMetricTypeSelector;
exports.mapStateToProps = (state, ownProps) => {
    const descriptors = state.data.metricsServiceMetadata.data;
    return Object.assign({ descriptors, loading: state.data.metricsServiceMetadata.load === asyncRequest_1.AsyncRequestState.Requesting }, ownProps);
};
exports.mapDispatchToProps = (dispatch) => {
    return {
        load: (filter) => {
            dispatch(Creators.updateStackdriverMetricDescriptorFilter({ filter }));
        },
    };
};
exports.default = react_redux_1.connect(exports.mapStateToProps, exports.mapDispatchToProps)(StackdriverMetricTypeSelector);


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const Actions = __webpack_require__(10);
const Creators = __webpack_require__(3);
const canaryConfig_service_1 = __webpack_require__(18);
exports.actionInterceptingMiddleware = (store) => (next) => (action) => {
    switch (action.type) {
        case Actions.CREATE_NEW_CONFIG: {
            const newConfig = canaryConfig_service_1.buildNewConfig(store.getState());
            const newAction = Creators.selectConfig({ config: newConfig });
            return next(newAction);
        }
        case Actions.COPY_SELECTED_CONFIG: {
            const copiedConfig = canaryConfig_service_1.buildConfigCopy(store.getState());
            const newAction = Creators.selectConfig({ config: copiedConfig });
            return next(newAction);
        }
        default:
            return next(action);
    }
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncDispatchMiddleware = (store) => (next) => (action) => {
    let syncActivityFinished = false;
    let actionQueue = [];
    const flushQueue = () => {
        actionQueue.forEach(a => store.dispatch(a));
        actionQueue = [];
    };
    const asyncDispatch = (a) => {
        actionQueue.push(a);
        if (syncActivityFinished) {
            flushQueue();
        }
    };
    const nextAction = next(Object.assign({}, action, { asyncDispatch }));
    syncActivityFinished = true;
    flushQueue();
    return nextAction;
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const Observable_1 = __webpack_require__(305);
__webpack_require__(306);
const redux_observable_1 = __webpack_require__(304);
const canaryConfig_service_1 = __webpack_require__(18);
const Actions = __webpack_require__(10);
const Creators = __webpack_require__(3);
const core_1 = __webpack_require__(6);
const canaryRun_service_1 = __webpack_require__(35);
const selectors_1 = __webpack_require__(9);
const domain_1 = __webpack_require__(13);
const metricsServiceMetadata_service_1 = __webpack_require__(274);
const typeMatches = (...actions) => (action) => actions.includes(action.type);
const loadConfigEpic = (action$) => action$.filter(typeMatches(Actions.LOAD_CONFIG_REQUEST, Actions.SAVE_CONFIG_SUCCESS)).concatMap(action => Observable_1.Observable.fromPromise(canaryConfig_service_1.getCanaryConfigById(action.payload.id))
    .map(config => Creators.loadConfigSuccess({ config }))
    .catch(error => Observable_1.Observable.of(Creators.loadConfigFailure({ error }))));
const selectConfigEpic = (action$) => action$
    .filter(typeMatches(Actions.LOAD_CONFIG_SUCCESS))
    .map(action => Creators.selectConfig({ config: action.payload.config }));
const saveConfigEpic = (action$, store) => action$.filter(typeMatches(Actions.SAVE_CONFIG_REQUEST)).concatMap(() => {
    const config = canaryConfig_service_1.mapStateToConfig(store.getState());
    let saveAction;
    if (config.isNew) {
        delete config.isNew;
        saveAction = canaryConfig_service_1.createCanaryConfig(config);
    }
    else {
        saveAction = canaryConfig_service_1.updateCanaryConfig(config);
    }
    return Observable_1.Observable.fromPromise(saveAction)
        .concatMap(({ canaryConfigId }) => Observable_1.Observable.forkJoin(core_1.ReactInjector.$state.go('^.configDetail', { id: canaryConfigId, copy: false, new: false }), store
        .getState()
        .data.application.getDataSource('canaryConfigs')
        .refresh(true)).mapTo(Creators.saveConfigSuccess({ id: canaryConfigId })))
        .catch((error) => Observable_1.Observable.of(Creators.saveConfigFailure({ error })));
});
const deleteConfigRequestEpic = (action$, store) => action$.filter(typeMatches(Actions.DELETE_CONFIG_REQUEST)).concatMap(() => Observable_1.Observable.fromPromise(canaryConfig_service_1.deleteCanaryConfig(store.getState().selectedConfig.config.id))
    .mapTo(Creators.deleteConfigSuccess())
    .catch((error) => Observable_1.Observable.of(Creators.deleteConfigFailure({ error }))));
const deleteConfigSuccessEpic = (action$, store) => action$
    .filter(typeMatches(Actions.DELETE_CONFIG_SUCCESS))
    .concatMap(() => Observable_1.Observable.forkJoin(core_1.ReactInjector.$state.go('^.configDefault'), store
    .getState()
    .data.application.getDataSource('canaryConfigs')
    .refresh(true)))
    .mapTo(Creators.closeDeleteConfigModal());
const loadCanaryRunRequestEpic = (action$) => action$.filter(typeMatches(Actions.LOAD_RUN_REQUEST)).concatMap(action => Observable_1.Observable.fromPromise(canaryRun_service_1.getCanaryRun(action.payload.configId, action.payload.runId))
    .map(run => Creators.loadRunSuccess({ run }))
    .catch((error) => Observable_1.Observable.of(Creators.loadRunFailure({ error }))));
const loadMetricSetPairEpic = (action$, store) => action$.filter(typeMatches(Actions.LOAD_METRIC_SET_PAIR_REQUEST)).concatMap(action => {
    const run = selectors_1.runSelector(store.getState());
    return Observable_1.Observable.fromPromise(canaryRun_service_1.getMetricSetPair(run.metricSetPairListId, action.payload.pairId))
        .map(metricSetPair => Creators.loadMetricSetPairSuccess({ metricSetPair }))
        .catch((error) => Observable_1.Observable.of(Creators.loadMetricSetPairFailure({ error })));
});
const updatePrometheusMetricDescriptionFilterEpic = (action$) => action$
    .filter(typeMatches(Actions.UPDATE_PROMETHEUS_METRIC_DESCRIPTOR_FILTER))
    .filter(action => action.payload.filter && action.payload.filter.length > 2)
    .debounceTime(200)
    .map(action => {
    return Creators.loadMetricsServiceMetadataRequest({
        filter: action.payload.filter,
        metricsAccountName: action.payload.metricsAccountName,
    });
});
const updateStackdriverMetricDescriptionFilterEpic = (action$, store) => action$
    .filter(typeMatches(Actions.UPDATE_STACKDRIVER_METRIC_DESCRIPTOR_FILTER))
    .filter(action => action.payload.filter && action.payload.filter.length > 2)
    .debounceTime(200)
    .map(action => {
    const [metricsAccountName] = store
        .getState()
        .data.kayentaAccounts.data.filter(account => account.supportedTypes.includes(domain_1.KayentaAccountType.MetricsStore) &&
        account.metricsStoreType === 'stackdriver')
        .map(account => account.name);
    return Creators.loadMetricsServiceMetadataRequest({
        filter: action.payload.filter,
        metricsAccountName,
    });
});
const updateGraphiteMetricDescriptionFilterEpic = (action$, store) => action$
    .filter(typeMatches(Actions.UPDATE_GRAPHITE_METRIC_DESCRIPTOR_FILTER))
    .filter(action => action.payload.filter && action.payload.filter.length > 2)
    .debounceTime(200)
    .map(action => {
    const [metricsAccountName] = store
        .getState()
        .data.kayentaAccounts.data.filter(account => account.supportedTypes.includes(domain_1.KayentaAccountType.MetricsStore) && account.type === 'graphite')
        .map(account => account.name);
    return Creators.loadMetricsServiceMetadataRequest({
        filter: action.payload.filter,
        metricsAccountName,
    });
});
const updateDatadogMetricDescriptionFilterEpic = (action$, store) => action$
    .filter(typeMatches(Actions.UPDATE_DATADOG_METRIC_DESCRIPTOR_FILTER))
    .filter(action => action.payload.filter && action.payload.filter.length > 2)
    .debounceTime(200)
    .map(action => {
    const [metricsAccountName] = store
        .getState()
        .data.kayentaAccounts.data.filter(account => account.supportedTypes.includes(domain_1.KayentaAccountType.MetricsStore) && account.type === 'datadog')
        .map(account => account.name);
    return Creators.loadMetricsServiceMetadataRequest({
        filter: action.payload.filter,
        metricsAccountName,
    });
});
const loadMetricsServiceMetadataEpic = (action$) => action$.filter(typeMatches(Actions.LOAD_METRICS_SERVICE_METADATA_REQUEST)).concatMap(action => {
    return Observable_1.Observable.fromPromise(metricsServiceMetadata_service_1.listMetricsServiceMetadata(action.payload.filter, action.payload.metricsAccountName))
        .map(data => Creators.loadMetricsServiceMetadataSuccess({ data }))
        .catch((error) => Observable_1.Observable.of(Creators.loadMetricsServiceMetadataFailure({ error })));
});
const loadKayentaAccountsEpic = (action$) => action$.filter(typeMatches(Actions.LOAD_KAYENTA_ACCOUNTS_REQUEST, Actions.INITIALIZE)).concatMap(() => Observable_1.Observable.fromPromise(canaryConfig_service_1.listKayentaAccounts())
    .map(accounts => Creators.loadKayentaAccountsSuccess({ accounts }))
    .catch((error) => Observable_1.Observable.of(Creators.loadKayentaAccountsFailure({ error }))));
const rootEpic = redux_observable_1.combineEpics(loadConfigEpic, selectConfigEpic, saveConfigEpic, deleteConfigRequestEpic, deleteConfigSuccessEpic, loadCanaryRunRequestEpic, loadMetricSetPairEpic, updateGraphiteMetricDescriptionFilterEpic, updatePrometheusMetricDescriptionFilterEpic, updateStackdriverMetricDescriptionFilterEpic, updateDatadogMetricDescriptionFilterEpic, loadMetricsServiceMetadataEpic, loadKayentaAccountsEpic);
exports.epicMiddleware = redux_observable_1.createEpicMiddleware(rootEpic);


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(224));
__export(__webpack_require__(225));
__export(__webpack_require__(226));


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __webpack_require__(12);
const angularjs_1 = __webpack_require__(290);
const core_1 = __webpack_require__(6);
const configDetailLoader_1 = __webpack_require__(170);
const edit_1 = __webpack_require__(175);
const save_1 = __webpack_require__(192);
const canary_1 = __webpack_require__(53);
const selectConfig_1 = __webpack_require__(196);
const report_1 = __webpack_require__(273);
const detailLoader_1 = __webpack_require__(243);
const loadStates_1 = __webpack_require__(269);
const Creators = __webpack_require__(3);
exports.CANARY_STATES = 'spinnaker.kayenta.canary.states';
angular_1.module(exports.CANARY_STATES, [core_1.APPLICATION_STATE_PROVIDER])
    .config([
    'applicationStateProvider',
    (applicationStateProvider) => {
        'ngInject';
        const configDetail = {
            name: 'configDetail',
            url: '/:id?copy&new',
            views: {
                detail: {
                    component: configDetailLoader_1.default,
                    $type: 'react',
                },
                footer: {
                    component: save_1.default,
                    $type: 'react',
                },
            },
            params: {
                copy: { type: 'boolean', value: false, squash: true },
                new: { type: 'boolean', value: false, squash: true },
            },
            resolve: [
                {
                    token: 'configNameStream',
                    deps: [angularjs_1.UIRouter],
                    resolveFn: (uiRouter) => uiRouter.globals.params$,
                },
            ],
        };
        const configDefault = {
            name: 'configDefault',
            url: '',
            views: {
                detail: {
                    component: selectConfig_1.default,
                    $type: 'react',
                },
            },
        };
        const config = {
            name: 'canaryConfig',
            url: '/config',
            views: {
                canary: {
                    component: edit_1.default,
                    $type: 'react',
                },
            },
            children: [configDefault, configDetail],
            redirectTo: transition => transition.to().name + '.configDefault',
        };
        const reportDetail = {
            name: 'reportDetail',
            url: '/:configId/:runId',
            views: {
                detail: {
                    component: detailLoader_1.default,
                    $type: 'react',
                },
            },
            resolve: [
                {
                    token: 'resultIdStream',
                    deps: [angularjs_1.UIRouter],
                    resolveFn: (uiRouter) => uiRouter.globals.params$,
                },
            ],
        };
        const reportDefault = {
            name: 'reportDefault',
            url: '',
            views: {
                detail: {
                    component: loadStates_1.default,
                    $type: 'react',
                },
            },
        };
        const report = {
            name: 'report',
            url: '/report',
            views: {
                canary: {
                    component: report_1.default,
                    $type: 'react',
                },
            },
            children: [reportDetail, reportDefault],
            redirectTo: transition => transition.to().name + '.reportDefault',
        };
        const canaryRoot = {
            abstract: true,
            name: 'canary',
            url: '/canary',
            views: {
                insight: {
                    component: canary_1.default,
                    $type: 'react',
                },
            },
            data: {
                pageTitleSection: {
                    title: 'Canary',
                },
            },
            children: [config, report],
            resolve: [
                {
                    token: 'success$',
                    deps: [angularjs_1.UIRouter],
                    resolveFn: (uiRouter) => uiRouter.globals.success$,
                },
            ],
        };
        applicationStateProvider.addChildState(canaryRoot);
    },
])
    .run([
    '$uiRouter',
    '$window',
    '$rootScope',
    ($uiRouter, $window, $rootScope) => {
        $uiRouter.transitionService.onBefore({
            from: '**.configDetail.**',
            to: state => !state.name.includes('configDetail'),
        }, () => {
            canary_1.canaryStore.dispatch(Creators.clearSelectedConfig());
        });
        $rootScope.$on('$stateChangeStart', event => {
            const state = canary_1.canaryStore.getState();
            const warningMessage = 'You have unsaved changes.\nAre you sure you want to navigate away from this page?';
            if (state.selectedConfig && !state.selectedConfig.isInSyncWithServer) {
                if (!$window.confirm(warningMessage)) {
                    event.preventDefault();
                }
            }
        });
        $uiRouter.transitionService.onEnter({ to: '**.configDetail.**' }, () => {
            $window.onbeforeunload = () => {
                const state = canary_1.canaryStore.getState();
                return (state.selectedConfig && !state.selectedConfig.isInSyncWithServer) || null;
            };
        });
        $uiRouter.transitionService.onExit({ from: '**.configDetail.**' }, () => {
            $window.onbeforeunload = undefined;
        });
    },
]);


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = __webpack_require__(21);
const redux_actions_1 = __webpack_require__(16);
const Actions = __webpack_require__(10);
const configJsonModal_1 = __webpack_require__(57);
const deleteConfigModalOpen = redux_actions_1.handleActions({
    [Actions.DELETE_CONFIG_MODAL_OPEN]: () => true,
    [redux_actions_1.combineActions(Actions.DELETE_CONFIG_MODAL_CLOSE, Actions.DELETE_CONFIG_SUCCESS)]: () => false,
}, false);
const configJsonModalOpen = redux_actions_1.handleActions({
    [Actions.CONFIG_JSON_MODAL_OPEN]: () => true,
    [redux_actions_1.combineActions(Actions.CONFIG_JSON_MODAL_CLOSE, Actions.SELECT_CONFIG)]: () => false,
}, false);
const configJsonModalTabState = redux_actions_1.handleActions({
    [Actions.SET_CONFIG_JSON_MODAL_TAB_STATE]: (_state, action) => action.payload.state,
    [Actions.CONFIG_JSON_MODAL_OPEN]: () => configJsonModal_1.ConfigJsonModalTabState.Edit,
}, configJsonModal_1.ConfigJsonModalTabState.Edit);
const disableConfigEdit = redux_actions_1.handleActions({}, false);
exports.app = redux_1.combineReducers({
    deleteConfigModalOpen,
    configJsonModalOpen,
    configJsonModalTabState,
    disableConfigEdit,
});


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = __webpack_require__(21);
const redux_actions_1 = __webpack_require__(16);
const lodash_1 = __webpack_require__(2);
const Actions = __webpack_require__(10);
const asyncRequest_1 = __webpack_require__(15);
exports.application = redux_actions_1.handleActions({
    [Actions.INITIALIZE]: (_state, action) => action.state.data.application,
}, null);
exports.configSummaries = redux_actions_1.handleActions({
    [Actions.INITIALIZE]: (_state, action) => action.state.data.configSummaries,
    [Actions.UPDATE_CONFIG_SUMMARIES]: (_state, action) => action.payload.configSummaries,
}, []);
const configs = redux_actions_1.handleActions({
    [Actions.LOAD_CONFIG_SUCCESS]: (state, action) => {
        if (state.some(config => config.id === action.payload.config.id)) {
            return lodash_1.without(state, state.find(config => config.id === action.payload.config.id)).concat([
                action.payload.config,
            ]);
        }
        else {
            return state.concat([action.payload.config]);
        }
    },
}, []);
const judges = redux_actions_1.handleActions({
    [Actions.INITIALIZE]: (_state, action) => action.state.data.judges,
    [Actions.UPDATE_JUDGES]: (_state, action) => action.payload.judges,
}, null);
const executions = redux_1.combineReducers({
    data: redux_actions_1.handleActions({
        [Actions.LOAD_EXECUTIONS_SUCCESS]: (_state, action) => action.payload.executions,
    }, []),
    load: redux_actions_1.handleActions({
        [Actions.LOAD_EXECUTIONS_REQUEST]: () => asyncRequest_1.AsyncRequestState.Requesting,
        [Actions.LOAD_EXECUTIONS_SUCCESS]: () => asyncRequest_1.AsyncRequestState.Fulfilled,
        [Actions.LOAD_EXECUTIONS_FAILURE]: () => asyncRequest_1.AsyncRequestState.Failed,
    }, asyncRequest_1.AsyncRequestState.Requesting),
});
const metricsServiceMetadata = redux_1.combineReducers({
    load: redux_actions_1.handleActions({
        [Actions.LOAD_METRICS_SERVICE_METADATA_REQUEST]: () => asyncRequest_1.AsyncRequestState.Requesting,
        [Actions.LOAD_METRICS_SERVICE_METADATA_SUCCESS]: () => asyncRequest_1.AsyncRequestState.Fulfilled,
        [Actions.LOAD_METRICS_SERVICE_METADATA_FAILURE]: () => asyncRequest_1.AsyncRequestState.Failed,
    }, asyncRequest_1.AsyncRequestState.Fulfilled),
    data: redux_actions_1.handleActions({
        [Actions.LOAD_METRICS_SERVICE_METADATA_SUCCESS]: (_state, action) => action.payload.data,
        [Actions.UPDATE_PROMETHEUS_METRIC_TYPE]: (state, action) => {
            return action.payload.metricName ? state : [];
        },
        [Actions.UPDATE_STACKDRIVER_METRIC_TYPE]: (state, action) => {
            return action.payload.metricType ? state : [];
        },
        [Actions.UPDATE_DATADOG_METRIC_TYPE]: (state, action) => {
            return action.payload.metricType ? state : [];
        },
        [Actions.UPDATE_NEWRELIC_SELECT]: (state, action) => {
            return action.payload.select ? state : [];
        },
        [Actions.UPDATE_GRAPHITE_METRIC_NAME]: (state, action) => {
            return action.payload.metricName ? state : [];
        },
        [Actions.EDIT_METRIC_BEGIN]: () => [],
    }, []),
});
const kayentaAccounts = redux_1.combineReducers({
    load: redux_actions_1.handleActions({
        [Actions.LOAD_KAYENTA_ACCOUNTS_REQUEST]: () => asyncRequest_1.AsyncRequestState.Requesting,
        [Actions.LOAD_KAYENTA_ACCOUNTS_SUCCESS]: () => asyncRequest_1.AsyncRequestState.Fulfilled,
        [Actions.LOAD_KAYENTA_ACCOUNTS_FAILURE]: () => asyncRequest_1.AsyncRequestState.Failed,
    }, asyncRequest_1.AsyncRequestState.Requesting),
    data: redux_actions_1.handleActions({
        [Actions.LOAD_KAYENTA_ACCOUNTS_SUCCESS]: (_state, action) => action.payload.accounts,
    }, []),
});
exports.data = redux_1.combineReducers({
    application: exports.application,
    configSummaries: exports.configSummaries,
    judges,
    configs,
    executions,
    metricsServiceMetadata,
    kayentaAccounts,
});


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const redux_actions_1 = __webpack_require__(16);
const redux_1 = __webpack_require__(21);
const Actions = __webpack_require__(10);
const name = redux_actions_1.handleActions({
    [Actions.EDIT_TEMPLATE_BEGIN]: (_state, action) => action.payload.name,
    [Actions.EDIT_TEMPLATE_CANCEL]: () => null,
    [Actions.ADD_TEMPLATE]: () => '',
}, null);
const editedName = redux_actions_1.handleActions({
    [redux_actions_1.combineActions(Actions.EDIT_TEMPLATE_BEGIN, Actions.EDIT_TEMPLATE_NAME)]: (_state, action) => action.payload.name,
    [Actions.EDIT_TEMPLATE_CANCEL]: () => null,
    [Actions.ADD_TEMPLATE]: () => '',
}, null);
const editedValue = redux_actions_1.handleActions({
    [redux_actions_1.combineActions(Actions.EDIT_TEMPLATE_VALUE, Actions.EDIT_TEMPLATE_BEGIN)]: (_state, action) => action.payload.value,
    [Actions.EDIT_TEMPLATE_CANCEL]: () => null,
    [Actions.ADD_TEMPLATE]: () => '',
}, null);
const isNew = redux_actions_1.handleActions({
    [Actions.ADD_TEMPLATE]: () => true,
    [Actions.EDIT_TEMPLATE_CANCEL]: () => false,
}, false);
exports.editingTemplate = redux_1.combineReducers({
    name,
    editedName,
    editedValue,
    isNew,
});


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = __webpack_require__(21);
const redux_actions_1 = __webpack_require__(16);
const lodash_1 = __webpack_require__(2);
const Actions = __webpack_require__(10);
function groupsFromMetrics(metrics = []) {
    const results = metrics
        .reduce((groups, metric) => {
        return groups.concat(metric.groups.filter((g) => !groups.includes(g)));
    }, [])
        .sort();
    if (!results.length) {
        results.push('Group 1');
    }
    return results;
}
const list = redux_actions_1.handleActions({
    [Actions.SELECT_CONFIG]: (_state, action) => groupsFromMetrics(action.payload.config.metrics),
    [Actions.ADD_METRIC]: (state, action) => {
        const groups = action.payload.metric.groups;
        return state.concat(groups.filter((g) => !state.includes(g)));
    },
    [Actions.ADD_GROUP]: (state) => {
        let n = 1;
        let name = null;
        do {
            name = 'Group ' + n;
            n++;
        } while (state.includes(name));
        return state.concat([name]);
    },
}, []);
const selected = redux_actions_1.handleActions({
    [Actions.SELECT_GROUP]: (_state, action) => action.payload.name,
    [Actions.SELECT_CONFIG]: () => '',
}, '');
const groupWeights = redux_actions_1.handleActions({
    [Actions.SELECT_CONFIG]: (_state, action) => lodash_1.get(action, 'payload.config.classifier.groupWeights', {}),
    [Actions.UPDATE_GROUP_WEIGHT]: (state, action) => (Object.assign({}, state, { [action.payload.group]: action.payload.weight })),
}, {});
const edit = redux_actions_1.handleActions({
    [Actions.EDIT_GROUP_BEGIN]: (_state, action) => action.payload.group,
    [Actions.EDIT_GROUP_UPDATE]: (_state, action) => action.payload.edit,
    [redux_actions_1.combineActions(Actions.SELECT_GROUP, Actions.EDIT_GROUP_CONFIRM)]: () => null,
}, null);
exports.group = redux_1.combineReducers({
    list,
    selected,
    groupWeights,
    edit,
});


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = __webpack_require__(21);
const redux_actions_1 = __webpack_require__(16);
const lodash_1 = __webpack_require__(2);
const Actions = __webpack_require__(10);
const Creators = __webpack_require__(3);
const data_1 = __webpack_require__(230);
const app_1 = __webpack_require__(229);
const selectedConfig_1 = __webpack_require__(235);
const judgeSelect_1 = __webpack_require__(39);
const domain_1 = __webpack_require__(13);
const canaryConfig_service_1 = __webpack_require__(18);
const selectedRun_1 = __webpack_require__(236);
const selectors_1 = __webpack_require__(9);
const validators_1 = __webpack_require__(239);
const asyncRequest_1 = __webpack_require__(15);
const canary_settings_1 = __webpack_require__(11);
const combined = redux_1.combineReducers({
    app: app_1.app,
    configValidationErrors: () => null,
    data: data_1.data,
    selectedConfig: selectedConfig_1.selectedConfig,
    selectedRun: selectedRun_1.selectedRun,
});
const getRenderState = (judges, judgeConfig) => {
    if (judges.some(judge => judge.name === judgeConfig.name)) {
        if (judges.length === 1) {
            return judgeSelect_1.JudgeSelectRenderState.None;
        }
        else {
            return judgeSelect_1.JudgeSelectRenderState.Multiple;
        }
    }
    else {
        return judgeSelect_1.JudgeSelectRenderState.Single;
    }
};
const judgeRenderStateReducer = redux_actions_1.handleActions({
    [redux_actions_1.combineActions(Actions.SELECT_CONFIG, Actions.UPDATE_JUDGES)]: (state) => {
        const { data: { judges = [] }, selectedConfig: { judge: { judgeConfig }, }, } = state;
        if (!judgeConfig) {
            return state;
        }
        else {
            return Object.assign({}, state, { selectedConfig: Object.assign({}, state.selectedConfig, { judge: Object.assign({}, state.selectedConfig.judge, { renderState: getRenderState(judges, judgeConfig) }) }) });
        }
    },
}, null);
const isInSyncWithServerReducer = (state) => {
    return Object.assign({}, state, { selectedConfig: Object.assign({}, state.selectedConfig, { isInSyncWithServer: (() => {
                const editedConfig = canaryConfig_service_1.mapStateToConfig(state);
                if (!editedConfig) {
                    return true;
                }
                else {
                    const originalConfig = state.data.configs.find(c => c.id === editedConfig.id);
                    if (!originalConfig &&
                        editedConfig.isNew &&
                        state.selectedConfig.save.state === asyncRequest_1.AsyncRequestState.Requesting) {
                        return true;
                    }
                    return lodash_1.isEqual(editedConfig, originalConfig);
                }
            })() }) });
};
const resolveSelectedMetricId = (state, action) => {
    switch (action.type) {
        case Actions.SELECT_REPORT_METRIC:
            return action.payload.metricId;
        case Actions.LOAD_RUN_SUCCESS:
            return selectors_1.metricResultsSelector(state).length ? selectors_1.metricResultsSelector(state)[0].id : null;
        case Actions.SELECT_REPORT_METRIC_GROUP: {
            const results = selectors_1.metricResultsSelector(state);
            if (!results.length) {
                return null;
            }
            const group = action.payload.group;
            const filter = group ? r => r.groups.includes(group) : () => true;
            return results.find(filter) ? results.find(filter).id : null;
        }
        default:
            return null;
    }
};
const selectedMetricReducer = (state, action) => {
    if (![Actions.SELECT_REPORT_METRIC, Actions.SELECT_REPORT_METRIC_GROUP, Actions.LOAD_RUN_SUCCESS].includes(action.type)) {
        return state;
    }
    const id = resolveSelectedMetricId(state, action);
    if (!id) {
        return state;
    }
    action.asyncDispatch(Creators.loadMetricSetPairRequest({
        pairId: id,
    }));
    return Object.assign({}, state, { selectedRun: Object.assign({}, state.selectedRun, { selectedMetric: id, metricSetPair: Object.assign({}, state.selectedRun.metricSetPair, { load: asyncRequest_1.AsyncRequestState.Requesting }) }) });
};
const selectedMetricStoreReducer = (state, action) => {
    switch (action.type) {
        case Actions.SELECT_CONFIG:
        case Actions.LOAD_KAYENTA_ACCOUNTS_SUCCESS: {
            const stores = lodash_1.chain(state.data.kayentaAccounts.data)
                .filter(account => account.supportedTypes.includes(domain_1.KayentaAccountType.MetricsStore))
                .map(account => account.metricsStoreType || account.type)
                .uniq()
                .valueOf();
            let selectedStore = (state.selectedConfig.metricList || [])
                .map(metric => metric.query.type)
                .find(store => !!store);
            selectedStore =
                selectedStore ||
                    (stores.length ? (stores.includes(canary_settings_1.CanarySettings.metricStore) ? canary_settings_1.CanarySettings.metricStore : stores[0]) : null);
            return Object.assign({}, state, { selectedConfig: Object.assign({}, state.selectedConfig, { selectedStore }) });
        }
        case Actions.SELECT_METRIC_STORE: {
            const selectedStore = action.payload.store;
            const metricUpdater = (metric) => (Object.assign({}, metric, { query: Object.assign({}, metric.query, { type: selectedStore, serviceType: selectedStore }) }));
            return Object.assign({}, state, { selectedConfig: Object.assign({}, state.selectedConfig, { metricList: state.selectedConfig.metricList.map(metricUpdater), selectedStore }) });
        }
        default:
            return state;
    }
};
const disableConfigEditReducer = (state) => {
    if (!state.selectedConfig.config) {
        return state;
    }
    return Object.assign({}, state, { app: Object.assign({}, state.app, { disableConfigEdit: !state.selectedConfig.config.applications.includes(state.data.application.name) }) });
};
exports.rootReducer = (state, action) => {
    return [
        combined,
        judgeRenderStateReducer,
        selectedMetricStoreReducer,
        selectedMetricReducer,
        disableConfigEditReducer,
        validators_1.validationErrorsReducer,
        isInSyncWithServerReducer,
    ].reduce((s, reducer) => reducer(s, action), state);
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const redux_actions_1 = __webpack_require__(16);
const lodash_1 = __webpack_require__(2);
const Actions = __webpack_require__(10);
const list_1 = __webpack_require__(33);
const updateLabelBindingsReducer = list_1.updateListReducer();
const updateGroupByReducer = list_1.updateListReducer();
exports.prometheusMetricConfigReducer = redux_actions_1.handleActions({
    [Actions.UPDATE_PROMETHEUS_METRIC_TYPE]: (state, action) => (Object.assign({}, state, { query: Object.assign({}, state.query, { metricName: action.payload.metricName, type: 'prometheus' }) })),
    [Actions.UPDATE_PROMETHEUS_METRIC_QUERY_FIELD]: (state, action) => {
        if (!action.payload.value) {
            return Object.assign({}, state, { query: lodash_1.omit(state.query, action.payload.field) });
        }
        return Object.assign({}, state, { query: Object.assign({}, state.query, { [action.payload.field]: action.payload.value }) });
    },
    [Actions.UPDATE_PROMETHEUS_LABEL_BINDINGS]: (state, action) => (Object.assign({}, state, { query: Object.assign({}, state.query, { labelBindings: updateLabelBindingsReducer(state.query.labelBindings || [], action) }) })),
    [Actions.UPDATE_PROMETHEUS_GROUP_BY_FIELDS]: (state, action) => (Object.assign({}, state, { query: Object.assign({}, state.query, { groupByFields: updateGroupByReducer(state.query.groupByFields || [], action) }) })),
}, null);


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = __webpack_require__(21);
const redux_actions_1 = __webpack_require__(16);
const lodash_1 = __webpack_require__(2);
const Actions = __webpack_require__(10);
const canary_settings_1 = __webpack_require__(11);
const group_1 = __webpack_require__(232);
const judgeSelect_1 = __webpack_require__(39);
const groupTabs_1 = __webpack_require__(58);
const asyncRequest_1 = __webpack_require__(15);
const editingTemplate_1 = __webpack_require__(231);
const prometheusMetricConfig_1 = __webpack_require__(234);
const signalFxMetricConfig_1 = __webpack_require__(237);
const stackdriverMetricConfig_1 = __webpack_require__(238);
const config = redux_actions_1.handleActions({
    [Actions.SELECT_CONFIG]: (_state, action) => action.payload.config,
    [Actions.UPDATE_CONFIG_NAME]: (state, action) => (Object.assign({}, state, { name: action.payload.name })),
    [Actions.UPDATE_CONFIG_DESCRIPTION]: (state, action) => (Object.assign({}, state, { description: action.payload.description })),
    [redux_actions_1.combineActions(Actions.DELETE_CONFIG_SUCCESS, Actions.CLEAR_SELECTED_CONFIG)]: () => null,
    [Actions.DELETE_TEMPLATE]: (state, action) => {
        if (!action.payload.name) {
            return state;
        }
        return Object.assign({}, state, { templates: lodash_1.omit(state.templates, action.payload.name) });
    },
}, null);
const load = redux_1.combineReducers({
    state: redux_actions_1.handleActions({
        [Actions.LOAD_CONFIG_REQUEST]: () => asyncRequest_1.AsyncRequestState.Requesting,
        [Actions.LOAD_CONFIG_FAILURE]: () => asyncRequest_1.AsyncRequestState.Failed,
        [Actions.SELECT_CONFIG]: () => asyncRequest_1.AsyncRequestState.Fulfilled,
    }, asyncRequest_1.AsyncRequestState.Requesting),
});
function idMetrics(metrics = []) {
    return metrics.map((metric, index) => (Object.assign({}, metric, { id: '#' + index })));
}
const metricList = redux_actions_1.handleActions({
    [Actions.SELECT_CONFIG]: (_state, action) => idMetrics(action.payload.config.metrics),
    [Actions.ADD_METRIC]: (state, action) => idMetrics(state.concat([action.payload.metric])),
    [Actions.REMOVE_METRIC]: (state, action) => idMetrics(state.filter(metric => metric.id !== action.payload.id)),
    [Actions.DELETE_TEMPLATE]: (state, action) => state.map(m => removeDeletedTemplateFromMetric(m, action.payload.name)),
}, []);
function removeDeletedTemplateFromMetric(metric, deletedTemplateName) {
    if (lodash_1.get(metric, 'query.customFilterTemplate') === deletedTemplateName) {
        return Object.assign({}, metric, { query: Object.assign({}, metric.query, { customFilterTemplate: null }) });
    }
    return metric;
}
const editingMetric = redux_actions_1.handleActions({
    [Actions.RENAME_METRIC]: (state, action) => (Object.assign({}, state, { name: action.payload.name })),
    [Actions.UPDATE_METRIC_DIRECTION]: (state, action) => lodash_1.set(lodash_1.cloneDeep(state), ['analysisConfigurations', 'canary', 'direction'], action.payload.direction),
    [Actions.UPDATE_METRIC_NAN_STRATEGY]: (state, { payload }) => {
        const newState = lodash_1.cloneDeep(state);
        payload.strategy === 'default'
            ? lodash_1.unset(newState, ['analysisConfigurations', 'canary', 'nanStrategy'])
            : lodash_1.set(newState, ['analysisConfigurations', 'canary', 'nanStrategy'], payload.strategy);
        return newState;
    },
    [Actions.UPDATE_METRIC_CRITICALITY]: (state, { payload }) => {
        const newState = lodash_1.cloneDeep(state);
        payload.critical
            ? lodash_1.set(newState, ['analysisConfigurations', 'canary', 'critical'], payload.critical)
            : lodash_1.unset(newState, ['analysisConfigurations', 'canary', 'critical']);
        return newState;
    },
    [Actions.UPDATE_METRIC_GROUP]: (state, action) => (Object.assign({}, state, { groups: [action.payload.group] })),
    [Actions.UPDATE_ATLAS_QUERY]: (state, action) => (Object.assign({}, state, { query: Object.assign({}, state.query, { q: action.query }) })),
    [Actions.UPDATE_DATADOG_METRIC_NAME]: (state, action) => (Object.assign({}, state, { query: Object.assign({}, state.query, { metricName: action.payload.metricName }) })),
    [Actions.UPDATE_NEWRELIC_SELECT]: (state, action) => (Object.assign({}, state, { query: Object.assign({}, state.query, { select: action.payload.select }) })),
    [Actions.SELECT_TEMPLATE]: (state, action) => (Object.assign({}, state, { query: Object.assign({}, state.query, { customFilterTemplate: action.payload.name }) })),
    [Actions.UPDATE_METRIC_SCOPE_NAME]: (state, action) => (Object.assign({}, state, { scopeName: action.payload.scopeName })),
    [Actions.UPDATE_GRAPHITE_METRIC_NAME]: (state, action) => (Object.assign({}, state, { query: Object.assign({}, state.query, { metricName: action.payload.metricName }) })),
    [Actions.EDIT_INLINE_TEMPLATE]: (state, action) => (Object.assign({}, state, { query: Object.assign({}, state.query, { customInlineTemplate: action.payload.value }) })),
}, null);
const save = redux_1.combineReducers({
    state: redux_actions_1.handleActions({
        [Actions.SAVE_CONFIG_REQUEST]: () => asyncRequest_1.AsyncRequestState.Requesting,
        [redux_actions_1.combineActions(Actions.SAVE_CONFIG_SUCCESS, Actions.DISMISS_SAVE_CONFIG_ERROR)]: () => asyncRequest_1.AsyncRequestState.Fulfilled,
        [Actions.SAVE_CONFIG_FAILURE]: () => asyncRequest_1.AsyncRequestState.Failed,
    }, asyncRequest_1.AsyncRequestState.Fulfilled),
    error: redux_actions_1.handleActions({
        [Actions.SAVE_CONFIG_FAILURE]: (_state, action) => lodash_1.get(action, 'payload.error.data.message', null),
    }, null),
});
const destroy = redux_1.combineReducers({
    state: redux_actions_1.handleActions({
        [Actions.DELETE_CONFIG_REQUEST]: () => asyncRequest_1.AsyncRequestState.Requesting,
        [Actions.DELETE_CONFIG_SUCCESS]: () => asyncRequest_1.AsyncRequestState.Fulfilled,
        [Actions.DELETE_CONFIG_FAILURE]: () => asyncRequest_1.AsyncRequestState.Failed,
    }, asyncRequest_1.AsyncRequestState.Fulfilled),
    error: redux_actions_1.handleActions({
        [Actions.DELETE_CONFIG_FAILURE]: (_state, action) => lodash_1.get(action, 'payload.error.data.message', null),
    }, null),
});
const json = redux_1.combineReducers({
    configJson: redux_actions_1.handleActions({
        [Actions.SET_CONFIG_JSON]: (_state, action) => action.payload.json,
        [redux_actions_1.combineActions(Actions.CONFIG_JSON_MODAL_CLOSE, Actions.SELECT_CONFIG)]: () => null,
    }, null),
    error: redux_actions_1.handleActions({
        [redux_actions_1.combineActions(Actions.CONFIG_JSON_MODAL_CLOSE, Actions.SELECT_CONFIG, Actions.SET_CONFIG_JSON)]: () => null,
        [Actions.SET_CONFIG_JSON]: (_state, action) => {
            try {
                const parsed = JSON.parse(action.payload.json);
                parsed.metrics.forEach((m, index) => {
                    if (!m.groups || !m.groups.length) {
                        throw new Error(`metric #${index + 1}: 'groups' is a required field`);
                    }
                });
                return null;
            }
            catch (e) {
                return e.message;
            }
        },
    }, null),
});
const judge = redux_1.combineReducers({
    judgeConfig: redux_actions_1.handleActions({
        [Actions.SELECT_JUDGE_NAME]: (state, action) => (Object.assign({}, state, { name: action.payload.judge.name })),
    }, null),
    renderState: redux_actions_1.handleActions({}, judgeSelect_1.JudgeSelectRenderState.None),
});
const changeMetricGroup = redux_1.combineReducers({
    toGroup: redux_actions_1.handleActions({
        [Actions.CHANGE_METRIC_GROUP_SELECT]: (_state, action) => action.payload.group,
        [Actions.CHANGE_METRIC_GROUP]: () => null,
    }, null),
    metric: redux_actions_1.handleActions({
        [Actions.CHANGE_METRIC_GROUP]: (_state, action) => action.payload.id,
        [Actions.CHANGE_METRIC_GROUP_CONFIRM]: () => null,
    }, null),
});
const isInSyncWithServer = redux_actions_1.handleActions({}, null);
function editingMetricReducer(state = null, action) {
    switch (action.type) {
        case Actions.ADD_METRIC:
            return Object.assign({}, state, { editingMetric: state.metricList[state.metricList.length - 1] });
        case Actions.EDIT_METRIC_BEGIN:
            return Object.assign({}, state, { editingMetric: state.metricList.find(metric => metric.id === action.payload.id) });
        case Actions.EDIT_METRIC_CONFIRM: {
            const editing = lodash_1.omit(state.editingMetric, 'isNew');
            return Object.assign({}, state, { metricList: state.metricList.map(metric => (metric.id === editing.id ? editing : metric)), editingMetric: null });
        }
        case Actions.EDIT_METRIC_CANCEL:
            return Object.assign({}, state, { metricList: state.metricList.filter(metric => !metric.isNew), editingMetric: null });
        default:
            return state;
    }
}
function selectedJudgeReducer(state = null, action) {
    switch (action.type) {
        case Actions.SELECT_CONFIG:
            if (lodash_1.has(action, 'payload.config.judge')) {
                return Object.assign({}, state, { judge: Object.assign({}, state.judge, { judgeConfig: Object.assign({}, action.payload.config.judge) }) });
            }
            else {
                return Object.assign({}, state, { judge: Object.assign({}, state.judge, { judgeConfig: { name: canary_settings_1.CanarySettings.defaultJudge, judgeConfigurations: {} } }) });
            }
        default:
            return state;
    }
}
function editGroupConfirmReducer(state = null, action) {
    if (action.type !== Actions.EDIT_GROUP_CONFIRM) {
        return state;
    }
    const { payload } = action;
    const allGroups = lodash_1.flatMap(state.metricList, metric => metric.groups);
    if (!payload.edit || payload.edit === groupTabs_1.ALL || allGroups.includes(payload.edit)) {
        return state;
    }
    const metricUpdater = (c) => (Object.assign({}, c, { groups: (c.groups || []).includes(payload.group)
            ? [payload.edit].concat((c.groups || []).filter(g => g !== payload.group))
            : c.groups }));
    const weightsUpdater = (weights) => {
        const weight = weights[payload.group];
        weights = lodash_1.omit(weights, payload.group);
        return Object.assign({}, weights, { [payload.edit]: weight });
    };
    const listUpdater = (groupList) => [payload.edit].concat((groupList || []).filter(g => g !== payload.group));
    return Object.assign({}, state, { metricList: state.metricList.map(metricUpdater), group: Object.assign({}, state.group, { selected: payload.edit, groupWeights: weightsUpdater(state.group.groupWeights), list: listUpdater(state.group.list) }) });
}
exports.editGroupConfirmReducer = editGroupConfirmReducer;
function changeMetricGroupConfirmReducer(state, action) {
    if (action.type !== Actions.CHANGE_METRIC_GROUP_CONFIRM) {
        return state;
    }
    const { changeMetricGroup: { toGroup }, } = state;
    const { payload: { metricId }, } = action;
    if (!metricId) {
        return state;
    }
    const metricUpdater = (m) => (Object.assign({}, m, { groups: m.id === metricId ? [toGroup] : m.groups }));
    return Object.assign({}, state, { metricList: state.metricList.map(metricUpdater) });
}
exports.changeMetricGroupConfirmReducer = changeMetricGroupConfirmReducer;
function updateGroupWeightsReducer(state, action) {
    if (![Actions.SELECT_CONFIG, Actions.CHANGE_METRIC_GROUP_CONFIRM, Actions.ADD_METRIC, Actions.REMOVE_METRIC].includes(action.type)) {
        return state;
    }
    const groups = lodash_1.chain(state.metricList)
        .flatMap(metric => metric.groups)
        .uniq()
        .value();
    let groupWeights = lodash_1.pick(state.group.groupWeights, groups);
    groupWeights = Object.assign({}, lodash_1.fromPairs(groups.map(g => [g, 0])), groupWeights);
    return Object.assign({}, state, { group: Object.assign({}, state.group, { groupWeights }) });
}
exports.updateGroupWeightsReducer = updateGroupWeightsReducer;
const editingTemplateConfirmReducer = (state, action) => {
    if (action.type !== Actions.EDIT_TEMPLATE_CONFIRM) {
        return state;
    }
    const { name, editedName, editedValue, isNew } = state.editingTemplate;
    const templates = Object.assign({}, (name ? lodash_1.omit(state.config.templates, name) : state.config.templates), { [editedName]: editedValue });
    const metricUpdater = (metric) => {
        if (lodash_1.get(metric, 'query.customFilterTemplate') !== name) {
            return metric;
        }
        return Object.assign({}, metric, { query: Object.assign({}, metric.query, { customFilterTemplate: editedName }) });
    };
    const editingMetricUpdater = (metric) => {
        if (isNew) {
            return Object.assign({}, metric, { query: Object.assign({}, metric.query, { customFilterTemplate: editedName }) });
        }
        return metricUpdater(metric);
    };
    return Object.assign({}, state, { editingTemplate: {
            name: null,
            editedName: null,
            editedValue: null,
            isNew: false,
        }, config: Object.assign({}, state.config, { templates }), metricList: (state.metricList || []).map(metricUpdater), editingMetric: editingMetricUpdater(state.editingMetric) });
};
const combined = redux_1.combineReducers({
    config,
    load,
    save,
    destroy,
    json,
    judge,
    metricList,
    editingMetric: (metric, action) => [editingMetric, prometheusMetricConfig_1.prometheusMetricConfigReducer, signalFxMetricConfig_1.signalFxMetricConfigReducer, stackdriverMetricConfig_1.stackdriverMetricConfigReducer].reduce((s, reducer) => reducer(s, action), metric),
    group: group_1.group,
    changeMetricGroup,
    isInSyncWithServer,
    validationErrors: () => null,
    editingTemplate: editingTemplate_1.editingTemplate,
    selectedStore: redux_actions_1.handleActions({}, null),
});
exports.selectedConfig = (state, action) => {
    return [
        combined,
        editingMetricReducer,
        selectedJudgeReducer,
        editGroupConfirmReducer,
        changeMetricGroupConfirmReducer,
        updateGroupWeightsReducer,
        editingTemplateConfirmReducer,
    ].reduce((s, reducer) => reducer(s, action), state);
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const redux_1 = __webpack_require__(21);
const redux_actions_1 = __webpack_require__(16);
const Actions = __webpack_require__(10);
const asyncRequest_1 = __webpack_require__(15);
const metricSetPairGraph_service_1 = __webpack_require__(27);
const run = redux_actions_1.handleActions({
    [Actions.LOAD_RUN_SUCCESS]: (_state, action) => action.payload.run,
}, null);
const load = redux_actions_1.handleActions({
    [Actions.LOAD_RUN_REQUEST]: () => asyncRequest_1.AsyncRequestState.Requesting,
    [Actions.LOAD_RUN_SUCCESS]: () => asyncRequest_1.AsyncRequestState.Fulfilled,
    [Actions.LOAD_RUN_FAILURE]: () => asyncRequest_1.AsyncRequestState.Failed,
}, asyncRequest_1.AsyncRequestState.Requesting);
const selectedGroup = redux_actions_1.handleActions({
    [Actions.SELECT_REPORT_METRIC_GROUP]: (_state, action) => action.payload.group,
}, null);
const selectedMetric = redux_actions_1.handleActions({
    [Actions.SELECT_REPORT_METRIC_GROUP]: () => null,
}, null);
const metricSetPair = redux_1.combineReducers({
    pair: redux_actions_1.handleActions({
        [Actions.LOAD_METRIC_SET_PAIR_REQUEST]: () => null,
        [Actions.LOAD_METRIC_SET_PAIR_SUCCESS]: (_state, action) => action.payload.metricSetPair,
    }, null),
    load: redux_actions_1.handleActions({
        [Actions.LOAD_METRIC_SET_PAIR_REQUEST]: () => asyncRequest_1.AsyncRequestState.Requesting,
        [Actions.LOAD_METRIC_SET_PAIR_SUCCESS]: () => asyncRequest_1.AsyncRequestState.Fulfilled,
        [Actions.LOAD_METRIC_SET_PAIR_FAILURE]: () => asyncRequest_1.AsyncRequestState.Failed,
    }, asyncRequest_1.AsyncRequestState.Fulfilled),
});
const graphType = redux_actions_1.handleActions({
    [Actions.SELECT_GRAPH_TYPE]: (_state, action) => action.payload.type,
}, metricSetPairGraph_service_1.GraphType.TimeSeries);
exports.selectedRun = redux_1.combineReducers({
    run,
    load,
    selectedGroup,
    selectedMetric,
    metricSetPair,
    graphType,
});


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const redux_actions_1 = __webpack_require__(16);
const Actions = __webpack_require__(10);
const keyValueList_1 = __webpack_require__(62);
const updateQueryPairsReducer = keyValueList_1.updateListReducer();
exports.signalFxMetricConfigReducer = redux_actions_1.handleActions({
    [Actions.UPDATE_SIGNAL_FX_QUERY_PAIRS]: (state, action) => (Object.assign({}, state, { query: Object.assign({}, state.query, { queryPairs: updateQueryPairsReducer(state.query.queryPairs || [], action) }) })),
    [Actions.UPDATE_SIGNAL_FX_METRIC_NAME]: (state, action) => (Object.assign({}, state, { query: Object.assign({}, state.query, { metricName: action.payload.metricName }) })),
    [Actions.UPDATE_SIGNAL_FX_AGGREGATION_METHOD]: (state, action) => (Object.assign({}, state, { query: Object.assign({}, state.query, { aggregationMethod: action.payload.aggregationMethod }) })),
}, null);


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const redux_actions_1 = __webpack_require__(16);
const lodash_1 = __webpack_require__(2);
const Actions = __webpack_require__(10);
const list_1 = __webpack_require__(33);
const updateGroupByReducer = list_1.updateListReducer();
exports.stackdriverMetricConfigReducer = redux_actions_1.handleActions({
    [Actions.UPDATE_STACKDRIVER_GROUP_BY_FIELDS]: (state, action) => (Object.assign({}, state, { query: Object.assign({}, state.query, { groupByFields: updateGroupByReducer(state.query.groupByFields || [], action) }) })),
    [Actions.UPDATE_STACKDRIVER_METRIC_QUERY_FIELD]: (state, action) => {
        if (!action.payload.value) {
            return Object.assign({}, state, { query: lodash_1.omit(state.query, action.payload.field) });
        }
        return Object.assign({}, state, { query: Object.assign({}, state.query, { [action.payload.field]: action.payload.value, type: 'stackdriver' }) });
    },
}, null);


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __webpack_require__(2);
const domain_1 = __webpack_require__(13);
const createValidationReducer = (validator) => {
    return (state) => {
        if (!state.selectedConfig.config) {
            return state;
        }
        const error = validator(state);
        if (!error) {
            return state;
        }
        return Object.assign({}, state, { selectedConfig: Object.assign({}, state.selectedConfig, { validationErrors: state.selectedConfig.validationErrors.concat(error ? [error] : []) }) });
    };
};
const isConfigNameUnique = state => {
    const selectedConfig = state.selectedConfig.config;
    const configSummaries = state.data.configSummaries;
    const isUnique = configSummaries.every(s => selectedConfig.name !== s.name || selectedConfig.id === s.id);
    return isUnique ? null : { message: `Canary config '${selectedConfig.name}' already exists.` };
};
const pattern = /^[a-zA-Z0-9_-]*$/;
const isConfigNameValid = state => {
    const isValid = pattern.test(state.selectedConfig.config.name);
    return isValid
        ? null
        : {
            message: 'Canary config names must contain only letters, numbers, dashes (-) and underscores (_).',
        };
};
const isGroupWeightsSumValid = state => {
    const weights = Object.values(state.selectedConfig.group.groupWeights);
    const sumOfWeights = weights.reduce((sum, weight) => sum + weight, 0);
    const groupWeightsSumIsValid = weights.length === 0 || sumOfWeights === 100;
    return groupWeightsSumIsValid ? null : { message: 'Metric group weights must sum to 100.' };
};
const isEveryGroupWeightValid = state => {
    const everyGroupWeightIsValid = Object.values(state.selectedConfig.group.groupWeights).every(weight => weight >= 0);
    return everyGroupWeightIsValid ? null : { message: 'A group weight must be greater than or equal to 0.' };
};
const isEveryQueriedMetricStoreAvailable = state => {
    const available = lodash_1.chain(state.data.kayentaAccounts.data)
        .filter(account => account.supportedTypes.includes(domain_1.KayentaAccountType.MetricsStore))
        .map(account => account.metricsStoreType || account.type)
        .uniq()
        .valueOf();
    const queried = lodash_1.chain(state.selectedConfig.metricList)
        .map(metric => metric.query.type)
        .uniq()
        .valueOf();
    const unavailableQueried = queried.filter(store => !available.includes(store));
    let message;
    if (unavailableQueried.length === 1) {
        message = `This config contains metrics configured to query a metric
               store (${unavailableQueried[0]})
               that does not have any configured accounts.`;
    }
    else if (unavailableQueried.length > 1) {
        message = `This config contains metrics configured to query metric
               stores (${unavailableQueried.join()})
               that do not have any configured accounts.`;
    }
    return unavailableQueried.length ? { message } : null;
};
const areMultipleMetricStoresQueried = state => {
    const queried = lodash_1.chain(state.selectedConfig.metricList)
        .map(metric => metric.query.type)
        .uniq()
        .valueOf();
    return queried.length > 1 ? { message: 'All metrics must be from the same metric store.' } : null;
};
exports.validationErrorsReducer = (state) => {
    if (!state.selectedConfig) {
        return state;
    }
    if (!state.selectedConfig.validationErrors) {
        state = Object.assign({}, state, { selectedConfig: Object.assign({}, state.selectedConfig, { validationErrors: [] }) });
    }
    return [
        isConfigNameUnique,
        isConfigNameValid,
        isGroupWeightsSumValid,
        isEveryGroupWeightValid,
        isEveryQueriedMetricStoreAvailable,
        areMultipleMetricStoresQueried,
    ].reduce((s, validator) => createValidationReducer(validator)(s), state);
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
const colors_1 = __webpack_require__(42);
const headerArrow_1 = __webpack_require__(68);
exports.default = ({ className, onClick, score, scoreThresholds }) => (React.createElement("section", { className: className },
    React.createElement("div", { onClick: onClick, style: {
            backgroundColor: colors_1.mapGroupToColor(score, scoreThresholds),
        }, className: classNames('clickable', 'text-center', 'all-metric-results-header') },
        React.createElement("h3", { className: "heading-3 label" }, "ALL"),
        React.createElement(headerArrow_1.default, { className: "outer", arrowColor: "var(--color-titanium)" }),
        React.createElement(headerArrow_1.default, { className: "inner", arrowColor: colors_1.mapGroupToColor(score, scoreThresholds) }))));


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
const headerArrow_1 = __webpack_require__(68);
exports.default = ({ label, onClick, style, className }) => (React.createElement("section", { style: style, onClick: onClick, className: classNames('clickable', 'text-center', 'group-score', className) },
    React.createElement("h3", { className: "heading-3 uppercase label" }, label),
    React.createElement(headerArrow_1.default, { arrowColor: style.backgroundColor })));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const header_1 = __webpack_require__(254);
const reportScores_1 = __webpack_require__(266);
const metricResults_1 = __webpack_require__(260);
__webpack_require__(127);
class DetailView extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { isExpanded: true };
        this.toggleDetailHeader = () => {
            this.setState({ isExpanded: !this.state.isExpanded });
        };
    }
    render() {
        const { isExpanded } = this.state;
        const chevronStyle = {
            transform: this.state.isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
            transition: 'all ease 0.15s',
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "kayenta-overview-toggle", onClick: this.toggleDetailHeader },
                isExpanded ? React.createElement("p", null, "hide details") : React.createElement("p", null, "show details"),
                React.createElement("span", { className: "glyphicon glyphicon-chevron-right", style: chevronStyle })),
            React.createElement("div", { className: "vertical flex-1" },
                isExpanded && React.createElement(header_1.default, null),
                React.createElement(reportScores_1.default, null),
                React.createElement(metricResults_1.default, null))));
    }
}
exports.default = DetailView;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const Creators = __webpack_require__(3);
const loadStates_1 = __webpack_require__(255);
class ResultDetailLoader extends React.Component {
    constructor(props) {
        super(props);
        const { resultIdStream, loadResult } = props;
        this.subscription = resultIdStream.subscribe(loadResult);
    }
    componentWillUnmount() {
        this.subscription.unsubscribe();
    }
    render() {
        return React.createElement(loadStates_1.default, null);
    }
}
const mapDispatchToProps = (dispatch) => ({
    loadResult: (stateParams) => dispatch(Creators.loadRunRequest({
        configId: stateParams.configId,
        runId: stateParams.runId,
    })),
});
exports.default = react_redux_1.connect(null, mapDispatchToProps)(ResultDetailLoader);


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const metricSetPairGraph_service_1 = __webpack_require__(27);
const selectors_1 = __webpack_require__(9);
const GRAPH_IMPLEMENTATIONS = ['semiotic'];
const MetricSetPairGraph = ({ pair, result, graphType }) => {
    const delegates = GRAPH_IMPLEMENTATIONS.map(name => metricSetPairGraph_service_1.metricSetPairGraphService.getDelegate(name)).filter(d => !!d);
    const delegate = delegates.find(candidate => candidate.handlesGraphType(graphType));
    if (!delegate) {
        return React.createElement("h3", { className: "heading-3" }, "Could not load graph.");
    }
    const Graph = delegate.getGraph();
    return React.createElement(Graph, { metricSetPair: pair, result: result, type: graphType });
};
const mapStateToProps = (state) => {
    const selectedMetric = state.selectedRun.selectedMetric;
    return {
        pair: state.selectedRun.metricSetPair.pair,
        result: selectors_1.metricResultsSelector(state).find(result => result.id === selectedMetric),
        graphType: state.selectedRun.graphType,
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(MetricSetPairGraph);


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const semiotic_1 = __webpack_require__(30);
const d3_array_1 = __webpack_require__(50);
const labella_1 = __webpack_require__(295);
const utils = __webpack_require__(24);
const config_1 = __webpack_require__(19);
const chartHeader_1 = __webpack_require__(43);
const chartLegend_1 = __webpack_require__(44);
__webpack_require__(128);
const tooltip_1 = __webpack_require__(47);
const circleIcon_1 = __webpack_require__(45);
class BoxPlot extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            tooltip: null,
        };
        this.margin = {
            top: 10,
            bottom: 20,
            left: 60,
            right: 40,
        };
        this.decorateData = (dataPoints, group) => {
            return dataPoints.map(dp => ({
                group,
                value: dp,
                color: config_1.vizConfig.colors[group],
            }));
        };
        this.generateChartData = () => {
            const { metricSetPair } = this.props;
            const filterFunc = (v) => typeof v.value === 'number';
            const baselineInput = this.decorateData(metricSetPair.values.control, 'baseline');
            const canaryInput = this.decorateData(metricSetPair.values.experiment, 'canary');
            const chartData = baselineInput.concat(canaryInput).filter(filterFunc);
            return chartData;
        };
        this.createChartHoverHandler = () => {
            return (d) => {
                if (d && d.type === 'frame-hover') {
                    const points = d.points;
                    const data = {
                        baseline: [],
                        canary: [],
                    };
                    points.forEach((p) => {
                        data[p.key].push({ label: p.label, value: p.value });
                    });
                    const summaryLabels = data.baseline.map((b) => b.label);
                    const summaryKeysColumn = [
                        React.createElement("div", { className: 'header', key: 'summary' }, "Summary"),
                        ...summaryLabels.map((label) => {
                            return React.createElement("div", { key: label }, label);
                        }),
                    ];
                    const baselineColumn = [
                        React.createElement("div", { className: 'header', key: 'baseline' },
                            React.createElement(circleIcon_1.default, { group: 'baseline' }),
                            "Baseline"),
                        data.baseline.map((hd, i) => {
                            return React.createElement("div", { key: i }, utils.formatMetricValue(hd.value));
                        }),
                    ];
                    const canaryColumn = [
                        React.createElement("div", { className: "header", key: "canary" },
                            React.createElement(circleIcon_1.default, { group: "canary" }),
                            "Canary"),
                        data.canary.map((hd, i) => {
                            return React.createElement("div", { key: i }, utils.formatMetricValue(hd.value));
                        }),
                    ];
                    const tooltipContent = (React.createElement("div", { className: "tooltip-container" },
                        React.createElement("div", { className: "columns" },
                            React.createElement("div", { className: "column" }, summaryKeysColumn),
                            React.createElement("div", { className: "column" }, baselineColumn),
                            React.createElement("div", { className: "column" }, canaryColumn))));
                    this.setState({
                        tooltip: {
                            content: tooltipContent,
                            x: d.x + this.margin.left,
                            y: d.y + this.margin.top,
                        },
                    });
                }
                else {
                    this.setState({ tooltip: null });
                }
            };
        };
        this.defineAnnotations = () => {
            return ['baseline', 'canary'].map((g) => {
                return {
                    type: 'summary-custom',
                    group: g,
                    summaryKeys: ['q1area', 'median', 'q3area'],
                };
            });
        };
        this.customAnnotationFunction = (args) => {
            const { d, orFrameState: { pieceDataXY }, categories, } = args;
            if (d.type === 'summary-custom') {
                if (!categories[d.group]) {
                    return null;
                }
                const summaryData = pieceDataXY.filter((sd) => sd.key === d.group);
                const boxPlotWidth = categories[d.group].width;
                const statLabelMap = {
                    median: 'median',
                    q1area: '25th %-ile',
                    q3area: '75th %-ile',
                };
                const createNoteElement = (posY, dataPoint) => {
                    const name = dataPoint.summaryPieceName;
                    const label = statLabelMap[name];
                    const noteData = {
                        x: dataPoint.x,
                        y: posY,
                        dx: boxPlotWidth / 2,
                        dy: 0,
                        note: {
                            label: `${label}: ${utils.formatMetricValue(dataPoint.value)}`,
                            wrap: 100,
                            lineType: 'vertical',
                            align: 'middle',
                            orientation: 'topBottom',
                            padding: 10,
                        },
                        className: 'boxplot-annotation',
                    };
                    return React.createElement(semiotic_1.Annotation, { key: name, noteData: noteData });
                };
                const nodes = d.summaryKeys
                    .map((summaryKey) => {
                    const pieceData = summaryData.find((sd) => sd.summaryPieceName === summaryKey);
                    return pieceData ? new labella_1.Node(pieceData.y, 20, pieceData) : null;
                })
                    .map((v) => v);
                const forceOptions = {
                    minPos: this.margin.top,
                    maxPos: config_1.vizConfig.height - this.margin.bottom,
                };
                const annotations = new labella_1.Force(forceOptions)
                    .nodes(nodes)
                    .compute()
                    .nodes()
                    .map((n) => createNoteElement(n.currentPos, n.data));
                return annotations;
            }
            else {
                return null;
            }
        };
        this.getChartProps = () => {
            const { parentWidth } = this.props;
            const chartData = this.generateChartData();
            return {
                size: [parentWidth, config_1.vizConfig.height],
                margin: this.margin,
                projection: 'vertical',
                summaryType: 'boxplot',
                oLabel: false,
                oPadding: 160,
                style: (d) => {
                    return {
                        fill: d.color,
                        fillOpacity: 0.7,
                    };
                },
                summaryStyle: (d) => {
                    return {
                        fill: d.color,
                        fillOpacity: 0.4,
                        stroke: '#6a6a6a',
                        strokeWidth: 2,
                    };
                },
                pieceClass: (d) => `piece ${d.group}`,
                type: {
                    type: 'swarm',
                    r: 3,
                    iterations: 50,
                },
                rExtent: d3_array_1.extent(chartData.map(o => o.value)),
                customHoverBehavior: this.createChartHoverHandler(),
                hoverAnnotation: false,
                annotations: this.defineAnnotations(),
                summaryHoverAnnotation: [],
                data: chartData,
                oAccessor: (d) => d.group,
                rAccessor: (d) => d.value,
                svgAnnotationRules: this.customAnnotationFunction,
                summaryClass: 'boxplot-summary',
                axis: {
                    orient: 'left',
                    label: 'metric value',
                    tickFormat: (d) => utils.formatMetricValue(d),
                },
            };
        };
    }
    render() {
        const { metricSetPair } = this.props;
        return (React.createElement("div", { className: "boxplot" },
            React.createElement(chartHeader_1.default, { metric: metricSetPair.name }),
            React.createElement(chartLegend_1.default, null),
            React.createElement("div", { className: "graph-container" },
                React.createElement("div", { className: "boxplot-chart" },
                    React.createElement(semiotic_1.OrdinalFrame, Object.assign({}, this.getChartProps()))),
                React.createElement(tooltip_1.default, Object.assign({}, this.state.tooltip)))));
    }
}
exports.default = BoxPlot;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const d3_scale_1 = __webpack_require__(28);
const semiotic_1 = __webpack_require__(30);
const moment = __webpack_require__(36);
const d3_shape_1 = __webpack_require__(74);
const config_1 = __webpack_require__(19);
__webpack_require__(130);
const utils = __webpack_require__(24);
const customAxisTickLabel_1 = __webpack_require__(46);
const secondaryTSXAxis_1 = __webpack_require__(67);
class DifferenceArea extends React.Component {
    constructor() {
        super(...arguments);
        this.margin = {
            left: 60,
            right: 20,
        };
        this.chartHeight = 40;
        this.headerHeight = 17;
        this.getChartData = () => {
            const { metricSetPair, millisBaselineSet } = this.props;
            const { values: { experiment, control }, scopes, } = metricSetPair;
            const stepMillis = scopes.control.stepMillis;
            const maxDataPoints = Math.max(experiment.length, control.length);
            const intDataSet = Array(maxDataPoints)
                .fill(0)
                .map((_, i) => {
                const e = experiment[i];
                const c = control[i];
                return {
                    timestamp: scopes.control.startTimeMillis + i * stepMillis,
                    canary: e,
                    baseline: c,
                };
            })
                .filter((ds) => millisBaselineSet.includes(ds.timestamp));
            const baselineReferenceDataPoints = intDataSet.map((ds) => ({
                timestampMillis: ds.timestamp,
                value: 0,
            }));
            const differenceDataPoints = intDataSet.map((ds) => ({
                timestampMillis: ds.timestamp,
                value: typeof ds.canary === 'number' && typeof ds.baseline === 'number' ? ds.canary - ds.baseline : 0,
            }));
            return {
                chartData: [
                    {
                        label: 'difference',
                        color: config_1.vizConfig.colors.canary,
                        coordinates: differenceDataPoints,
                    },
                    {
                        label: 'baselineReference',
                        color: config_1.vizConfig.colors.baseline,
                        coordinates: baselineReferenceDataPoints,
                    },
                ],
            };
        };
        this.getSecondaryAxis = (millisOffset, millisBaselineSet) => {
            const { parentWidth } = this.props;
            const millisSetCanary = millisBaselineSet.map((ms) => ms + millisOffset);
            return (React.createElement(secondaryTSXAxis_1.default, { margin: { left: this.margin.left, right: this.margin.right, top: 0, bottom: 0 }, width: parentWidth, millisSet: millisSetCanary, axisLabel: 'canary', bottomOffset: 0 }));
        };
        this.getXAxisTotalHeight = (shouldUseSecondaryXAxis) => {
            const { axisTickLineHeight, axisTickLabelHeight, axisLabelHeight } = config_1.vizConfig.timeSeries;
            return shouldUseSecondaryXAxis
                ? 2 * (axisLabelHeight + axisTickLabelHeight) + axisTickLineHeight
                : axisTickLabelHeight;
        };
    }
    render() {
        const { metricSetPair, parentWidth, millisBaselineSet } = this.props;
        const { scopes } = metricSetPair;
        const { chartData } = this.getChartData();
        const millisOffset = scopes.experiment.startTimeMillis - scopes.control.startTimeMillis;
        const shouldUseSecondaryXAxis = millisOffset !== 0;
        const xAxisTotalHeight = this.getXAxisTotalHeight(shouldUseSecondaryXAxis);
        const computedConfig = {
            lines: chartData,
            size: [parentWidth, this.chartHeight + xAxisTotalHeight],
            margin: Object.assign({}, this.margin, { top: 0, bottom: xAxisTotalHeight }),
            lineType: {
                type: 'area',
                interpolator: d3_shape_1.curveStepAfter,
            },
            lineStyle: (ds) => ds.label === 'difference'
                ? {
                    fill: ds.color,
                    fillOpacity: 0.6,
                }
                : {
                    stroke: ds.color,
                    strokeOpacity: 1,
                    strokeWidth: 2,
                    strokeDasharray: 5,
                },
            xAccessor: (d) => moment(d.timestampMillis).toDate(),
            yAccessor: 'value',
            xScaleType: d3_scale_1.scaleUtc(),
            axes: [
                {
                    orient: 'left',
                    tickFormat: () => `\u0394 = 0`,
                    tickValues: [0],
                },
                {
                    orient: 'bottom',
                    tickValues: utils.calculateDateTimeTicks(millisBaselineSet),
                    tickFormat: (d) => React.createElement(customAxisTickLabel_1.default, { millis: d }),
                    label: shouldUseSecondaryXAxis ? 'Baseline' : undefined,
                    className: shouldUseSecondaryXAxis ? 'baseline-dual-axis' : '',
                },
            ],
            xExtent: [millisBaselineSet[0], millisBaselineSet[millisBaselineSet.length - 1]],
        };
        return (React.createElement("div", { className: "difference-area" },
            React.createElement("div", { className: "chart-title", style: { height: this.headerHeight } }, "Canary Value Differences from Baseline"),
            React.createElement(semiotic_1.XYFrame, Object.assign({}, computedConfig)),
            shouldUseSecondaryXAxis ? this.getSecondaryAxis(millisOffset, millisBaselineSet) : null));
    }
}
exports.default = DifferenceArea;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const semiotic_1 = __webpack_require__(30);
const d3_array_1 = __webpack_require__(50);
const d3_scale_1 = __webpack_require__(28);
const utils = __webpack_require__(24);
const config_1 = __webpack_require__(19);
__webpack_require__(131);
const chartHeader_1 = __webpack_require__(43);
const chartLegend_1 = __webpack_require__(44);
const tooltip_1 = __webpack_require__(47);
const circleIcon_1 = __webpack_require__(45);
class Histogram extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            tooltip: null,
        };
        this.margin = {
            top: 20,
            bottom: 20,
            left: 60,
            right: 10,
        };
        this.decorateData = (dataPoints, group) => {
            return dataPoints.map(dp => ({
                group,
                value: dp,
            }));
        };
        this.generateChartData = () => {
            const { metricSetPair } = this.props;
            const filterFunc = (v) => typeof v.value === 'number';
            const baselineInput = this.decorateData(metricSetPair.values.control, 'baseline');
            const canaryInput = this.decorateData(metricSetPair.values.experiment, 'canary');
            const combinedInput = baselineInput.concat(canaryInput).filter(filterFunc);
            const x = d3_scale_1.scaleLinear()
                .domain(d3_array_1.extent(combinedInput.map(o => o.value)))
                .nice();
            const domain = x.domain();
            const histogramData = d3_array_1.histogram()
                .domain(domain)
                .value((d) => d.value)(combinedInput);
            const chartData = [];
            histogramData.forEach(h => {
                const { x0, x1 } = h;
                const baselineBin = { group: 'baseline', x0, x1, count: 0 };
                const canaryBin = { group: 'canary', x0, x1, count: 0 };
                h.forEach(d => (d.group === 'baseline' ? baselineBin.count++ : canaryBin.count++));
                chartData.push(baselineBin);
                chartData.push(canaryBin);
            });
            return chartData;
        };
        this.createChartHoverHandler = (chartData) => {
            return (d) => {
                if (d && d.type === 'column-hover') {
                    const x1Max = Math.max(...chartData.map((cd) => cd.x1));
                    const xyData = d.column.xyData;
                    const x = xyData[1].xy.x + this.margin.left;
                    const halfHeight1 = xyData[0].xy.height / 2;
                    const halfHeight2 = xyData[1].xy.height / 2;
                    const y = config_1.vizConfig.height - this.margin.bottom - Math.min(halfHeight1, halfHeight2);
                    const { x0, x1 } = d.summary[0].data;
                    const tooltipRows = d.summary.map((s) => {
                        const { group, count } = s.data;
                        const valueStyle = {
                            fontWeight: 'bold',
                        };
                        return (React.createElement("div", { key: group },
                            React.createElement(circleIcon_1.default, { group: group }),
                            React.createElement("span", null, ` ${group} count: `),
                            React.createElement("span", { style: valueStyle }, count)));
                    });
                    let label = `For metric value more than / equal to ${utils.formatMetricValue(x0)} `;
                    label +=
                        x1 === x1Max
                            ? `and less than / equal to ${utils.formatMetricValue(x1)}`
                            : `and less than ${utils.formatMetricValue(x1)}`;
                    const tooltipContent = (React.createElement("div", null,
                        React.createElement("div", null, label),
                        tooltipRows));
                    this.setState({
                        tooltip: {
                            content: tooltipContent,
                            x,
                            y,
                        },
                    });
                }
                else {
                    this.setState({ tooltip: null });
                }
            };
        };
        this.defineAnnotations = (chartData) => {
            const annotations = [];
            chartData.forEach((d) => {
                if (d.count > 0) {
                    annotations.push(Object.assign({ type: 'bar-value-custom' }, d));
                }
            });
            return annotations;
        };
        this.customAnnotationFunction = (args) => {
            const { d, i, categories } = args;
            if (d.type === 'bar-value-custom') {
                const { x, y, width } = categories[d.x1].xyData.find((c) => c.piece.data.group === d.group).xy;
                const noteData = {
                    x: x + width / 2,
                    y,
                    nx: x + width / 2,
                    ny: y - 1,
                    note: {
                        label: `${d.count}`,
                        wrap: 100,
                        align: 'middle',
                        orientation: 'topBottom',
                        padding: 0,
                        color: config_1.vizConfig.colors[d.group],
                        lineType: 'horizontal',
                    },
                    className: `bar-annotation`,
                };
                return React.createElement(semiotic_1.Annotation, { key: i, noteData: noteData });
            }
            else {
                return null;
            }
        };
        this.getChartProps = () => {
            const { parentWidth } = this.props;
            const chartData = this.generateChartData();
            return {
                size: [parentWidth, config_1.vizConfig.height],
                margin: this.margin,
                projection: 'vertical',
                type: 'clusterbar',
                oLabel: (v) => React.createElement("text", { textAnchor: "middle" }, utils.formatMetricValue(parseFloat(v))),
                oPadding: 20,
                oAccessor: (d) => d.x1,
                style: (d) => {
                    return {
                        fill: config_1.vizConfig.colors[d.group],
                        strokeWidth: 1,
                        stroke: config_1.vizConfig.colors.background,
                        strokeOpacity: 1,
                    };
                },
                customHoverBehavior: this.createChartHoverHandler(chartData),
                data: this.generateChartData(),
                axis: [
                    {
                        orient: 'left',
                        label: 'measurement count',
                        tickFormat: (d) => (d === 0 ? null : Math.abs(d)),
                    },
                ],
                rAccessor: (d) => d.count,
                annotations: this.defineAnnotations(chartData),
                svgAnnotationRules: this.customAnnotationFunction,
                hoverAnnotation: [],
            };
        };
    }
    render() {
        const { metricSetPair } = this.props;
        return (React.createElement("div", { className: "histogram" },
            React.createElement(chartHeader_1.default, { metric: metricSetPair.name }),
            React.createElement(chartLegend_1.default, null),
            React.createElement("div", { className: "graph-container" },
                React.createElement("div", { className: "canary-chart" },
                    React.createElement(semiotic_1.OrdinalFrame, Object.assign({}, this.getChartProps()))),
                React.createElement(tooltip_1.default, Object.assign({}, this.state.tooltip)))));
    }
}
exports.default = Histogram;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const metricSetPairGraph_service_1 = __webpack_require__(27);
const semioticGraph_1 = __webpack_require__(250);
const supportedGraphTypes = [metricSetPairGraph_service_1.GraphType.TimeSeries, metricSetPairGraph_service_1.GraphType.Histogram, metricSetPairGraph_service_1.GraphType.BoxPlot];
metricSetPairGraph_service_1.metricSetPairGraphService.register({
    name: 'semiotic',
    handlesGraphType: type => supportedGraphTypes.includes(type),
    getGraph: () => semioticGraph_1.default,
});


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const config_1 = __webpack_require__(19);
__webpack_require__(132);
exports.default = () => (React.createElement("div", { style: { height: config_1.vizConfig.height }, className: "no-data-sign" }, "No Valid Data is Available for This Metric"));


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_container_dimensions_1 = __webpack_require__(299);
const metricSetPairGraph_service_1 = __webpack_require__(27);
const timeSeries_1 = __webpack_require__(251);
const histogram_1 = __webpack_require__(247);
const boxplot_1 = __webpack_require__(245);
const noValidDataSign_1 = __webpack_require__(249);
__webpack_require__(134);
class SemioticGraph extends React.Component {
    constructor() {
        super(...arguments);
        this.fetchChart = (parentWidth) => {
            const { type, metricSetPair: { values: { control, experiment }, }, } = this.props;
            const chartProps = Object.assign({}, this.props, { parentWidth });
            const filterInvalidValues = (data) => data.filter(v => typeof v === 'number');
            if (filterInvalidValues(control).length === 0 && filterInvalidValues(experiment).length === 0) {
                return React.createElement(noValidDataSign_1.default, null);
            }
            switch (type) {
                case metricSetPairGraph_service_1.GraphType.TimeSeries:
                    return React.createElement(timeSeries_1.default, Object.assign({}, chartProps));
                    break;
                case metricSetPairGraph_service_1.GraphType.Histogram:
                    return React.createElement(histogram_1.default, Object.assign({}, chartProps));
                    break;
                case metricSetPairGraph_service_1.GraphType.BoxPlot:
                    return React.createElement(boxplot_1.default, Object.assign({}, chartProps));
                    break;
                default:
                    return null;
            }
        };
    }
    render() {
        return (React.createElement("div", { className: "semiotic-graph" },
            React.createElement(react_container_dimensions_1.default, null, ({ width }) => this.fetchChart(width))));
    }
}
exports.default = SemioticGraph;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const d3_scale_1 = __webpack_require__(28);
const semiotic_1 = __webpack_require__(30);
const moment = __webpack_require__(36);
const core_1 = __webpack_require__(6);
const { defaultTimeZone } = core_1.SETTINGS;
const d3_shape_1 = __webpack_require__(74);
const classNames = __webpack_require__(7);
const lodash_1 = __webpack_require__(2);
const utils = __webpack_require__(24);
const tooltip_1 = __webpack_require__(47);
const chartHeader_1 = __webpack_require__(43);
const chartLegend_1 = __webpack_require__(44);
__webpack_require__(135);
const config_1 = __webpack_require__(19);
const circleIcon_1 = __webpack_require__(45);
const differenceArea_1 = __webpack_require__(246);
const secondaryTSXAxis_1 = __webpack_require__(67);
const customAxisTickLabel_1 = __webpack_require__(46);
moment.tz.setDefault(defaultTimeZone);
class TimeSeries extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            tooltip: null,
            userBrushExtent: null,
            showGroup: {
                baseline: true,
                canary: true,
            },
            graphs: {
                line: null,
                differenceArea: null,
            },
        };
        this.mainMinimapHeight = 320;
        this.marginMain = {
            top: 10,
            left: 60,
            right: 20,
        };
        this.marginMinimap = {
            top: 0,
            bottom: 0,
            left: 60,
            right: 20,
        };
        this.getChartData = (dataSetsAttr, metricSetPair) => {
            const { maxDataCount } = dataSetsAttr;
            const { showGroup } = this.state;
            const { dataGroupMap, colors } = config_1.vizConfig;
            const { scopes, values } = metricSetPair;
            const { userBrushExtent } = this.state;
            const groups = ['baseline', 'canary'];
            const isOnlyCanarySelected = showGroup.canary && !showGroup.baseline;
            const stepMillis = scopes.control.stepMillis;
            const intDataSet = lodash_1.chain(Array(maxDataCount).fill(0))
                .map((_, i) => {
                const valueList = groups.map((g) => values[dataGroupMap[g]][i]);
                const timestampMillisList = groups.map((g) => scopes[dataGroupMap[g]].startTimeMillis + i * stepMillis);
                return {
                    hasValidData: valueList.some((v) => typeof v === 'number'),
                    timestampMillisBaseline: timestampMillisList[0],
                    timestampMillisMain: isOnlyCanarySelected ? timestampMillisList[1] : timestampMillisList[0],
                    valueList,
                    timestampMillisList,
                };
            })
                .dropRightWhile((ds) => !ds.hasValidData)
                .dropWhile((ds) => !ds.hasValidData)
                .value();
            const dataSets = groups.map((g, i) => {
                const dataPoints = intDataSet.map((ds) => {
                    return {
                        timestampMillis: ds.timestampMillisList[i],
                        timestampMillisBaseline: ds.timestampMillisBaseline,
                        timestampMillisMain: ds.timestampMillisMain,
                        value: ds.valueList[i],
                    };
                });
                return {
                    label: g,
                    color: colors[g],
                    coordinates: dataPoints.filter(d => typeof d.value === 'number'),
                    coordinatesUnfiltered: dataPoints,
                };
            });
            const millisSetBaselineAll = intDataSet.map((ds) => ds.timestampMillisBaseline);
            const intDataSetMain = !userBrushExtent
                ? intDataSet
                : intDataSet.filter((ds) => {
                    return (ds.timestampMillisBaseline >= userBrushExtent[0].valueOf() &&
                        ds.timestampMillisBaseline <= userBrushExtent[1].valueOf());
                });
            const millisSetMain = intDataSetMain.map((ds) => ds.timestampMillisMain);
            return {
                dataSets,
                millisSetBaselineAll,
                millisSetMain,
                xExtentMain: [millisSetMain[0], millisSetMain[millisSetMain.length - 1]],
            };
        };
        this.createCommonChartProps = () => {
            return {
                lineType: {
                    type: 'line',
                    interpolator: d3_shape_1.curveStepAfter,
                },
                lineStyle: (ds) => ({
                    stroke: ds.color,
                    strokeWidth: 2,
                    strokeOpacity: 0.8,
                }),
                yAccessor: 'value',
                xScaleType: d3_scale_1.scaleUtc(),
                baseMarkProps: { transitionDuration: { default: 200, fill: 200 } },
            };
        };
        this.createLineChartProps = (chartData, dataSetsAttributes, commonChartProps) => {
            const { axisTickLineHeight, axisTickLabelHeight, axisLabelHeight, minimapHeight } = config_1.vizConfig.timeSeries;
            const { parentWidth } = this.props;
            const { showGroup } = this.state;
            const { shouldUseSecondaryXAxis, shouldDisplayMinimap } = dataSetsAttributes;
            const { dataSets, millisSetMain, xExtentMain } = chartData;
            const totalXAxisHeight = shouldUseSecondaryXAxis
                ? 2 * (axisTickLabelHeight + axisLabelHeight) + axisTickLineHeight
                : axisTickLabelHeight;
            const lineChartProps = Object.assign({}, commonChartProps, { lines: dataSets.filter((ds) => showGroup[ds.label]), hoverAnnotation: [
                    {
                        type: 'x',
                        disable: ['connector', 'note'],
                    },
                    {
                        type: 'vertical-points',
                        threshold: 0.1,
                        r: () => 5,
                    },
                ], customHoverBehavior: this.createChartHoverHandler(dataSets, dataSetsAttributes), xExtent: xExtentMain, axes: [
                    {
                        orient: 'left',
                        label: 'metric value',
                        tickFormat: (d) => utils.formatMetricValue(d),
                    },
                    {
                        orient: 'bottom',
                        label: shouldUseSecondaryXAxis ? 'Baseline' : undefined,
                        tickValues: utils.calculateDateTimeTicks(millisSetMain),
                        tickFormat: (d) => React.createElement(customAxisTickLabel_1.default, { millis: d }),
                        className: shouldUseSecondaryXAxis ? 'baseline-dual-axis' : '',
                    },
                ], margin: Object.assign({}, this.marginMain, { bottom: totalXAxisHeight }), matte: true, size: [parentWidth, shouldDisplayMinimap ? this.mainMinimapHeight - minimapHeight : this.mainMinimapHeight], xAccessor: (d) => moment(d.timestampMillisMain).toDate() });
            if (shouldDisplayMinimap) {
                return Object.assign({}, lineChartProps, { minimap: Object.assign({}, commonChartProps, { lines: dataSets, yBrushable: false, brushEnd: this.onBrushEnd, size: [parentWidth, minimapHeight], axes: [
                            {
                                orient: 'left',
                                tickFormat: () => null,
                            },
                            {
                                orient: 'bottom',
                            },
                        ], margin: this.marginMinimap, xAccessor: (d) => moment(d.timestampMillisBaseline).toDate() }) });
            }
            else {
                return lineChartProps;
            }
        };
        this.createGraphs = () => {
            const { metricSetPair, parentWidth } = this.props;
            const { showGroup } = this.state;
            const { minimapDataPointsThreshold, minimapHeight } = config_1.vizConfig.timeSeries;
            const baselineStartTimeMillis = metricSetPair.scopes.control.startTimeMillis;
            const canaryStartTimeMillis = metricSetPair.scopes.experiment.startTimeMillis;
            const isStartTimeMillisEqual = baselineStartTimeMillis === canaryStartTimeMillis;
            const dataSetsAttributes = {
                startTimeMillisOffset: canaryStartTimeMillis - baselineStartTimeMillis,
                maxDataCount: Math.max(metricSetPair.values.control.length, metricSetPair.values.experiment.length),
                shouldDisplayMinimap: metricSetPair.values.control.length > minimapDataPointsThreshold,
                shouldUseSecondaryXAxis: !isStartTimeMillisEqual && showGroup.canary && showGroup.baseline,
            };
            const chartData = this.getChartData(dataSetsAttributes, metricSetPair);
            const commonChartProps = this.createCommonChartProps();
            const lineChartProps = this.createLineChartProps(chartData, dataSetsAttributes, commonChartProps);
            const line = (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "time-series-chart" }, dataSetsAttributes.shouldDisplayMinimap ? (React.createElement(semiotic_1.MinimapXYFrame, Object.assign({}, lineChartProps))) : (React.createElement(semiotic_1.XYFrame, Object.assign({}, lineChartProps)))),
                dataSetsAttributes.shouldUseSecondaryXAxis ? (React.createElement(secondaryTSXAxis_1.default, { margin: { left: this.marginMain.left, right: this.marginMain.right, top: 0, bottom: 0 }, width: parentWidth, millisSet: chartData.millisSetMain.map((ms) => ms + dataSetsAttributes.startTimeMillisOffset), axisLabel: "canary", bottomOffset: dataSetsAttributes.shouldDisplayMinimap ? minimapHeight : 0 })) : null,
                dataSetsAttributes.shouldDisplayMinimap ? (React.createElement("div", { className: "zoom-icon" },
                    React.createElement("i", { className: "fas fa-search-plus" }))) : null));
            const differenceArea = showGroup.baseline && showGroup.canary ? (React.createElement(differenceArea_1.default, Object.assign({}, this.props, { millisBaselineSet: chartData.millisSetBaselineAll }))) : null;
            this.setState({
                graphs: {
                    line,
                    differenceArea,
                },
            });
        };
        this.onLegendClickHandler = (group) => {
            const showGroup = this.state.showGroup;
            this.setState({
                showGroup: Object.assign({}, showGroup, { [group]: !showGroup[group] }),
            });
        };
        this.createChartHoverHandler = (dataSets, dataSetsAttr) => {
            const { shouldUseSecondaryXAxis } = dataSetsAttr;
            return (d) => {
                if (d && d.timestampMillisMain) {
                    const tooltipData = dataSets.map((ds) => {
                        const coord = ds.coordinatesUnfiltered.find((c) => c.timestampMillisMain === d.timestampMillisMain);
                        return {
                            color: ds.color,
                            label: ds.label,
                            ts: coord.timestampMillis,
                            value: coord.value,
                        };
                    });
                    let tooltipRows = tooltipData
                        .concat()
                        .sort((a, b) => b.value - a.value)
                        .map((o) => {
                        const tsRow = shouldUseSecondaryXAxis ? (React.createElement("div", { className: "tooltip-ts" }, moment(o.ts).format('YYYY-MM-DD HH:mm:ss z'))) : null;
                        return (React.createElement("div", { key: o.label, className: classNames({ 'tooltip-dual-axis-row': shouldUseSecondaryXAxis }) },
                            tsRow,
                            React.createElement("div", { id: o.label },
                                React.createElement(circleIcon_1.default, { group: o.label }),
                                React.createElement("span", null, `${o.label}: `),
                                React.createElement("span", null, utils.formatMetricValue(o.value)))));
                    });
                    if (tooltipData.length === 2) {
                        const canaryMinusBaseline = tooltipData[1].value - tooltipData[0].value;
                        tooltipRows = tooltipRows.concat([
                            React.createElement("div", { id: "diff", key: "diff", className: "tooltip-row" },
                                React.createElement("span", null, "Canary - Baseline: "),
                                React.createElement("span", null, utils.formatMetricValue(canaryMinusBaseline))),
                        ]);
                    }
                    const tooltipContent = (React.createElement("div", null,
                        shouldUseSecondaryXAxis ? null : (React.createElement("div", { key: "ts", className: "tooltip-ts" }, moment(tooltipData[0].ts).format('YYYY-MM-DD HH:mm:ss z'))),
                        tooltipRows));
                    this.setState({
                        tooltip: {
                            content: tooltipContent,
                            x: d.voronoiX + this.marginMain.left,
                            y: d.voronoiY + this.marginMain.top,
                        },
                    });
                }
                else {
                    this.setState({ tooltip: null });
                }
            };
        };
        this.onBrushEnd = (e) => {
            this.setState({
                userBrushExtent: e,
            });
        };
    }
    componentDidMount() {
        this.createGraphs();
    }
    componentDidUpdate(prevProps, prevState) {
        const { metricSetPair, parentWidth } = this.props;
        const { userBrushExtent, showGroup } = this.state;
        if (metricSetPair !== prevProps.metricSetPair ||
            parentWidth !== prevProps.parentWidth ||
            userBrushExtent !== prevState.userBrushExtent ||
            showGroup !== prevState.showGroup) {
            this.createGraphs();
        }
    }
    render() {
        const { metricSetPair } = this.props;
        const { showGroup, tooltip } = this.state;
        const { line, differenceArea } = this.state.graphs;
        return (React.createElement("div", { className: "time-series" },
            React.createElement(chartHeader_1.default, { metric: metricSetPair.name }),
            React.createElement(chartLegend_1.default, { showGroup: showGroup, isClickable: true, onClickHandler: this.onLegendClickHandler }),
            React.createElement("div", { className: "graph-container" },
                line,
                React.createElement(tooltip_1.default, Object.assign({}, tooltip))),
            differenceArea));
    }
}
exports.default = TimeSeries;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const Creators = __webpack_require__(3);
const metricSetPairGraph_service_1 = __webpack_require__(27);
__webpack_require__(136);
const GraphTypeSelector = ({ selected, selectGraphType, }) => {
    return (React.createElement("ul", { className: "list-inline graph-type-selector" },
        React.createElement("li", null,
            React.createElement("label", { className: "label uppercase color-text-primary", style: { paddingLeft: 0 } }, "Graph:")),
        Object.values(metricSetPairGraph_service_1.GraphType).map(type => (React.createElement("li", { style: selected === type ? { textDecoration: 'underline' } : null, key: type, onClick: () => selectGraphType(type) },
            React.createElement("a", { className: "small clickable" }, type))))));
};
const mapStateToProps = (state) => ({
    selected: state.selectedRun.graphType,
});
const mapDispatchToProps = (dispatch) => ({
    selectGraphType: (type) => dispatch(Creators.selectGraphType({ type })),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(GraphTypeSelector);


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const classNames = __webpack_require__(7);
const react_redux_1 = __webpack_require__(1);
const Creators = __webpack_require__(3);
const selectors_1 = __webpack_require__(9);
const clickableHeader_1 = __webpack_require__(241);
const colors_1 = __webpack_require__(42);
const GroupScores = ({ groups, groupWeights, scoreThresholds, className, select, selectedGroup, }) => (React.createElement("section", { className: classNames('horizontal', className) }, groups.map(g => (React.createElement(clickableHeader_1.default, { key: g.name, style: {
        width: `${groupWeights[g.name]}%`,
        backgroundColor: colors_1.mapGroupToColor(g, scoreThresholds),
    }, onClick: () => select(g.name), label: g.name, className: classNames('report-score', { active: g.name === selectedGroup }) })))));
const mapStateToProps = (state) => ({
    selectedGroup: state.selectedRun.selectedGroup,
    groupWeights: selectors_1.serializedGroupWeightsSelector(state),
    scoreThresholds: selectors_1.canaryExecutionRequestSelector(state).thresholds,
});
const mapDispatchToProps = (dispatch, ownProps) => (Object.assign({ select: (group) => dispatch(Creators.selectReportMetricGroup({ group })) }, ownProps));
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(GroupScores);


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const react_1 = __webpack_require__(20);
const selectors_1 = __webpack_require__(9);
const reportMetadata_1 = __webpack_require__(265);
const score_1 = __webpack_require__(71);
__webpack_require__(137);
const ReportHeader = ({ id, name, score }) => (React.createElement("section", { className: "horizontal report-header" },
    React.createElement("div", { className: "report-score-wrapper" },
        React.createElement(score_1.default, { score: score, showClassification: true }),
        React.createElement("h1", { className: "heading-2 color-text-primary" },
            React.createElement(react_1.UISref, { to: "^.^.canaryConfig.configDetail", params: { id } },
                React.createElement("a", { className: "clickable color-text-primary" },
                    " ",
                    name)))),
    React.createElement(reportMetadata_1.default, null)));
const mapStateToProps = (state) => ({
    id: selectors_1.serializedCanaryConfigSelector(state).id,
    name: selectors_1.serializedCanaryConfigSelector(state).name,
    score: selectors_1.judgeResultSelector(state).score,
});
exports.default = react_redux_1.connect(mapStateToProps)(ReportHeader);


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const centeredDetail_1 = __webpack_require__(25);
const detail_1 = __webpack_require__(242);
const loadStates_1 = __webpack_require__(32);
const ReportLoadStates = ({ loadState }) => {
    const LoadStates = new loadStates_1.default()
        .onFulfilled(React.createElement(detail_1.default, null))
        .onFailed(React.createElement(centeredDetail_1.default, null,
        React.createElement("h3", { className: "heading-3" }, "Could not load canary report.")))
        .build();
    return React.createElement(LoadStates, { state: loadState });
};
const mapStateToProps = (state) => ({
    loadState: state.selectedRun.load,
});
exports.default = react_redux_1.connect(mapStateToProps)(ReportLoadStates);


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const core_1 = __webpack_require__(6);
const canary_settings_1 = __webpack_require__(11);
const selectors_1 = __webpack_require__(9);
const metricStoreConfig_service_1 = __webpack_require__(17);
__webpack_require__(138);
const buildAtlasGraphUrl = (metricSetPair) => {
    const { attributes, scopes, values } = metricSetPair;
    const { atlasGraphBaseUrl } = canary_settings_1.CanarySettings;
    const backend = encodeURIComponent(attributes.control.baseURL);
    const query = `${attributes.experiment.query},Canary,:legend,:freeze,${attributes.control.query},Baseline,:legend`;
    const startTime = Math.min(scopes.control.startTimeMillis, scopes.experiment.startTimeMillis);
    const controlEndTime = scopes.control.startTimeMillis + values.control.length * scopes.control.stepMillis;
    const experimentEndTime = scopes.experiment.startTimeMillis + values.experiment.length * scopes.experiment.stepMillis;
    const endTime = Math.max(controlEndTime, experimentEndTime);
    return `${atlasGraphBaseUrl}?backend=${backend}&g.q=${query}&g.s=${startTime}&g.e=${endTime}&g.w=651&mode=png&axis=0`;
};
const MetricResultActions = ({ metricSetPair, metricConfig }) => {
    const atlasURL = buildAtlasGraphUrl(metricSetPair);
    const atlasQuery = metricStoreConfig_service_1.default.getDelegate(metricConfig.query.type).queryFinder(metricConfig);
    const copyToClipboard = (React.createElement("div", { className: "copy-button-container" },
        React.createElement(core_1.CopyToClipboard, { displayText: false, text: atlasQuery, toolTip: null }),
        React.createElement("button", { className: "primary copy-button", key: "copy-link" },
            React.createElement("i", { className: "glyphicon glyphicon-copy  copy-icon" }),
            "Copy this Metric URL")));
    const openAtlas = (React.createElement("a", { href: atlasURL, target: "_blank" },
        React.createElement("button", { className: "primary" },
            React.createElement("i", { className: "fas fa-chart-line" }),
            "Explore More Data in Atlas")));
    const actions = [copyToClipboard, openAtlas].map((action, i) => {
        return (React.createElement("li", { className: "action", key: i }, action));
    });
    return (React.createElement("div", { className: "metric-result-actions" },
        React.createElement("ul", { className: "actions-layout list-inline" }, actions)));
};
const mapStateToProps = (state) => ({
    metricConfig: selectors_1.selectedMetricConfigSelector(state),
    metricSetPair: state.selectedRun.metricSetPair.pair,
});
exports.default = react_redux_1.connect(mapStateToProps)(MetricResultActions);


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const metricSetPairLoadStates_1 = __webpack_require__(263);
exports.default = ({ result }) => {
    if (result) {
        return React.createElement(metricSetPairLoadStates_1.default, null);
    }
    else {
        return React.createElement("h3", { className: "heading-3 text-center" }, "Select a metric result.");
    }
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const graph_1 = __webpack_require__(244);
const metricResultStats_1 = __webpack_require__(259);
const metricResultActions_1 = __webpack_require__(256);
const graphTypeSelector_1 = __webpack_require__(252);
exports.default = () => (React.createElement("section", { className: "vertical flex-1", style: { overflowY: 'auto' } },
    React.createElement(graphTypeSelector_1.default, null),
    React.createElement(graph_1.default, null),
    React.createElement(metricResultActions_1.default, null),
    React.createElement(metricResultStats_1.default, null)));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const lodash_1 = __webpack_require__(2);
const react_redux_1 = __webpack_require__(1);
const selectors_1 = __webpack_require__(9);
const formattedDate_1 = __webpack_require__(26);
const table_1 = __webpack_require__(23);
__webpack_require__(139);
const getStats = (run, id, target) => {
    const result = run.result.judgeResult.results.find(r => r.id === id);
    if (target === 'experiment') {
        return result.experimentMetadata.stats;
    }
    else if (target === 'control') {
        return result.controlMetadata.stats;
    }
    else {
        return null;
    }
};
const ResultMetadataRow = ({ row }) => {
    if (!row.getContent()) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement("label", { className: "label uppercase color-text-primary" }, row.label),
        row.getContent()));
};
const MetricResultStats = ({ metricConfig, metricSetPair, run }) => {
    const tableColumns = [
        {
            getContent: target => React.createElement("span", null, target === 'control' ? 'Baseline' : 'Canary'),
        },
        {
            label: 'start',
            getContent: target => React.createElement(formattedDate_1.default, { dateIso: metricSetPair.scopes[target].startTimeIso }),
            hide: () => {
                const request = run.canaryExecutionRequest;
                const configuredControlStart = request.scopes[metricConfig.scopeName].controlScope.start;
                const actualControlStart = metricSetPair.scopes.control.startTimeIso;
                const configuredExperimentStart = request.scopes[metricConfig.scopeName].experimentScope.start;
                const actualExperimentStart = metricSetPair.scopes.experiment.startTimeIso;
                return configuredControlStart === actualControlStart && configuredExperimentStart === actualExperimentStart;
            },
        },
        {
            label: 'count',
            getContent: target => React.createElement("span", null, getStats(run, metricSetPair.id, target).count),
        },
        {
            label: 'avg',
            getContent: target => React.createElement("span", null, lodash_1.round(getStats(run, metricSetPair.id, target).mean, 3)),
        },
        {
            label: 'max',
            getContent: target => React.createElement("span", null, lodash_1.round(getStats(run, metricSetPair.id, target).max, 3)),
        },
        {
            label: 'min',
            getContent: target => React.createElement("span", null, lodash_1.round(getStats(run, metricSetPair.id, target).min, 3)),
        },
    ];
    const metadataRows = [
        {
            label: 'classification reason',
            getContent: () => {
                const result = run.result.judgeResult.results.find(r => r.id === metricSetPair.id);
                if (!result.classificationReason) {
                    return null;
                }
                return React.createElement("p", null, result.classificationReason);
            },
        },
    ];
    return (React.createElement("div", { className: "metric-stats vertical" },
        metadataRows.map(row => (React.createElement(ResultMetadataRow, { row: row, key: row.label }))),
        React.createElement(table_1.NativeTable, { columns: tableColumns, rows: ['control', 'experiment'], rowKey: row => row })));
};
const mapStateToProps = (state) => ({
    metricConfig: selectors_1.selectedMetricConfigSelector(state),
    metricSetPair: state.selectedRun.metricSetPair.pair,
    run: selectors_1.runSelector(state),
    service: selectors_1.selectedMetricConfigSelector(state).query.type,
});
exports.default = react_redux_1.connect(mapStateToProps)(MetricResultStats);


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const listDetail_1 = __webpack_require__(63);
const metricResultsList_1 = __webpack_require__(262);
const metricResultDetail_1 = __webpack_require__(257);
const selectors_1 = __webpack_require__(9);
const MetricResults = ({ metricResults, selectedMetricResult }) => {
    const list = React.createElement(metricResultsList_1.default, { results: metricResults });
    const detail = React.createElement(metricResultDetail_1.default, { result: selectedMetricResult });
    return (React.createElement(listDetail_1.default, { list: list, listClass: "vertical", listWidth: 5, detail: detail, detailClass: "vertical", detailWidth: 9, className: "metric-results flex-1" }));
};
const mapStateToProps = (state) => {
    const { selectedRun: { selectedGroup, selectedMetric }, } = state;
    const result = selectors_1.judgeResultSelector(state);
    const filter = selectedGroup
        ? r => r.groups.includes(selectedGroup)
        : () => true;
    return {
        metricResults: Object.values(result.results).filter(filter),
        selectedMetricResult: Object.values(result.results).find(r => r.id === selectedMetric),
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(MetricResults);


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const metricResultClassification_1 = __webpack_require__(69);
const metricResultDeviation_1 = __webpack_require__(70);
exports.metricResultsColumns = [
    {
        label: 'metric name',
        getContent: ({ metricName }) => React.createElement("span", null, metricName),
        width: 5,
    },
    {
        label: 'deviation',
        getContent: ({ results }) => results[0].resultMetadata && React.createElement(metricResultDeviation_1.default, { ratio: results[0].resultMetadata.ratio }),
        width: 1,
    },
    {
        label: 'result',
        getContent: ({ results }) => React.createElement(metricResultClassification_1.default, { classification: results[0].classification }),
        width: 1,
    },
];


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const classNames = __webpack_require__(7);
const Creators = __webpack_require__(3);
const table_1 = __webpack_require__(23);
const metricResultsColumns_1 = __webpack_require__(261);
const multipleResultsTable_1 = __webpack_require__(264);
__webpack_require__(140);
const buildTableRows = (results) => {
    const tableRowsByMetricName = results.reduce((map, result) => map.has(result.name)
        ? map.set(result.name, { metricName: result.name, results: map.get(result.name).results.concat(result) })
        : map.set(result.name, { metricName: result.name, results: [result] }), new Map());
    return Array.from(tableRowsByMetricName.values());
};
const buildRowForMetricWithMultipleResults = (row) => {
    if (row.results.length < 2) {
        return null;
    }
    return (React.createElement("li", { className: "horizontal multiple-results" },
        React.createElement("section", { className: "vertical flex-fill" },
            React.createElement("div", null, row.metricName),
            React.createElement(multipleResultsTable_1.default, { results: row.results }))));
};
const ResultsList = ({ results, select, selectedMetric, }) => {
    const rows = buildTableRows(results);
    return (React.createElement("section", { className: "vertical metric-results-list flex-1" },
        React.createElement(table_1.Table, { rowKey: r => r.metricName, tableBodyClassName: "list-unstyled tabs-vertical flex-1", rowClassName: r => classNames('horizontal', { selected: r.results[0].id === selectedMetric }), rows: rows, columns: metricResultsColumns_1.metricResultsColumns, onRowClick: r => select(r.results[0].id), className: "flex-1 vertical", customRow: buildRowForMetricWithMultipleResults })));
};
const mapStateToProps = (state) => ({
    selectedMetric: state.selectedRun.selectedMetric,
});
const mapDispatchToProps = (dispatch, ownProps) => (Object.assign({ select: (metricId) => dispatch(Creators.selectReportMetric({ metricId })) }, ownProps));
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ResultsList);


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const loadStates_1 = __webpack_require__(32);
const metricResultDetailLayout_1 = __webpack_require__(258);
const MetricSetPairLoadStates = ({ state }) => {
    const LoadStates = new loadStates_1.default()
        .onFulfilled(React.createElement(metricResultDetailLayout_1.default, null))
        .onFailed(React.createElement("h3", { className: "heading-3 text-center" }, "Could not load metrics."))
        .build();
    return React.createElement(LoadStates, { state: state });
};
const mapStateToProps = (state) => ({
    state: state.selectedRun.metricSetPair.load,
});
exports.default = react_redux_1.connect(mapStateToProps)(MetricSetPairLoadStates);


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const lodash_1 = __webpack_require__(2);
const react_redux_1 = __webpack_require__(1);
const classNames = __webpack_require__(7);
const table_1 = __webpack_require__(23);
const selectors_1 = __webpack_require__(9);
const Creators = __webpack_require__(3);
const metricResultClassification_1 = __webpack_require__(69);
const metricResultDeviation_1 = __webpack_require__(70);
const MultipleResultsTable = ({ results, select, selectedResult, }) => {
    const tagKeys = lodash_1.chain(results)
        .flatMap(r => Object.keys(r.tags || {}))
        .uniq()
        .value();
    let columns = tagKeys.map(key => ({
        label: key,
        width: 5,
        getContent: (result) => React.createElement("span", null, result.tags[key]),
    }));
    columns = columns.concat([
        {
            width: 1,
            getContent: ({ resultMetadata }) => resultMetadata && React.createElement(metricResultDeviation_1.default, { ratio: resultMetadata.ratio }),
        },
        {
            width: 1,
            getContent: ({ classification }) => React.createElement(metricResultClassification_1.default, { classification: classification }),
        },
    ]);
    return (React.createElement(table_1.Table, { rows: results, columns: columns, className: "multiple-results-table", headerClassName: "sticky-header-2", rowClassName: r => classNames('horizontal', { selected: r.id === selectedResult }), rowKey: r => Object.entries(r.tags || {})
            .map(([key, value]) => `${key}:${value}`)
            .join(':'), onRowClick: r => select(r.id) }));
};
const mapStateToProps = (state) => ({
    selectedResult: selectors_1.selectedMetricResultIdSelector(state),
});
const mapDispatchToProps = (dispatch, ownProps) => (Object.assign({}, ownProps, { select: (metricId) => dispatch(Creators.selectReportMetric({ metricId })) }));
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(MultipleResultsTable);


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const formattedDate_1 = __webpack_require__(26);
const sourceLinks_1 = __webpack_require__(267);
const core_1 = __webpack_require__(6);
const Label = ({ label, extraClass }) => (React.createElement("label", { className: `label uppercase color-text-primary ${extraClass}` }, label));
const buildScopeMetadataEntries = (run) => {
    const request = run.canaryExecutionRequest;
    const scopes = Object.values(request.scopes);
    if (scopes.length > 1) {
        return null;
    }
    const { controlScope: { step, location: controlLocation, scope: controlScope }, experimentScope: { start: experimentStart, end: experimentEnd, location: experimentLocation, scope: experimentScope, }, } = scopes[0];
    return [
        {
            label: 'baseline',
            entries: [
                {
                    label: 'scope',
                    popover: true,
                    getContent: () => React.createElement("p", { className: "kayenta-scope" }, controlScope),
                },
                {
                    label: 'location',
                    getContent: () => React.createElement("p", null, controlLocation),
                },
            ],
        },
        {
            label: 'canary',
            entries: [
                {
                    label: 'scope',
                    popover: true,
                    getContent: () => React.createElement("p", { className: "kayenta-scope" }, experimentScope),
                },
                {
                    label: 'location',
                    getContent: () => React.createElement("p", null, experimentLocation),
                },
            ],
        },
        {
            label: 'time',
            entries: [
                {
                    label: 'start',
                    getContent: () => (React.createElement("p", null,
                        React.createElement(formattedDate_1.default, { dateIso: experimentStart }))),
                },
                {
                    label: 'end',
                    getContent: () => (React.createElement("p", null,
                        React.createElement(formattedDate_1.default, { dateIso: experimentEnd }))),
                },
                {
                    label: 'step',
                    getContent: () => {
                        const mins = step / 60;
                        return (React.createElement("p", null,
                            mins,
                            " min",
                            mins === 1 ? '' : 's'));
                    },
                },
            ],
        },
    ];
};
const ReportMetadata = ({ run }) => {
    const { thresholds: { marginal, pass }, } = run.canaryExecutionRequest;
    const metadataGroups = buildScopeMetadataEntries(run) || [];
    metadataGroups.push({
        label: 'threshold',
        entries: [
            {
                label: 'marginal',
                getContent: () => React.createElement("p", null, marginal),
            },
            {
                label: 'pass',
                getContent: () => React.createElement("p", null, pass),
            },
        ],
    });
    return (React.createElement("section", { className: "report-metadata" },
        metadataGroups.map((group, index) => (React.createElement("div", { className: `group group-${group.label}`, key: group.label || index },
            React.createElement(Label, { label: group.label || '', extraClass: "label-lg" }),
            React.createElement("ul", { className: "list-unstyled" }, group.entries.map(e => (React.createElement("li", { key: e.label || index },
                React.createElement(Label, { label: e.label }),
                e.popover ? (React.createElement(core_1.HoverablePopover, { template: e.getContent() }, e.getContent())) : (React.createElement(React.Fragment, null, e.getContent()))))))))),
        React.createElement("div", { className: "group group-source", key: "source" },
            React.createElement(Label, { label: "Source", extraClass: "label-lgf" }),
            React.createElement(sourceLinks_1.default, null))));
};
const mapStateToProps = (state) => ({
    run: state.selectedRun.run,
});
exports.default = react_redux_1.connect(mapStateToProps)(ReportMetadata);


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const lodash_1 = __webpack_require__(2);
const classNames = __webpack_require__(7);
const Creators = __webpack_require__(3);
const selectors_1 = __webpack_require__(9);
const allMetricResultsHeader_1 = __webpack_require__(240);
const groupScores_1 = __webpack_require__(253);
__webpack_require__(141);
const ReportScores = ({ groups, selectedGroup, clearSelectedGroup, score, scoreThresholds, }) => (React.createElement("section", { className: "horizontal report-scores" },
    React.createElement(allMetricResultsHeader_1.default, { onClick: clearSelectedGroup, score: score, scoreThresholds: scoreThresholds, className: classNames('flex-1', 'report-score', { active: !selectedGroup }) }),
    React.createElement(groupScores_1.default, { groups: groups, className: "flex-12" })));
const mapStateToProps = (state) => ({
    groups: lodash_1.sortBy(selectors_1.judgeResultSelector(state).groupScores, [(group) => -selectors_1.serializedGroupWeightsSelector(state)[group.name], 'name']),
    score: selectors_1.judgeResultSelector(state).score,
    scoreThresholds: state.selectedRun.run.canaryExecutionRequest.thresholds,
    selectedGroup: state.selectedRun.selectedGroup,
});
const mapDispatchToProps = (dispatch) => ({
    clearSelectedGroup: () => dispatch(Creators.selectReportMetricGroup({ group: null })),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ReportScores);


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const core_1 = __webpack_require__(6);
const canary_settings_1 = __webpack_require__(11);
const selectors_1 = __webpack_require__(9);
const SourceLinks = ({ reportUrl, metricListUrl }) => {
    return (React.createElement("ul", { className: "list-unstyled small" },
        React.createElement("li", null,
            React.createElement("a", { target: "_blank", href: reportUrl }, "Report")),
        React.createElement("li", null,
            React.createElement("p", null,
                React.createElement("a", { target: "_blank", href: metricListUrl }, "Metrics")))));
};
const resolveReportUrl = (state) => {
    const canaryConfigId = selectors_1.serializedCanaryConfigSelector(state).id;
    const result = selectors_1.runSelector(state);
    const canaryRunId = result.id;
    let url = `${core_1.SETTINGS.gateUrl}/v2/canaries/canary/${canaryConfigId}/${canaryRunId}`;
    const storageAccountName = result.storageAccountName || canary_settings_1.CanarySettings.storageAccountName;
    if (storageAccountName) {
        url += `?storageAccountName=${storageAccountName}`;
    }
    return url;
};
const resolveMetricListUrl = (state) => {
    const status = selectors_1.runSelector(state);
    const { metricSetPairListId } = status;
    let url = `${core_1.SETTINGS.gateUrl}/v2/canaries/metricSetPairList/${metricSetPairListId}`;
    const storageAccountName = status.storageAccountName || canary_settings_1.CanarySettings.storageAccountName;
    if (storageAccountName) {
        url += `?storageAccountName=${storageAccountName}`;
    }
    return url;
};
const mapStateToProps = (state) => {
    return {
        reportUrl: resolveReportUrl(state),
        metricListUrl: resolveMetricListUrl(state),
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(SourceLinks);


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const selectors_1 = __webpack_require__(9);
const link_1 = __webpack_require__(48);
exports.ConfigLink = ({ configId, configName }) => {
    return (React.createElement(link_1.Link, { targetState: "^.^.canaryConfig.configDetail", stateParams: {
            id: configId,
        } }, configName));
};
const mapStateToProps = (state, ownProps) => {
    return Object.assign({ configId: selectors_1.resolveConfigIdFromExecutionId(state, ownProps.executionId) }, ownProps);
};
exports.default = react_redux_1.connect(mapStateToProps)(exports.ConfigLink);


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const loadStates_1 = __webpack_require__(32);
const table_1 = __webpack_require__(272);
const centeredDetail_1 = __webpack_require__(25);
const ExecutionListLoadStates = ({ loadState }) => {
    const LoadStates = new loadStates_1.default()
        .onFulfilled(React.createElement(table_1.default, null))
        .onFailed(React.createElement(centeredDetail_1.default, null,
        React.createElement("h3", { className: "heading-3" }, "Could not load canary execution history.")))
        .build();
    return React.createElement(LoadStates, { state: loadState });
};
const mapStateToProps = (state) => {
    return {
        loadState: state.data.executions.load,
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(ExecutionListLoadStates);


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const link_1 = __webpack_require__(48);
exports.PipelineLink = ({ parentPipelineExecutionId, application }) => {
    return (React.createElement(link_1.Link, { targetState: "home.applications.application.pipelines.executionDetails.execution", stateParams: {
            application,
            executionId: parentPipelineExecutionId,
        } }, "Pipeline"));
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const selectors_1 = __webpack_require__(9);
const link_1 = __webpack_require__(48);
exports.ReportLink = ({ configId, executionId, children }) => {
    return (React.createElement(link_1.Link, { targetState: "^.reportDetail", stateParams: {
            configId,
            runId: executionId,
        } }, children));
};
const mapStateToProps = (state, ownProps) => {
    return Object.assign({ configId: selectors_1.resolveConfigIdFromExecutionId(state, ownProps.executionId) }, ownProps);
};
exports.default = react_redux_1.connect(mapStateToProps)(exports.ReportLink);


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_redux_1 = __webpack_require__(1);
const moment = __webpack_require__(296);
const lodash_1 = __webpack_require__(2);
const canary_settings_1 = __webpack_require__(11);
const table_1 = __webpack_require__(23);
const domain_1 = __webpack_require__(13);
const formattedDate_1 = __webpack_require__(26);
const centeredDetail_1 = __webpack_require__(25);
const score_1 = __webpack_require__(71);
const reportLink_1 = __webpack_require__(271);
const configLink_1 = __webpack_require__(268);
const pipelineLink_1 = __webpack_require__(270);
const ManualAnalysisModal_1 = __webpack_require__(203);
__webpack_require__(142);
const isAtlasScope = (scope, metrics) => metrics.some(({ query, scopeName }) => scopeName === scope && query.type === 'atlas');
const getScopeLocations = (scopes, metrics) => Object.keys(scopes).reduce((acc, scopeName) => {
    const { controlScope, experimentScope } = scopes[scopeName];
    const isAtlas = isAtlasScope(scopeName, metrics);
    if (isAtlas && lodash_1.get(controlScope, 'extendedScopeParams.dataset') === 'global') {
        acc.add('Global');
    }
    else {
        acc.add(controlScope.location);
    }
    if (isAtlas && lodash_1.get(experimentScope, 'extendedScopeParams.dataset') === 'global') {
        acc.add('Global');
    }
    else {
        acc.add(experimentScope.location);
    }
    return acc;
}, new Set());
const columns = [
    {
        label: 'Summary',
        getContent: execution => (React.createElement("div", null,
            React.createElement(reportLink_1.default, { configName: execution.config.name, executionId: execution.pipelineId, application: execution.application },
                React.createElement(score_1.default, { score: execution.result.judgeResult.score, showClassification: false, inverse: true }),
                '  ',
                React.createElement(formattedDate_1.default, { dateIso: execution.startTimeIso })),
            execution.startTimeIso && (React.createElement("div", { className: "color-text-caption body-small" }, moment(execution.startTimeIso).fromNow())))),
    },
    {
        label: 'Locations',
        getContent: ({ canaryExecutionRequest: { scopes }, config: { metrics } }) => {
            const locations = [...getScopeLocations(scopes, metrics)];
            return (React.createElement("div", { className: "vertical" }, locations.map(location => (React.createElement("span", { key: location }, location)))));
        },
    },
    {
        label: 'Config',
        getContent: execution => (React.createElement(configLink_1.default, { configName: execution.config.name, executionId: execution.pipelineId, application: execution.application })),
    },
    {
        label: 'Scopes',
        getContent: ({ canaryExecutionRequest: { scopes } }) => {
            const baselineScopeNames = Object.keys(scopes).reduce((acc, scope) => acc.add(scopes[scope].controlScope.scope), new Set());
            const canaryScopeNames = Object.keys(scopes).reduce((acc, scope) => acc.add(scopes[scope].experimentScope.scope), new Set());
            const areScopesIdentical = lodash_1.isEqual(baselineScopeNames, canaryScopeNames);
            const styles = { maxWidth: '350px', wordBreak: 'break-all' };
            if (areScopesIdentical) {
                return (React.createElement("div", { className: "vertical", style: styles }, [...canaryScopeNames].map(scope => (React.createElement("span", { key: scope }, scope)))));
            }
            else {
                return (React.createElement("div", { className: "vertical", style: styles },
                    React.createElement("span", { className: "heading-6 uppercase color-text-caption" }, "Baseline"),
                    [...baselineScopeNames].map(scope => (React.createElement("span", { key: scope }, scope))),
                    React.createElement("span", { className: "heading-6 uppercase color-text-caption", style: { marginTop: '5px' } }, "Canary"),
                    [...canaryScopeNames].map(scope => (React.createElement("span", { key: scope }, scope)))));
            }
        },
    },
    {
        getContent: ({ parentPipelineExecutionId, application }) => parentPipelineExecutionId &&
            parentPipelineExecutionId !== domain_1.CANARY_EXECUTION_NO_PIPELINE_STATUS && (React.createElement(pipelineLink_1.PipelineLink, { parentPipelineExecutionId: parentPipelineExecutionId, application: application })),
    },
];
const startManualAnalysis = (application, accounts) => {
    ManualAnalysisModal_1.ManualAnalysisModal.show({
        title: 'Start Manual Analysis',
        application,
        accounts,
    });
};
const ExecutionListTable = ({ executions, application, accounts }) => {
    if (!executions || !executions.length) {
        return (React.createElement(centeredDetail_1.default, null,
            React.createElement("h3", { className: "heading-3" }, "No canary execution history for this application.")));
    }
    return (React.createElement("div", { className: "vertical execution-list-container" },
        canary_settings_1.CanarySettings.manualAnalysisEnabled && (React.createElement("button", { style: { alignSelf: 'flex-end', flexShrink: 0 }, className: "primary", onClick: () => startManualAnalysis(application, accounts) },
            React.createElement("i", { className: "fa fa-play" }),
            " Start Manual Analysis")),
        React.createElement(table_1.NativeTable, { rows: executions, className: "flex-1 execution-list-table", columns: columns, rowKey: execution => execution.pipelineId })));
};
const mapStateToProps = (state) => ({
    executions: Object.values(state.data.executions.data).filter(e => e.result),
    application: state.data.application,
    accounts: state.data.kayentaAccounts.data,
});
exports.default = react_redux_1.connect(mapStateToProps)(ExecutionListTable);


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const react_1 = __webpack_require__(20);
exports.default = () => {
    const noWrap = { wrap: false };
    return (React.createElement("div", { className: "vertical flex-1" },
        React.createElement(react_1.UIView, Object.assign({}, noWrap, { name: "detail" }))));
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = __webpack_require__(6);
exports.listMetricsServiceMetadata = (filter, metricsAccountName) => core_1.API.one('v2/canaries/metadata/metricsService')
    .withParams({ filter, metricsAccountName })
    .get();


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const core_1 = __webpack_require__(6);
const domain_1 = __webpack_require__(13);
exports.AnalysisTypeWarning = () => (React.createElement("div", { className: "alert alert-warning" }, "The analysis type you've selected isn't supported by any of this application's cloud providers. Please select a different type."));
exports.AnalysisTypeRadioButton = ({ selectedType, analysisTypes, onChange = core_1.noop, label, type, }) => {
    if (!analysisTypes.includes(type)) {
        return null;
    }
    return (React.createElement("div", { className: "radio" },
        React.createElement("label", null,
            React.createElement("input", { type: "radio", name: "analysisType", checked: selectedType === type, onChange: () => onChange(type) }),
            label)));
};
exports.AnalysisType = (props) => {
    const { analysisTypes = [], selectedType } = props;
    return (React.createElement(React.Fragment, null,
        !analysisTypes.includes(selectedType) && React.createElement(exports.AnalysisTypeWarning, null),
        React.createElement(exports.AnalysisTypeRadioButton, Object.assign({}, props, { label: "Real Time (Automatic)", type: domain_1.KayentaAnalysisType.RealTimeAutomatic })),
        React.createElement(exports.AnalysisTypeRadioButton, Object.assign({}, props, { label: "Real Time (Manual)", type: domain_1.KayentaAnalysisType.RealTime })),
        React.createElement(exports.AnalysisTypeRadioButton, Object.assign({}, props, { label: "Retrospective", type: domain_1.KayentaAnalysisType.Retrospective }))));
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __webpack_require__(2);
const React = __webpack_require__(0);
const canaryScore_1 = __webpack_require__(31);
exports.CanaryExecutionLabel = ({ stage }) => {
    const { overallScore, overallResult } = lodash_1.get(stage, 'masterStage.context', {});
    const score = (React.createElement(canaryScore_1.CanaryScore, { inverse: true, score: overallScore, result: overallResult === 'success' ? overallResult : null, health: overallResult === 'success' ? null : 'unhealthy' }));
    return (React.createElement("span", { className: "stage-label" },
        React.createElement("span", null, stage.name),
        " (",
        score,
        ")"));
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __webpack_require__(12);
const react2angular_1 = __webpack_require__(37);
const AnalysisType_1 = __webpack_require__(275);
exports.KAYENTA_ANALYSIS_TYPE_COMPONENT = 'spinnaker.kayenta.analysisType.component';
angular_1.module(exports.KAYENTA_ANALYSIS_TYPE_COMPONENT, []).component('kayentaAnalysisType', react2angular_1.react2angular(AnalysisType_1.AnalysisType, ['analysisTypes', 'selectedType', 'onChange']));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __webpack_require__(12);
const react2angular_1 = __webpack_require__(37);
const canaryRunSummaries_1 = __webpack_require__(279);
exports.CANARY_RUN_SUMMARIES_COMPONENT = 'spinnaker.kayenta.canaryRunSummaries.component';
angular_1.module(exports.CANARY_RUN_SUMMARIES_COMPONENT, []).component('canaryRunSummaries', react2angular_1.react2angular(canaryRunSummaries_1.default, ['canaryRuns', 'firstScopeName']));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = __webpack_require__(0);
const lodash_1 = __webpack_require__(2);
const core_1 = __webpack_require__(6);
const canaryScore_1 = __webpack_require__(31);
const styleguide_1 = __webpack_require__(22);
const table_1 = __webpack_require__(23);
__webpack_require__(143);
function CanaryRunSummaries({ canaryRuns, firstScopeName }) {
    const canaryRunColumns = [
        {
            label: 'Canary Result',
            getContent: run => {
                return (React.createElement(React.Fragment, null,
                    React.createElement(canaryScore_1.CanaryScore, { score: run.context.canaryScore, health: run.health, result: run.result, inverse: false, className: "label" }),
                    lodash_1.get(run, ['context', 'warnings'], []).length > 0 && (React.createElement(core_1.HoverablePopover, { template: React.createElement(CanaryRunWarningMessages, { messages: run.context.warnings }) },
                        React.createElement("i", { className: "fa fa-exclamation-triangle", style: { paddingLeft: '8px' } })))));
            },
        },
        {
            label: 'Duration',
            getContent: run => React.createElement("span", null, run.context.durationString || ' - '),
        },
        {
            label: 'Last Updated',
            getContent: run => React.createElement("span", null, core_1.timestamp(run.context.lastUpdated)),
        },
        {
            getContent: run => {
                const popoverTemplate = React.createElement(CanaryRunTimestamps, { canaryRun: run, firstScopeName: firstScopeName });
                return (React.createElement("section", { className: "horizontal text-center" },
                    React.createElement("div", { className: "flex-1" },
                        React.createElement(ReportLink, { canaryRun: run })),
                    React.createElement("div", { className: "flex-1" },
                        React.createElement(core_1.HoverablePopover, { template: popoverTemplate },
                            React.createElement("i", { className: "far fa-clock" })))));
            },
        },
    ];
    return (React.createElement(styleguide_1.default, { className: "horizontal flex-1" },
        React.createElement(table_1.NativeTable, { rows: canaryRuns, className: "header-transparent flex-1", columns: canaryRunColumns, rowKey: run => run.id })));
}
exports.default = CanaryRunSummaries;
function CanaryRunTimestamps({ canaryRun, firstScopeName }) {
    const toolTipText = 'Copy timestamp to clipboard as UTC instant in ISO-8601 format';
    return (React.createElement("section", { className: "small" },
        React.createElement("ul", { className: "list-unstyled" },
            React.createElement("li", null,
                React.createElement("b", null, "Start:"),
                " ",
                core_1.timestamp(Date.parse(canaryRun.context.scopes[firstScopeName].experimentScope.start)),
                React.createElement(core_1.CopyToClipboard, { displayText: false, text: canaryRun.context.scopes[firstScopeName].experimentScope.start, toolTip: toolTipText })),
            React.createElement("li", null,
                React.createElement("b", null, "End:"),
                " ",
                core_1.timestamp(Date.parse(canaryRun.context.scopes[firstScopeName].experimentScope.end)),
                React.createElement(core_1.CopyToClipboard, { displayText: false, text: canaryRun.context.scopes[firstScopeName].experimentScope.end, toolTip: toolTipText })))));
}
function ReportLink({ canaryRun }) {
    if (!lodash_1.has(canaryRun, 'context.canaryConfigId') ||
        !lodash_1.has(canaryRun, 'context.canaryPipelineExecutionId') ||
        canaryRun.status === 'RUNNING') {
        return null;
    }
    const onClick = () => core_1.ReactInjector.$state.go('home.applications.application.canary.report.reportDetail', {
        configId: canaryRun.context.canaryConfigId,
        runId: canaryRun.context.canaryPipelineExecutionId,
    });
    return React.createElement("i", { className: "fa fa-chart-bar clickable", onClick: onClick });
}
function CanaryRunWarningMessages({ messages }) {
    return (React.createElement("div", null, messages.map((message, i) => (React.createElement("p", { key: `${i}-${message}` }, message)))));
}


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __webpack_require__(12);
const ngimport_1 = __webpack_require__(297);
const domain_1 = __webpack_require__(13);
class ForAnalysisTypeController {
    constructor() {
        this.showForAnalysisType = () => {
            if (!this.stage) {
                ngimport_1.$log.warn('No stage bound to <for-analysis-type> component');
            }
            if (!this.types) {
                ngimport_1.$log.warn('No types bound to <for-analysis-type> component');
            }
            return (this.types || '')
                .split(',')
                .map(type => {
                const val = type.trim();
                if (![
                    domain_1.KayentaAnalysisType.Retrospective,
                    domain_1.KayentaAnalysisType.RealTime,
                    domain_1.KayentaAnalysisType.RealTimeAutomatic,
                ].includes(val)) {
                    ngimport_1.$log.warn(`${val} is not a Kayenta analysis type.`);
                }
                return val;
            })
                .includes(this.stage.analysisType);
        };
    }
}
exports.FOR_ANALYSIS_TYPE_COMPONENT = 'spinnaker.kayenta.forAnalysisType.component';
angular_1.module(exports.FOR_ANALYSIS_TYPE_COMPONENT, []).component('forAnalysisType', {
    bindings: {
        types: '@',
        stage: '<',
    },
    controller: ForAnalysisTypeController,
    transclude: true,
    template: '<ng-transclude ng-if="$ctrl.showForAnalysisType()"></ng-transclude>',
});


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __webpack_require__(2);
const core_1 = __webpack_require__(6);
const canary_settings_1 = __webpack_require__(11);
const canaryConfig_service_1 = __webpack_require__(18);
const domain_1 = __webpack_require__(13);
const duration_1 = __webpack_require__(287);
__webpack_require__(144);
const REAL_TIME_AUTOMATIC_PROVIDERS = ['gce', 'aws', 'titus'];
class KayentaStageController {
    constructor($scope, $uibModal, $log, serverGroupCommandBuilder, serverGroupTransformer, stage) {
        'ngInject';
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.$log = $log;
        this.serverGroupCommandBuilder = serverGroupCommandBuilder;
        this.serverGroupTransformer = serverGroupTransformer;
        this.stage = stage;
        this.state = {
            useLookback: false,
            backingDataLoading: false,
            lifetimeHoursUpdatedToDuration: false,
            lifetime: { hours: 0, minutes: 0 },
            showAdvancedSettings: false,
            useAtlasGlobalDataset: false,
            atlasScopeType: 'cluster',
            legacySiteLocalRecipients: '',
            showLegacySiteLocalRecipients: canary_settings_1.CanarySettings.legacySiteLocalFieldsEnabled,
            showAllLocations: {
                control: false,
                experiment: false,
            },
            delayBeforeCleanup: { hours: 0, minutes: 0 },
            analysisTypes: [
                domain_1.KayentaAnalysisType.RealTimeAutomatic,
                domain_1.KayentaAnalysisType.RealTime,
                domain_1.KayentaAnalysisType.Retrospective,
            ],
        };
        this.canaryConfigSummaries = [];
        this.scopeNames = [];
        this.kayentaAccounts = new Map();
        this.initialize = () => __awaiter(this, void 0, void 0, function* () {
            yield this.loadBackingData();
            const firstStorageAccount = lodash_1.first(this.kayentaAccounts.get(domain_1.KayentaAccountType.ObjectStore));
            const firstMetricsAccount = lodash_1.first(this.kayentaAccounts.get(domain_1.KayentaAccountType.MetricsStore));
            this.stage.canaryConfig = Object.assign({ storageAccountName: (firstStorageAccount && firstStorageAccount.name) || canary_settings_1.CanarySettings.storageAccountName, metricsAccountName: (firstMetricsAccount && firstMetricsAccount.name) || canary_settings_1.CanarySettings.metricsAccountName }, this.stage.canaryConfig, { scoreThresholds: Object.assign({ marginal: null, pass: null }, lodash_1.get(this.stage, 'canaryConfig.scoreThresholds')) });
            this.stage.analysisType = this.stage.analysisType || this.state.analysisTypes[0];
            if (!this.stage.canaryConfig.scopes || !this.stage.canaryConfig.scopes.length) {
                this.stage.canaryConfig.scopes = [{ scopeName: 'default' }];
            }
            if (!this.stage.isNew) {
                const stageLifetimeDuration = lodash_1.get(this.stage, 'canaryConfig.lifetimeDuration');
                this.state.lifetime = duration_1.parseDurationString(stageLifetimeDuration);
                const stageDelayBeforeCleanupDuration = lodash_1.get(this.stage, 'deployments.delayBeforeCleanup');
                this.state.delayBeforeCleanup = duration_1.parseDurationString(stageDelayBeforeCleanupDuration);
            }
            if (this.stage.canaryConfig.lookbackMins) {
                this.state.useLookback = true;
            }
            this.populateScopeNameChoices();
            this.setMetricStore();
            this.setLocations();
            this.setShowAdvancedSettings();
            this.setClusterList();
            this.deleteConfigAccountsIfMissing();
            this.updateLifetimeFromHoursToDuration();
            this.deleteCanaryConfigIdIfMissing();
            if (canary_settings_1.CanarySettings.legacySiteLocalFieldsEnabled) {
                this.setLegacySiteLocalRecipients();
            }
            if (this.stage.isNew && this.stage.analysisType === domain_1.KayentaAnalysisType.RealTimeAutomatic) {
                yield this.initializeRealTimeAutomaticAnalysisType();
            }
        });
        this.loadBackingData = () => __awaiter(this, void 0, void 0, function* () {
            this.state.backingDataLoading = true;
            try {
                yield this.$scope.application.ready();
                [
                    this.selectedCanaryConfigDetails,
                    this.kayentaAccounts,
                    this.providers,
                    this.accounts,
                    this.canaryConfigSummaries,
                ] = yield Promise.all([
                    this.loadCanaryConfigDetails(),
                    this.loadKayentaAccounts(),
                    this.loadProviders(),
                    this.loadAccounts(),
                    Promise.resolve(this.$scope.application.getDataSource('canaryConfigs').data),
                ]);
            }
            catch (e) {
                this.$log.warn('Error loading backing data for Kayenta stage: ', e);
            }
            finally {
                this.state.backingDataLoading = false;
                this.$scope.$applyAsync();
            }
        });
        this.onUseLookbackChange = () => {
            if (!this.state.useLookback) {
                delete this.stage.canaryConfig.lookbackMins;
            }
        };
        this.onCanaryConfigSelect = () => __awaiter(this, void 0, void 0, function* () {
            this.selectedCanaryConfigDetails = yield this.loadCanaryConfigDetails();
            this.populateScopeNameChoices();
            this.setMetricStore();
        });
        this.isExpression = (val) => {
            return lodash_1.isString(val) && val.includes('${');
        };
        this.handleScoreThresholdChange = (scoreThresholds) => {
            this.$scope.$applyAsync(() => {
                this.stage.canaryConfig.scoreThresholds.pass = scoreThresholds.successfulScore;
                this.stage.canaryConfig.scoreThresholds.marginal = scoreThresholds.unhealthyScore;
            });
        };
        this.handleAnalysisTypeChange = (type) => __awaiter(this, void 0, void 0, function* () {
            this.stage.analysisType = type;
            switch (this.stage.analysisType) {
                case domain_1.KayentaAnalysisType.RealTime:
                    delete this.stage.canaryConfig.scopes[0].startTimeIso;
                    delete this.stage.canaryConfig.scopes[0].endTimeIso;
                    delete this.stage.deployments;
                    if (this.metricStore === 'atlas') {
                        this.stage.canaryConfig.scopes.forEach(scope => {
                            lodash_1.unset(scope, 'extendedScopeParams.dataset');
                            lodash_1.unset(scope, 'extendedScopeParams.environment');
                        });
                        this.setAtlasScopeParams();
                    }
                    break;
                case domain_1.KayentaAnalysisType.RealTimeAutomatic:
                    delete this.stage.canaryConfig.scopes[0].startTimeIso;
                    delete this.stage.canaryConfig.scopes[0].endTimeIso;
                    delete this.stage.canaryConfig.scopes[0].controlLocation;
                    delete this.stage.canaryConfig.scopes[0].experimentLocation;
                    this.initializeRealTimeAutomaticAnalysisType();
                    break;
                case domain_1.KayentaAnalysisType.Retrospective:
                    delete this.stage.canaryConfig.beginCanaryAnalysisAfterMins;
                    delete this.stage.canaryConfig.lifetimeDuration;
                    delete this.stage.deployments;
                    if (this.metricStore === 'atlas') {
                        this.stage.canaryConfig.scopes.forEach(scope => {
                            lodash_1.unset(scope, 'extendedScopeParams.dataset');
                            lodash_1.unset(scope, 'extendedScopeParams.environment');
                        });
                        this.setAtlasScopeParams();
                    }
                    break;
            }
            this.$scope.$applyAsync();
        });
        this.initializeRealTimeAutomaticAnalysisType = () => __awaiter(this, void 0, void 0, function* () {
            this.stage.deployments = Object.assign({}, this.stage.deployments, { baseline: Object.assign({}, lodash_1.get(this.stage, 'deployments.baseline'), { cloudProvider: this.providers[0], application: this.$scope.application.name, cluster: null, account: null }), serverGroupPairs: [] });
            this.accounts = yield this.loadAccounts();
            this.setClusterList();
            this.setMetricStore();
        });
        this.loadCanaryConfigDetails = () => __awaiter(this, void 0, void 0, function* () {
            if (!lodash_1.has(this.stage, 'canaryConfig.canaryConfigId')) {
                return null;
            }
            const id = this.stage.canaryConfig.canaryConfigId;
            try {
                return canaryConfig_service_1.getCanaryConfigById(id);
            }
            catch (e) {
                this.$log.warn(`Could not load canary config with id ${id}: `, e);
                return null;
            }
        });
        this.setMetricStore = () => {
            this.metricStore = lodash_1.get(this.selectedCanaryConfigDetails, 'metrics[0].query.type');
            if (this.metricStore === 'atlas') {
                this.setAtlasScopeParams();
                this.$scope.$applyAsync();
            }
            else {
                this.stage.canaryConfig.scopes.forEach(scope => {
                    lodash_1.unset(scope, 'extendedScopeParams.type');
                });
            }
        };
        this.setAtlasScopeParams = () => {
            const isRealTimeAutomatic = this.stage.analysisType === domain_1.KayentaAnalysisType.RealTimeAutomatic;
            const existingScopeType = lodash_1.get(this.stage.canaryConfig.scopes[0], 'extendedScopeParams.type');
            if (!isRealTimeAutomatic) {
                this.state.atlasScopeType = existingScopeType !== 'asg' ? existingScopeType : 'cluster';
            }
            this.stage.canaryConfig.scopes.forEach(scope => {
                lodash_1.set(scope, 'extendedScopeParams.type', isRealTimeAutomatic ? 'asg' : this.state.atlasScopeType);
            });
            if (isRealTimeAutomatic) {
                this.state.useAtlasGlobalDataset =
                    lodash_1.get(this.stage.canaryConfig.scopes[0], 'extendedScopeParams.dataset') === 'global';
                this.stage.canaryConfig.scopes.forEach(scope => {
                    lodash_1.set(scope, 'extendedScopeParams.dataset', this.state.useAtlasGlobalDataset ? 'global' : 'regional');
                });
            }
        };
        this.setLocations = () => {
            const { recommendedLocations, locations, hasChoices } = this.getLocationChoices();
            if (!hasChoices) {
                return;
            }
            this.state.showAllLocations.control = this.state.showAllLocations.experiment =
                recommendedLocations.length === 0 && locations.length > 0;
            this.stage.canaryConfig.scopes.forEach(scope => {
                if (!recommendedLocations.includes(scope.controlLocation) && !locations.includes(scope.controlLocation)) {
                    delete scope.controlLocation;
                }
                else if (!recommendedLocations.includes(scope.controlLocation)) {
                    this.state.showAllLocations.control = true;
                }
                if (!recommendedLocations.includes(scope.experimentLocation) && !locations.includes(scope.experimentLocation)) {
                    delete scope.experimentLocation;
                }
                else if (!recommendedLocations.includes(scope.experimentLocation)) {
                    this.state.showAllLocations.experiment = true;
                }
            });
        };
        this.setShowAdvancedSettings = () => {
            this.state.showAdvancedSettings =
                this.kayentaAccounts.get(domain_1.KayentaAccountType.MetricsStore).length > 1 ||
                    this.kayentaAccounts.get(domain_1.KayentaAccountType.ObjectStore).length > 1 ||
                    this.scopeNames.length > 1 ||
                    canary_settings_1.CanarySettings.legacySiteLocalFieldsEnabled;
        };
        this.getLocationChoices = () => {
            const accounts = this.kayentaAccounts.get(domain_1.KayentaAccountType.MetricsStore);
            const selectedAccount = accounts && accounts.find(({ name }) => name === this.stage.canaryConfig.metricsAccountName);
            if (!selectedAccount) {
                return {
                    combinedLocations: { control: [], experiment: [] },
                    recommendedLocations: [],
                    locations: [],
                    hasChoices: false,
                };
            }
            const hasChoices = selectedAccount.locations.length > 0 || selectedAccount.recommendedLocations.length > 0;
            const allLocations = selectedAccount.recommendedLocations.concat(selectedAccount.locations);
            const control = lodash_1.uniq(this.state.showAllLocations.control
                ? allLocations
                : selectedAccount.recommendedLocations.length > 0
                    ? selectedAccount.recommendedLocations
                    : selectedAccount.locations);
            const experiment = lodash_1.uniq(this.state.showAllLocations.experiment
                ? allLocations
                : selectedAccount.recommendedLocations.length > 0
                    ? selectedAccount.recommendedLocations
                    : selectedAccount.locations);
            return {
                combinedLocations: {
                    control,
                    experiment,
                },
                recommendedLocations: selectedAccount.recommendedLocations,
                locations: selectedAccount.locations,
                hasChoices,
            };
        };
        this.toggleAllLocations = (type) => {
            this.state.showAllLocations[type] = !this.state.showAllLocations[type];
            const locationChoices = this.getLocationChoices();
            this.stage.canaryConfig.scopes.forEach(scope => {
                if (!locationChoices.combinedLocations.control.includes(scope.controlLocation)) {
                    delete scope.controlLocation;
                }
                if (!locationChoices.combinedLocations.experiment.includes(scope.experimentLocation)) {
                    delete scope.experimentLocation;
                }
            });
        };
        this.populateScopeNameChoices = () => {
            if (!this.selectedCanaryConfigDetails) {
                return;
            }
            const scopeNames = lodash_1.uniq(lodash_1.map(this.selectedCanaryConfigDetails.metrics, metric => metric.scopeName || 'default'));
            this.scopeNames = !lodash_1.isEmpty(scopeNames) ? scopeNames : ['default'];
            this.setShowAdvancedSettings();
            if (!lodash_1.isEmpty(this.stage.canaryConfig.scopes) && !scopeNames.includes(this.stage.canaryConfig.scopes[0].scopeName)) {
                delete this.stage.canaryConfig.scopes[0].scopeName;
            }
            else if (lodash_1.isEmpty(this.stage.canaryConfig.scopes)) {
                this.stage.canaryConfig.scopes = [{ scopeName: scopeNames[0] }];
            }
        };
        this.loadKayentaAccounts = () => __awaiter(this, void 0, void 0, function* () {
            const mapped = new Map();
            const accounts = yield canaryConfig_service_1.listKayentaAccounts();
            accounts.forEach(account => {
                account.supportedTypes.forEach(type => {
                    if (mapped.has(type)) {
                        mapped.set(type, mapped.get(type).concat([account]));
                    }
                    else {
                        mapped.set(type, [account]);
                    }
                });
            });
            return mapped;
        });
        this.deleteConfigAccountsIfMissing = () => {
            if ((this.kayentaAccounts.get(domain_1.KayentaAccountType.ObjectStore) || []).every(account => account.name !== this.stage.canaryConfig.storageAccountName)) {
                delete this.stage.canaryConfig.storageAccountName;
            }
            if ((this.kayentaAccounts.get(domain_1.KayentaAccountType.MetricsStore) || []).every(account => account.name !== this.stage.canaryConfig.metricsAccountName)) {
                delete this.stage.canaryConfig.metricsAccountName;
            }
        };
        this.deleteCanaryConfigIdIfMissing = () => {
            if (this.canaryConfigSummaries.every(s => s.id !== this.stage.canaryConfig.canaryConfigId)) {
                delete this.stage.canaryConfig.canaryConfigId;
            }
        };
        this.populateScopeWithExpressions = () => {
            this.stage.canaryConfig.scopes[0].controlScope =
                "${ #stage('Clone Server Group')['context']['source']['serverGroupName'] }";
            this.stage.canaryConfig.scopes[0].controlLocation = '${ deployedServerGroups[0].region }';
            this.stage.canaryConfig.scopes[0].experimentScope = '${ deployedServerGroups[0].serverGroup }';
            this.stage.canaryConfig.scopes[0].experimentLocation = '${ deployedServerGroups[0].region }';
        };
        this.onLifetimeChange = () => {
            this.stage.canaryConfig.lifetimeDuration = duration_1.getDurationString(this.state.lifetime);
        };
        this.updateLifetimeFromHoursToDuration = () => {
            if (lodash_1.has(this.stage, ['canaryConfig', 'lifetimeHours'])) {
                const hours = parseInt(this.stage.canaryConfig.lifetimeHours, 10);
                if (lodash_1.isFinite(hours)) {
                    const fractional = parseFloat(this.stage.canaryConfig.lifetimeHours) - hours;
                    const minutes = Math.floor(fractional * 60);
                    this.stage.canaryConfig.lifetimeDuration = `PT${hours}H`;
                    if (lodash_1.isFinite(minutes)) {
                        this.stage.canaryConfig.lifetimeDuration += `${minutes}M`;
                    }
                    this.state.lifetimeHoursUpdatedToDuration = true;
                }
                delete this.stage.canaryConfig.lifetimeHours;
            }
        };
        this.getLifetimeClassnames = () => {
            if (this.state.lifetimeHoursUpdatedToDuration) {
                return 'alert alert-warning';
            }
            return '';
        };
        this.getLifetimeInputClassnames = () => {
            const { hours, minutes } = this.state.lifetime;
            if (hours === 0 && minutes === 0) {
                return 'ng-invalid ng-invalid-required';
            }
            return '';
        };
        this.loadProviders = () => __awaiter(this, void 0, void 0, function* () {
            this.providers = (yield core_1.AccountService.listProviders(this.$scope.application)).filter(p => REAL_TIME_AUTOMATIC_PROVIDERS.includes(p));
            if (!this.providers.length) {
                this.state.analysisTypes = [domain_1.KayentaAnalysisType.RealTime, domain_1.KayentaAnalysisType.Retrospective];
            }
            return this.providers;
        });
        this.handleProviderChange = () => __awaiter(this, void 0, void 0, function* () {
            lodash_1.set(this.stage, 'deployments.baseline.account', null);
            lodash_1.set(this.stage, 'deployments.baseline.cluster', null);
            this.accounts = yield this.loadAccounts();
            this.setClusterList();
        });
        this.loadAccounts = () => {
            if (!lodash_1.has(this.stage, 'deployments.baseline.cloudProvider')) {
                return null;
            }
            return Promise.resolve(core_1.AccountService.listAccounts(this.stage.deployments.baseline.cloudProvider));
        };
        this.setClusterList = () => {
            this.clusterList = core_1.AppListExtractor.getClusters([this.$scope.application], sg => lodash_1.has(this.stage, 'deployments.baseline.account') ? sg.account === this.stage.deployments.baseline.account : true);
            this.setAtlasEnvironment();
        };
        this.setAtlasEnvironment = () => {
            if (this.metricStore === 'atlas' && this.stage.analysisType === domain_1.KayentaAnalysisType.RealTimeAutomatic) {
                this.stage.canaryConfig.scopes.forEach(scope => {
                    if (this.stage.deployments.baseline.account) {
                        const accountDetails = this.accounts.find(({ name }) => this.stage.deployments.baseline.account === name);
                        accountDetails && lodash_1.set(scope, 'extendedScopeParams.environment', accountDetails.environment);
                    }
                    else {
                        lodash_1.unset(scope, 'extendedScopeParams.environment');
                    }
                });
            }
        };
        this.setLegacySiteLocalRecipients = () => {
            const recipients = lodash_1.get(this.stage.canaryConfig, 'siteLocal.notificationEmail');
            if (Array.isArray(recipients)) {
                this.state.legacySiteLocalRecipients = recipients.join(',');
            }
            else {
                this.state.legacySiteLocalRecipients = lodash_1.isString(recipients) ? recipients : '';
            }
        };
        this.handleLegacySiteLocalRecipientsChange = () => {
            if (this.state.legacySiteLocalRecipients.includes('${')) {
                lodash_1.set(this.stage.canaryConfig, 'siteLocal.notificationEmail', this.state.legacySiteLocalRecipients);
            }
            else if (this.state.legacySiteLocalRecipients.length) {
                lodash_1.set(this.stage.canaryConfig, 'siteLocal.notificationEmail', this.state.legacySiteLocalRecipients.split(',').map(email => email.trim()));
            }
            else {
                delete this.stage.canaryConfig.siteLocal;
            }
        };
        this.getRegion = (serverGroup) => {
            if (serverGroup.region) {
                return serverGroup.region;
            }
            const availabilityZones = serverGroup.availabilityZones;
            return availabilityZones
                ? Object.keys(availabilityZones).length
                    ? Object.keys(availabilityZones)[0]
                    : 'n/a'
                : 'n/a';
        };
        this.getServerGroupName = (serverGroup) => {
            return core_1.NameUtils.getClusterName(serverGroup.application, serverGroup.stack, serverGroup.freeFormDetails);
        };
        this.addPair = () => __awaiter(this, void 0, void 0, function* () {
            this.stage.deployments.serverGroupPairs = this.stage.deployments.serverGroupPairs || [];
            const provider = yield (lodash_1.has(this.stage, 'deployments.baseline.cloudProvider')
                ? Promise.resolve(this.stage.deployments.baseline.cloudProvider)
                : Promise.resolve(core_1.ProviderSelectionService.selectProvider(this.$scope.application, 'serverGroup')));
            this.stage.deployments.baseline.cloudProvider = provider;
            const config = core_1.CloudProviderRegistry.getValue(provider, 'serverGroup');
            const command = yield this.serverGroupCommandBuilder.buildNewServerGroupCommandForPipeline(provider, null, null);
            command.viewState = Object.assign({}, command.viewState, { requiresTemplateSelection: true, disableStrategySelection: true, hideClusterNamePreview: true, readOnlyFields: {
                    credentials: true,
                    region: true,
                    subnet: true,
                    useSourceCapacity: true,
                }, overrides: {
                    capacity: {
                        min: 1,
                        max: 1,
                        desired: 1,
                    },
                    useSourceCapacity: false,
                }, imageSourceText: `
        <p>This dialogue will configure two server groups.</p>
        <p>
          The <b>Baseline</b> server group's image will be resolved
          from the <b>Newest</b> server group
          in the <b>Baseline Version</b> cluster defined in this stage.
        </p>
        <p>
          The <b>Canary</b> server group's image will be resolved from
          an upstream <b>Bake</b> or <b>Find Image</b> stage.
        </p>` });
            delete command.strategy;
            try {
                const title = 'Add Baseline + Canary Pair';
                const application = this.$scope.application;
                let result;
                if (config.CloneServerGroupModal) {
                    result = yield config.CloneServerGroupModal.show({
                        title,
                        application,
                        command,
                    });
                }
                else {
                    result = yield this.$uibModal.open({
                        templateUrl: config.cloneServerGroupTemplateUrl,
                        controller: `${config.cloneServerGroupController} as ctrl`,
                        size: 'lg',
                        resolve: {
                            title: () => title,
                            application: () => application,
                            serverGroupCommand: () => command,
                        },
                    }).result;
                }
                const control = this.serverGroupTransformer.convertServerGroupCommandToDeployConfiguration(result);
                const experiment = lodash_1.cloneDeep(control);
                const cleanup = (serverGroup, type) => {
                    delete serverGroup.backingData;
                    if (serverGroup.freeFormDetails && serverGroup.freeFormDetails.split('-').pop() === type) {
                        return;
                    }
                    serverGroup.freeFormDetails = `${serverGroup.freeFormDetails ? `${serverGroup.freeFormDetails}-` : ''}${type}`;
                };
                cleanup(control, 'baseline');
                cleanup(experiment, 'canary');
                this.stage.deployments.serverGroupPairs = [{ control, experiment }];
                this.$scope.$applyAsync();
            }
            catch (e) {
                this.$log.warn('Error creating server group pair for Kayenta stage: ', e);
            }
        });
        this.editServerGroup = (serverGroup, index, type) => __awaiter(this, void 0, void 0, function* () {
            serverGroup.provider = serverGroup.provider || serverGroup.cloudProvider;
            const config = core_1.CloudProviderRegistry.getValue(serverGroup.cloudProvider, 'serverGroup');
            try {
                const title = `Configure ${type[0].toUpperCase() + type.substring(1)} Server Group`;
                const application = this.$scope.application;
                const command = yield this.serverGroupCommandBuilder.buildServerGroupCommandFromPipeline(application, serverGroup, null, null);
                command.viewState = Object.assign({}, command.viewState, { disableStrategySelection: true, hideClusterNamePreview: true, readOnlyFields: {
                        credentials: true,
                        region: true,
                        subnet: true,
                        useSourceCapacity: true,
                    }, imageSourceText: this.resolveImageSourceText(type) });
                delete command.strategy;
                let result;
                if (config.CloneServerGroupModal) {
                    result = yield config.CloneServerGroupModal.show({
                        title,
                        application,
                        command,
                    });
                }
                else {
                    result = yield this.$uibModal.open({
                        templateUrl: config.cloneServerGroupTemplateUrl,
                        controller: `${config.cloneServerGroupController} as ctrl`,
                        size: 'lg',
                        resolve: {
                            title: () => title,
                            application: () => application,
                            serverGroupCommand: () => command,
                        },
                    }).result;
                }
                this.stage.deployments.serverGroupPairs[index][type] = this.serverGroupTransformer.convertServerGroupCommandToDeployConfiguration(result);
            }
            catch (e) {
                this.$log.warn('Error editing server group pair for Kayenta stage: ', e);
            }
        });
        this.deletePair = (index) => {
            (this.stage.deployments.serverGroupPairs || []).splice(index, 1);
        };
        this.handleAtlasDatasetChange = (event) => {
            const { checked } = event.target;
            this.$scope.$applyAsync(() => {
                this.stage.canaryConfig.scopes.forEach(scope => {
                    lodash_1.set(scope, 'extendedScopeParams.dataset', checked ? 'global' : 'regional');
                    lodash_1.set(scope, 'extendedScopeParams.type', this.stage.analysisType === domain_1.KayentaAnalysisType.RealTimeAutomatic ? 'asg' : this.state.atlasScopeType);
                });
            });
        };
        this.onAtlasScopeTypeChange = () => {
            this.$scope.$applyAsync(() => {
                this.stage.canaryConfig.scopes.forEach(scope => {
                    lodash_1.set(scope, 'extendedScopeParams.type', this.state.atlasScopeType);
                });
            });
        };
        this.handleExtendedScopeParamsChange = () => {
            if (this.metricStore !== 'atlas') {
                return;
            }
            this.stage.canaryConfig.scopes.forEach(scope => {
                lodash_1.set(scope, 'extendedScopeParams.type', this.stage.analysisType === domain_1.KayentaAnalysisType.RealTimeAutomatic ? 'asg' : this.state.atlasScopeType);
            });
            if (this.stage.analysisType === domain_1.KayentaAnalysisType.RealTimeAutomatic) {
                this.stage.canaryConfig.scopes.forEach(scope => {
                    lodash_1.set(scope, 'extendedScopeParams.dataset', this.state.useAtlasGlobalDataset ? 'global' : 'regional');
                });
                this.setAtlasEnvironment();
            }
            this.$scope.$applyAsync();
        };
        this.onDelayBeforeCleanupChange = () => {
            this.stage.deployments.delayBeforeCleanup = duration_1.getDurationString(this.state.delayBeforeCleanup);
        };
        this.initialize();
    }
    resolveImageSourceText(type) {
        if (type === 'experiment') {
            return `This server group's image will be resolved from an upstream
        <b>Bake</b> or <b>Find Image</b> stage.`;
        }
        else {
            return `This server group's image will be resolved from the <b>Newest</b>
        server group in the <b>Baseline Version</b> cluster defined in this stage.`;
        }
    }
}
KayentaStageController.$inject = [
    '$scope',
    '$uibModal',
    '$log',
    'serverGroupCommandBuilder',
    'serverGroupTransformer',
    'stage',
];
exports.KayentaStageController = KayentaStageController;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __webpack_require__(12);
const lodash_1 = __webpack_require__(2);
const core_1 = __webpack_require__(6);
const stageTypes_1 = __webpack_require__(73);
const stageTypesToAlwaysShow = [stageTypes_1.KAYENTA_CANARY, stageTypes_1.CREATE_SERVER_GROUP];
class KayentaStageTransformer {
    transform(_application, execution) {
        const kayentaStages = execution.stages.filter(({ type }) => type === stageTypes_1.KAYENTA_CANARY);
        if (!kayentaStages.length) {
            return;
        }
        let stagesToRenderAsTasks = [];
        execution.stages.forEach(stage => {
            if (stage.type === stageTypes_1.KAYENTA_CANARY) {
                core_1.OrchestratedItemTransformer.defineProperties(stage);
                const intervalStageId = stage.context.intervalStageId;
                const syntheticCanaryStages = intervalStageId
                    ? execution.stages.filter(({ parentStageId, type }) => parentStageId && parentStageId === intervalStageId && [stageTypes_1.WAIT, stageTypes_1.RUN_CANARY].includes(type))
                    : [];
                stagesToRenderAsTasks = stagesToRenderAsTasks.concat(syntheticCanaryStages);
                const runCanaryStages = syntheticCanaryStages.filter(s => s.type === stageTypes_1.RUN_CANARY);
                syntheticCanaryStages.forEach(syntheticStage => core_1.OrchestratedItemTransformer.defineProperties(syntheticStage));
                this.calculateRunCanaryResults(runCanaryStages);
                this.calculateKayentaCanaryResults(stage, syntheticCanaryStages);
                stage.exceptions = [];
                this.addExceptions([stage, ...syntheticCanaryStages], stage.exceptions);
                stage.tasks = [...syntheticCanaryStages, ...stage.tasks];
            }
            else if (stage.type === stageTypes_1.CREATE_SERVER_GROUP && this.isDescendantOf(stage, kayentaStages, execution)) {
                core_1.OrchestratedItemTransformer.defineProperties(stage);
                const parentKayentaStageId = this.isDescendantOf(stage, kayentaStages, execution);
                const locations = stage.context['deploy.server.groups'] && Object.keys(stage.context['deploy.server.groups']);
                stage.name = `Deploy ${stage.context.freeFormDetails}${locations ? ' in ' + locations.join(', ') : ''}`;
                stage.parentStageId = parentKayentaStageId;
            }
        });
        const kayentaStageIds = kayentaStages.map(({ id }) => id);
        const deployCanaryServerGroupsStages = execution.stages.filter(({ parentStageId, type }) => kayentaStageIds.includes(parentStageId) && type === stageTypes_1.DEPLOY_CANARY_SERVER_GROUPS);
        deployCanaryServerGroupsStages.forEach(deployCanaryStage => {
            const parentKayentaStage = kayentaStages.find(({ id }) => deployCanaryStage.parentStageId === id);
            if (parentKayentaStage && (deployCanaryStage.outputs.deployedServerGroups || []).length) {
                const [{ controlScope, experimentScope }] = deployCanaryStage.outputs.deployedServerGroups;
                parentKayentaStage.outputs = Object.assign({}, parentKayentaStage.outputs, { controlScope, experimentScope });
            }
        });
        execution.stages = execution.stages.filter(stage => !stagesToRenderAsTasks.includes(stage) &&
            (!this.isDescendantOf(stage, kayentaStages, execution) ||
                stageTypesToAlwaysShow.includes(stage.type) ||
                stage.status !== 'SUCCEEDED'));
    }
    isDescendantOf(child, ancestors, execution) {
        const ancestorIds = ancestors.map(({ id }) => id);
        let node = child;
        while (node && node.parentStageId) {
            const parentNode = execution.stages.find(({ id }) => node.parentStageId === id);
            if (parentNode && ancestorIds.includes(parentNode.id)) {
                return parentNode.id;
            }
            else {
                node = parentNode;
            }
        }
        return null;
    }
    calculateRunCanaryResults(runCanaryStages) {
        runCanaryStages.forEach(run => {
            if (typeof run.getValueFor('canaryScore') === 'number') {
                if (run.status === 'SUCCEEDED') {
                    if (run.context.canaryScore >= run.context.scoreThresholds.pass) {
                        run.result = 'success';
                    }
                }
                else {
                    run.health = 'unhealthy';
                }
                run.context.canaryScore = lodash_1.round(run.context.canaryScore, 2);
            }
        });
    }
    calculateKayentaCanaryResults(kayentaStage, runCanaryStages) {
        if (!kayentaStage.isRunning) {
            if (kayentaStage.getValueFor('canaryScores')) {
                kayentaStage.context.overallScore = lodash_1.last(kayentaStage.getValueFor('canaryScores'));
            }
            else {
                kayentaStage.context.overallScore = this.getLastCanaryRunScore(runCanaryStages);
            }
            kayentaStage.context.overallScore = lodash_1.round(kayentaStage.context.overallScore, 2);
            if (!kayentaStage.context.canaryScoreMessage) {
                kayentaStage.context.canaryScoreMessage = this.getLastCanaryScoreMessage(runCanaryStages);
            }
            if (!kayentaStage.isCanceled) {
                const overallScore = lodash_1.get(kayentaStage, 'context.overallScore', null);
                const scoreThreshold = lodash_1.get(kayentaStage, 'context.canaryConfig.scoreThresholds.marginal', null);
                if (kayentaStage.status === 'SUCCEEDED' || (overallScore && overallScore > scoreThreshold)) {
                    kayentaStage.context.overallResult = 'success';
                }
                else {
                    kayentaStage.context.overallHealth = 'unhealthy';
                }
            }
        }
    }
    getLastCanaryRunScore(runCanaryStages = []) {
        const canaryRunScores = runCanaryStages
            .filter(s => typeof s.getValueFor('canaryScore') === 'number')
            .map(s => s.getValueFor('canaryScore'));
        return lodash_1.last(canaryRunScores);
    }
    getLastCanaryScoreMessage(runCanaryStages = []) {
        const canaryRunMessages = runCanaryStages
            .filter(s => s.getValueFor('canaryScoreMessage'))
            .map(s => s.getValueFor('canaryScoreMessage'));
        return lodash_1.last(canaryRunMessages);
    }
    addExceptions(stages, exceptions) {
        stages.forEach(stage => {
            if (this.getException(stage)) {
                exceptions.push(this.getException(stage));
            }
            const overallScore = lodash_1.get(stage, 'context.overallScore', null);
            const scoreThreshold = lodash_1.get(stage, 'context.canaryConfig.scoreThresholds.marginal', null);
            const message = lodash_1.get(stage, 'context.canaryScoreMessage', null);
            if (overallScore && message && overallScore <= scoreThreshold) {
                exceptions.push(message);
            }
        });
    }
    getException(stage) {
        if (stage && stage.isFailed) {
            if (stage.context &&
                stage.context.exception &&
                stage.context.exception.details &&
                stage.context.exception.details.responseBody) {
                return stage.context.exception.details.responseBody;
            }
            else {
                return stage.failureMessage;
            }
        }
        else {
            return null;
        }
    }
}
exports.KayentaStageTransformer = KayentaStageTransformer;
exports.KAYENTA_STAGE_TRANSFORMER = 'spinnaker.kayenta.kayentaStageTransformer';
angular_1.module(exports.KAYENTA_STAGE_TRANSFORMER, []).service('kayentaStageTransformer', KayentaStageTransformer);


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __webpack_require__(12);
const lodash_1 = __webpack_require__(2);
const core_1 = __webpack_require__(6);
const canary_settings_1 = __webpack_require__(11);
const canaryConfig_service_1 = __webpack_require__(18);
const domain_1 = __webpack_require__(13);
const canaryScores_component_1 = __webpack_require__(54);
const kayentaStage_transformer_1 = __webpack_require__(282);
const kayentaStage_controller_1 = __webpack_require__(281);
const CanaryExecutionLabel_1 = __webpack_require__(276);
const kayentaStageExecutionDetails_controller_1 = __webpack_require__(285);
const kayentaStageConfigSection_component_1 = __webpack_require__(284);
const analysisType_component_1 = __webpack_require__(277);
const forAnalysisType_component_1 = __webpack_require__(280);
const isExpression = (value) => lodash_1.isString(value) && value.includes('${');
const emailPattern = /^(.+)@(.+).([A-Za-z]{2,6})/;
const isValidEmail = (email) => isExpression(email) || email.match(emailPattern);
const utcInstantPattern = /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$/;
const isValidUtcInstant = (timestamp) => isExpression(timestamp) || (lodash_1.isString(timestamp) && timestamp.match(utcInstantPattern));
const requiredForAnalysisTypes = (analysisTypes = [], fieldName, fieldLabel) => {
    return (_pipeline, stage) => {
        if (analysisTypes.includes(stage.analysisType)) {
            if (!lodash_1.has(stage, fieldName) || lodash_1.get(stage, fieldName) === '') {
                return `<strong>${fieldLabel || fieldName}</strong> is a required field for Kayenta Canary stages.`;
            }
        }
        return null;
    };
};
const allScopesMustBeConfigured = (_pipeline, stage) => {
    return canaryConfig_service_1.getCanaryConfigById(lodash_1.get(stage, 'canaryConfig.canaryConfigId')).then(configDetails => {
        let definedScopeNames = lodash_1.uniq(lodash_1.map(configDetails.metrics, metric => metric.scopeName || 'default'));
        definedScopeNames = !lodash_1.isEmpty(definedScopeNames) ? definedScopeNames : ['default'];
        const configureScopedNames = lodash_1.map(lodash_1.get(stage, 'canaryConfig.scopes'), 'scopeName');
        const missingScopeNames = lodash_1.difference(definedScopeNames, configureScopedNames);
        if (missingScopeNames.length > 1) {
            return `Scopes <strong>${missingScopeNames.join()}</strong> are defined but not configured.`;
        }
        else if (missingScopeNames.length === 1) {
            return `Scope <strong>${missingScopeNames[0]}</strong> is defined but not configured.`;
        }
        else {
            return null;
        }
    });
};
const allConfiguredScopesMustBeDefined = (_pipeline, stage) => {
    return canaryConfig_service_1.getCanaryConfigById(lodash_1.get(stage, 'canaryConfig.canaryConfigId')).then(configDetails => {
        let definedScopeNames = lodash_1.uniq(lodash_1.map(configDetails.metrics, metric => metric.scopeName || 'default'));
        definedScopeNames = !lodash_1.isEmpty(definedScopeNames) ? definedScopeNames : ['default'];
        const configureScopedNames = lodash_1.map(lodash_1.get(stage, 'canaryConfig.scopes'), 'scopeName');
        const missingScopeNames = lodash_1.difference(configureScopedNames, definedScopeNames);
        if (missingScopeNames.length > 1) {
            return `Scopes <strong>${missingScopeNames.join()}</strong> are configured but are not defined in the canary configuration.`;
        }
        else if (missingScopeNames.length === 1) {
            return `Scope <strong>${missingScopeNames[0]}</strong> is configured but is not defined in the canary configuration.`;
        }
        else {
            return null;
        }
    });
};
exports.KAYENTA_CANARY_STAGE = 'spinnaker.kayenta.canaryStage';
angular_1.module(exports.KAYENTA_CANARY_STAGE, [
    canaryScores_component_1.CANARY_SCORES_CONFIG_COMPONENT,
    analysisType_component_1.KAYENTA_ANALYSIS_TYPE_COMPONENT,
    kayentaStageConfigSection_component_1.KAYENTA_STAGE_CONFIG_SECTION,
    kayentaStage_transformer_1.KAYENTA_STAGE_TRANSFORMER,
    kayentaStageExecutionDetails_controller_1.KAYENTA_STAGE_EXECUTION_DETAILS_CONTROLLER,
    forAnalysisType_component_1.FOR_ANALYSIS_TYPE_COMPONENT,
])
    .config(() => {
    'ngInject';
    core_1.Registry.pipeline.registerStage({
        label: canary_settings_1.CanarySettings.stageName || 'Canary Analysis',
        description: canary_settings_1.CanarySettings.stageDescription || 'Runs a canary task',
        key: 'kayentaCanary',
        templateUrl: __webpack_require__(51),
        controller: 'KayentaCanaryStageCtrl',
        controllerAs: 'kayentaCanaryStageCtrl',
        executionDetailsUrl: __webpack_require__(52),
        executionLabelComponent: CanaryExecutionLabel_1.CanaryExecutionLabel,
        validators: [
            { type: 'requiredField', fieldName: 'canaryConfig.canaryConfigId', fieldLabel: 'Config Name' },
            { type: 'requiredField', fieldName: 'canaryConfig.metricsAccountName', fieldLabel: 'Metrics Account' },
            { type: 'requiredField', fieldName: 'canaryConfig.storageAccountName', fieldLabel: 'Storage Account' },
            {
                type: 'custom',
                validate: requiredForAnalysisTypes([domain_1.KayentaAnalysisType.RealTimeAutomatic], 'deployments.serverGroupPairs[0].control', 'Baseline & Canary Server Groups'),
            },
            {
                type: 'custom',
                validate: requiredForAnalysisTypes([domain_1.KayentaAnalysisType.RealTimeAutomatic], 'deployments.baseline.cluster', 'Baseline Cluster'),
            },
            {
                type: 'custom',
                validate: requiredForAnalysisTypes([domain_1.KayentaAnalysisType.RealTimeAutomatic], 'deployments.baseline.account', 'Baseline Account'),
            },
            {
                type: 'custom',
                validate: requiredForAnalysisTypes([domain_1.KayentaAnalysisType.RealTime, domain_1.KayentaAnalysisType.Retrospective], 'canaryConfig.scopes[0].controlScope', 'Baseline Scope'),
            },
            {
                type: 'custom',
                validate: requiredForAnalysisTypes([domain_1.KayentaAnalysisType.RealTime, domain_1.KayentaAnalysisType.Retrospective], 'canaryConfig.scopes[0].experimentScope', 'Canary Scope'),
            },
            {
                type: 'custom',
                validate: requiredForAnalysisTypes([domain_1.KayentaAnalysisType.RealTime, domain_1.KayentaAnalysisType.RealTimeAutomatic], 'canaryConfig.lifetimeDuration', 'Lifetime'),
            },
            {
                type: 'custom',
                validate: requiredForAnalysisTypes([domain_1.KayentaAnalysisType.Retrospective], 'canaryConfig.scopes[0].startTimeIso', 'Start Time'),
            },
            {
                type: 'custom',
                validate: requiredForAnalysisTypes([domain_1.KayentaAnalysisType.Retrospective], 'canaryConfig.scopes[0].endTimeIso', 'End Time'),
            },
            {
                type: 'custom',
                validate: (_pipeline, stage) => {
                    if (!lodash_1.has(stage, 'canaryConfig.canaryConfigId') ||
                        stage.analysisType === domain_1.KayentaAnalysisType.RealTimeAutomatic) {
                        return null;
                    }
                    return canaryConfig_service_1.getCanaryConfigById(lodash_1.get(stage, 'canaryConfig.canaryConfigId')).then(configDetails => {
                        if (lodash_1.get(configDetails, 'metrics[0].query.type') === 'atlas' &&
                            !lodash_1.get(stage, 'canaryConfig.scopes[0].extendedScopeParams.type')) {
                            return 'Scope Type is required';
                        }
                        else {
                            return null;
                        }
                    });
                },
            },
            {
                type: 'custom',
                validate: allScopesMustBeConfigured,
            },
            {
                type: 'custom',
                validate: allConfiguredScopesMustBeDefined,
            },
            {
                type: 'custom',
                validate: (_pipeline, { canaryConfig }) => {
                    if (!canary_settings_1.CanarySettings.legacySiteLocalFieldsEnabled) {
                        return null;
                    }
                    const notificationEmail = lodash_1.get(canaryConfig, 'siteLocal.notificationEmail');
                    if (!notificationEmail) {
                        return null;
                    }
                    const emails = Array.isArray(notificationEmail) ? notificationEmail : [notificationEmail];
                    const invalidEmail = emails.find(email => !isValidEmail(email));
                    return invalidEmail ? `Invalid <strong>Notification Email</strong> (${invalidEmail})` : null;
                },
            },
            {
                type: 'custom',
                validate: (_pipeline, stage) => {
                    const startTime = lodash_1.get(stage, 'canaryConfig.scopes[0].startTimeIso');
                    if (stage.analysisType == domain_1.KayentaAnalysisType.Retrospective &&
                        !lodash_1.isEmpty(startTime) &&
                        !isValidUtcInstant(startTime)) {
                        return '<strong>Start Time</strong> must be formatted as a UTC instant using ISO-8601 instant format (e.g., 2018-07-12T20:28:29Z).';
                    }
                    return null;
                },
            },
            {
                type: 'custom',
                validate: (_pipeline, stage) => {
                    const endTime = lodash_1.get(stage, 'canaryConfig.scopes[0].endTimeIso');
                    if (stage.analysisType === domain_1.KayentaAnalysisType.Retrospective &&
                        !lodash_1.isEmpty(endTime) &&
                        !isValidUtcInstant(endTime)) {
                        return '<strong>End Time</strong> must be formatted as a UTC instant using ISO-8601 instant format (e.g., 2018-07-12T20:28:29Z).';
                    }
                    return null;
                },
            },
        ],
    });
})
    .controller('KayentaCanaryStageCtrl', kayentaStage_controller_1.KayentaStageController)
    .run([
    'kayentaStageTransformer',
    (kayentaStageTransformer) => {
        'ngInject';
        core_1.Registry.pipeline.registerTransformer(kayentaStageTransformer);
    },
]);


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __webpack_require__(12);
class KayentaStageConfigSection {
    constructor() {
        this.transclude = {
            sectionHeader: '?sectionHeader',
        };
        this.bindings = { title: '@' };
        this.template = `
    <section>
      <ul class="list-inline">
        <li><h5>{{ $ctrl.title }}</h5></li>
        <li><span ng-transclude="sectionHeader"></span></li>
      </ul>
      <div class="horizontal-rule"></div>
      <ng-transclude></ng-transclude>
    </section>
  `;
    }
}
exports.KAYENTA_STAGE_CONFIG_SECTION = 'spinnaker.kayenta.stageConfigSection';
angular_1.module(exports.KAYENTA_STAGE_CONFIG_SECTION, []).component('kayentaStageConfigSection', new KayentaStageConfigSection());


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __webpack_require__(12);
const stageTypes_1 = __webpack_require__(73);
const canaryRunSummaries_component_1 = __webpack_require__(278);
const domain_1 = __webpack_require__(13);
__webpack_require__(145);
class KayentaStageExecutionDetailsController {
    constructor($scope, $stateParams, executionDetailsSectionService) {
        'ngInject';
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.executionDetailsSectionService = executionDetailsSectionService;
        this.$scope.configSections = ['canarySummary', 'canaryConfig', 'taskStatus'];
        this.$scope.$on('$stateChangeSuccess', () => this.initialize());
    }
    $onInit() {
        this.initialize();
    }
    initialize() {
        this.executionDetailsSectionService.synchronizeSection(this.$scope.configSections, () => this.initialized());
    }
    initialized() {
        this.$scope.detailsSection = this.$stateParams.details;
        this.$scope.application.ready().then(() => {
            if (this.$scope.stage.type !== stageTypes_1.KAYENTA_CANARY) {
                return;
            }
            const canaryConfigSummary = this.$scope.application
                .getDataSource('canaryConfigs')
                .data.find((config) => config.id === this.$scope.stage.context.canaryConfig.canaryConfigId);
            if (canaryConfigSummary) {
                this.canaryConfigName = canaryConfigSummary.name;
            }
        });
        this.setCanaryRuns();
        this.resolveFirstScopeName();
        this.resolveControlAndExperimentNames();
        this.$scope.$watchCollection('stage.tasks', () => this.setCanaryRuns());
    }
    setCanaryRuns() {
        this.canaryRuns = this.$scope.stage.tasks.filter((t) => t.type === stageTypes_1.RUN_CANARY);
    }
    resolveFirstScopeName() {
        this.firstScopeName = this.$scope.stage.context.canaryConfig.scopes[0].scopeName;
    }
    resolveControlAndExperimentNames() {
        if (this.$scope.stage.context.analysisType === domain_1.KayentaAnalysisType.RealTimeAutomatic) {
            this.resolvedControl = this.$scope.stage.outputs.controlScope;
            this.resolvedExperiment = this.$scope.stage.outputs.experimentScope;
        }
        else {
            this.resolvedControl = this.canaryRuns.length
                ? this.canaryRuns[0].context.scopes[this.firstScopeName].controlScope.scope
                : this.$scope.stage.context.canaryConfig.scopes[0].controlScope;
            this.resolvedExperiment = this.canaryRuns.length
                ? this.canaryRuns[0].context.scopes[this.firstScopeName].experimentScope.scope
                : this.$scope.stage.context.canaryConfig.scopes[0].experimentScope;
        }
    }
}
KayentaStageExecutionDetailsController.$inject = ['$scope', '$stateParams', 'executionDetailsSectionService'];
exports.KAYENTA_STAGE_EXECUTION_DETAILS_CONTROLLER = 'spinnaker.kayenta.kayentaStageExecutionDetails.controller';
angular_1.module(exports.KAYENTA_STAGE_EXECUTION_DETAILS_CONTROLLER, [canaryRunSummaries_component_1.CANARY_RUN_SUMMARIES_COMPONENT])
    .controller('kayentaStageExecutionDetailsCtrl', KayentaStageExecutionDetailsController)
    .filter('dateToMillis', () => Date.parse);


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const angular_1 = __webpack_require__(12);
const kayentaStage_1 = __webpack_require__(283);
exports.CANARY_STAGES = 'spinnaker.kayenta.stages.module';
angular_1.module(exports.CANARY_STAGES, [kayentaStage_1.KAYENTA_CANARY_STAGE]);


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __webpack_require__(2);
exports.defaultDurationObject = {
    hours: 0,
    minutes: 0,
};
exports.defaultDurationString = 'PT0H0M';
function parseDurationString(duration) {
    const defaultDurationObjectCopy = Object.assign({}, exports.defaultDurationObject);
    if (!lodash_1.isString(duration)) {
        return defaultDurationObjectCopy;
    }
    const durationComponents = duration.match(/PT(\d+)H(?:(\d+)M)?/i);
    if (lodash_1.isEmpty(durationComponents)) {
        return defaultDurationObjectCopy;
    }
    let hours = parseInt(durationComponents[1], 10);
    if (!lodash_1.isInteger(hours) || hours < 0) {
        hours = 0;
    }
    let minutes = parseInt(durationComponents[2], 10);
    if (!lodash_1.isInteger(minutes) || minutes < 0) {
        minutes = 0;
    }
    return { hours, minutes };
}
exports.parseDurationString = parseDurationString;
function getDurationString(duration) {
    if (!duration) {
        return exports.defaultDurationString;
    }
    let { hours, minutes } = duration;
    if (!lodash_1.isInteger(hours) || hours < 0) {
        hours = 0;
    }
    if (!lodash_1.isInteger(minutes) || minutes < 0) {
        minutes = 0;
    }
    return `PT${hours}H${minutes}M`;
}
exports.getDurationString = getDurationString;


/***/ }),
/* 288 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./stages/kayentaStage/kayentaStage.html": 51,
	"./stages/kayentaStage/kayentaStageExecutionDetails.html": 52
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 289;

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports = require("@uirouter/angularjs");

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports = require("brace/ext/searchbox");

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports = require("brace/mode/json");

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports = require("d3-format");

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports = require("formik");

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports = require("labella");

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = require("moment");

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = require("ngimport");

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = require("react-bootstrap-typeahead");

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = require("react-container-dimensions");

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports = require("react-select");

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = require("react-tooltip");

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = require("redux-logger");

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = require("redux-observable");

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = require("rxjs/Observable");

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = require("rxjs/add/observable/concat");

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(75);


/***/ })
/******/ ]);
});
//# sourceMappingURL=lib.js.map